/* eslint-disable */
// @ts-nocheck
// Generated by scripts/generate-public-validators.mjs. Do not edit by hand.
// These standalone validators keep @maipo/format compatible with strict CSP environments.
"use strict";
export const validateLegacySceneSchema = validate20;
const schema31 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.0/scene.schema.json","title":"Maipo legacy scene 0.0 migration source","description":"Retrospective, read-only contract for deterministic migration into Maipo public scene 0.1. It is not an authoring or rendering target.","type":"object","additionalProperties":false,"required":["$schema","format","version","id","revision","title","canvas","fonts","assets","nodes"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.0/scene.schema.json"},"format":{"const":"maipo-scene"},"version":{"const":"0.0"},"id":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"revision":{"type":"integer","minimum":0},"title":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/name"},"canvas":{"type":"object","additionalProperties":false,"required":["width","height","backgroundColor"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"backgroundColor":{"oneOf":[{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/color"},{"type":"null"}]}}},"fonts":{"type":"array","maxItems":256,"items":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/font"}},"assets":{"type":"array","maxItems":4096,"items":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/asset"}},"nodes":{"type":"array","maxItems":4096,"items":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/node"}},"extensionDeclarations":{"type":"array","maxItems":64,"items":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration"}},"extensions":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensions"}}};
const schema33 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const schema34 = {"type":"string","minLength":1,"maxLength":256};
const schema36 = {"type":"string","pattern":"^#[0-9A-Fa-f]{6}$"};
const schema96 = {"type":"object","additionalProperties":false,"required":["key","version","kind"],"properties":{"key":{"type":"string","pattern":"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},"version":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[0-9A-Za-z][0-9A-Za-z._+-]*$"},"kind":{"const":"metadata"},"required":{"type":"boolean","default":false},"schemaId":{"type":"string","minLength":1,"maxLength":2048}}};
const schema57 = {"type":"object","maxProperties":64,"propertyNames":{"pattern":"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},"additionalProperties":true};
const func1 = Object.prototype.hasOwnProperty;
const func3 = (value) => { let length = 0; for (let index = 0; index < value.length; index += 1) { length += 1; const code = value.charCodeAt(index); if (code >= 0xd800 && code <= 0xdbff && index + 1 < value.length && (value.charCodeAt(index + 1) & 0xfc00) === 0xdc00) index += 1; } return length; };
const pattern4 = new RegExp("^[A-Za-z0-9][A-Za-z0-9._:/-]*$", "u");
const pattern5 = new RegExp("^#[0-9A-Fa-f]{6}$", "u");
const pattern12 = new RegExp("^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$", "u");
const pattern25 = new RegExp("^[0-9A-Za-z][0-9A-Za-z._+-]*$", "u");
const schema37 = {"type":"object","additionalProperties":false,"required":["id","family","weight","style","source","license"],"properties":{"id":{"$ref":"#/$defs/id"},"family":{"type":"string","minLength":1,"maxLength":256},"weight":{"type":"integer","minimum":1,"maximum":1000},"style":{"enum":["normal","italic","oblique"]},"source":{"oneOf":[{"type":"object","additionalProperties":false,"required":["kind"],"properties":{"kind":{"const":"system"}}},{"type":"object","additionalProperties":false,"required":["kind","asset"],"properties":{"kind":{"const":"embedded"},"asset":{"$ref":"#/$defs/id"}}}]},"license":{"type":"object","additionalProperties":false,"required":["spdx","embedding"],"properties":{"spdx":{"type":"string","minLength":1,"maxLength":128},"embedding":{"enum":["installable","editable","preview-print","restricted","unknown"]},"notice":{"type":"string","maxLength":4096}}}}};

function validate71(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate71.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.family === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "family"},message:"must have required property '"+"family"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.weight === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "weight"},message:"must have required property '"+"weight"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.style === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "style"},message:"must have required property '"+"style"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.source === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.license === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "license"},message:"must have required property '"+"license"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "id") || (key0 === "family")) || (key0 === "weight")) || (key0 === "style")) || (key0 === "source")) || (key0 === "license"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(func3(data0) < 1){
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(!pattern4.test(data0)){
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.family !== undefined){
let data1 = data.family;
if(typeof data1 === "string"){
if(func3(data1) > 256){
const err11 = {instancePath:instancePath+"/family",schemaPath:"#/properties/family/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(func3(data1) < 1){
const err12 = {instancePath:instancePath+"/family",schemaPath:"#/properties/family/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/family",schemaPath:"#/properties/family/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.weight !== undefined){
let data2 = data.weight;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err14 = {instancePath:instancePath+"/weight",schemaPath:"#/properties/weight/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000 || isNaN(data2)){
const err15 = {instancePath:instancePath+"/weight",schemaPath:"#/properties/weight/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000},message:"must be <= 1000"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data2 < 1 || isNaN(data2)){
const err16 = {instancePath:instancePath+"/weight",schemaPath:"#/properties/weight/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
if(data.style !== undefined){
let data3 = data.style;
if(!(((data3 === "normal") || (data3 === "italic")) || (data3 === "oblique"))){
const err17 = {instancePath:instancePath+"/style",schemaPath:"#/properties/style/enum",keyword:"enum",params:{allowedValues: schema37.properties.style.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.source !== undefined){
let data4 = data.source;
const _errs11 = errors;
let valid2 = false;
let passing0 = null;
const _errs12 = errors;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.kind === undefined){
const err18 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/0/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
for(const key1 in data4){
if(!(key1 === "kind")){
const err19 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/0/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data4.kind !== undefined){
if("system" !== data4.kind){
const err20 = {instancePath:instancePath+"/source/kind",schemaPath:"#/properties/source/oneOf/0/properties/kind/const",keyword:"const",params:{allowedValue: "system"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/0/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
var _valid0 = _errs12 === errors;
if(_valid0){
valid2 = true;
passing0 = 0;
var props0 = true;
}
const _errs16 = errors;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.kind === undefined){
const err22 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/1/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data4.asset === undefined){
const err23 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/1/required",keyword:"required",params:{missingProperty: "asset"},message:"must have required property '"+"asset"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
for(const key2 in data4){
if(!((key2 === "kind") || (key2 === "asset"))){
const err24 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data4.kind !== undefined){
if("embedded" !== data4.kind){
const err25 = {instancePath:instancePath+"/source/kind",schemaPath:"#/properties/source/oneOf/1/properties/kind/const",keyword:"const",params:{allowedValue: "embedded"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data4.asset !== undefined){
let data7 = data4.asset;
if(typeof data7 === "string"){
if(func3(data7) > 128){
const err26 = {instancePath:instancePath+"/source/asset",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(func3(data7) < 1){
const err27 = {instancePath:instancePath+"/source/asset",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(!pattern4.test(data7)){
const err28 = {instancePath:instancePath+"/source/asset",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
else {
const err29 = {instancePath:instancePath+"/source/asset",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
else {
const err30 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
var _valid0 = _errs16 === errors;
if(_valid0 && valid2){
valid2 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid2 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid2){
const err31 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
else {
errors = _errs11;
if(vErrors !== null){
if(_errs11){
vErrors.length = _errs11;
}
else {
vErrors = null;
}
}
}
}
if(data.license !== undefined){
let data8 = data.license;
if(data8 && typeof data8 == "object" && !Array.isArray(data8)){
if(data8.spdx === undefined){
const err32 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/required",keyword:"required",params:{missingProperty: "spdx"},message:"must have required property '"+"spdx"+"'"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data8.embedding === undefined){
const err33 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/required",keyword:"required",params:{missingProperty: "embedding"},message:"must have required property '"+"embedding"+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
for(const key3 in data8){
if(!(((key3 === "spdx") || (key3 === "embedding")) || (key3 === "notice"))){
const err34 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data8.spdx !== undefined){
let data9 = data8.spdx;
if(typeof data9 === "string"){
if(func3(data9) > 128){
const err35 = {instancePath:instancePath+"/license/spdx",schemaPath:"#/properties/license/properties/spdx/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(func3(data9) < 1){
const err36 = {instancePath:instancePath+"/license/spdx",schemaPath:"#/properties/license/properties/spdx/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
else {
const err37 = {instancePath:instancePath+"/license/spdx",schemaPath:"#/properties/license/properties/spdx/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data8.embedding !== undefined){
let data10 = data8.embedding;
if(!(((((data10 === "installable") || (data10 === "editable")) || (data10 === "preview-print")) || (data10 === "restricted")) || (data10 === "unknown"))){
const err38 = {instancePath:instancePath+"/license/embedding",schemaPath:"#/properties/license/properties/embedding/enum",keyword:"enum",params:{allowedValues: schema37.properties.license.properties.embedding.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data8.notice !== undefined){
let data11 = data8.notice;
if(typeof data11 === "string"){
if(func3(data11) > 4096){
const err39 = {instancePath:instancePath+"/license/notice",schemaPath:"#/properties/license/properties/notice/maxLength",keyword:"maxLength",params:{limit: 4096},message:"must NOT have more than 4096 characters"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
else {
const err40 = {instancePath:instancePath+"/license/notice",schemaPath:"#/properties/license/properties/notice/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
else {
const err41 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
}
else {
const err42 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
validate71.errors = vErrors;
return errors === 0;
}
validate71.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema40 = {"type":"object","additionalProperties":false,"required":["id","digest","mediaType","byteLength","data"],"properties":{"id":{"$ref":"#/$defs/id"},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"mediaType":{"enum":["image/png","image/jpeg","image/webp","font/woff2","font/woff","font/ttf","font/otf"]},"byteLength":{"type":"integer","minimum":0,"maximum":536870912},"data":{"type":"string","contentEncoding":"base64","maxLength":715827884}}};
const pattern9 = new RegExp("^sha256:[0-9a-f]{64}$", "u");

function validate73(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate73.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.digest === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.mediaType === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "mediaType"},message:"must have required property '"+"mediaType"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.byteLength === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.data === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "data"},message:"must have required property '"+"data"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "id") || (key0 === "digest")) || (key0 === "mediaType")) || (key0 === "byteLength")) || (key0 === "data"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(func3(data0) < 1){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!pattern4.test(data0)){
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.digest !== undefined){
let data1 = data.digest;
if(typeof data1 === "string"){
if(!pattern9.test(data1)){
const err10 = {instancePath:instancePath+"/digest",schemaPath:"#/properties/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/digest",schemaPath:"#/properties/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.mediaType !== undefined){
let data2 = data.mediaType;
if(!(((((((data2 === "image/png") || (data2 === "image/jpeg")) || (data2 === "image/webp")) || (data2 === "font/woff2")) || (data2 === "font/woff")) || (data2 === "font/ttf")) || (data2 === "font/otf"))){
const err12 = {instancePath:instancePath+"/mediaType",schemaPath:"#/properties/mediaType/enum",keyword:"enum",params:{allowedValues: schema40.properties.mediaType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.byteLength !== undefined){
let data3 = data.byteLength;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err13 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 536870912 || isNaN(data3)){
const err14 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 536870912},message:"must be <= 536870912"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data3 < 0 || isNaN(data3)){
const err15 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
if(data.data !== undefined){
let data4 = data.data;
if(typeof data4 === "string"){
if(func3(data4) > 715827884){
const err16 = {instancePath:instancePath+"/data",schemaPath:"#/properties/data/maxLength",keyword:"maxLength",params:{limit: 715827884},message:"must NOT have more than 715827884 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/data",schemaPath:"#/properties/data/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
else {
const err18 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
validate73.errors = vErrors;
return errors === 0;
}
validate73.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema42 = {"oneOf":[{"$ref":"#/$defs/groupNode"},{"$ref":"#/$defs/textNode"},{"$ref":"#/$defs/vectorNode"},{"$ref":"#/$defs/imageNode"}]};
const schema43 = {"type":"object","allOf":[{"$ref":"#/$defs/nodeCommon"},{"type":"object","required":["children"],"properties":{"type":{"const":"group"},"children":{"type":"array","maxItems":4096,"items":{"$ref":"#/$defs/node"}}}}],"unevaluatedProperties":false};
const schema44 = {"type":"object","required":["id","type","name"],"properties":{"id":{"$ref":"#/$defs/id"},"type":{"type":"string"},"name":{"$ref":"#/$defs/name"},"role":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"visible":{"type":"boolean","default":true},"opacity":{"$ref":"#/$defs/unit","default":1},"fillOpacity":{"$ref":"#/$defs/unit","default":1},"blendMode":{"$ref":"#/$defs/blendMode"},"locked":{"type":"boolean","default":false},"clipping":{"type":"boolean","default":false},"transform":{"$ref":"#/$defs/transform"},"extensions":{"$ref":"#/$defs/extensions"}}};
const schema47 = {"type":"number","minimum":0,"maximum":1};
const schema49 = {"enum":["normal","multiply","screen","overlay","darken","lighten","color-dodge","color-burn","hard-light","soft-light","difference","exclusion"],"default":"normal"};
const schema50 = {"type":"object","additionalProperties":false,"properties":{"x":{"$ref":"#/$defs/finite","default":0},"y":{"$ref":"#/$defs/finite","default":0},"rotation":{"$ref":"#/$defs/finite","default":0},"scaleX":{"$ref":"#/$defs/finite","default":1},"scaleY":{"$ref":"#/$defs/finite","default":1},"skewX":{"$ref":"#/$defs/finite","default":0}}};
const schema51 = {"type":"number","minimum":-1000000,"maximum":1000000};

function validate31(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate31.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if(!((((((key0 === "x") || (key0 === "y")) || (key0 === "rotation")) || (key0 === "scaleX")) || (key0 === "scaleY")) || (key0 === "skewX"))){
const err0 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
if(data.x !== undefined){
let data0 = data.x;
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 1000000 || isNaN(data0)){
const err1 = {instancePath:instancePath+"/x",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data0 < -1000000 || isNaN(data0)){
const err2 = {instancePath:instancePath+"/x",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
else {
const err3 = {instancePath:instancePath+"/x",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.y !== undefined){
let data1 = data.y;
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 1000000 || isNaN(data1)){
const err4 = {instancePath:instancePath+"/y",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data1 < -1000000 || isNaN(data1)){
const err5 = {instancePath:instancePath+"/y",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/y",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.rotation !== undefined){
let data2 = data.rotation;
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000000 || isNaN(data2)){
const err7 = {instancePath:instancePath+"/rotation",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data2 < -1000000 || isNaN(data2)){
const err8 = {instancePath:instancePath+"/rotation",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/rotation",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.scaleX !== undefined){
let data3 = data.scaleX;
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 1000000 || isNaN(data3)){
const err10 = {instancePath:instancePath+"/scaleX",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data3 < -1000000 || isNaN(data3)){
const err11 = {instancePath:instancePath+"/scaleX",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/scaleX",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.scaleY !== undefined){
let data4 = data.scaleY;
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 1000000 || isNaN(data4)){
const err13 = {instancePath:instancePath+"/scaleY",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data4 < -1000000 || isNaN(data4)){
const err14 = {instancePath:instancePath+"/scaleY",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/scaleY",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.skewX !== undefined){
let data5 = data.skewX;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 1000000 || isNaN(data5)){
const err16 = {instancePath:instancePath+"/skewX",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data5 < -1000000 || isNaN(data5)){
const err17 = {instancePath:instancePath+"/skewX",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/skewX",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
validate31.errors = vErrors;
return errors === 0;
}
validate31.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate30(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate30.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.type === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.name === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err3 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func3(data0) < 1){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern4.test(data0)){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.type !== undefined){
if(typeof data.type !== "string"){
const err7 = {instancePath:instancePath+"/type",schemaPath:"#/properties/type/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.name !== undefined){
let data2 = data.name;
if(typeof data2 === "string"){
if(func3(data2) > 256){
const err8 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/name/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func3(data2) < 1){
const err9 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.role !== undefined){
let data3 = data.role;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err11 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(func3(data3) < 1){
const err12 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(!pattern4.test(data3)){
const err13 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.visible !== undefined){
if(typeof data.visible !== "boolean"){
const err15 = {instancePath:instancePath+"/visible",schemaPath:"#/properties/visible/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.opacity !== undefined){
let data5 = data.opacity;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 1 || isNaN(data5)){
const err16 = {instancePath:instancePath+"/opacity",schemaPath:"#/$defs/unit/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data5 < 0 || isNaN(data5)){
const err17 = {instancePath:instancePath+"/opacity",schemaPath:"#/$defs/unit/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/opacity",schemaPath:"#/$defs/unit/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.fillOpacity !== undefined){
let data6 = data.fillOpacity;
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 > 1 || isNaN(data6)){
const err19 = {instancePath:instancePath+"/fillOpacity",schemaPath:"#/$defs/unit/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data6 < 0 || isNaN(data6)){
const err20 = {instancePath:instancePath+"/fillOpacity",schemaPath:"#/$defs/unit/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/fillOpacity",schemaPath:"#/$defs/unit/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.blendMode !== undefined){
let data7 = data.blendMode;
if(!((((((((((((data7 === "normal") || (data7 === "multiply")) || (data7 === "screen")) || (data7 === "overlay")) || (data7 === "darken")) || (data7 === "lighten")) || (data7 === "color-dodge")) || (data7 === "color-burn")) || (data7 === "hard-light")) || (data7 === "soft-light")) || (data7 === "difference")) || (data7 === "exclusion"))){
const err22 = {instancePath:instancePath+"/blendMode",schemaPath:"#/$defs/blendMode/enum",keyword:"enum",params:{allowedValues: schema49.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.locked !== undefined){
if(typeof data.locked !== "boolean"){
const err23 = {instancePath:instancePath+"/locked",schemaPath:"#/properties/locked/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.clipping !== undefined){
if(typeof data.clipping !== "boolean"){
const err24 = {instancePath:instancePath+"/clipping",schemaPath:"#/properties/clipping/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.transform !== undefined){
if(!(validate31(data.transform, {instancePath:instancePath+"/transform",parentData:data,parentDataProperty:"transform",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate31.errors : vErrors.concat(validate31.errors);
errors = vErrors.length;
}
}
if(data.extensions !== undefined){
let data11 = data.extensions;
if(data11 && typeof data11 == "object" && !Array.isArray(data11)){
if(Object.keys(data11).length > 64){
const err25 = {instancePath:instancePath+"/extensions",schemaPath:"#/$defs/extensions/maxProperties",keyword:"maxProperties",params:{limit: 64},message:"must NOT have more than 64 properties"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
for(const key0 in data11){
const _errs29 = errors;
if(typeof key0 === "string"){
if(!pattern12.test(key0)){
const err26 = {instancePath:instancePath+"/extensions",schemaPath:"#/$defs/extensions/propertyNames/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},message:"must match pattern \""+"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"+"\"",propertyName:key0};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
var valid7 = _errs29 === errors;
if(!valid7){
const err27 = {instancePath:instancePath+"/extensions",schemaPath:"#/$defs/extensions/propertyNames",keyword:"propertyNames",params:{propertyName: key0},message:"property name must be valid"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath:instancePath+"/extensions",schemaPath:"#/$defs/extensions/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
}
else {
const err29 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
validate30.errors = vErrors;
return errors === 0;
}
validate30.evaluated = {"props":{"id":true,"type":true,"name":true,"role":true,"visible":true,"opacity":true,"fillOpacity":true,"blendMode":true,"locked":true,"clipping":true,"transform":true,"extensions":true},"dynamicProps":false,"dynamicItems":false};

const wrapper0 = {validate: validate28};
const schema58 = {"type":"object","allOf":[{"$ref":"#/$defs/nodeCommon"},{"type":"object","required":["text","frame","style"],"properties":{"type":{"const":"text"},"text":{"type":"string","maxLength":1000000},"frame":{"type":"object","additionalProperties":false,"required":["width","height"],"properties":{"width":{"$ref":"#/$defs/positiveLength"},"height":{"$ref":"#/$defs/positiveLength"},"autoHeight":{"type":"boolean","default":false}}},"style":{"type":"object","additionalProperties":false,"required":["fontFamily","fontWeight","fontSize","lineHeight","letterSpacing","textAlign","color"],"properties":{"fontRef":{"$ref":"#/$defs/id"},"fontFamily":{"type":"string","minLength":1,"maxLength":256},"fontWeight":{"type":"integer","minimum":1,"maximum":1000},"fontSize":{"type":"number","exclusiveMinimum":0,"maximum":4096},"lineHeight":{"type":"number","minimum":0.25,"maximum":20},"letterSpacing":{"type":"number","minimum":-4096,"maximum":4096},"textAlign":{"enum":["left","center","right"]},"color":{"$ref":"#/$defs/color"}}}}}],"unevaluatedProperties":false};
const schema59 = {"type":"number","exclusiveMinimum":0,"maximum":32768};

function validate35(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate35.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate30(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate30.errors : vErrors.concat(validate30.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.text === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "text"},message:"must have required property '"+"text"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.frame === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "frame"},message:"must have required property '"+"frame"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.style === undefined){
const err2 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "style"},message:"must have required property '"+"style"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.type !== undefined){
if("text" !== data.type){
const err3 = {instancePath:instancePath+"/type",schemaPath:"#/allOf/1/properties/type/const",keyword:"const",params:{allowedValue: "text"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.text !== undefined){
let data1 = data.text;
if(typeof data1 === "string"){
if(func3(data1) > 1000000){
const err4 = {instancePath:instancePath+"/text",schemaPath:"#/allOf/1/properties/text/maxLength",keyword:"maxLength",params:{limit: 1000000},message:"must NOT have more than 1000000 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/text",schemaPath:"#/allOf/1/properties/text/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.frame !== undefined){
let data2 = data.frame;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.width === undefined){
const err6 = {instancePath:instancePath+"/frame",schemaPath:"#/allOf/1/properties/frame/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2.height === undefined){
const err7 = {instancePath:instancePath+"/frame",schemaPath:"#/allOf/1/properties/frame/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data2){
if(!(((key0 === "width") || (key0 === "height")) || (key0 === "autoHeight"))){
const err8 = {instancePath:instancePath+"/frame",schemaPath:"#/allOf/1/properties/frame/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data2.width !== undefined){
let data3 = data2.width;
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 32768 || isNaN(data3)){
const err9 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/positiveLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data3 <= 0 || isNaN(data3)){
const err10 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/positiveLength/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/positiveLength/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data2.height !== undefined){
let data4 = data2.height;
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 32768 || isNaN(data4)){
const err12 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/positiveLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data4 <= 0 || isNaN(data4)){
const err13 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/positiveLength/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/positiveLength/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data2.autoHeight !== undefined){
if(typeof data2.autoHeight !== "boolean"){
const err15 = {instancePath:instancePath+"/frame/autoHeight",schemaPath:"#/allOf/1/properties/frame/properties/autoHeight/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath:instancePath+"/frame",schemaPath:"#/allOf/1/properties/frame/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.style !== undefined){
let data6 = data.style;
if(data6 && typeof data6 == "object" && !Array.isArray(data6)){
if(data6.fontFamily === undefined){
const err17 = {instancePath:instancePath+"/style",schemaPath:"#/allOf/1/properties/style/required",keyword:"required",params:{missingProperty: "fontFamily"},message:"must have required property '"+"fontFamily"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data6.fontWeight === undefined){
const err18 = {instancePath:instancePath+"/style",schemaPath:"#/allOf/1/properties/style/required",keyword:"required",params:{missingProperty: "fontWeight"},message:"must have required property '"+"fontWeight"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data6.fontSize === undefined){
const err19 = {instancePath:instancePath+"/style",schemaPath:"#/allOf/1/properties/style/required",keyword:"required",params:{missingProperty: "fontSize"},message:"must have required property '"+"fontSize"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data6.lineHeight === undefined){
const err20 = {instancePath:instancePath+"/style",schemaPath:"#/allOf/1/properties/style/required",keyword:"required",params:{missingProperty: "lineHeight"},message:"must have required property '"+"lineHeight"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data6.letterSpacing === undefined){
const err21 = {instancePath:instancePath+"/style",schemaPath:"#/allOf/1/properties/style/required",keyword:"required",params:{missingProperty: "letterSpacing"},message:"must have required property '"+"letterSpacing"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data6.textAlign === undefined){
const err22 = {instancePath:instancePath+"/style",schemaPath:"#/allOf/1/properties/style/required",keyword:"required",params:{missingProperty: "textAlign"},message:"must have required property '"+"textAlign"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data6.color === undefined){
const err23 = {instancePath:instancePath+"/style",schemaPath:"#/allOf/1/properties/style/required",keyword:"required",params:{missingProperty: "color"},message:"must have required property '"+"color"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
for(const key1 in data6){
if(!((((((((key1 === "fontRef") || (key1 === "fontFamily")) || (key1 === "fontWeight")) || (key1 === "fontSize")) || (key1 === "lineHeight")) || (key1 === "letterSpacing")) || (key1 === "textAlign")) || (key1 === "color"))){
const err24 = {instancePath:instancePath+"/style",schemaPath:"#/allOf/1/properties/style/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data6.fontRef !== undefined){
let data7 = data6.fontRef;
if(typeof data7 === "string"){
if(func3(data7) > 128){
const err25 = {instancePath:instancePath+"/style/fontRef",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(func3(data7) < 1){
const err26 = {instancePath:instancePath+"/style/fontRef",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(!pattern4.test(data7)){
const err27 = {instancePath:instancePath+"/style/fontRef",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
else {
const err28 = {instancePath:instancePath+"/style/fontRef",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data6.fontFamily !== undefined){
let data8 = data6.fontFamily;
if(typeof data8 === "string"){
if(func3(data8) > 256){
const err29 = {instancePath:instancePath+"/style/fontFamily",schemaPath:"#/allOf/1/properties/style/properties/fontFamily/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(func3(data8) < 1){
const err30 = {instancePath:instancePath+"/style/fontFamily",schemaPath:"#/allOf/1/properties/style/properties/fontFamily/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
else {
const err31 = {instancePath:instancePath+"/style/fontFamily",schemaPath:"#/allOf/1/properties/style/properties/fontFamily/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data6.fontWeight !== undefined){
let data9 = data6.fontWeight;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err32 = {instancePath:instancePath+"/style/fontWeight",schemaPath:"#/allOf/1/properties/style/properties/fontWeight/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 > 1000 || isNaN(data9)){
const err33 = {instancePath:instancePath+"/style/fontWeight",schemaPath:"#/allOf/1/properties/style/properties/fontWeight/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000},message:"must be <= 1000"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data9 < 1 || isNaN(data9)){
const err34 = {instancePath:instancePath+"/style/fontWeight",schemaPath:"#/allOf/1/properties/style/properties/fontWeight/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
if(data6.fontSize !== undefined){
let data10 = data6.fontSize;
if((typeof data10 == "number") && (isFinite(data10))){
if(data10 > 4096 || isNaN(data10)){
const err35 = {instancePath:instancePath+"/style/fontSize",schemaPath:"#/allOf/1/properties/style/properties/fontSize/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data10 <= 0 || isNaN(data10)){
const err36 = {instancePath:instancePath+"/style/fontSize",schemaPath:"#/allOf/1/properties/style/properties/fontSize/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
else {
const err37 = {instancePath:instancePath+"/style/fontSize",schemaPath:"#/allOf/1/properties/style/properties/fontSize/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data6.lineHeight !== undefined){
let data11 = data6.lineHeight;
if((typeof data11 == "number") && (isFinite(data11))){
if(data11 > 20 || isNaN(data11)){
const err38 = {instancePath:instancePath+"/style/lineHeight",schemaPath:"#/allOf/1/properties/style/properties/lineHeight/maximum",keyword:"maximum",params:{comparison: "<=", limit: 20},message:"must be <= 20"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if(data11 < 0.25 || isNaN(data11)){
const err39 = {instancePath:instancePath+"/style/lineHeight",schemaPath:"#/allOf/1/properties/style/properties/lineHeight/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0.25},message:"must be >= 0.25"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
else {
const err40 = {instancePath:instancePath+"/style/lineHeight",schemaPath:"#/allOf/1/properties/style/properties/lineHeight/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data6.letterSpacing !== undefined){
let data12 = data6.letterSpacing;
if((typeof data12 == "number") && (isFinite(data12))){
if(data12 > 4096 || isNaN(data12)){
const err41 = {instancePath:instancePath+"/style/letterSpacing",schemaPath:"#/allOf/1/properties/style/properties/letterSpacing/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data12 < -4096 || isNaN(data12)){
const err42 = {instancePath:instancePath+"/style/letterSpacing",schemaPath:"#/allOf/1/properties/style/properties/letterSpacing/minimum",keyword:"minimum",params:{comparison: ">=", limit: -4096},message:"must be >= -4096"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
else {
const err43 = {instancePath:instancePath+"/style/letterSpacing",schemaPath:"#/allOf/1/properties/style/properties/letterSpacing/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data6.textAlign !== undefined){
let data13 = data6.textAlign;
if(!(((data13 === "left") || (data13 === "center")) || (data13 === "right"))){
const err44 = {instancePath:instancePath+"/style/textAlign",schemaPath:"#/allOf/1/properties/style/properties/textAlign/enum",keyword:"enum",params:{allowedValues: schema58.allOf[1].properties.style.properties.textAlign.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
if(data6.color !== undefined){
let data14 = data6.color;
if(typeof data14 === "string"){
if(!pattern5.test(data14)){
const err45 = {instancePath:instancePath+"/style/color",schemaPath:"#/$defs/color/pattern",keyword:"pattern",params:{pattern: "^#[0-9A-Fa-f]{6}$"},message:"must match pattern \""+"^#[0-9A-Fa-f]{6}$"+"\""};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
else {
const err46 = {instancePath:instancePath+"/style/color",schemaPath:"#/$defs/color/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
}
else {
const err47 = {instancePath:instancePath+"/style",schemaPath:"#/allOf/1/properties/style/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
}
else {
const err48 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key2 in data){
if(((((((((((((((key2 !== "type") && (key2 !== "text")) && (key2 !== "frame")) && (key2 !== "style")) && (key2 !== "id")) && (key2 !== "name")) && (key2 !== "role")) && (key2 !== "visible")) && (key2 !== "opacity")) && (key2 !== "fillOpacity")) && (key2 !== "blendMode")) && (key2 !== "locked")) && (key2 !== "clipping")) && (key2 !== "transform")) && (key2 !== "extensions")){
const err49 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key2},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
}
else {
const err50 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
validate35.errors = vErrors;
return errors === 0;
}
validate35.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema63 = {"type":"object","allOf":[{"$ref":"#/$defs/nodeCommon"},{"type":"object","required":["objects"],"properties":{"type":{"const":"vector"},"objects":{"type":"array","minItems":1,"maxItems":100000,"items":{"$ref":"#/$defs/vectorObject"}}}}],"unevaluatedProperties":false};
const schema64 = {"oneOf":[{"$ref":"#/$defs/rectangleObject"},{"$ref":"#/$defs/ellipseObject"},{"$ref":"#/$defs/pathObject"}]};
const schema65 = {"type":"object","allOf":[{"$ref":"#/$defs/vectorObjectCommon"},{"type":"object","required":["geometry"],"properties":{"type":{"const":"rectangle"},"geometry":{"type":"object","additionalProperties":false,"required":["x","y","width","height","radius"],"properties":{"x":{"$ref":"#/$defs/finite"},"y":{"$ref":"#/$defs/finite"},"width":{"$ref":"#/$defs/finite"},"height":{"$ref":"#/$defs/finite"},"radius":{"type":"object","additionalProperties":false,"required":["topLeft","topRight","bottomRight","bottomLeft"],"properties":{"topLeft":{"type":"number","minimum":0,"maximum":32768},"topRight":{"type":"number","minimum":0,"maximum":32768},"bottomRight":{"type":"number","minimum":0,"maximum":32768},"bottomLeft":{"type":"number","minimum":0,"maximum":32768}}}}}}}],"unevaluatedProperties":false};
const schema66 = {"type":"object","required":["id","type","name"],"properties":{"id":{"$ref":"#/$defs/id"},"type":{"type":"string"},"name":{"$ref":"#/$defs/name"},"role":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"visible":{"type":"boolean","default":true},"opacity":{"$ref":"#/$defs/unit","default":1},"transform":{"$ref":"#/$defs/transform"},"fill":{"oneOf":[{"$ref":"#/$defs/solidPaint"},{"type":"null"}],"default":null},"stroke":{"oneOf":[{"$ref":"#/$defs/stroke"},{"type":"null"}],"default":null},"extensions":{"$ref":"#/$defs/extensions"}}};
const schema70 = {"type":"object","additionalProperties":false,"required":["type","color"],"properties":{"type":{"const":"solid"},"color":{"$ref":"#/$defs/color"},"opacity":{"$ref":"#/$defs/unit","default":1}}};

function validate44(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate44.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.type === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.color === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "color"},message:"must have required property '"+"color"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "type") || (key0 === "color")) || (key0 === "opacity"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.type !== undefined){
if("solid" !== data.type){
const err3 = {instancePath:instancePath+"/type",schemaPath:"#/properties/type/const",keyword:"const",params:{allowedValue: "solid"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.color !== undefined){
let data1 = data.color;
if(typeof data1 === "string"){
if(!pattern5.test(data1)){
const err4 = {instancePath:instancePath+"/color",schemaPath:"#/$defs/color/pattern",keyword:"pattern",params:{pattern: "^#[0-9A-Fa-f]{6}$"},message:"must match pattern \""+"^#[0-9A-Fa-f]{6}$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/color",schemaPath:"#/$defs/color/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.opacity !== undefined){
let data2 = data.opacity;
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1 || isNaN(data2)){
const err6 = {instancePath:instancePath+"/opacity",schemaPath:"#/$defs/unit/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2 < 0 || isNaN(data2)){
const err7 = {instancePath:instancePath+"/opacity",schemaPath:"#/$defs/unit/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/opacity",schemaPath:"#/$defs/unit/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate44.errors = vErrors;
return errors === 0;
}
validate44.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema73 = {"type":"object","additionalProperties":false,"required":["paint","width","lineCap","lineJoin","dash"],"properties":{"paint":{"$ref":"#/$defs/solidPaint"},"width":{"type":"number","minimum":0,"maximum":32768},"lineCap":{"enum":["butt","round","square"]},"lineJoin":{"enum":["miter","round","bevel"]},"dash":{"type":"array","maxItems":128,"items":{"type":"number","minimum":0,"maximum":32768}}}};

function validate46(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate46.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.paint === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "paint"},message:"must have required property '"+"paint"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.width === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.lineCap === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "lineCap"},message:"must have required property '"+"lineCap"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.lineJoin === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "lineJoin"},message:"must have required property '"+"lineJoin"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.dash === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dash"},message:"must have required property '"+"dash"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "paint") || (key0 === "width")) || (key0 === "lineCap")) || (key0 === "lineJoin")) || (key0 === "dash"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.paint !== undefined){
if(!(validate44(data.paint, {instancePath:instancePath+"/paint",parentData:data,parentDataProperty:"paint",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
errors = vErrors.length;
}
}
if(data.width !== undefined){
let data1 = data.width;
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 32768 || isNaN(data1)){
const err6 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data1 < 0 || isNaN(data1)){
const err7 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.lineCap !== undefined){
let data2 = data.lineCap;
if(!(((data2 === "butt") || (data2 === "round")) || (data2 === "square"))){
const err9 = {instancePath:instancePath+"/lineCap",schemaPath:"#/properties/lineCap/enum",keyword:"enum",params:{allowedValues: schema73.properties.lineCap.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.lineJoin !== undefined){
let data3 = data.lineJoin;
if(!(((data3 === "miter") || (data3 === "round")) || (data3 === "bevel"))){
const err10 = {instancePath:instancePath+"/lineJoin",schemaPath:"#/properties/lineJoin/enum",keyword:"enum",params:{allowedValues: schema73.properties.lineJoin.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.dash !== undefined){
let data4 = data.dash;
if(Array.isArray(data4)){
if(data4.length > 128){
const err11 = {instancePath:instancePath+"/dash",schemaPath:"#/properties/dash/maxItems",keyword:"maxItems",params:{limit: 128},message:"must NOT have more than 128 items"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
const len0 = data4.length;
for(let i0=0; i0<len0; i0++){
let data5 = data4[i0];
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 32768 || isNaN(data5)){
const err12 = {instancePath:instancePath+"/dash/" + i0,schemaPath:"#/properties/dash/items/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data5 < 0 || isNaN(data5)){
const err13 = {instancePath:instancePath+"/dash/" + i0,schemaPath:"#/properties/dash/items/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/dash/" + i0,schemaPath:"#/properties/dash/items/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath:instancePath+"/dash",schemaPath:"#/properties/dash/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate46.errors = vErrors;
return errors === 0;
}
validate46.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate42(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate42.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.type === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.name === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err3 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func3(data0) < 1){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern4.test(data0)){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.type !== undefined){
if(typeof data.type !== "string"){
const err7 = {instancePath:instancePath+"/type",schemaPath:"#/properties/type/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.name !== undefined){
let data2 = data.name;
if(typeof data2 === "string"){
if(func3(data2) > 256){
const err8 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/name/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func3(data2) < 1){
const err9 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.role !== undefined){
let data3 = data.role;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err11 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(func3(data3) < 1){
const err12 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(!pattern4.test(data3)){
const err13 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.visible !== undefined){
if(typeof data.visible !== "boolean"){
const err15 = {instancePath:instancePath+"/visible",schemaPath:"#/properties/visible/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.opacity !== undefined){
let data5 = data.opacity;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 1 || isNaN(data5)){
const err16 = {instancePath:instancePath+"/opacity",schemaPath:"#/$defs/unit/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data5 < 0 || isNaN(data5)){
const err17 = {instancePath:instancePath+"/opacity",schemaPath:"#/$defs/unit/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/opacity",schemaPath:"#/$defs/unit/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.transform !== undefined){
if(!(validate31(data.transform, {instancePath:instancePath+"/transform",parentData:data,parentDataProperty:"transform",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate31.errors : vErrors.concat(validate31.errors);
errors = vErrors.length;
}
}
if(data.fill !== undefined){
let data7 = data.fill;
const _errs18 = errors;
let valid4 = false;
let passing0 = null;
const _errs19 = errors;
if(!(validate44(data7, {instancePath:instancePath+"/fill",parentData:data,parentDataProperty:"fill",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
errors = vErrors.length;
}
var _valid0 = _errs19 === errors;
if(_valid0){
valid4 = true;
passing0 = 0;
}
const _errs20 = errors;
if(data7 !== null){
const err19 = {instancePath:instancePath+"/fill",schemaPath:"#/properties/fill/oneOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
var _valid0 = _errs20 === errors;
if(_valid0 && valid4){
valid4 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid4 = true;
passing0 = 1;
}
}
if(!valid4){
const err20 = {instancePath:instancePath+"/fill",schemaPath:"#/properties/fill/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
else {
errors = _errs18;
if(vErrors !== null){
if(_errs18){
vErrors.length = _errs18;
}
else {
vErrors = null;
}
}
}
}
if(data.stroke !== undefined){
let data8 = data.stroke;
const _errs23 = errors;
let valid5 = false;
let passing1 = null;
const _errs24 = errors;
if(!(validate46(data8, {instancePath:instancePath+"/stroke",parentData:data,parentDataProperty:"stroke",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate46.errors : vErrors.concat(validate46.errors);
errors = vErrors.length;
}
var _valid1 = _errs24 === errors;
if(_valid1){
valid5 = true;
passing1 = 0;
}
const _errs25 = errors;
if(data8 !== null){
const err21 = {instancePath:instancePath+"/stroke",schemaPath:"#/properties/stroke/oneOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
var _valid1 = _errs25 === errors;
if(_valid1 && valid5){
valid5 = false;
passing1 = [passing1, 1];
}
else {
if(_valid1){
valid5 = true;
passing1 = 1;
}
}
if(!valid5){
const err22 = {instancePath:instancePath+"/stroke",schemaPath:"#/properties/stroke/oneOf",keyword:"oneOf",params:{passingSchemas: passing1},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
else {
errors = _errs23;
if(vErrors !== null){
if(_errs23){
vErrors.length = _errs23;
}
else {
vErrors = null;
}
}
}
}
if(data.extensions !== undefined){
let data9 = data.extensions;
if(data9 && typeof data9 == "object" && !Array.isArray(data9)){
if(Object.keys(data9).length > 64){
const err23 = {instancePath:instancePath+"/extensions",schemaPath:"#/$defs/extensions/maxProperties",keyword:"maxProperties",params:{limit: 64},message:"must NOT have more than 64 properties"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
for(const key0 in data9){
const _errs30 = errors;
if(typeof key0 === "string"){
if(!pattern12.test(key0)){
const err24 = {instancePath:instancePath+"/extensions",schemaPath:"#/$defs/extensions/propertyNames/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},message:"must match pattern \""+"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"+"\"",propertyName:key0};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
var valid7 = _errs30 === errors;
if(!valid7){
const err25 = {instancePath:instancePath+"/extensions",schemaPath:"#/$defs/extensions/propertyNames",keyword:"propertyNames",params:{propertyName: key0},message:"property name must be valid"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
}
else {
const err26 = {instancePath:instancePath+"/extensions",schemaPath:"#/$defs/extensions/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
else {
const err27 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
validate42.errors = vErrors;
return errors === 0;
}
validate42.evaluated = {"props":{"id":true,"type":true,"name":true,"role":true,"visible":true,"opacity":true,"transform":true,"fill":true,"stroke":true,"extensions":true},"dynamicProps":false,"dynamicItems":false};


function validate41(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate41.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate42(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate42.errors : vErrors.concat(validate42.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.geometry === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "geometry"},message:"must have required property '"+"geometry"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.type !== undefined){
if("rectangle" !== data.type){
const err1 = {instancePath:instancePath+"/type",schemaPath:"#/allOf/1/properties/type/const",keyword:"const",params:{allowedValue: "rectangle"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.geometry !== undefined){
let data1 = data.geometry;
if(data1 && typeof data1 == "object" && !Array.isArray(data1)){
if(data1.x === undefined){
const err2 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data1.y === undefined){
const err3 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data1.width === undefined){
const err4 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data1.height === undefined){
const err5 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data1.radius === undefined){
const err6 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/required",keyword:"required",params:{missingProperty: "radius"},message:"must have required property '"+"radius"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data1){
if(!(((((key0 === "x") || (key0 === "y")) || (key0 === "width")) || (key0 === "height")) || (key0 === "radius"))){
const err7 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data1.x !== undefined){
let data2 = data1.x;
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000000 || isNaN(data2)){
const err8 = {instancePath:instancePath+"/geometry/x",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data2 < -1000000 || isNaN(data2)){
const err9 = {instancePath:instancePath+"/geometry/x",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/geometry/x",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data1.y !== undefined){
let data3 = data1.y;
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 1000000 || isNaN(data3)){
const err11 = {instancePath:instancePath+"/geometry/y",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data3 < -1000000 || isNaN(data3)){
const err12 = {instancePath:instancePath+"/geometry/y",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/geometry/y",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data1.width !== undefined){
let data4 = data1.width;
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 1000000 || isNaN(data4)){
const err14 = {instancePath:instancePath+"/geometry/width",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data4 < -1000000 || isNaN(data4)){
const err15 = {instancePath:instancePath+"/geometry/width",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/geometry/width",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data1.height !== undefined){
let data5 = data1.height;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 1000000 || isNaN(data5)){
const err17 = {instancePath:instancePath+"/geometry/height",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data5 < -1000000 || isNaN(data5)){
const err18 = {instancePath:instancePath+"/geometry/height",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/geometry/height",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data1.radius !== undefined){
let data6 = data1.radius;
if(data6 && typeof data6 == "object" && !Array.isArray(data6)){
if(data6.topLeft === undefined){
const err20 = {instancePath:instancePath+"/geometry/radius",schemaPath:"#/allOf/1/properties/geometry/properties/radius/required",keyword:"required",params:{missingProperty: "topLeft"},message:"must have required property '"+"topLeft"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data6.topRight === undefined){
const err21 = {instancePath:instancePath+"/geometry/radius",schemaPath:"#/allOf/1/properties/geometry/properties/radius/required",keyword:"required",params:{missingProperty: "topRight"},message:"must have required property '"+"topRight"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data6.bottomRight === undefined){
const err22 = {instancePath:instancePath+"/geometry/radius",schemaPath:"#/allOf/1/properties/geometry/properties/radius/required",keyword:"required",params:{missingProperty: "bottomRight"},message:"must have required property '"+"bottomRight"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data6.bottomLeft === undefined){
const err23 = {instancePath:instancePath+"/geometry/radius",schemaPath:"#/allOf/1/properties/geometry/properties/radius/required",keyword:"required",params:{missingProperty: "bottomLeft"},message:"must have required property '"+"bottomLeft"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
for(const key1 in data6){
if(!((((key1 === "topLeft") || (key1 === "topRight")) || (key1 === "bottomRight")) || (key1 === "bottomLeft"))){
const err24 = {instancePath:instancePath+"/geometry/radius",schemaPath:"#/allOf/1/properties/geometry/properties/radius/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data6.topLeft !== undefined){
let data7 = data6.topLeft;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 32768 || isNaN(data7)){
const err25 = {instancePath:instancePath+"/geometry/radius/topLeft",schemaPath:"#/allOf/1/properties/geometry/properties/radius/properties/topLeft/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data7 < 0 || isNaN(data7)){
const err26 = {instancePath:instancePath+"/geometry/radius/topLeft",schemaPath:"#/allOf/1/properties/geometry/properties/radius/properties/topLeft/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/geometry/radius/topLeft",schemaPath:"#/allOf/1/properties/geometry/properties/radius/properties/topLeft/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data6.topRight !== undefined){
let data8 = data6.topRight;
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 32768 || isNaN(data8)){
const err28 = {instancePath:instancePath+"/geometry/radius/topRight",schemaPath:"#/allOf/1/properties/geometry/properties/radius/properties/topRight/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data8 < 0 || isNaN(data8)){
const err29 = {instancePath:instancePath+"/geometry/radius/topRight",schemaPath:"#/allOf/1/properties/geometry/properties/radius/properties/topRight/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/geometry/radius/topRight",schemaPath:"#/allOf/1/properties/geometry/properties/radius/properties/topRight/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data6.bottomRight !== undefined){
let data9 = data6.bottomRight;
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 > 32768 || isNaN(data9)){
const err31 = {instancePath:instancePath+"/geometry/radius/bottomRight",schemaPath:"#/allOf/1/properties/geometry/properties/radius/properties/bottomRight/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data9 < 0 || isNaN(data9)){
const err32 = {instancePath:instancePath+"/geometry/radius/bottomRight",schemaPath:"#/allOf/1/properties/geometry/properties/radius/properties/bottomRight/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/geometry/radius/bottomRight",schemaPath:"#/allOf/1/properties/geometry/properties/radius/properties/bottomRight/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data6.bottomLeft !== undefined){
let data10 = data6.bottomLeft;
if((typeof data10 == "number") && (isFinite(data10))){
if(data10 > 32768 || isNaN(data10)){
const err34 = {instancePath:instancePath+"/geometry/radius/bottomLeft",schemaPath:"#/allOf/1/properties/geometry/properties/radius/properties/bottomLeft/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data10 < 0 || isNaN(data10)){
const err35 = {instancePath:instancePath+"/geometry/radius/bottomLeft",schemaPath:"#/allOf/1/properties/geometry/properties/radius/properties/bottomLeft/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
else {
const err36 = {instancePath:instancePath+"/geometry/radius/bottomLeft",schemaPath:"#/allOf/1/properties/geometry/properties/radius/properties/bottomLeft/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
else {
const err37 = {instancePath:instancePath+"/geometry/radius",schemaPath:"#/allOf/1/properties/geometry/properties/radius/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
else {
const err38 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
}
else {
const err39 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key2 in data){
if(((((((((((key2 !== "type") && (key2 !== "geometry")) && (key2 !== "id")) && (key2 !== "name")) && (key2 !== "role")) && (key2 !== "visible")) && (key2 !== "opacity")) && (key2 !== "transform")) && (key2 !== "fill")) && (key2 !== "stroke")) && (key2 !== "extensions")){
const err40 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key2},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
else {
const err41 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
validate41.errors = vErrors;
return errors === 0;
}
validate41.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema79 = {"type":"object","allOf":[{"$ref":"#/$defs/vectorObjectCommon"},{"type":"object","required":["geometry"],"properties":{"type":{"const":"ellipse"},"geometry":{"type":"object","additionalProperties":false,"required":["x","y","width","height"],"properties":{"x":{"$ref":"#/$defs/finite"},"y":{"$ref":"#/$defs/finite"},"width":{"$ref":"#/$defs/finite"},"height":{"$ref":"#/$defs/finite"}}}}}],"unevaluatedProperties":false};

function validate51(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate51.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate42(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate42.errors : vErrors.concat(validate42.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.geometry === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "geometry"},message:"must have required property '"+"geometry"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.type !== undefined){
if("ellipse" !== data.type){
const err1 = {instancePath:instancePath+"/type",schemaPath:"#/allOf/1/properties/type/const",keyword:"const",params:{allowedValue: "ellipse"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.geometry !== undefined){
let data1 = data.geometry;
if(data1 && typeof data1 == "object" && !Array.isArray(data1)){
if(data1.x === undefined){
const err2 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data1.y === undefined){
const err3 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data1.width === undefined){
const err4 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data1.height === undefined){
const err5 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data1){
if(!((((key0 === "x") || (key0 === "y")) || (key0 === "width")) || (key0 === "height"))){
const err6 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data1.x !== undefined){
let data2 = data1.x;
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000000 || isNaN(data2)){
const err7 = {instancePath:instancePath+"/geometry/x",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data2 < -1000000 || isNaN(data2)){
const err8 = {instancePath:instancePath+"/geometry/x",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/geometry/x",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data1.y !== undefined){
let data3 = data1.y;
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 1000000 || isNaN(data3)){
const err10 = {instancePath:instancePath+"/geometry/y",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data3 < -1000000 || isNaN(data3)){
const err11 = {instancePath:instancePath+"/geometry/y",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/geometry/y",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data1.width !== undefined){
let data4 = data1.width;
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 1000000 || isNaN(data4)){
const err13 = {instancePath:instancePath+"/geometry/width",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data4 < -1000000 || isNaN(data4)){
const err14 = {instancePath:instancePath+"/geometry/width",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/geometry/width",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data1.height !== undefined){
let data5 = data1.height;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 1000000 || isNaN(data5)){
const err16 = {instancePath:instancePath+"/geometry/height",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data5 < -1000000 || isNaN(data5)){
const err17 = {instancePath:instancePath+"/geometry/height",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/geometry/height",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
else {
const err20 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key1 in data){
if(((((((((((key1 !== "type") && (key1 !== "geometry")) && (key1 !== "id")) && (key1 !== "name")) && (key1 !== "role")) && (key1 !== "visible")) && (key1 !== "opacity")) && (key1 !== "transform")) && (key1 !== "fill")) && (key1 !== "stroke")) && (key1 !== "extensions")){
const err21 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key1},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
else {
const err22 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
validate51.errors = vErrors;
return errors === 0;
}
validate51.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema84 = {"type":"object","allOf":[{"$ref":"#/$defs/vectorObjectCommon"},{"type":"object","required":["geometry"],"properties":{"type":{"const":"path"},"geometry":{"type":"object","additionalProperties":false,"required":["nodes","subpaths","fillRule"],"properties":{"nodes":{"type":"array","minItems":1,"maxItems":400000,"items":{"$ref":"#/$defs/pathNode"}},"subpaths":{"type":"array","minItems":1,"maxItems":100000,"items":{"$ref":"#/$defs/pathSubpath"}},"fillRule":{"enum":["nonzero","evenodd"]}}}}}],"unevaluatedProperties":false};
const schema85 = {"type":"object","additionalProperties":false,"required":["id","subpathId","anchor","incoming","outgoing","continuity"],"properties":{"id":{"$ref":"#/$defs/id"},"subpathId":{"$ref":"#/$defs/id"},"anchor":{"$ref":"#/$defs/point"},"incoming":{"oneOf":[{"$ref":"#/$defs/point"},{"type":"null"}]},"outgoing":{"oneOf":[{"$ref":"#/$defs/point"},{"type":"null"}]},"continuity":{"enum":["corner","smooth","symmetric"]},"cornerRadius":{"type":"number","minimum":0,"maximum":32768}}};
const schema88 = {"type":"object","additionalProperties":false,"required":["x","y"],"properties":{"x":{"$ref":"#/$defs/finite"},"y":{"$ref":"#/$defs/finite"}}};

function validate57(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate57.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.x === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.y === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "x") || (key0 === "y"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.x !== undefined){
let data0 = data.x;
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 1000000 || isNaN(data0)){
const err3 = {instancePath:instancePath+"/x",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data0 < -1000000 || isNaN(data0)){
const err4 = {instancePath:instancePath+"/x",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/x",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.y !== undefined){
let data1 = data.y;
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 1000000 || isNaN(data1)){
const err6 = {instancePath:instancePath+"/y",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data1 < -1000000 || isNaN(data1)){
const err7 = {instancePath:instancePath+"/y",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/y",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate57.errors = vErrors;
return errors === 0;
}
validate57.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate56(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate56.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.subpathId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "subpathId"},message:"must have required property '"+"subpathId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.anchor === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "anchor"},message:"must have required property '"+"anchor"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.incoming === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "incoming"},message:"must have required property '"+"incoming"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.outgoing === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "outgoing"},message:"must have required property '"+"outgoing"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.continuity === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "continuity"},message:"must have required property '"+"continuity"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "id") || (key0 === "subpathId")) || (key0 === "anchor")) || (key0 === "incoming")) || (key0 === "outgoing")) || (key0 === "continuity")) || (key0 === "cornerRadius"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(func3(data0) < 1){
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(!pattern4.test(data0)){
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.subpathId !== undefined){
let data1 = data.subpathId;
if(typeof data1 === "string"){
if(func3(data1) > 128){
const err11 = {instancePath:instancePath+"/subpathId",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(func3(data1) < 1){
const err12 = {instancePath:instancePath+"/subpathId",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(!pattern4.test(data1)){
const err13 = {instancePath:instancePath+"/subpathId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/subpathId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.anchor !== undefined){
if(!(validate57(data.anchor, {instancePath:instancePath+"/anchor",parentData:data,parentDataProperty:"anchor",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
errors = vErrors.length;
}
}
if(data.incoming !== undefined){
let data3 = data.incoming;
const _errs10 = errors;
let valid3 = false;
let passing0 = null;
const _errs11 = errors;
if(!(validate57(data3, {instancePath:instancePath+"/incoming",parentData:data,parentDataProperty:"incoming",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
errors = vErrors.length;
}
var _valid0 = _errs11 === errors;
if(_valid0){
valid3 = true;
passing0 = 0;
}
const _errs12 = errors;
if(data3 !== null){
const err15 = {instancePath:instancePath+"/incoming",schemaPath:"#/properties/incoming/oneOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
var _valid0 = _errs12 === errors;
if(_valid0 && valid3){
valid3 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid3 = true;
passing0 = 1;
}
}
if(!valid3){
const err16 = {instancePath:instancePath+"/incoming",schemaPath:"#/properties/incoming/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
else {
errors = _errs10;
if(vErrors !== null){
if(_errs10){
vErrors.length = _errs10;
}
else {
vErrors = null;
}
}
}
}
if(data.outgoing !== undefined){
let data4 = data.outgoing;
const _errs15 = errors;
let valid4 = false;
let passing1 = null;
const _errs16 = errors;
if(!(validate57(data4, {instancePath:instancePath+"/outgoing",parentData:data,parentDataProperty:"outgoing",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
errors = vErrors.length;
}
var _valid1 = _errs16 === errors;
if(_valid1){
valid4 = true;
passing1 = 0;
}
const _errs17 = errors;
if(data4 !== null){
const err17 = {instancePath:instancePath+"/outgoing",schemaPath:"#/properties/outgoing/oneOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
var _valid1 = _errs17 === errors;
if(_valid1 && valid4){
valid4 = false;
passing1 = [passing1, 1];
}
else {
if(_valid1){
valid4 = true;
passing1 = 1;
}
}
if(!valid4){
const err18 = {instancePath:instancePath+"/outgoing",schemaPath:"#/properties/outgoing/oneOf",keyword:"oneOf",params:{passingSchemas: passing1},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
else {
errors = _errs15;
if(vErrors !== null){
if(_errs15){
vErrors.length = _errs15;
}
else {
vErrors = null;
}
}
}
}
if(data.continuity !== undefined){
let data5 = data.continuity;
if(!(((data5 === "corner") || (data5 === "smooth")) || (data5 === "symmetric"))){
const err19 = {instancePath:instancePath+"/continuity",schemaPath:"#/properties/continuity/enum",keyword:"enum",params:{allowedValues: schema85.properties.continuity.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.cornerRadius !== undefined){
let data6 = data.cornerRadius;
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 > 32768 || isNaN(data6)){
const err20 = {instancePath:instancePath+"/cornerRadius",schemaPath:"#/properties/cornerRadius/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data6 < 0 || isNaN(data6)){
const err21 = {instancePath:instancePath+"/cornerRadius",schemaPath:"#/properties/cornerRadius/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/cornerRadius",schemaPath:"#/properties/cornerRadius/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
validate56.errors = vErrors;
return errors === 0;
}
validate56.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema91 = {"type":"object","additionalProperties":false,"required":["id","nodeIds","closed"],"properties":{"id":{"$ref":"#/$defs/id"},"nodeIds":{"type":"array","minItems":1,"maxItems":400000,"items":{"$ref":"#/$defs/id"}},"closed":{"type":"boolean"}}};

function validate62(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate62.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.nodeIds === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nodeIds"},message:"must have required property '"+"nodeIds"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.closed === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "closed"},message:"must have required property '"+"closed"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "id") || (key0 === "nodeIds")) || (key0 === "closed"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(func3(data0) < 1){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!pattern4.test(data0)){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.nodeIds !== undefined){
let data1 = data.nodeIds;
if(Array.isArray(data1)){
if(data1.length > 400000){
const err8 = {instancePath:instancePath+"/nodeIds",schemaPath:"#/properties/nodeIds/maxItems",keyword:"maxItems",params:{limit: 400000},message:"must NOT have more than 400000 items"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data1.length < 1){
const err9 = {instancePath:instancePath+"/nodeIds",schemaPath:"#/properties/nodeIds/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if(typeof data2 === "string"){
if(func3(data2) > 128){
const err10 = {instancePath:instancePath+"/nodeIds/" + i0,schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func3(data2) < 1){
const err11 = {instancePath:instancePath+"/nodeIds/" + i0,schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern4.test(data2)){
const err12 = {instancePath:instancePath+"/nodeIds/" + i0,schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/nodeIds/" + i0,schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath:instancePath+"/nodeIds",schemaPath:"#/properties/nodeIds/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.closed !== undefined){
if(typeof data.closed !== "boolean"){
const err15 = {instancePath:instancePath+"/closed",schemaPath:"#/properties/closed/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate62.errors = vErrors;
return errors === 0;
}
validate62.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate54(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate54.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate42(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate42.errors : vErrors.concat(validate42.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.geometry === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "geometry"},message:"must have required property '"+"geometry"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.type !== undefined){
if("path" !== data.type){
const err1 = {instancePath:instancePath+"/type",schemaPath:"#/allOf/1/properties/type/const",keyword:"const",params:{allowedValue: "path"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.geometry !== undefined){
let data1 = data.geometry;
if(data1 && typeof data1 == "object" && !Array.isArray(data1)){
if(data1.nodes === undefined){
const err2 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/required",keyword:"required",params:{missingProperty: "nodes"},message:"must have required property '"+"nodes"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data1.subpaths === undefined){
const err3 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/required",keyword:"required",params:{missingProperty: "subpaths"},message:"must have required property '"+"subpaths"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data1.fillRule === undefined){
const err4 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/required",keyword:"required",params:{missingProperty: "fillRule"},message:"must have required property '"+"fillRule"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data1){
if(!(((key0 === "nodes") || (key0 === "subpaths")) || (key0 === "fillRule"))){
const err5 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data1.nodes !== undefined){
let data2 = data1.nodes;
if(Array.isArray(data2)){
if(data2.length > 400000){
const err6 = {instancePath:instancePath+"/geometry/nodes",schemaPath:"#/allOf/1/properties/geometry/properties/nodes/maxItems",keyword:"maxItems",params:{limit: 400000},message:"must NOT have more than 400000 items"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2.length < 1){
const err7 = {instancePath:instancePath+"/geometry/nodes",schemaPath:"#/allOf/1/properties/geometry/properties/nodes/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
const len0 = data2.length;
for(let i0=0; i0<len0; i0++){
if(!(validate56(data2[i0], {instancePath:instancePath+"/geometry/nodes/" + i0,parentData:data2,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate56.errors : vErrors.concat(validate56.errors);
errors = vErrors.length;
}
}
}
else {
const err8 = {instancePath:instancePath+"/geometry/nodes",schemaPath:"#/allOf/1/properties/geometry/properties/nodes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data1.subpaths !== undefined){
let data4 = data1.subpaths;
if(Array.isArray(data4)){
if(data4.length > 100000){
const err9 = {instancePath:instancePath+"/geometry/subpaths",schemaPath:"#/allOf/1/properties/geometry/properties/subpaths/maxItems",keyword:"maxItems",params:{limit: 100000},message:"must NOT have more than 100000 items"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data4.length < 1){
const err10 = {instancePath:instancePath+"/geometry/subpaths",schemaPath:"#/allOf/1/properties/geometry/properties/subpaths/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
const len1 = data4.length;
for(let i1=0; i1<len1; i1++){
if(!(validate62(data4[i1], {instancePath:instancePath+"/geometry/subpaths/" + i1,parentData:data4,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate62.errors : vErrors.concat(validate62.errors);
errors = vErrors.length;
}
}
}
else {
const err11 = {instancePath:instancePath+"/geometry/subpaths",schemaPath:"#/allOf/1/properties/geometry/properties/subpaths/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data1.fillRule !== undefined){
let data6 = data1.fillRule;
if(!((data6 === "nonzero") || (data6 === "evenodd"))){
const err12 = {instancePath:instancePath+"/geometry/fillRule",schemaPath:"#/allOf/1/properties/geometry/properties/fillRule/enum",keyword:"enum",params:{allowedValues: schema84.allOf[1].properties.geometry.properties.fillRule.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
else {
const err13 = {instancePath:instancePath+"/geometry",schemaPath:"#/allOf/1/properties/geometry/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key1 in data){
if(((((((((((key1 !== "type") && (key1 !== "geometry")) && (key1 !== "id")) && (key1 !== "name")) && (key1 !== "role")) && (key1 !== "visible")) && (key1 !== "opacity")) && (key1 !== "transform")) && (key1 !== "fill")) && (key1 !== "stroke")) && (key1 !== "extensions")){
const err15 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key1},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate54.errors = vErrors;
return errors === 0;
}
validate54.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate40(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate40.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate41(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate41.errors : vErrors.concat(validate41.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate51(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate51.errors : vErrors.concat(validate51.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
const _errs3 = errors;
if(!(validate54(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
errors = vErrors.length;
}
var _valid0 = _errs3 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
if(props0 !== true){
props0 = true;
}
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate40.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate40.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate38(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate38.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate30(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate30.errors : vErrors.concat(validate30.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.objects === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "objects"},message:"must have required property '"+"objects"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.type !== undefined){
if("vector" !== data.type){
const err1 = {instancePath:instancePath+"/type",schemaPath:"#/allOf/1/properties/type/const",keyword:"const",params:{allowedValue: "vector"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.objects !== undefined){
let data1 = data.objects;
if(Array.isArray(data1)){
if(data1.length > 100000){
const err2 = {instancePath:instancePath+"/objects",schemaPath:"#/allOf/1/properties/objects/maxItems",keyword:"maxItems",params:{limit: 100000},message:"must NOT have more than 100000 items"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data1.length < 1){
const err3 = {instancePath:instancePath+"/objects",schemaPath:"#/allOf/1/properties/objects/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
if(!(validate40(data1[i0], {instancePath:instancePath+"/objects/" + i0,parentData:data1,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate40.errors : vErrors.concat(validate40.errors);
errors = vErrors.length;
}
}
}
else {
const err4 = {instancePath:instancePath+"/objects",schemaPath:"#/allOf/1/properties/objects/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if(((((((((((((key0 !== "type") && (key0 !== "objects")) && (key0 !== "id")) && (key0 !== "name")) && (key0 !== "role")) && (key0 !== "visible")) && (key0 !== "opacity")) && (key0 !== "fillOpacity")) && (key0 !== "blendMode")) && (key0 !== "locked")) && (key0 !== "clipping")) && (key0 !== "transform")) && (key0 !== "extensions")){
const err6 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key0},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
else {
const err7 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
validate38.errors = vErrors;
return errors === 0;
}
validate38.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema94 = {"type":"object","allOf":[{"$ref":"#/$defs/nodeCommon"},{"type":"object","required":["asset","frame"],"properties":{"type":{"const":"image"},"asset":{"$ref":"#/$defs/id"},"frame":{"type":"object","additionalProperties":false,"required":["width","height","fit"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"fit":{"enum":["fill","contain","cover"]}}}}}],"unevaluatedProperties":false};

function validate67(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate67.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate30(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate30.errors : vErrors.concat(validate30.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.asset === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "asset"},message:"must have required property '"+"asset"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.frame === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "frame"},message:"must have required property '"+"frame"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.type !== undefined){
if("image" !== data.type){
const err2 = {instancePath:instancePath+"/type",schemaPath:"#/allOf/1/properties/type/const",keyword:"const",params:{allowedValue: "image"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.asset !== undefined){
let data1 = data.asset;
if(typeof data1 === "string"){
if(func3(data1) > 128){
const err3 = {instancePath:instancePath+"/asset",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func3(data1) < 1){
const err4 = {instancePath:instancePath+"/asset",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern4.test(data1)){
const err5 = {instancePath:instancePath+"/asset",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/asset",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.frame !== undefined){
let data2 = data.frame;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.width === undefined){
const err7 = {instancePath:instancePath+"/frame",schemaPath:"#/allOf/1/properties/frame/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data2.height === undefined){
const err8 = {instancePath:instancePath+"/frame",schemaPath:"#/allOf/1/properties/frame/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data2.fit === undefined){
const err9 = {instancePath:instancePath+"/frame",schemaPath:"#/allOf/1/properties/frame/required",keyword:"required",params:{missingProperty: "fit"},message:"must have required property '"+"fit"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key0 in data2){
if(!(((key0 === "width") || (key0 === "height")) || (key0 === "fit"))){
const err10 = {instancePath:instancePath+"/frame",schemaPath:"#/allOf/1/properties/frame/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data2.width !== undefined){
let data3 = data2.width;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err11 = {instancePath:instancePath+"/frame/width",schemaPath:"#/allOf/1/properties/frame/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 32768 || isNaN(data3)){
const err12 = {instancePath:instancePath+"/frame/width",schemaPath:"#/allOf/1/properties/frame/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data3 < 1 || isNaN(data3)){
const err13 = {instancePath:instancePath+"/frame/width",schemaPath:"#/allOf/1/properties/frame/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data2.height !== undefined){
let data4 = data2.height;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err14 = {instancePath:instancePath+"/frame/height",schemaPath:"#/allOf/1/properties/frame/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 32768 || isNaN(data4)){
const err15 = {instancePath:instancePath+"/frame/height",schemaPath:"#/allOf/1/properties/frame/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data4 < 1 || isNaN(data4)){
const err16 = {instancePath:instancePath+"/frame/height",schemaPath:"#/allOf/1/properties/frame/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
if(data2.fit !== undefined){
let data5 = data2.fit;
if(!(((data5 === "fill") || (data5 === "contain")) || (data5 === "cover"))){
const err17 = {instancePath:instancePath+"/frame/fit",schemaPath:"#/allOf/1/properties/frame/properties/fit/enum",keyword:"enum",params:{allowedValues: schema94.allOf[1].properties.frame.properties.fit.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
else {
const err18 = {instancePath:instancePath+"/frame",schemaPath:"#/allOf/1/properties/frame/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key1 in data){
if((((((((((((((key1 !== "type") && (key1 !== "asset")) && (key1 !== "frame")) && (key1 !== "id")) && (key1 !== "name")) && (key1 !== "role")) && (key1 !== "visible")) && (key1 !== "opacity")) && (key1 !== "fillOpacity")) && (key1 !== "blendMode")) && (key1 !== "locked")) && (key1 !== "clipping")) && (key1 !== "transform")) && (key1 !== "extensions")){
const err20 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key1},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
validate67.errors = vErrors;
return errors === 0;
}
validate67.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate28(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate28.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate29(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate29.errors : vErrors.concat(validate29.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate35(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate35.errors : vErrors.concat(validate35.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
const _errs3 = errors;
if(!(validate38(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate38.errors : vErrors.concat(validate38.errors);
errors = vErrors.length;
}
var _valid0 = _errs3 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
if(props0 !== true){
props0 = true;
}
}
const _errs4 = errors;
if(!(validate67(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate67.errors : vErrors.concat(validate67.errors);
errors = vErrors.length;
}
var _valid0 = _errs4 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 3];
}
else {
if(_valid0){
valid0 = true;
passing0 = 3;
if(props0 !== true){
props0 = true;
}
}
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate28.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate28.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate29(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate29.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate30(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate30.errors : vErrors.concat(validate30.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.children === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "children"},message:"must have required property '"+"children"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.type !== undefined){
if("group" !== data.type){
const err1 = {instancePath:instancePath+"/type",schemaPath:"#/allOf/1/properties/type/const",keyword:"const",params:{allowedValue: "group"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.children !== undefined){
let data1 = data.children;
if(Array.isArray(data1)){
if(data1.length > 4096){
const err2 = {instancePath:instancePath+"/children",schemaPath:"#/allOf/1/properties/children/maxItems",keyword:"maxItems",params:{limit: 4096},message:"must NOT have more than 4096 items"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
if(!(wrapper0.validate(data1[i0], {instancePath:instancePath+"/children/" + i0,parentData:data1,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? wrapper0.validate.errors : vErrors.concat(wrapper0.validate.errors);
errors = vErrors.length;
}
}
}
else {
const err3 = {instancePath:instancePath+"/children",schemaPath:"#/allOf/1/properties/children/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if(((((((((((((key0 !== "type") && (key0 !== "children")) && (key0 !== "id")) && (key0 !== "name")) && (key0 !== "role")) && (key0 !== "visible")) && (key0 !== "opacity")) && (key0 !== "fillOpacity")) && (key0 !== "blendMode")) && (key0 !== "locked")) && (key0 !== "clipping")) && (key0 !== "transform")) && (key0 !== "extensions")){
const err5 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key0},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
validate29.errors = vErrors;
return errors === 0;
}
validate29.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate75(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate75.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate29(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate29.errors : vErrors.concat(validate29.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate35(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate35.errors : vErrors.concat(validate35.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
const _errs3 = errors;
if(!(validate38(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate38.errors : vErrors.concat(validate38.errors);
errors = vErrors.length;
}
var _valid0 = _errs3 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
if(props0 !== true){
props0 = true;
}
}
const _errs4 = errors;
if(!(validate67(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate67.errors : vErrors.concat(validate67.errors);
errors = vErrors.length;
}
var _valid0 = _errs4 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 3];
}
else {
if(_valid0){
valid0 = true;
passing0 = 3;
if(props0 !== true){
props0 = true;
}
}
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate75.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate75.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate20(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.0/scene.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate20.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.id === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.revision === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "revision"},message:"must have required property '"+"revision"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.title === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "title"},message:"must have required property '"+"title"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.canvas === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "canvas"},message:"must have required property '"+"canvas"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.fonts === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fonts"},message:"must have required property '"+"fonts"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.assets === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assets"},message:"must have required property '"+"assets"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.nodes === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nodes"},message:"must have required property '"+"nodes"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema31.properties, key0))){
const err10 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.0/scene.schema.json" !== data.$schema){
const err11 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.0/scene.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-scene" !== data.format){
const err12 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-scene"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.version !== undefined){
if("0.0" !== data.version){
const err13 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.0"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.id !== undefined){
let data3 = data.id;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err14 = {instancePath:instancePath+"/id",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(func3(data3) < 1){
const err15 = {instancePath:instancePath+"/id",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(!pattern4.test(data3)){
const err16 = {instancePath:instancePath+"/id",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/id",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.revision !== undefined){
let data4 = data.revision;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err18 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err19 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
if(data.title !== undefined){
let data5 = data.title;
if(typeof data5 === "string"){
if(func3(data5) > 256){
const err20 = {instancePath:instancePath+"/title",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/name/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(func3(data5) < 1){
const err21 = {instancePath:instancePath+"/title",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/title",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.canvas !== undefined){
let data6 = data.canvas;
if(data6 && typeof data6 == "object" && !Array.isArray(data6)){
if(data6.width === undefined){
const err23 = {instancePath:instancePath+"/canvas",schemaPath:"#/properties/canvas/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data6.height === undefined){
const err24 = {instancePath:instancePath+"/canvas",schemaPath:"#/properties/canvas/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data6.backgroundColor === undefined){
const err25 = {instancePath:instancePath+"/canvas",schemaPath:"#/properties/canvas/required",keyword:"required",params:{missingProperty: "backgroundColor"},message:"must have required property '"+"backgroundColor"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
for(const key1 in data6){
if(!(((key1 === "width") || (key1 === "height")) || (key1 === "backgroundColor"))){
const err26 = {instancePath:instancePath+"/canvas",schemaPath:"#/properties/canvas/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data6.width !== undefined){
let data7 = data6.width;
if(!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))){
const err27 = {instancePath:instancePath+"/canvas/width",schemaPath:"#/properties/canvas/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 32768 || isNaN(data7)){
const err28 = {instancePath:instancePath+"/canvas/width",schemaPath:"#/properties/canvas/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data7 < 1 || isNaN(data7)){
const err29 = {instancePath:instancePath+"/canvas/width",schemaPath:"#/properties/canvas/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
if(data6.height !== undefined){
let data8 = data6.height;
if(!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))){
const err30 = {instancePath:instancePath+"/canvas/height",schemaPath:"#/properties/canvas/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 32768 || isNaN(data8)){
const err31 = {instancePath:instancePath+"/canvas/height",schemaPath:"#/properties/canvas/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data8 < 1 || isNaN(data8)){
const err32 = {instancePath:instancePath+"/canvas/height",schemaPath:"#/properties/canvas/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
}
if(data6.backgroundColor !== undefined){
let data9 = data6.backgroundColor;
const _errs21 = errors;
let valid4 = false;
let passing0 = null;
const _errs22 = errors;
if(typeof data9 === "string"){
if(!pattern5.test(data9)){
const err33 = {instancePath:instancePath+"/canvas/backgroundColor",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/color/pattern",keyword:"pattern",params:{pattern: "^#[0-9A-Fa-f]{6}$"},message:"must match pattern \""+"^#[0-9A-Fa-f]{6}$"+"\""};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
else {
const err34 = {instancePath:instancePath+"/canvas/backgroundColor",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/color/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
var _valid0 = _errs22 === errors;
if(_valid0){
valid4 = true;
passing0 = 0;
}
const _errs25 = errors;
if(data9 !== null){
const err35 = {instancePath:instancePath+"/canvas/backgroundColor",schemaPath:"#/properties/canvas/properties/backgroundColor/oneOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
var _valid0 = _errs25 === errors;
if(_valid0 && valid4){
valid4 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid4 = true;
passing0 = 1;
}
}
if(!valid4){
const err36 = {instancePath:instancePath+"/canvas/backgroundColor",schemaPath:"#/properties/canvas/properties/backgroundColor/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
else {
errors = _errs21;
if(vErrors !== null){
if(_errs21){
vErrors.length = _errs21;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err37 = {instancePath:instancePath+"/canvas",schemaPath:"#/properties/canvas/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data.fonts !== undefined){
let data10 = data.fonts;
if(Array.isArray(data10)){
if(data10.length > 256){
const err38 = {instancePath:instancePath+"/fonts",schemaPath:"#/properties/fonts/maxItems",keyword:"maxItems",params:{limit: 256},message:"must NOT have more than 256 items"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
const len0 = data10.length;
for(let i0=0; i0<len0; i0++){
if(!(validate71(data10[i0], {instancePath:instancePath+"/fonts/" + i0,parentData:data10,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
errors = vErrors.length;
}
}
}
else {
const err39 = {instancePath:instancePath+"/fonts",schemaPath:"#/properties/fonts/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data.assets !== undefined){
let data12 = data.assets;
if(Array.isArray(data12)){
if(data12.length > 4096){
const err40 = {instancePath:instancePath+"/assets",schemaPath:"#/properties/assets/maxItems",keyword:"maxItems",params:{limit: 4096},message:"must NOT have more than 4096 items"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
const len1 = data12.length;
for(let i1=0; i1<len1; i1++){
if(!(validate73(data12[i1], {instancePath:instancePath+"/assets/" + i1,parentData:data12,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate73.errors : vErrors.concat(validate73.errors);
errors = vErrors.length;
}
}
}
else {
const err41 = {instancePath:instancePath+"/assets",schemaPath:"#/properties/assets/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
if(data.nodes !== undefined){
let data14 = data.nodes;
if(Array.isArray(data14)){
if(data14.length > 4096){
const err42 = {instancePath:instancePath+"/nodes",schemaPath:"#/properties/nodes/maxItems",keyword:"maxItems",params:{limit: 4096},message:"must NOT have more than 4096 items"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
const len2 = data14.length;
for(let i2=0; i2<len2; i2++){
if(!(validate75(data14[i2], {instancePath:instancePath+"/nodes/" + i2,parentData:data14,parentDataProperty:i2,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate75.errors : vErrors.concat(validate75.errors);
errors = vErrors.length;
}
}
}
else {
const err43 = {instancePath:instancePath+"/nodes",schemaPath:"#/properties/nodes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data.extensionDeclarations !== undefined){
let data16 = data.extensionDeclarations;
if(Array.isArray(data16)){
if(data16.length > 64){
const err44 = {instancePath:instancePath+"/extensionDeclarations",schemaPath:"#/properties/extensionDeclarations/maxItems",keyword:"maxItems",params:{limit: 64},message:"must NOT have more than 64 items"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
const len3 = data16.length;
for(let i3=0; i3<len3; i3++){
let data17 = data16[i3];
if(data17 && typeof data17 == "object" && !Array.isArray(data17)){
if(data17.key === undefined){
const err45 = {instancePath:instancePath+"/extensionDeclarations/" + i3,schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/required",keyword:"required",params:{missingProperty: "key"},message:"must have required property '"+"key"+"'"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
if(data17.version === undefined){
const err46 = {instancePath:instancePath+"/extensionDeclarations/" + i3,schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
if(data17.kind === undefined){
const err47 = {instancePath:instancePath+"/extensionDeclarations/" + i3,schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
for(const key2 in data17){
if(!(((((key2 === "key") || (key2 === "version")) || (key2 === "kind")) || (key2 === "required")) || (key2 === "schemaId"))){
const err48 = {instancePath:instancePath+"/extensionDeclarations/" + i3,schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
if(data17.key !== undefined){
let data18 = data17.key;
if(typeof data18 === "string"){
if(!pattern12.test(data18)){
const err49 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/key",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/properties/key/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},message:"must match pattern \""+"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"+"\""};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
else {
const err50 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/key",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/properties/key/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
if(data17.version !== undefined){
let data19 = data17.version;
if(typeof data19 === "string"){
if(func3(data19) > 64){
const err51 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/version",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/properties/version/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
if(func3(data19) < 1){
const err52 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/version",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
if(!pattern25.test(data19)){
const err53 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/version",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/properties/version/pattern",keyword:"pattern",params:{pattern: "^[0-9A-Za-z][0-9A-Za-z._+-]*$"},message:"must match pattern \""+"^[0-9A-Za-z][0-9A-Za-z._+-]*$"+"\""};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
else {
const err54 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/version",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
if(data17.kind !== undefined){
if("metadata" !== data17.kind){
const err55 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/kind",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/properties/kind/const",keyword:"const",params:{allowedValue: "metadata"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
}
if(data17.required !== undefined){
if(typeof data17.required !== "boolean"){
const err56 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/required",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/properties/required/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
if(data17.schemaId !== undefined){
let data22 = data17.schemaId;
if(typeof data22 === "string"){
if(func3(data22) > 2048){
const err57 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/schemaId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/properties/schemaId/maxLength",keyword:"maxLength",params:{limit: 2048},message:"must NOT have more than 2048 characters"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
if(func3(data22) < 1){
const err58 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/schemaId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/properties/schemaId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
else {
const err59 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/schemaId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/properties/schemaId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
}
}
else {
const err60 = {instancePath:instancePath+"/extensionDeclarations/" + i3,schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensionDeclaration/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
}
else {
const err61 = {instancePath:instancePath+"/extensionDeclarations",schemaPath:"#/properties/extensionDeclarations/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
}
if(data.extensions !== undefined){
let data23 = data.extensions;
if(data23 && typeof data23 == "object" && !Array.isArray(data23)){
if(Object.keys(data23).length > 64){
const err62 = {instancePath:instancePath+"/extensions",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensions/maxProperties",keyword:"maxProperties",params:{limit: 64},message:"must NOT have more than 64 properties"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
for(const key3 in data23){
const _errs54 = errors;
if(typeof key3 === "string"){
if(!pattern12.test(key3)){
const err63 = {instancePath:instancePath+"/extensions",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensions/propertyNames/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},message:"must match pattern \""+"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"+"\"",propertyName:key3};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
}
var valid17 = _errs54 === errors;
if(!valid17){
const err64 = {instancePath:instancePath+"/extensions",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensions/propertyNames",keyword:"propertyNames",params:{propertyName: key3},message:"property name must be valid"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
}
}
else {
const err65 = {instancePath:instancePath+"/extensions",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/extensions/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
}
}
else {
const err66 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
validate20.errors = vErrors;
return errors === 0;
}
validate20.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateSceneSchema = validate21;
const schema32 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/scene.schema.json","title":"Maipo public scene 0.1","description":"Experimental, static, AI-authorable Maipo scene.","type":"object","additionalProperties":false,"required":["format","version","documentId","revision","name","canvas","fonts","assets","children"],"properties":{"$schema":{"type":"string","const":"https://maipo.design/schema/0.1/scene.schema.json"},"format":{"const":"maipo-scene"},"version":{"const":"0.1"},"documentId":{"$ref":"#/$defs/id"},"revision":{"type":"integer","minimum":0},"name":{"$ref":"#/$defs/name"},"canvas":{"$ref":"#/$defs/canvas"},"fonts":{"type":"array","maxItems":256,"items":{"$ref":"#/$defs/font"}},"assets":{"type":"array","maxItems":4096,"items":{"$ref":"#/$defs/asset"}},"children":{"type":"array","maxItems":4096,"items":{"$ref":"#/$defs/node"}},"extensionDeclarations":{"type":"array","maxItems":64,"items":{"$ref":"#/$defs/extensionDeclaration"}},"extensions":{"$ref":"#/$defs/extensions"}},"$defs":{"id":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"name":{"type":"string","minLength":1,"maxLength":256},"finite":{"type":"number","minimum":-1000000,"maximum":1000000},"unit":{"type":"number","minimum":0,"maximum":1},"positiveLength":{"type":"number","exclusiveMinimum":0,"maximum":32768},"color":{"type":"string","pattern":"^#[0-9A-Fa-f]{6}$"},"extensions":{"type":"object","maxProperties":64,"propertyNames":{"pattern":"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},"additionalProperties":true},"extensionDeclaration":{"type":"object","additionalProperties":false,"required":["key","version","kind"],"properties":{"key":{"type":"string","pattern":"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},"version":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[0-9A-Za-z][0-9A-Za-z._+-]*$"},"kind":{"const":"metadata"},"required":{"type":"boolean","default":false},"schemaId":{"type":"string","minLength":1,"maxLength":2048}}},"canvas":{"type":"object","additionalProperties":false,"required":["width","height","colorSpace","background"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"colorSpace":{"const":"srgb"},"background":{"oneOf":[{"type":"object","additionalProperties":false,"required":["type"],"properties":{"type":{"const":"transparent"}}},{"type":"object","additionalProperties":false,"required":["type","color"],"properties":{"type":{"const":"solid"},"color":{"$ref":"#/$defs/color"}}}]}}},"transform":{"type":"object","additionalProperties":false,"properties":{"x":{"$ref":"#/$defs/finite","default":0},"y":{"$ref":"#/$defs/finite","default":0},"rotation":{"$ref":"#/$defs/finite","default":0},"scaleX":{"$ref":"#/$defs/finite","default":1},"scaleY":{"$ref":"#/$defs/finite","default":1},"skewX":{"$ref":"#/$defs/finite","default":0}}},"blendMode":{"enum":["normal","multiply","screen","overlay","darken","lighten","color-dodge","color-burn","hard-light","soft-light","difference","exclusion"],"default":"normal"},"nodeCommon":{"type":"object","required":["id","type","name"],"properties":{"id":{"$ref":"#/$defs/id"},"type":{"type":"string"},"name":{"$ref":"#/$defs/name"},"role":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"visible":{"type":"boolean","default":true},"opacity":{"$ref":"#/$defs/unit","default":1},"fillOpacity":{"$ref":"#/$defs/unit","default":1},"blendMode":{"$ref":"#/$defs/blendMode"},"locked":{"type":"boolean","default":false},"clipping":{"type":"boolean","default":false},"transform":{"$ref":"#/$defs/transform"},"extensions":{"$ref":"#/$defs/extensions"}}},"groupNode":{"type":"object","allOf":[{"$ref":"#/$defs/nodeCommon"},{"type":"object","required":["children"],"properties":{"type":{"const":"group"},"children":{"type":"array","maxItems":4096,"items":{"$ref":"#/$defs/node"}}}}],"unevaluatedProperties":false},"textNode":{"type":"object","allOf":[{"$ref":"#/$defs/nodeCommon"},{"type":"object","required":["text","frame","style"],"properties":{"type":{"const":"text"},"text":{"type":"string","maxLength":1000000},"frame":{"type":"object","additionalProperties":false,"required":["width","height"],"properties":{"width":{"$ref":"#/$defs/positiveLength"},"height":{"$ref":"#/$defs/positiveLength"},"autoHeight":{"type":"boolean","default":false}}},"style":{"type":"object","additionalProperties":false,"required":["fontFamily","fontWeight","fontSize","lineHeight","letterSpacing","textAlign","color"],"properties":{"fontRef":{"$ref":"#/$defs/id"},"fontFamily":{"type":"string","minLength":1,"maxLength":256},"fontWeight":{"type":"integer","minimum":1,"maximum":1000},"fontSize":{"type":"number","exclusiveMinimum":0,"maximum":4096},"lineHeight":{"type":"number","minimum":0.25,"maximum":20},"letterSpacing":{"type":"number","minimum":-4096,"maximum":4096},"textAlign":{"enum":["left","center","right"]},"color":{"$ref":"#/$defs/color"}}}}}],"unevaluatedProperties":false},"vectorNode":{"type":"object","allOf":[{"$ref":"#/$defs/nodeCommon"},{"type":"object","required":["objects"],"properties":{"type":{"const":"vector"},"objects":{"type":"array","minItems":1,"maxItems":100000,"items":{"$ref":"#/$defs/vectorObject"}}}}],"unevaluatedProperties":false},"imageNode":{"type":"object","allOf":[{"$ref":"#/$defs/nodeCommon"},{"type":"object","required":["asset","frame"],"properties":{"type":{"const":"image"},"asset":{"$ref":"#/$defs/id"},"frame":{"type":"object","additionalProperties":false,"required":["width","height","fit"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"fit":{"enum":["fill","contain","cover"]}}}}}],"unevaluatedProperties":false},"node":{"oneOf":[{"$ref":"#/$defs/groupNode"},{"$ref":"#/$defs/textNode"},{"$ref":"#/$defs/vectorNode"},{"$ref":"#/$defs/imageNode"}]},"point":{"type":"object","additionalProperties":false,"required":["x","y"],"properties":{"x":{"$ref":"#/$defs/finite"},"y":{"$ref":"#/$defs/finite"}}},"solidPaint":{"type":"object","additionalProperties":false,"required":["type","color"],"properties":{"type":{"const":"solid"},"color":{"$ref":"#/$defs/color"},"opacity":{"$ref":"#/$defs/unit","default":1}}},"stroke":{"type":"object","additionalProperties":false,"required":["paint","width","lineCap","lineJoin","dash"],"properties":{"paint":{"$ref":"#/$defs/solidPaint"},"width":{"type":"number","minimum":0,"maximum":32768},"lineCap":{"enum":["butt","round","square"]},"lineJoin":{"enum":["miter","round","bevel"]},"dash":{"type":"array","maxItems":128,"items":{"type":"number","minimum":0,"maximum":32768}}}},"vectorObjectCommon":{"type":"object","required":["id","type","name"],"properties":{"id":{"$ref":"#/$defs/id"},"type":{"type":"string"},"name":{"$ref":"#/$defs/name"},"role":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"visible":{"type":"boolean","default":true},"opacity":{"$ref":"#/$defs/unit","default":1},"transform":{"$ref":"#/$defs/transform"},"fill":{"oneOf":[{"$ref":"#/$defs/solidPaint"},{"type":"null"}],"default":null},"stroke":{"oneOf":[{"$ref":"#/$defs/stroke"},{"type":"null"}],"default":null},"extensions":{"$ref":"#/$defs/extensions"}}},"rectangleObject":{"type":"object","allOf":[{"$ref":"#/$defs/vectorObjectCommon"},{"type":"object","required":["geometry"],"properties":{"type":{"const":"rectangle"},"geometry":{"type":"object","additionalProperties":false,"required":["x","y","width","height","radius"],"properties":{"x":{"$ref":"#/$defs/finite"},"y":{"$ref":"#/$defs/finite"},"width":{"$ref":"#/$defs/finite"},"height":{"$ref":"#/$defs/finite"},"radius":{"type":"object","additionalProperties":false,"required":["topLeft","topRight","bottomRight","bottomLeft"],"properties":{"topLeft":{"type":"number","minimum":0,"maximum":32768},"topRight":{"type":"number","minimum":0,"maximum":32768},"bottomRight":{"type":"number","minimum":0,"maximum":32768},"bottomLeft":{"type":"number","minimum":0,"maximum":32768}}}}}}}],"unevaluatedProperties":false},"ellipseObject":{"type":"object","allOf":[{"$ref":"#/$defs/vectorObjectCommon"},{"type":"object","required":["geometry"],"properties":{"type":{"const":"ellipse"},"geometry":{"type":"object","additionalProperties":false,"required":["x","y","width","height"],"properties":{"x":{"$ref":"#/$defs/finite"},"y":{"$ref":"#/$defs/finite"},"width":{"$ref":"#/$defs/finite"},"height":{"$ref":"#/$defs/finite"}}}}}],"unevaluatedProperties":false},"pathNode":{"type":"object","additionalProperties":false,"required":["id","subpathId","anchor","incoming","outgoing","continuity"],"properties":{"id":{"$ref":"#/$defs/id"},"subpathId":{"$ref":"#/$defs/id"},"anchor":{"$ref":"#/$defs/point"},"incoming":{"oneOf":[{"$ref":"#/$defs/point"},{"type":"null"}]},"outgoing":{"oneOf":[{"$ref":"#/$defs/point"},{"type":"null"}]},"continuity":{"enum":["corner","smooth","symmetric"]},"cornerRadius":{"type":"number","minimum":0,"maximum":32768}}},"pathSubpath":{"type":"object","additionalProperties":false,"required":["id","nodeIds","closed"],"properties":{"id":{"$ref":"#/$defs/id"},"nodeIds":{"type":"array","minItems":1,"maxItems":400000,"items":{"$ref":"#/$defs/id"}},"closed":{"type":"boolean"}}},"pathObject":{"type":"object","allOf":[{"$ref":"#/$defs/vectorObjectCommon"},{"type":"object","required":["geometry"],"properties":{"type":{"const":"path"},"geometry":{"type":"object","additionalProperties":false,"required":["nodes","subpaths","fillRule"],"properties":{"nodes":{"type":"array","minItems":1,"maxItems":400000,"items":{"$ref":"#/$defs/pathNode"}},"subpaths":{"type":"array","minItems":1,"maxItems":100000,"items":{"$ref":"#/$defs/pathSubpath"}},"fillRule":{"enum":["nonzero","evenodd"]}}}}}],"unevaluatedProperties":false},"vectorObject":{"oneOf":[{"$ref":"#/$defs/rectangleObject"},{"$ref":"#/$defs/ellipseObject"},{"$ref":"#/$defs/pathObject"}]},"asset":{"type":"object","additionalProperties":false,"required":["id","digest","mediaType","byteLength","data"],"properties":{"id":{"$ref":"#/$defs/id"},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"mediaType":{"enum":["image/png","image/jpeg","image/webp","font/woff2","font/woff","font/ttf","font/otf"]},"byteLength":{"type":"integer","minimum":0,"maximum":536870912},"data":{"type":"string","contentEncoding":"base64","maxLength":715827884}}},"font":{"type":"object","additionalProperties":false,"required":["id","family","weight","style","source","license"],"properties":{"id":{"$ref":"#/$defs/id"},"family":{"type":"string","minLength":1,"maxLength":256},"weight":{"type":"integer","minimum":1,"maximum":1000},"style":{"enum":["normal","italic","oblique"]},"source":{"oneOf":[{"type":"object","additionalProperties":false,"required":["kind"],"properties":{"kind":{"const":"system"}}},{"type":"object","additionalProperties":false,"required":["kind","asset"],"properties":{"kind":{"const":"embedded"},"asset":{"$ref":"#/$defs/id"}}}]},"license":{"type":"object","additionalProperties":false,"required":["spdx","embedding"],"properties":{"spdx":{"type":"string","minLength":1,"maxLength":128},"embedding":{"enum":["installable","editable","preview-print","restricted","unknown"]},"notice":{"type":"string","maxLength":4096}}}}}}};
const schema35 = {"type":"object","additionalProperties":false,"required":["width","height","colorSpace","background"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"colorSpace":{"const":"srgb"},"background":{"oneOf":[{"type":"object","additionalProperties":false,"required":["type"],"properties":{"type":{"const":"transparent"}}},{"type":"object","additionalProperties":false,"required":["type","color"],"properties":{"type":{"const":"solid"},"color":{"$ref":"#/$defs/color"}}}]}}};

function validate22(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate22.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.width === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.height === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.colorSpace === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "colorSpace"},message:"must have required property '"+"colorSpace"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.background === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "background"},message:"must have required property '"+"background"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "width") || (key0 === "height")) || (key0 === "colorSpace")) || (key0 === "background"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.width !== undefined){
let data0 = data.width;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err5 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 32768 || isNaN(data0)){
const err6 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data0 < 1 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
if(data.height !== undefined){
let data1 = data.height;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err8 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 32768 || isNaN(data1)){
const err9 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err10 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
if(data.colorSpace !== undefined){
if("srgb" !== data.colorSpace){
const err11 = {instancePath:instancePath+"/colorSpace",schemaPath:"#/properties/colorSpace/const",keyword:"const",params:{allowedValue: "srgb"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.background !== undefined){
let data3 = data.background;
const _errs8 = errors;
let valid1 = false;
let passing0 = null;
const _errs9 = errors;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.type === undefined){
const err12 = {instancePath:instancePath+"/background",schemaPath:"#/properties/background/oneOf/0/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
for(const key1 in data3){
if(!(key1 === "type")){
const err13 = {instancePath:instancePath+"/background",schemaPath:"#/properties/background/oneOf/0/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data3.type !== undefined){
if("transparent" !== data3.type){
const err14 = {instancePath:instancePath+"/background/type",schemaPath:"#/properties/background/oneOf/0/properties/type/const",keyword:"const",params:{allowedValue: "transparent"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath:instancePath+"/background",schemaPath:"#/properties/background/oneOf/0/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
var _valid0 = _errs9 === errors;
if(_valid0){
valid1 = true;
passing0 = 0;
var props0 = true;
}
const _errs13 = errors;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.type === undefined){
const err16 = {instancePath:instancePath+"/background",schemaPath:"#/properties/background/oneOf/1/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data3.color === undefined){
const err17 = {instancePath:instancePath+"/background",schemaPath:"#/properties/background/oneOf/1/required",keyword:"required",params:{missingProperty: "color"},message:"must have required property '"+"color"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
for(const key2 in data3){
if(!((key2 === "type") || (key2 === "color"))){
const err18 = {instancePath:instancePath+"/background",schemaPath:"#/properties/background/oneOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data3.type !== undefined){
if("solid" !== data3.type){
const err19 = {instancePath:instancePath+"/background/type",schemaPath:"#/properties/background/oneOf/1/properties/type/const",keyword:"const",params:{allowedValue: "solid"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data3.color !== undefined){
let data6 = data3.color;
if(typeof data6 === "string"){
if(!pattern5.test(data6)){
const err20 = {instancePath:instancePath+"/background/color",schemaPath:"#/$defs/color/pattern",keyword:"pattern",params:{pattern: "^#[0-9A-Fa-f]{6}$"},message:"must match pattern \""+"^#[0-9A-Fa-f]{6}$"+"\""};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/background/color",schemaPath:"#/$defs/color/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
else {
const err22 = {instancePath:instancePath+"/background",schemaPath:"#/properties/background/oneOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
var _valid0 = _errs13 === errors;
if(_valid0 && valid1){
valid1 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid1 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid1){
const err23 = {instancePath:instancePath+"/background",schemaPath:"#/properties/background/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
else {
errors = _errs8;
if(vErrors !== null){
if(_errs8){
vErrors.length = _errs8;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err24 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
validate22.errors = vErrors;
return errors === 0;
}
validate22.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate24(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate24.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.family === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "family"},message:"must have required property '"+"family"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.weight === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "weight"},message:"must have required property '"+"weight"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.style === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "style"},message:"must have required property '"+"style"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.source === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.license === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "license"},message:"must have required property '"+"license"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "id") || (key0 === "family")) || (key0 === "weight")) || (key0 === "style")) || (key0 === "source")) || (key0 === "license"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(func3(data0) < 1){
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(!pattern4.test(data0)){
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.family !== undefined){
let data1 = data.family;
if(typeof data1 === "string"){
if(func3(data1) > 256){
const err11 = {instancePath:instancePath+"/family",schemaPath:"#/properties/family/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(func3(data1) < 1){
const err12 = {instancePath:instancePath+"/family",schemaPath:"#/properties/family/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/family",schemaPath:"#/properties/family/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.weight !== undefined){
let data2 = data.weight;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err14 = {instancePath:instancePath+"/weight",schemaPath:"#/properties/weight/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000 || isNaN(data2)){
const err15 = {instancePath:instancePath+"/weight",schemaPath:"#/properties/weight/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000},message:"must be <= 1000"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data2 < 1 || isNaN(data2)){
const err16 = {instancePath:instancePath+"/weight",schemaPath:"#/properties/weight/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
if(data.style !== undefined){
let data3 = data.style;
if(!(((data3 === "normal") || (data3 === "italic")) || (data3 === "oblique"))){
const err17 = {instancePath:instancePath+"/style",schemaPath:"#/properties/style/enum",keyword:"enum",params:{allowedValues: schema37.properties.style.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.source !== undefined){
let data4 = data.source;
const _errs11 = errors;
let valid2 = false;
let passing0 = null;
const _errs12 = errors;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.kind === undefined){
const err18 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/0/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
for(const key1 in data4){
if(!(key1 === "kind")){
const err19 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/0/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data4.kind !== undefined){
if("system" !== data4.kind){
const err20 = {instancePath:instancePath+"/source/kind",schemaPath:"#/properties/source/oneOf/0/properties/kind/const",keyword:"const",params:{allowedValue: "system"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/0/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
var _valid0 = _errs12 === errors;
if(_valid0){
valid2 = true;
passing0 = 0;
var props0 = true;
}
const _errs16 = errors;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.kind === undefined){
const err22 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/1/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data4.asset === undefined){
const err23 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/1/required",keyword:"required",params:{missingProperty: "asset"},message:"must have required property '"+"asset"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
for(const key2 in data4){
if(!((key2 === "kind") || (key2 === "asset"))){
const err24 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data4.kind !== undefined){
if("embedded" !== data4.kind){
const err25 = {instancePath:instancePath+"/source/kind",schemaPath:"#/properties/source/oneOf/1/properties/kind/const",keyword:"const",params:{allowedValue: "embedded"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data4.asset !== undefined){
let data7 = data4.asset;
if(typeof data7 === "string"){
if(func3(data7) > 128){
const err26 = {instancePath:instancePath+"/source/asset",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(func3(data7) < 1){
const err27 = {instancePath:instancePath+"/source/asset",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(!pattern4.test(data7)){
const err28 = {instancePath:instancePath+"/source/asset",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
else {
const err29 = {instancePath:instancePath+"/source/asset",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
else {
const err30 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
var _valid0 = _errs16 === errors;
if(_valid0 && valid2){
valid2 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid2 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid2){
const err31 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
else {
errors = _errs11;
if(vErrors !== null){
if(_errs11){
vErrors.length = _errs11;
}
else {
vErrors = null;
}
}
}
}
if(data.license !== undefined){
let data8 = data.license;
if(data8 && typeof data8 == "object" && !Array.isArray(data8)){
if(data8.spdx === undefined){
const err32 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/required",keyword:"required",params:{missingProperty: "spdx"},message:"must have required property '"+"spdx"+"'"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data8.embedding === undefined){
const err33 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/required",keyword:"required",params:{missingProperty: "embedding"},message:"must have required property '"+"embedding"+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
for(const key3 in data8){
if(!(((key3 === "spdx") || (key3 === "embedding")) || (key3 === "notice"))){
const err34 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data8.spdx !== undefined){
let data9 = data8.spdx;
if(typeof data9 === "string"){
if(func3(data9) > 128){
const err35 = {instancePath:instancePath+"/license/spdx",schemaPath:"#/properties/license/properties/spdx/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(func3(data9) < 1){
const err36 = {instancePath:instancePath+"/license/spdx",schemaPath:"#/properties/license/properties/spdx/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
else {
const err37 = {instancePath:instancePath+"/license/spdx",schemaPath:"#/properties/license/properties/spdx/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data8.embedding !== undefined){
let data10 = data8.embedding;
if(!(((((data10 === "installable") || (data10 === "editable")) || (data10 === "preview-print")) || (data10 === "restricted")) || (data10 === "unknown"))){
const err38 = {instancePath:instancePath+"/license/embedding",schemaPath:"#/properties/license/properties/embedding/enum",keyword:"enum",params:{allowedValues: schema37.properties.license.properties.embedding.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data8.notice !== undefined){
let data11 = data8.notice;
if(typeof data11 === "string"){
if(func3(data11) > 4096){
const err39 = {instancePath:instancePath+"/license/notice",schemaPath:"#/properties/license/properties/notice/maxLength",keyword:"maxLength",params:{limit: 4096},message:"must NOT have more than 4096 characters"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
else {
const err40 = {instancePath:instancePath+"/license/notice",schemaPath:"#/properties/license/properties/notice/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
else {
const err41 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
}
else {
const err42 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
validate24.errors = vErrors;
return errors === 0;
}
validate24.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate26(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate26.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.digest === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.mediaType === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "mediaType"},message:"must have required property '"+"mediaType"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.byteLength === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.data === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "data"},message:"must have required property '"+"data"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "id") || (key0 === "digest")) || (key0 === "mediaType")) || (key0 === "byteLength")) || (key0 === "data"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(func3(data0) < 1){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!pattern4.test(data0)){
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.digest !== undefined){
let data1 = data.digest;
if(typeof data1 === "string"){
if(!pattern9.test(data1)){
const err10 = {instancePath:instancePath+"/digest",schemaPath:"#/properties/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/digest",schemaPath:"#/properties/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.mediaType !== undefined){
let data2 = data.mediaType;
if(!(((((((data2 === "image/png") || (data2 === "image/jpeg")) || (data2 === "image/webp")) || (data2 === "font/woff2")) || (data2 === "font/woff")) || (data2 === "font/ttf")) || (data2 === "font/otf"))){
const err12 = {instancePath:instancePath+"/mediaType",schemaPath:"#/properties/mediaType/enum",keyword:"enum",params:{allowedValues: schema40.properties.mediaType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.byteLength !== undefined){
let data3 = data.byteLength;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err13 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 536870912 || isNaN(data3)){
const err14 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 536870912},message:"must be <= 536870912"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data3 < 0 || isNaN(data3)){
const err15 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
if(data.data !== undefined){
let data4 = data.data;
if(typeof data4 === "string"){
if(func3(data4) > 715827884){
const err16 = {instancePath:instancePath+"/data",schemaPath:"#/properties/data/maxLength",keyword:"maxLength",params:{limit: 715827884},message:"must NOT have more than 715827884 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/data",schemaPath:"#/properties/data/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
else {
const err18 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
validate26.errors = vErrors;
return errors === 0;
}
validate26.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate21(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/scene.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate21.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.format === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.documentId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "documentId"},message:"must have required property '"+"documentId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.revision === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "revision"},message:"must have required property '"+"revision"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.name === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.canvas === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "canvas"},message:"must have required property '"+"canvas"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.fonts === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fonts"},message:"must have required property '"+"fonts"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.assets === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assets"},message:"must have required property '"+"assets"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.children === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "children"},message:"must have required property '"+"children"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema32.properties, key0))){
const err9 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.$schema !== undefined){
let data0 = data.$schema;
if(typeof data0 !== "string"){
const err10 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if("https://maipo.design/schema/0.1/scene.schema.json" !== data0){
const err11 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/scene.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-scene" !== data.format){
const err12 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-scene"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err13 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.documentId !== undefined){
let data3 = data.documentId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err14 = {instancePath:instancePath+"/documentId",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(func3(data3) < 1){
const err15 = {instancePath:instancePath+"/documentId",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(!pattern4.test(data3)){
const err16 = {instancePath:instancePath+"/documentId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/documentId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.revision !== undefined){
let data4 = data.revision;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err18 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err19 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
if(data.name !== undefined){
let data5 = data.name;
if(typeof data5 === "string"){
if(func3(data5) > 256){
const err20 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/name/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(func3(data5) < 1){
const err21 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.canvas !== undefined){
if(!(validate22(data.canvas, {instancePath:instancePath+"/canvas",parentData:data,parentDataProperty:"canvas",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
errors = vErrors.length;
}
}
if(data.fonts !== undefined){
let data7 = data.fonts;
if(Array.isArray(data7)){
if(data7.length > 256){
const err23 = {instancePath:instancePath+"/fonts",schemaPath:"#/properties/fonts/maxItems",keyword:"maxItems",params:{limit: 256},message:"must NOT have more than 256 items"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
const len0 = data7.length;
for(let i0=0; i0<len0; i0++){
if(!(validate24(data7[i0], {instancePath:instancePath+"/fonts/" + i0,parentData:data7,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
errors = vErrors.length;
}
}
}
else {
const err24 = {instancePath:instancePath+"/fonts",schemaPath:"#/properties/fonts/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.assets !== undefined){
let data9 = data.assets;
if(Array.isArray(data9)){
if(data9.length > 4096){
const err25 = {instancePath:instancePath+"/assets",schemaPath:"#/properties/assets/maxItems",keyword:"maxItems",params:{limit: 4096},message:"must NOT have more than 4096 items"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
const len1 = data9.length;
for(let i1=0; i1<len1; i1++){
if(!(validate26(data9[i1], {instancePath:instancePath+"/assets/" + i1,parentData:data9,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate26.errors : vErrors.concat(validate26.errors);
errors = vErrors.length;
}
}
}
else {
const err26 = {instancePath:instancePath+"/assets",schemaPath:"#/properties/assets/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.children !== undefined){
let data11 = data.children;
if(Array.isArray(data11)){
if(data11.length > 4096){
const err27 = {instancePath:instancePath+"/children",schemaPath:"#/properties/children/maxItems",keyword:"maxItems",params:{limit: 4096},message:"must NOT have more than 4096 items"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
const len2 = data11.length;
for(let i2=0; i2<len2; i2++){
if(!(validate28(data11[i2], {instancePath:instancePath+"/children/" + i2,parentData:data11,parentDataProperty:i2,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate28.errors : vErrors.concat(validate28.errors);
errors = vErrors.length;
}
}
}
else {
const err28 = {instancePath:instancePath+"/children",schemaPath:"#/properties/children/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.extensionDeclarations !== undefined){
let data13 = data.extensionDeclarations;
if(Array.isArray(data13)){
if(data13.length > 64){
const err29 = {instancePath:instancePath+"/extensionDeclarations",schemaPath:"#/properties/extensionDeclarations/maxItems",keyword:"maxItems",params:{limit: 64},message:"must NOT have more than 64 items"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
const len3 = data13.length;
for(let i3=0; i3<len3; i3++){
let data14 = data13[i3];
if(data14 && typeof data14 == "object" && !Array.isArray(data14)){
if(data14.key === undefined){
const err30 = {instancePath:instancePath+"/extensionDeclarations/" + i3,schemaPath:"#/$defs/extensionDeclaration/required",keyword:"required",params:{missingProperty: "key"},message:"must have required property '"+"key"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data14.version === undefined){
const err31 = {instancePath:instancePath+"/extensionDeclarations/" + i3,schemaPath:"#/$defs/extensionDeclaration/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data14.kind === undefined){
const err32 = {instancePath:instancePath+"/extensionDeclarations/" + i3,schemaPath:"#/$defs/extensionDeclaration/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
for(const key1 in data14){
if(!(((((key1 === "key") || (key1 === "version")) || (key1 === "kind")) || (key1 === "required")) || (key1 === "schemaId"))){
const err33 = {instancePath:instancePath+"/extensionDeclarations/" + i3,schemaPath:"#/$defs/extensionDeclaration/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data14.key !== undefined){
let data15 = data14.key;
if(typeof data15 === "string"){
if(!pattern12.test(data15)){
const err34 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/key",schemaPath:"#/$defs/extensionDeclaration/properties/key/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},message:"must match pattern \""+"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"+"\""};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
else {
const err35 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/key",schemaPath:"#/$defs/extensionDeclaration/properties/key/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data14.version !== undefined){
let data16 = data14.version;
if(typeof data16 === "string"){
if(func3(data16) > 64){
const err36 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/version",schemaPath:"#/$defs/extensionDeclaration/properties/version/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(func3(data16) < 1){
const err37 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/version",schemaPath:"#/$defs/extensionDeclaration/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(!pattern25.test(data16)){
const err38 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/version",schemaPath:"#/$defs/extensionDeclaration/properties/version/pattern",keyword:"pattern",params:{pattern: "^[0-9A-Za-z][0-9A-Za-z._+-]*$"},message:"must match pattern \""+"^[0-9A-Za-z][0-9A-Za-z._+-]*$"+"\""};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
else {
const err39 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/version",schemaPath:"#/$defs/extensionDeclaration/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data14.kind !== undefined){
if("metadata" !== data14.kind){
const err40 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/kind",schemaPath:"#/$defs/extensionDeclaration/properties/kind/const",keyword:"const",params:{allowedValue: "metadata"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data14.required !== undefined){
if(typeof data14.required !== "boolean"){
const err41 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/required",schemaPath:"#/$defs/extensionDeclaration/properties/required/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
if(data14.schemaId !== undefined){
let data19 = data14.schemaId;
if(typeof data19 === "string"){
if(func3(data19) > 2048){
const err42 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/schemaId",schemaPath:"#/$defs/extensionDeclaration/properties/schemaId/maxLength",keyword:"maxLength",params:{limit: 2048},message:"must NOT have more than 2048 characters"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(func3(data19) < 1){
const err43 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/schemaId",schemaPath:"#/$defs/extensionDeclaration/properties/schemaId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
else {
const err44 = {instancePath:instancePath+"/extensionDeclarations/" + i3+"/schemaId",schemaPath:"#/$defs/extensionDeclaration/properties/schemaId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
}
else {
const err45 = {instancePath:instancePath+"/extensionDeclarations/" + i3,schemaPath:"#/$defs/extensionDeclaration/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
}
else {
const err46 = {instancePath:instancePath+"/extensionDeclarations",schemaPath:"#/properties/extensionDeclarations/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
if(data.extensions !== undefined){
let data20 = data.extensions;
if(data20 && typeof data20 == "object" && !Array.isArray(data20)){
if(Object.keys(data20).length > 64){
const err47 = {instancePath:instancePath+"/extensions",schemaPath:"#/$defs/extensions/maxProperties",keyword:"maxProperties",params:{limit: 64},message:"must NOT have more than 64 properties"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
for(const key2 in data20){
const _errs42 = errors;
if(typeof key2 === "string"){
if(!pattern12.test(key2)){
const err48 = {instancePath:instancePath+"/extensions",schemaPath:"#/$defs/extensions/propertyNames/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},message:"must match pattern \""+"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"+"\"",propertyName:key2};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
var valid14 = _errs42 === errors;
if(!valid14){
const err49 = {instancePath:instancePath+"/extensions",schemaPath:"#/$defs/extensions/propertyNames",keyword:"propertyNames",params:{propertyName: key2},message:"property name must be valid"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
}
else {
const err50 = {instancePath:instancePath+"/extensions",schemaPath:"#/$defs/extensions/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
}
else {
const err51 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
validate21.errors = vErrors;
return errors === 0;
}
validate21.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validatePatchSchema = validate81;
const schema109 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/patch.schema.json","title":"Maipo atomic patch 0.1","description":"Experimental transaction envelope for a Maipo public scene.","type":"object","additionalProperties":false,"required":["format","version","documentId","baseRevision","clientPatchId","operations"],"properties":{"$schema":{"type":"string","const":"https://maipo.design/schema/0.1/patch.schema.json"},"format":{"const":"maipo-patch"},"version":{"const":"0.1"},"documentId":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"baseRevision":{"type":"integer","minimum":0},"clientPatchId":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"operations":{"type":"array","minItems":1,"maxItems":10000,"items":{"$ref":"#/$defs/operation"}}},"$defs":{"editablePath":{"type":"string","enum":["/name","/role","/visible","/opacity","/fillOpacity","/blendMode","/locked","/clipping","/transform","/transform/x","/transform/y","/transform/rotation","/transform/scaleX","/transform/scaleY","/transform/skewX","/text","/frame","/frame/width","/frame/height","/frame/autoHeight","/frame/fit","/style","/style/fontRef","/style/fontFamily","/style/fontWeight","/style/fontSize","/style/lineHeight","/style/letterSpacing","/style/textAlign","/style/color","/fill","/stroke","/geometry"]},"set":{"type":"object","additionalProperties":false,"required":["op","target","path","value"],"properties":{"op":{"const":"set"},"target":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"path":{"$ref":"#/$defs/editablePath"},"value":true}},"insert":{"type":"object","additionalProperties":false,"required":["op","parent","node"],"properties":{"op":{"const":"insert"},"parent":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"before":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"node":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/node"}}},"remove":{"type":"object","additionalProperties":false,"required":["op","target"],"properties":{"op":{"const":"remove"},"target":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"}}},"move":{"type":"object","additionalProperties":false,"required":["op","target","parent"],"properties":{"op":{"const":"move"},"target":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"parent":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"before":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"}}},"operation":{"oneOf":[{"$ref":"#/$defs/set"},{"$ref":"#/$defs/insert"},{"$ref":"#/$defs/remove"},{"$ref":"#/$defs/move"}]}}};
const schema112 = {"oneOf":[{"$ref":"#/$defs/set"},{"$ref":"#/$defs/insert"},{"$ref":"#/$defs/remove"},{"$ref":"#/$defs/move"}]};
const schema113 = {"type":"object","additionalProperties":false,"required":["op","target","path","value"],"properties":{"op":{"const":"set"},"target":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"path":{"$ref":"#/$defs/editablePath"},"value":true}};
const schema115 = {"type":"string","enum":["/name","/role","/visible","/opacity","/fillOpacity","/blendMode","/locked","/clipping","/transform","/transform/x","/transform/y","/transform/rotation","/transform/scaleX","/transform/scaleY","/transform/skewX","/text","/frame","/frame/width","/frame/height","/frame/autoHeight","/frame/fit","/style","/style/fontRef","/style/fontFamily","/style/fontWeight","/style/fontSize","/style/lineHeight","/style/letterSpacing","/style/textAlign","/style/color","/fill","/stroke","/geometry"]};

function validate83(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate83.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.op === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "op"},message:"must have required property '"+"op"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.target === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.path === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "path"},message:"must have required property '"+"path"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.value === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "value"},message:"must have required property '"+"value"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "op") || (key0 === "target")) || (key0 === "path")) || (key0 === "value"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.op !== undefined){
if("set" !== data.op){
const err5 = {instancePath:instancePath+"/op",schemaPath:"#/properties/op/const",keyword:"const",params:{allowedValue: "set"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.target !== undefined){
let data1 = data.target;
if(typeof data1 === "string"){
if(func3(data1) > 128){
const err6 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(func3(data1) < 1){
const err7 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!pattern4.test(data1)){
const err8 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.path !== undefined){
let data2 = data.path;
if(typeof data2 !== "string"){
const err10 = {instancePath:instancePath+"/path",schemaPath:"#/$defs/editablePath/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!(((((((((((((((((((((((((((((((((data2 === "/name") || (data2 === "/role")) || (data2 === "/visible")) || (data2 === "/opacity")) || (data2 === "/fillOpacity")) || (data2 === "/blendMode")) || (data2 === "/locked")) || (data2 === "/clipping")) || (data2 === "/transform")) || (data2 === "/transform/x")) || (data2 === "/transform/y")) || (data2 === "/transform/rotation")) || (data2 === "/transform/scaleX")) || (data2 === "/transform/scaleY")) || (data2 === "/transform/skewX")) || (data2 === "/text")) || (data2 === "/frame")) || (data2 === "/frame/width")) || (data2 === "/frame/height")) || (data2 === "/frame/autoHeight")) || (data2 === "/frame/fit")) || (data2 === "/style")) || (data2 === "/style/fontRef")) || (data2 === "/style/fontFamily")) || (data2 === "/style/fontWeight")) || (data2 === "/style/fontSize")) || (data2 === "/style/lineHeight")) || (data2 === "/style/letterSpacing")) || (data2 === "/style/textAlign")) || (data2 === "/style/color")) || (data2 === "/fill")) || (data2 === "/stroke")) || (data2 === "/geometry"))){
const err11 = {instancePath:instancePath+"/path",schemaPath:"#/$defs/editablePath/enum",keyword:"enum",params:{allowedValues: schema115.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate83.errors = vErrors;
return errors === 0;
}
validate83.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema116 = {"type":"object","additionalProperties":false,"required":["op","parent","node"],"properties":{"op":{"const":"insert"},"parent":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"before":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"node":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/node"}}};

function validate86(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate86.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate29(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate29.errors : vErrors.concat(validate29.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate35(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate35.errors : vErrors.concat(validate35.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
const _errs3 = errors;
if(!(validate38(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate38.errors : vErrors.concat(validate38.errors);
errors = vErrors.length;
}
var _valid0 = _errs3 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
if(props0 !== true){
props0 = true;
}
}
const _errs4 = errors;
if(!(validate67(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate67.errors : vErrors.concat(validate67.errors);
errors = vErrors.length;
}
var _valid0 = _errs4 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 3];
}
else {
if(_valid0){
valid0 = true;
passing0 = 3;
if(props0 !== true){
props0 = true;
}
}
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate86.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate86.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate85(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate85.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.op === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "op"},message:"must have required property '"+"op"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.parent === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "parent"},message:"must have required property '"+"parent"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.node === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "node"},message:"must have required property '"+"node"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "op") || (key0 === "parent")) || (key0 === "before")) || (key0 === "node"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.op !== undefined){
if("insert" !== data.op){
const err4 = {instancePath:instancePath+"/op",schemaPath:"#/properties/op/const",keyword:"const",params:{allowedValue: "insert"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.parent !== undefined){
let data1 = data.parent;
if(typeof data1 === "string"){
if(func3(data1) > 128){
const err5 = {instancePath:instancePath+"/parent",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func3(data1) < 1){
const err6 = {instancePath:instancePath+"/parent",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern4.test(data1)){
const err7 = {instancePath:instancePath+"/parent",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/parent",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.before !== undefined){
let data2 = data.before;
if(typeof data2 === "string"){
if(func3(data2) > 128){
const err9 = {instancePath:instancePath+"/before",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func3(data2) < 1){
const err10 = {instancePath:instancePath+"/before",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!pattern4.test(data2)){
const err11 = {instancePath:instancePath+"/before",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/before",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.node !== undefined){
if(!(validate86(data.node, {instancePath:instancePath+"/node",parentData:data,parentDataProperty:"node",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate86.errors : vErrors.concat(validate86.errors);
errors = vErrors.length;
}
}
}
else {
const err13 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
validate85.errors = vErrors;
return errors === 0;
}
validate85.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema120 = {"type":"object","additionalProperties":false,"required":["op","target"],"properties":{"op":{"const":"remove"},"target":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"}}};

function validate93(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate93.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.op === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "op"},message:"must have required property '"+"op"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.target === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "op") || (key0 === "target"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.op !== undefined){
if("remove" !== data.op){
const err3 = {instancePath:instancePath+"/op",schemaPath:"#/properties/op/const",keyword:"const",params:{allowedValue: "remove"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.target !== undefined){
let data1 = data.target;
if(typeof data1 === "string"){
if(func3(data1) > 128){
const err4 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(func3(data1) < 1){
const err5 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!pattern4.test(data1)){
const err6 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate93.errors = vErrors;
return errors === 0;
}
validate93.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema122 = {"type":"object","additionalProperties":false,"required":["op","target","parent"],"properties":{"op":{"const":"move"},"target":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"parent":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"before":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"}}};

function validate95(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate95.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.op === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "op"},message:"must have required property '"+"op"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.target === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.parent === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "parent"},message:"must have required property '"+"parent"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "op") || (key0 === "target")) || (key0 === "parent")) || (key0 === "before"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.op !== undefined){
if("move" !== data.op){
const err4 = {instancePath:instancePath+"/op",schemaPath:"#/properties/op/const",keyword:"const",params:{allowedValue: "move"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.target !== undefined){
let data1 = data.target;
if(typeof data1 === "string"){
if(func3(data1) > 128){
const err5 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func3(data1) < 1){
const err6 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern4.test(data1)){
const err7 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.parent !== undefined){
let data2 = data.parent;
if(typeof data2 === "string"){
if(func3(data2) > 128){
const err9 = {instancePath:instancePath+"/parent",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func3(data2) < 1){
const err10 = {instancePath:instancePath+"/parent",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!pattern4.test(data2)){
const err11 = {instancePath:instancePath+"/parent",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/parent",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.before !== undefined){
let data3 = data.before;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err13 = {instancePath:instancePath+"/before",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(func3(data3) < 1){
const err14 = {instancePath:instancePath+"/before",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(!pattern4.test(data3)){
const err15 = {instancePath:instancePath+"/before",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/before",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate95.errors = vErrors;
return errors === 0;
}
validate95.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate82(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate82.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate83(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate83.errors : vErrors.concat(validate83.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate85(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate85.errors : vErrors.concat(validate85.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
const _errs3 = errors;
if(!(validate93(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate93.errors : vErrors.concat(validate93.errors);
errors = vErrors.length;
}
var _valid0 = _errs3 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
if(props0 !== true){
props0 = true;
}
}
const _errs4 = errors;
if(!(validate95(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate95.errors : vErrors.concat(validate95.errors);
errors = vErrors.length;
}
var _valid0 = _errs4 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 3];
}
else {
if(_valid0){
valid0 = true;
passing0 = 3;
if(props0 !== true){
props0 = true;
}
}
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate82.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate82.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate81(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/patch.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate81.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.format === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.documentId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "documentId"},message:"must have required property '"+"documentId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.baseRevision === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "baseRevision"},message:"must have required property '"+"baseRevision"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.clientPatchId === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "clientPatchId"},message:"must have required property '"+"clientPatchId"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.operations === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operations"},message:"must have required property '"+"operations"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "$schema") || (key0 === "format")) || (key0 === "version")) || (key0 === "documentId")) || (key0 === "baseRevision")) || (key0 === "clientPatchId")) || (key0 === "operations"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.$schema !== undefined){
let data0 = data.$schema;
if(typeof data0 !== "string"){
const err7 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if("https://maipo.design/schema/0.1/patch.schema.json" !== data0){
const err8 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/patch.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-patch" !== data.format){
const err9 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-patch"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err10 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.documentId !== undefined){
let data3 = data.documentId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err11 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(func3(data3) < 1){
const err12 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(!pattern4.test(data3)){
const err13 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.baseRevision !== undefined){
let data4 = data.baseRevision;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err15 = {instancePath:instancePath+"/baseRevision",schemaPath:"#/properties/baseRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err16 = {instancePath:instancePath+"/baseRevision",schemaPath:"#/properties/baseRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
if(data.clientPatchId !== undefined){
let data5 = data.clientPatchId;
if(typeof data5 === "string"){
if(func3(data5) > 128){
const err17 = {instancePath:instancePath+"/clientPatchId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(func3(data5) < 1){
const err18 = {instancePath:instancePath+"/clientPatchId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(!pattern4.test(data5)){
const err19 = {instancePath:instancePath+"/clientPatchId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/clientPatchId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.operations !== undefined){
let data6 = data.operations;
if(Array.isArray(data6)){
if(data6.length > 10000){
const err21 = {instancePath:instancePath+"/operations",schemaPath:"#/properties/operations/maxItems",keyword:"maxItems",params:{limit: 10000},message:"must NOT have more than 10000 items"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data6.length < 1){
const err22 = {instancePath:instancePath+"/operations",schemaPath:"#/properties/operations/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
const len0 = data6.length;
for(let i0=0; i0<len0; i0++){
if(!(validate82(data6[i0], {instancePath:instancePath+"/operations/" + i0,parentData:data6,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate82.errors : vErrors.concat(validate82.errors);
errors = vErrors.length;
}
}
}
else {
const err23 = {instancePath:instancePath+"/operations",schemaPath:"#/properties/operations/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
else {
const err24 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
validate81.errors = vErrors;
return errors === 0;
}
validate81.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validatePackageSchema = validate98;
const schema126 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/package.schema.json","title":"Maipo public package manifest 0.1","description":"Manifest for the deterministic packed form of a Maipo public scene.","type":"object","additionalProperties":false,"required":["format","version","scene","sceneDigest","entryCount","expandedBytes","assets"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/package.schema.json"},"format":{"const":"maipo-package"},"version":{"const":"0.1"},"scene":{"const":"scene.maipo.json"},"sceneDigest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"entryCount":{"type":"integer","minimum":2,"maximum":4098},"expandedBytes":{"type":"integer","minimum":0,"maximum":1073741824},"assets":{"type":"array","maxItems":4096,"items":{"type":"object","additionalProperties":false,"required":["id","digest","mediaType","byteLength","path"],"properties":{"id":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"mediaType":{"enum":["image/png","image/jpeg","image/webp","font/woff2","font/woff","font/ttf","font/otf"]},"byteLength":{"type":"integer","minimum":0,"maximum":536870912},"path":{"type":"string","pattern":"^assets/sha256/[0-9a-f]{64}$"}}}}}};
const pattern48 = new RegExp("^assets/sha256/[0-9a-f]{64}$", "u");

function validate98(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/package.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate98.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.format === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.scene === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "scene"},message:"must have required property '"+"scene"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.sceneDigest === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sceneDigest"},message:"must have required property '"+"sceneDigest"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.entryCount === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "entryCount"},message:"must have required property '"+"entryCount"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.expandedBytes === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expandedBytes"},message:"must have required property '"+"expandedBytes"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.assets === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assets"},message:"must have required property '"+"assets"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "$schema") || (key0 === "format")) || (key0 === "version")) || (key0 === "scene")) || (key0 === "sceneDigest")) || (key0 === "entryCount")) || (key0 === "expandedBytes")) || (key0 === "assets"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/package.schema.json" !== data.$schema){
const err8 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/package.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-package" !== data.format){
const err9 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-package"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err10 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.scene !== undefined){
if("scene.maipo.json" !== data.scene){
const err11 = {instancePath:instancePath+"/scene",schemaPath:"#/properties/scene/const",keyword:"const",params:{allowedValue: "scene.maipo.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.sceneDigest !== undefined){
let data4 = data.sceneDigest;
if(typeof data4 === "string"){
if(!pattern9.test(data4)){
const err12 = {instancePath:instancePath+"/sceneDigest",schemaPath:"#/properties/sceneDigest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/sceneDigest",schemaPath:"#/properties/sceneDigest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.entryCount !== undefined){
let data5 = data.entryCount;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err14 = {instancePath:instancePath+"/entryCount",schemaPath:"#/properties/entryCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 4098 || isNaN(data5)){
const err15 = {instancePath:instancePath+"/entryCount",schemaPath:"#/properties/entryCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4098},message:"must be <= 4098"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data5 < 2 || isNaN(data5)){
const err16 = {instancePath:instancePath+"/entryCount",schemaPath:"#/properties/entryCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 2},message:"must be >= 2"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
if(data.expandedBytes !== undefined){
let data6 = data.expandedBytes;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err17 = {instancePath:instancePath+"/expandedBytes",schemaPath:"#/properties/expandedBytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 > 1073741824 || isNaN(data6)){
const err18 = {instancePath:instancePath+"/expandedBytes",schemaPath:"#/properties/expandedBytes/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1073741824},message:"must be <= 1073741824"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data6 < 0 || isNaN(data6)){
const err19 = {instancePath:instancePath+"/expandedBytes",schemaPath:"#/properties/expandedBytes/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
if(data.assets !== undefined){
let data7 = data.assets;
if(Array.isArray(data7)){
if(data7.length > 4096){
const err20 = {instancePath:instancePath+"/assets",schemaPath:"#/properties/assets/maxItems",keyword:"maxItems",params:{limit: 4096},message:"must NOT have more than 4096 items"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
const len0 = data7.length;
for(let i0=0; i0<len0; i0++){
let data8 = data7[i0];
if(data8 && typeof data8 == "object" && !Array.isArray(data8)){
if(data8.id === undefined){
const err21 = {instancePath:instancePath+"/assets/" + i0,schemaPath:"#/properties/assets/items/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data8.digest === undefined){
const err22 = {instancePath:instancePath+"/assets/" + i0,schemaPath:"#/properties/assets/items/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data8.mediaType === undefined){
const err23 = {instancePath:instancePath+"/assets/" + i0,schemaPath:"#/properties/assets/items/required",keyword:"required",params:{missingProperty: "mediaType"},message:"must have required property '"+"mediaType"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data8.byteLength === undefined){
const err24 = {instancePath:instancePath+"/assets/" + i0,schemaPath:"#/properties/assets/items/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data8.path === undefined){
const err25 = {instancePath:instancePath+"/assets/" + i0,schemaPath:"#/properties/assets/items/required",keyword:"required",params:{missingProperty: "path"},message:"must have required property '"+"path"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
for(const key1 in data8){
if(!(((((key1 === "id") || (key1 === "digest")) || (key1 === "mediaType")) || (key1 === "byteLength")) || (key1 === "path"))){
const err26 = {instancePath:instancePath+"/assets/" + i0,schemaPath:"#/properties/assets/items/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data8.id !== undefined){
let data9 = data8.id;
if(typeof data9 === "string"){
if(func3(data9) > 128){
const err27 = {instancePath:instancePath+"/assets/" + i0+"/id",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(func3(data9) < 1){
const err28 = {instancePath:instancePath+"/assets/" + i0+"/id",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(!pattern4.test(data9)){
const err29 = {instancePath:instancePath+"/assets/" + i0+"/id",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/assets/" + i0+"/id",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data8.digest !== undefined){
let data10 = data8.digest;
if(typeof data10 === "string"){
if(!pattern9.test(data10)){
const err31 = {instancePath:instancePath+"/assets/" + i0+"/digest",schemaPath:"#/properties/assets/items/properties/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
else {
const err32 = {instancePath:instancePath+"/assets/" + i0+"/digest",schemaPath:"#/properties/assets/items/properties/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data8.mediaType !== undefined){
let data11 = data8.mediaType;
if(!(((((((data11 === "image/png") || (data11 === "image/jpeg")) || (data11 === "image/webp")) || (data11 === "font/woff2")) || (data11 === "font/woff")) || (data11 === "font/ttf")) || (data11 === "font/otf"))){
const err33 = {instancePath:instancePath+"/assets/" + i0+"/mediaType",schemaPath:"#/properties/assets/items/properties/mediaType/enum",keyword:"enum",params:{allowedValues: schema126.properties.assets.items.properties.mediaType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data8.byteLength !== undefined){
let data12 = data8.byteLength;
if(!(((typeof data12 == "number") && (!(data12 % 1) && !isNaN(data12))) && (isFinite(data12)))){
const err34 = {instancePath:instancePath+"/assets/" + i0+"/byteLength",schemaPath:"#/properties/assets/items/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if((typeof data12 == "number") && (isFinite(data12))){
if(data12 > 536870912 || isNaN(data12)){
const err35 = {instancePath:instancePath+"/assets/" + i0+"/byteLength",schemaPath:"#/properties/assets/items/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 536870912},message:"must be <= 536870912"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data12 < 0 || isNaN(data12)){
const err36 = {instancePath:instancePath+"/assets/" + i0+"/byteLength",schemaPath:"#/properties/assets/items/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
if(data8.path !== undefined){
let data13 = data8.path;
if(typeof data13 === "string"){
if(!pattern48.test(data13)){
const err37 = {instancePath:instancePath+"/assets/" + i0+"/path",schemaPath:"#/properties/assets/items/properties/path/pattern",keyword:"pattern",params:{pattern: "^assets/sha256/[0-9a-f]{64}$"},message:"must match pattern \""+"^assets/sha256/[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
else {
const err38 = {instancePath:instancePath+"/assets/" + i0+"/path",schemaPath:"#/properties/assets/items/properties/path/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
}
else {
const err39 = {instancePath:instancePath+"/assets/" + i0,schemaPath:"#/properties/assets/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
}
else {
const err40 = {instancePath:instancePath+"/assets",schemaPath:"#/properties/assets/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
else {
const err41 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
validate98.errors = vErrors;
return errors === 0;
}
validate98.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateRendererRequestSchema = validate99;
const schema128 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/renderer-request.schema.json","title":"Maipo renderer process request 0.1","description":"One request line in the language-neutral Maipo renderer NDJSON protocol.","oneOf":[{"$ref":"#/$defs/capabilitiesRequest"},{"$ref":"#/$defs/renderRequest"}],"$defs":{"protocol":{"const":"maipo-renderer-protocol"},"version":{"const":"0.1"},"requestId":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"profile":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"capabilitiesRequest":{"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/renderer-request.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"capabilities"}}},"renderOptions":{"type":"object","additionalProperties":false,"required":["profile","outputMediaType"],"dependentRequired":{"width":["height"],"height":["width"]},"properties":{"profile":{"$ref":"#/$defs/profile"},"outputMediaType":{"enum":["image/png","image/svg+xml"]},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"includeNodeMap":{"type":"boolean","default":false}}},"renderRequest":{"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","scene","options"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/renderer-request.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"render"},"scene":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json"},"options":{"$ref":"#/$defs/renderOptions"}}}}};
const schema129 = {"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/renderer-request.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"capabilities"}}};
const schema130 = {"const":"maipo-renderer-protocol"};
const schema131 = {"const":"0.1"};

function validate100(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate100.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.protocol === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "protocol"},message:"must have required property '"+"protocol"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.requestId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.operation === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operation"},message:"must have required property '"+"operation"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "$schema") || (key0 === "protocol")) || (key0 === "version")) || (key0 === "requestId")) || (key0 === "operation"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/renderer-request.schema.json" !== data.$schema){
const err5 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/renderer-request.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.protocol !== undefined){
if("maipo-renderer-protocol" !== data.protocol){
const err6 = {instancePath:instancePath+"/protocol",schemaPath:"#/$defs/protocol/const",keyword:"const",params:{allowedValue: "maipo-renderer-protocol"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err7 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.requestId !== undefined){
let data3 = data.requestId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err8 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func3(data3) < 1){
const err9 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!pattern4.test(data3)){
const err10 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.operation !== undefined){
if("capabilities" !== data.operation){
const err12 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/const",keyword:"const",params:{allowedValue: "capabilities"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
else {
const err13 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
validate100.errors = vErrors;
return errors === 0;
}
validate100.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema133 = {"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","scene","options"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/renderer-request.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"render"},"scene":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json"},"options":{"$ref":"#/$defs/renderOptions"}}};
const schema137 = {"type":"object","additionalProperties":false,"required":["profile","outputMediaType"],"dependentRequired":{"width":["height"],"height":["width"]},"properties":{"profile":{"$ref":"#/$defs/profile"},"outputMediaType":{"enum":["image/png","image/svg+xml"]},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"includeNodeMap":{"type":"boolean","default":false}}};
const schema138 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};

function validate104(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate104.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.profile === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profile"},message:"must have required property '"+"profile"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.outputMediaType === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "outputMediaType"},message:"must have required property '"+"outputMediaType"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "profile") || (key0 === "outputMediaType")) || (key0 === "width")) || (key0 === "height")) || (key0 === "includeNodeMap"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.profile !== undefined){
let data0 = data.profile;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err3 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func3(data0) < 1){
const err4 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern4.test(data0)){
const err5 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.outputMediaType !== undefined){
let data1 = data.outputMediaType;
if(!((data1 === "image/png") || (data1 === "image/svg+xml"))){
const err7 = {instancePath:instancePath+"/outputMediaType",schemaPath:"#/properties/outputMediaType/enum",keyword:"enum",params:{allowedValues: schema137.properties.outputMediaType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.width !== undefined){
let data2 = data.width;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 32768 || isNaN(data2)){
const err9 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data2 < 1 || isNaN(data2)){
const err10 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
if(data.height !== undefined){
let data3 = data.height;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err11 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 32768 || isNaN(data3)){
const err12 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data3 < 1 || isNaN(data3)){
const err13 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data.includeNodeMap !== undefined){
if(typeof data.includeNodeMap !== "boolean"){
const err14 = {instancePath:instancePath+"/includeNodeMap",schemaPath:"#/properties/includeNodeMap/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.width !== undefined){
if(data.height === undefined){
const err15 = {instancePath,schemaPath:"#/dependentRequired",keyword:"dependentRequired",params:{property: "width",
    missingProperty: "height",
    depsCount: 1,
    deps: "height"},message:"must have property height when property width is present"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.height !== undefined){
if(data.width === undefined){
const err16 = {instancePath,schemaPath:"#/dependentRequired",keyword:"dependentRequired",params:{property: "height",
    missingProperty: "width",
    depsCount: 1,
    deps: "width"},message:"must have property width when property height is present"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate104.errors = vErrors;
return errors === 0;
}
validate104.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate102(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate102.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.protocol === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "protocol"},message:"must have required property '"+"protocol"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.requestId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.operation === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operation"},message:"must have required property '"+"operation"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.scene === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "scene"},message:"must have required property '"+"scene"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.options === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "options"},message:"must have required property '"+"options"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "$schema") || (key0 === "protocol")) || (key0 === "version")) || (key0 === "requestId")) || (key0 === "operation")) || (key0 === "scene")) || (key0 === "options"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/renderer-request.schema.json" !== data.$schema){
const err7 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/renderer-request.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.protocol !== undefined){
if("maipo-renderer-protocol" !== data.protocol){
const err8 = {instancePath:instancePath+"/protocol",schemaPath:"#/$defs/protocol/const",keyword:"const",params:{allowedValue: "maipo-renderer-protocol"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err9 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.requestId !== undefined){
let data3 = data.requestId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err10 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func3(data3) < 1){
const err11 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern4.test(data3)){
const err12 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.operation !== undefined){
if("render" !== data.operation){
const err14 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/const",keyword:"const",params:{allowedValue: "render"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.scene !== undefined){
if(!(validate21(data.scene, {instancePath:instancePath+"/scene",parentData:data,parentDataProperty:"scene",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
errors = vErrors.length;
}
}
if(data.options !== undefined){
if(!(validate104(data.options, {instancePath:instancePath+"/options",parentData:data,parentDataProperty:"options",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate104.errors : vErrors.concat(validate104.errors);
errors = vErrors.length;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate102.errors = vErrors;
return errors === 0;
}
validate102.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate99(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/renderer-request.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate99.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate100(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate100.errors : vErrors.concat(validate100.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate102(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate102.errors : vErrors.concat(validate102.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate99.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate99.evaluated = {"dynamicProps":true,"dynamicItems":false};

export const validateRendererResponseSchema = validate107;
const schema139 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/renderer-response.schema.json","title":"Maipo renderer process response 0.1","description":"One response line in the language-neutral Maipo renderer NDJSON protocol.","oneOf":[{"$ref":"#/$defs/capabilitiesResponse"},{"$ref":"#/$defs/renderResponse"},{"$ref":"#/$defs/errorResponse"}],"$defs":{"protocol":{"const":"maipo-renderer-protocol"},"version":{"const":"0.1"},"requestId":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"profile":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"rendererId":{"type":"string","minLength":1,"maxLength":128,"pattern":"^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"},"renderer":{"type":"object","additionalProperties":false,"required":["id","version","backend"],"properties":{"id":{"$ref":"#/$defs/rendererId"},"version":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"},"backend":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[A-Za-z0-9][A-Za-z0-9._-]*$"}}},"features":{"type":"object","additionalProperties":false,"required":["deterministic","diagnostics","nodeBounds","nodeMap","embeddedFonts"],"properties":{"deterministic":{"type":"boolean"},"diagnostics":{"type":"boolean"},"nodeBounds":{"type":"boolean"},"nodeMap":{"type":"boolean"},"embeddedFonts":{"type":"boolean"}}},"limits":{"type":"object","additionalProperties":false,"required":["maxRequestBytes","maxArtifactBytes","maxWidth","maxHeight","maxNodeMapPixels"],"properties":{"maxRequestBytes":{"type":"integer","minimum":1024,"maximum":1073741824},"maxArtifactBytes":{"type":"integer","minimum":1024,"maximum":1073741824},"maxWidth":{"type":"integer","minimum":1,"maximum":32768},"maxHeight":{"type":"integer","minimum":1,"maximum":32768},"maxNodeMapPixels":{"type":"integer","minimum":0,"maximum":4194304}}},"capabilities":{"type":"object","additionalProperties":false,"required":["renderer","profiles","outputMediaTypes","features","limits"],"properties":{"renderer":{"$ref":"#/$defs/renderer"},"profiles":{"type":"array","minItems":1,"maxItems":128,"items":{"$ref":"#/$defs/profile"}},"outputMediaTypes":{"type":"array","minItems":1,"maxItems":2,"items":{"enum":["image/png","image/svg+xml"]}},"features":{"$ref":"#/$defs/features"},"limits":{"$ref":"#/$defs/limits"}}},"diagnostic":{"type":"object","additionalProperties":false,"required":["severity","code","message"],"properties":{"severity":{"enum":["warning","error"]},"code":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"},"target":{"$ref":"#/$defs/requestId"},"message":{"type":"string","minLength":1,"maxLength":4096}}},"artifact":{"type":"object","additionalProperties":false,"required":["mediaType","width","height","encoding","byteLength","digest","data"],"properties":{"mediaType":{"enum":["image/png","image/svg+xml"]},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"encoding":{"const":"base64"},"byteLength":{"type":"integer","minimum":0,"maximum":67108864},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"data":{"type":"string","contentEncoding":"base64","maxLength":89478488}}},"bounds":{"type":"object","additionalProperties":false,"required":["x","y","width","height"],"properties":{"x":{"type":"number","minimum":-1000000000,"maximum":1000000000},"y":{"type":"number","minimum":-1000000000,"maximum":1000000000},"width":{"type":"number","minimum":0,"maximum":1000000000},"height":{"type":"number","minimum":0,"maximum":1000000000}}},"node":{"type":"object","additionalProperties":false,"required":["id","name","visible","bounds"],"properties":{"id":{"$ref":"#/$defs/requestId"},"name":{"type":"string","minLength":1,"maxLength":1024},"role":{"type":"string","minLength":1,"maxLength":128},"visible":{"type":"boolean"},"bounds":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/bounds"}]}}},"nodeMap":{"type":"object","additionalProperties":false,"required":["width","height","ids","encoding","byteLength","digest","data"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"ids":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/requestId"}},"encoding":{"const":"uint32le-base64"},"byteLength":{"type":"integer","minimum":4,"maximum":16777216},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"data":{"type":"string","contentEncoding":"base64","maxLength":22369624}}},"timing":{"type":"object","additionalProperties":false,"required":["totalMs"],"properties":{"totalMs":{"type":"number","minimum":0,"maximum":86400000}}},"capabilitiesResponse":{"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","status","capabilities"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/renderer-response.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"capabilities"},"status":{"const":"ok"},"capabilities":{"$ref":"#/$defs/capabilities"}}},"renderResponse":{"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","status","renderer","profile","artifact","diagnostics","timing"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/renderer-response.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"render"},"status":{"const":"ok"},"renderer":{"$ref":"#/$defs/renderer"},"profile":{"$ref":"#/$defs/profile"},"artifact":{"$ref":"#/$defs/artifact"},"diagnostics":{"type":"array","maxItems":10000,"items":{"$ref":"#/$defs/diagnostic"}},"nodes":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/node"}},"nodeMap":{"$ref":"#/$defs/nodeMap"},"timing":{"$ref":"#/$defs/timing"}}},"protocolError":{"type":"object","additionalProperties":false,"required":["code","message"],"properties":{"code":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"},"message":{"type":"string","minLength":1,"maxLength":4096},"diagnostics":{"type":"array","maxItems":10000,"items":{"$ref":"#/$defs/diagnostic"}}}},"errorResponse":{"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","status","error"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/renderer-response.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"enum":["capabilities","render"]},"status":{"const":"error"},"error":{"$ref":"#/$defs/protocolError"}}}}};
const schema140 = {"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","status","capabilities"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/renderer-response.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"capabilities"},"status":{"const":"ok"},"capabilities":{"$ref":"#/$defs/capabilities"}}};
const schema141 = {"const":"maipo-renderer-protocol"};
const schema142 = {"const":"0.1"};
const schema143 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const schema144 = {"type":"object","additionalProperties":false,"required":["renderer","profiles","outputMediaTypes","features","limits"],"properties":{"renderer":{"$ref":"#/$defs/renderer"},"profiles":{"type":"array","minItems":1,"maxItems":128,"items":{"$ref":"#/$defs/profile"}},"outputMediaTypes":{"type":"array","minItems":1,"maxItems":2,"items":{"enum":["image/png","image/svg+xml"]}},"features":{"$ref":"#/$defs/features"},"limits":{"$ref":"#/$defs/limits"}}};
const schema147 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const schema148 = {"type":"object","additionalProperties":false,"required":["deterministic","diagnostics","nodeBounds","nodeMap","embeddedFonts"],"properties":{"deterministic":{"type":"boolean"},"diagnostics":{"type":"boolean"},"nodeBounds":{"type":"boolean"},"nodeMap":{"type":"boolean"},"embeddedFonts":{"type":"boolean"}}};
const schema149 = {"type":"object","additionalProperties":false,"required":["maxRequestBytes","maxArtifactBytes","maxWidth","maxHeight","maxNodeMapPixels"],"properties":{"maxRequestBytes":{"type":"integer","minimum":1024,"maximum":1073741824},"maxArtifactBytes":{"type":"integer","minimum":1024,"maximum":1073741824},"maxWidth":{"type":"integer","minimum":1,"maximum":32768},"maxHeight":{"type":"integer","minimum":1,"maximum":32768},"maxNodeMapPixels":{"type":"integer","minimum":0,"maximum":4194304}}};
const schema145 = {"type":"object","additionalProperties":false,"required":["id","version","backend"],"properties":{"id":{"$ref":"#/$defs/rendererId"},"version":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"},"backend":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[A-Za-z0-9][A-Za-z0-9._-]*$"}}};
const schema146 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"};
const pattern53 = new RegExp("^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$", "u");
const pattern54 = new RegExp("^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$", "u");
const pattern55 = new RegExp("^[A-Za-z0-9][A-Za-z0-9._-]*$", "u");

function validate110(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate110.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.backend === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "id") || (key0 === "version")) || (key0 === "backend"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/rendererId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(func3(data0) < 1){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/rendererId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!pattern53.test(data0)){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/rendererId/pattern",keyword:"pattern",params:{pattern: "^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"},message:"must match pattern \""+"^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/rendererId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.version !== undefined){
let data1 = data.version;
if(typeof data1 === "string"){
if(func3(data1) > 64){
const err8 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func3(data1) < 1){
const err9 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!pattern54.test(data1)){
const err10 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.backend !== undefined){
let data2 = data.backend;
if(typeof data2 === "string"){
if(func3(data2) > 64){
const err12 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(func3(data2) < 1){
const err13 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!pattern55.test(data2)){
const err14 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._-]*$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate110.errors = vErrors;
return errors === 0;
}
validate110.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate109(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate109.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.renderer === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "renderer"},message:"must have required property '"+"renderer"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.profiles === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profiles"},message:"must have required property '"+"profiles"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.outputMediaTypes === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "outputMediaTypes"},message:"must have required property '"+"outputMediaTypes"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.features === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "features"},message:"must have required property '"+"features"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.limits === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "limits"},message:"must have required property '"+"limits"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "renderer") || (key0 === "profiles")) || (key0 === "outputMediaTypes")) || (key0 === "features")) || (key0 === "limits"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.renderer !== undefined){
if(!(validate110(data.renderer, {instancePath:instancePath+"/renderer",parentData:data,parentDataProperty:"renderer",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate110.errors : vErrors.concat(validate110.errors);
errors = vErrors.length;
}
}
if(data.profiles !== undefined){
let data1 = data.profiles;
if(Array.isArray(data1)){
if(data1.length > 128){
const err6 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/maxItems",keyword:"maxItems",params:{limit: 128},message:"must NOT have more than 128 items"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data1.length < 1){
const err7 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if(typeof data2 === "string"){
if(func3(data2) > 128){
const err8 = {instancePath:instancePath+"/profiles/" + i0,schemaPath:"#/$defs/profile/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func3(data2) < 1){
const err9 = {instancePath:instancePath+"/profiles/" + i0,schemaPath:"#/$defs/profile/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!pattern4.test(data2)){
const err10 = {instancePath:instancePath+"/profiles/" + i0,schemaPath:"#/$defs/profile/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/profiles/" + i0,schemaPath:"#/$defs/profile/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.outputMediaTypes !== undefined){
let data3 = data.outputMediaTypes;
if(Array.isArray(data3)){
if(data3.length > 2){
const err13 = {instancePath:instancePath+"/outputMediaTypes",schemaPath:"#/properties/outputMediaTypes/maxItems",keyword:"maxItems",params:{limit: 2},message:"must NOT have more than 2 items"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data3.length < 1){
const err14 = {instancePath:instancePath+"/outputMediaTypes",schemaPath:"#/properties/outputMediaTypes/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
const len1 = data3.length;
for(let i1=0; i1<len1; i1++){
let data4 = data3[i1];
if(!((data4 === "image/png") || (data4 === "image/svg+xml"))){
const err15 = {instancePath:instancePath+"/outputMediaTypes/" + i1,schemaPath:"#/properties/outputMediaTypes/items/enum",keyword:"enum",params:{allowedValues: schema144.properties.outputMediaTypes.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath:instancePath+"/outputMediaTypes",schemaPath:"#/properties/outputMediaTypes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.features !== undefined){
let data5 = data.features;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.deterministic === undefined){
const err17 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/required",keyword:"required",params:{missingProperty: "deterministic"},message:"must have required property '"+"deterministic"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data5.diagnostics === undefined){
const err18 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/required",keyword:"required",params:{missingProperty: "diagnostics"},message:"must have required property '"+"diagnostics"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data5.nodeBounds === undefined){
const err19 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/required",keyword:"required",params:{missingProperty: "nodeBounds"},message:"must have required property '"+"nodeBounds"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data5.nodeMap === undefined){
const err20 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/required",keyword:"required",params:{missingProperty: "nodeMap"},message:"must have required property '"+"nodeMap"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data5.embeddedFonts === undefined){
const err21 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/required",keyword:"required",params:{missingProperty: "embeddedFonts"},message:"must have required property '"+"embeddedFonts"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
for(const key1 in data5){
if(!(((((key1 === "deterministic") || (key1 === "diagnostics")) || (key1 === "nodeBounds")) || (key1 === "nodeMap")) || (key1 === "embeddedFonts"))){
const err22 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data5.deterministic !== undefined){
if(typeof data5.deterministic !== "boolean"){
const err23 = {instancePath:instancePath+"/features/deterministic",schemaPath:"#/$defs/features/properties/deterministic/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data5.diagnostics !== undefined){
if(typeof data5.diagnostics !== "boolean"){
const err24 = {instancePath:instancePath+"/features/diagnostics",schemaPath:"#/$defs/features/properties/diagnostics/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data5.nodeBounds !== undefined){
if(typeof data5.nodeBounds !== "boolean"){
const err25 = {instancePath:instancePath+"/features/nodeBounds",schemaPath:"#/$defs/features/properties/nodeBounds/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data5.nodeMap !== undefined){
if(typeof data5.nodeMap !== "boolean"){
const err26 = {instancePath:instancePath+"/features/nodeMap",schemaPath:"#/$defs/features/properties/nodeMap/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data5.embeddedFonts !== undefined){
if(typeof data5.embeddedFonts !== "boolean"){
const err27 = {instancePath:instancePath+"/features/embeddedFonts",schemaPath:"#/$defs/features/properties/embeddedFonts/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.limits !== undefined){
let data11 = data.limits;
if(data11 && typeof data11 == "object" && !Array.isArray(data11)){
if(data11.maxRequestBytes === undefined){
const err29 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/required",keyword:"required",params:{missingProperty: "maxRequestBytes"},message:"must have required property '"+"maxRequestBytes"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data11.maxArtifactBytes === undefined){
const err30 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/required",keyword:"required",params:{missingProperty: "maxArtifactBytes"},message:"must have required property '"+"maxArtifactBytes"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data11.maxWidth === undefined){
const err31 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/required",keyword:"required",params:{missingProperty: "maxWidth"},message:"must have required property '"+"maxWidth"+"'"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data11.maxHeight === undefined){
const err32 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/required",keyword:"required",params:{missingProperty: "maxHeight"},message:"must have required property '"+"maxHeight"+"'"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data11.maxNodeMapPixels === undefined){
const err33 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/required",keyword:"required",params:{missingProperty: "maxNodeMapPixels"},message:"must have required property '"+"maxNodeMapPixels"+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
for(const key2 in data11){
if(!(((((key2 === "maxRequestBytes") || (key2 === "maxArtifactBytes")) || (key2 === "maxWidth")) || (key2 === "maxHeight")) || (key2 === "maxNodeMapPixels"))){
const err34 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data11.maxRequestBytes !== undefined){
let data12 = data11.maxRequestBytes;
if(!(((typeof data12 == "number") && (!(data12 % 1) && !isNaN(data12))) && (isFinite(data12)))){
const err35 = {instancePath:instancePath+"/limits/maxRequestBytes",schemaPath:"#/$defs/limits/properties/maxRequestBytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if((typeof data12 == "number") && (isFinite(data12))){
if(data12 > 1073741824 || isNaN(data12)){
const err36 = {instancePath:instancePath+"/limits/maxRequestBytes",schemaPath:"#/$defs/limits/properties/maxRequestBytes/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1073741824},message:"must be <= 1073741824"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data12 < 1024 || isNaN(data12)){
const err37 = {instancePath:instancePath+"/limits/maxRequestBytes",schemaPath:"#/$defs/limits/properties/maxRequestBytes/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1024},message:"must be >= 1024"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
if(data11.maxArtifactBytes !== undefined){
let data13 = data11.maxArtifactBytes;
if(!(((typeof data13 == "number") && (!(data13 % 1) && !isNaN(data13))) && (isFinite(data13)))){
const err38 = {instancePath:instancePath+"/limits/maxArtifactBytes",schemaPath:"#/$defs/limits/properties/maxArtifactBytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if((typeof data13 == "number") && (isFinite(data13))){
if(data13 > 1073741824 || isNaN(data13)){
const err39 = {instancePath:instancePath+"/limits/maxArtifactBytes",schemaPath:"#/$defs/limits/properties/maxArtifactBytes/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1073741824},message:"must be <= 1073741824"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data13 < 1024 || isNaN(data13)){
const err40 = {instancePath:instancePath+"/limits/maxArtifactBytes",schemaPath:"#/$defs/limits/properties/maxArtifactBytes/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1024},message:"must be >= 1024"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
if(data11.maxWidth !== undefined){
let data14 = data11.maxWidth;
if(!(((typeof data14 == "number") && (!(data14 % 1) && !isNaN(data14))) && (isFinite(data14)))){
const err41 = {instancePath:instancePath+"/limits/maxWidth",schemaPath:"#/$defs/limits/properties/maxWidth/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if((typeof data14 == "number") && (isFinite(data14))){
if(data14 > 32768 || isNaN(data14)){
const err42 = {instancePath:instancePath+"/limits/maxWidth",schemaPath:"#/$defs/limits/properties/maxWidth/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(data14 < 1 || isNaN(data14)){
const err43 = {instancePath:instancePath+"/limits/maxWidth",schemaPath:"#/$defs/limits/properties/maxWidth/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
}
if(data11.maxHeight !== undefined){
let data15 = data11.maxHeight;
if(!(((typeof data15 == "number") && (!(data15 % 1) && !isNaN(data15))) && (isFinite(data15)))){
const err44 = {instancePath:instancePath+"/limits/maxHeight",schemaPath:"#/$defs/limits/properties/maxHeight/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
if((typeof data15 == "number") && (isFinite(data15))){
if(data15 > 32768 || isNaN(data15)){
const err45 = {instancePath:instancePath+"/limits/maxHeight",schemaPath:"#/$defs/limits/properties/maxHeight/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
if(data15 < 1 || isNaN(data15)){
const err46 = {instancePath:instancePath+"/limits/maxHeight",schemaPath:"#/$defs/limits/properties/maxHeight/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
}
if(data11.maxNodeMapPixels !== undefined){
let data16 = data11.maxNodeMapPixels;
if(!(((typeof data16 == "number") && (!(data16 % 1) && !isNaN(data16))) && (isFinite(data16)))){
const err47 = {instancePath:instancePath+"/limits/maxNodeMapPixels",schemaPath:"#/$defs/limits/properties/maxNodeMapPixels/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
if((typeof data16 == "number") && (isFinite(data16))){
if(data16 > 4194304 || isNaN(data16)){
const err48 = {instancePath:instancePath+"/limits/maxNodeMapPixels",schemaPath:"#/$defs/limits/properties/maxNodeMapPixels/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4194304},message:"must be <= 4194304"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
if(data16 < 0 || isNaN(data16)){
const err49 = {instancePath:instancePath+"/limits/maxNodeMapPixels",schemaPath:"#/$defs/limits/properties/maxNodeMapPixels/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
}
}
else {
const err50 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
}
else {
const err51 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
validate109.errors = vErrors;
return errors === 0;
}
validate109.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate108(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate108.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.protocol === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "protocol"},message:"must have required property '"+"protocol"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.requestId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.operation === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operation"},message:"must have required property '"+"operation"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.status === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.capabilities === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilities"},message:"must have required property '"+"capabilities"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "$schema") || (key0 === "protocol")) || (key0 === "version")) || (key0 === "requestId")) || (key0 === "operation")) || (key0 === "status")) || (key0 === "capabilities"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/renderer-response.schema.json" !== data.$schema){
const err7 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/renderer-response.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.protocol !== undefined){
if("maipo-renderer-protocol" !== data.protocol){
const err8 = {instancePath:instancePath+"/protocol",schemaPath:"#/$defs/protocol/const",keyword:"const",params:{allowedValue: "maipo-renderer-protocol"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err9 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.requestId !== undefined){
let data3 = data.requestId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err10 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func3(data3) < 1){
const err11 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern4.test(data3)){
const err12 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.operation !== undefined){
if("capabilities" !== data.operation){
const err14 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/const",keyword:"const",params:{allowedValue: "capabilities"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.status !== undefined){
if("ok" !== data.status){
const err15 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/const",keyword:"const",params:{allowedValue: "ok"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.capabilities !== undefined){
if(!(validate109(data.capabilities, {instancePath:instancePath+"/capabilities",parentData:data,parentDataProperty:"capabilities",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate109.errors : vErrors.concat(validate109.errors);
errors = vErrors.length;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate108.errors = vErrors;
return errors === 0;
}
validate108.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema150 = {"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","status","renderer","profile","artifact","diagnostics","timing"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/renderer-response.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"render"},"status":{"const":"ok"},"renderer":{"$ref":"#/$defs/renderer"},"profile":{"$ref":"#/$defs/profile"},"artifact":{"$ref":"#/$defs/artifact"},"diagnostics":{"type":"array","maxItems":10000,"items":{"$ref":"#/$defs/diagnostic"}},"nodes":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/node"}},"nodeMap":{"$ref":"#/$defs/nodeMap"},"timing":{"$ref":"#/$defs/timing"}}};
const schema155 = {"type":"object","additionalProperties":false,"required":["mediaType","width","height","encoding","byteLength","digest","data"],"properties":{"mediaType":{"enum":["image/png","image/svg+xml"]},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"encoding":{"const":"base64"},"byteLength":{"type":"integer","minimum":0,"maximum":67108864},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"data":{"type":"string","contentEncoding":"base64","maxLength":89478488}}};
const schema163 = {"type":"object","additionalProperties":false,"required":["totalMs"],"properties":{"totalMs":{"type":"number","minimum":0,"maximum":86400000}}};
const schema156 = {"type":"object","additionalProperties":false,"required":["severity","code","message"],"properties":{"severity":{"enum":["warning","error"]},"code":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"},"target":{"$ref":"#/$defs/requestId"},"message":{"type":"string","minLength":1,"maxLength":4096}}};
const pattern60 = new RegExp("^[a-z0-9][a-z0-9-]*$", "u");

function validate116(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate116.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.severity === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "severity"},message:"must have required property '"+"severity"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.code === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "code"},message:"must have required property '"+"code"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.message === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "message"},message:"must have required property '"+"message"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "severity") || (key0 === "code")) || (key0 === "target")) || (key0 === "message"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.severity !== undefined){
let data0 = data.severity;
if(!((data0 === "warning") || (data0 === "error"))){
const err4 = {instancePath:instancePath+"/severity",schemaPath:"#/properties/severity/enum",keyword:"enum",params:{allowedValues: schema156.properties.severity.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.code !== undefined){
let data1 = data.code;
if(typeof data1 === "string"){
if(func3(data1) > 128){
const err5 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func3(data1) < 1){
const err6 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern60.test(data1)){
const err7 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.target !== undefined){
let data2 = data.target;
if(typeof data2 === "string"){
if(func3(data2) > 128){
const err9 = {instancePath:instancePath+"/target",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func3(data2) < 1){
const err10 = {instancePath:instancePath+"/target",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!pattern4.test(data2)){
const err11 = {instancePath:instancePath+"/target",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/target",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.message !== undefined){
let data3 = data.message;
if(typeof data3 === "string"){
if(func3(data3) > 4096){
const err13 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/maxLength",keyword:"maxLength",params:{limit: 4096},message:"must NOT have more than 4096 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(func3(data3) < 1){
const err14 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate116.errors = vErrors;
return errors === 0;
}
validate116.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema158 = {"type":"object","additionalProperties":false,"required":["id","name","visible","bounds"],"properties":{"id":{"$ref":"#/$defs/requestId"},"name":{"type":"string","minLength":1,"maxLength":1024},"role":{"type":"string","minLength":1,"maxLength":128},"visible":{"type":"boolean"},"bounds":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/bounds"}]}}};
const schema160 = {"type":"object","additionalProperties":false,"required":["x","y","width","height"],"properties":{"x":{"type":"number","minimum":-1000000000,"maximum":1000000000},"y":{"type":"number","minimum":-1000000000,"maximum":1000000000},"width":{"type":"number","minimum":0,"maximum":1000000000},"height":{"type":"number","minimum":0,"maximum":1000000000}}};

function validate118(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate118.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.visible === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "visible"},message:"must have required property '"+"visible"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.bounds === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bounds"},message:"must have required property '"+"bounds"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "id") || (key0 === "name")) || (key0 === "role")) || (key0 === "visible")) || (key0 === "bounds"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func3(data0) < 1){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern4.test(data0)){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 === "string"){
if(func3(data1) > 1024){
const err9 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func3(data1) < 1){
const err10 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.role !== undefined){
let data2 = data.role;
if(typeof data2 === "string"){
if(func3(data2) > 128){
const err12 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(func3(data2) < 1){
const err13 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.visible !== undefined){
if(typeof data.visible !== "boolean"){
const err15 = {instancePath:instancePath+"/visible",schemaPath:"#/properties/visible/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.bounds !== undefined){
let data4 = data.bounds;
const _errs12 = errors;
let valid2 = false;
let passing0 = null;
const _errs13 = errors;
if(data4 !== null){
const err16 = {instancePath:instancePath+"/bounds",schemaPath:"#/properties/bounds/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
var _valid0 = _errs13 === errors;
if(_valid0){
valid2 = true;
passing0 = 0;
}
const _errs15 = errors;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.x === undefined){
const err17 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data4.y === undefined){
const err18 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data4.width === undefined){
const err19 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data4.height === undefined){
const err20 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
for(const key1 in data4){
if(!((((key1 === "x") || (key1 === "y")) || (key1 === "width")) || (key1 === "height"))){
const err21 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data4.x !== undefined){
let data5 = data4.x;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 1000000000 || isNaN(data5)){
const err22 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/bounds/properties/x/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data5 < -1000000000 || isNaN(data5)){
const err23 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/bounds/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/bounds/properties/x/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data4.y !== undefined){
let data6 = data4.y;
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 > 1000000000 || isNaN(data6)){
const err25 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/bounds/properties/y/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data6 < -1000000000 || isNaN(data6)){
const err26 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/bounds/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/bounds/properties/y/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data4.width !== undefined){
let data7 = data4.width;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 1000000000 || isNaN(data7)){
const err28 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/bounds/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data7 < 0 || isNaN(data7)){
const err29 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/bounds/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/bounds/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data4.height !== undefined){
let data8 = data4.height;
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 1000000000 || isNaN(data8)){
const err31 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/bounds/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data8 < 0 || isNaN(data8)){
const err32 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/bounds/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/bounds/properties/height/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
else {
const err34 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
var _valid0 = _errs15 === errors;
if(_valid0 && valid2){
valid2 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid2 = true;
passing0 = 1;
}
}
if(!valid2){
const err35 = {instancePath:instancePath+"/bounds",schemaPath:"#/properties/bounds/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
else {
errors = _errs12;
if(vErrors !== null){
if(_errs12){
vErrors.length = _errs12;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err36 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
validate118.errors = vErrors;
return errors === 0;
}
validate118.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema161 = {"type":"object","additionalProperties":false,"required":["width","height","ids","encoding","byteLength","digest","data"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"ids":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/requestId"}},"encoding":{"const":"uint32le-base64"},"byteLength":{"type":"integer","minimum":4,"maximum":16777216},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"data":{"type":"string","contentEncoding":"base64","maxLength":22369624}}};

function validate120(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate120.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.width === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.height === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.ids === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ids"},message:"must have required property '"+"ids"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.encoding === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "encoding"},message:"must have required property '"+"encoding"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.byteLength === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.digest === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.data === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "data"},message:"must have required property '"+"data"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "width") || (key0 === "height")) || (key0 === "ids")) || (key0 === "encoding")) || (key0 === "byteLength")) || (key0 === "digest")) || (key0 === "data"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.width !== undefined){
let data0 = data.width;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 32768 || isNaN(data0)){
const err9 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data0 < 1 || isNaN(data0)){
const err10 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
if(data.height !== undefined){
let data1 = data.height;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err11 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 32768 || isNaN(data1)){
const err12 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err13 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data.ids !== undefined){
let data2 = data.ids;
if(Array.isArray(data2)){
if(data2.length > 100000){
const err14 = {instancePath:instancePath+"/ids",schemaPath:"#/properties/ids/maxItems",keyword:"maxItems",params:{limit: 100000},message:"must NOT have more than 100000 items"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
const len0 = data2.length;
for(let i0=0; i0<len0; i0++){
let data3 = data2[i0];
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err15 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(func3(data3) < 1){
const err16 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(!pattern4.test(data3)){
const err17 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath:instancePath+"/ids",schemaPath:"#/properties/ids/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.encoding !== undefined){
if("uint32le-base64" !== data.encoding){
const err20 = {instancePath:instancePath+"/encoding",schemaPath:"#/properties/encoding/const",keyword:"const",params:{allowedValue: "uint32le-base64"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.byteLength !== undefined){
let data5 = data.byteLength;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err21 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 16777216 || isNaN(data5)){
const err22 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16777216},message:"must be <= 16777216"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data5 < 4 || isNaN(data5)){
const err23 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 4},message:"must be >= 4"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
if(data.digest !== undefined){
let data6 = data.digest;
if(typeof data6 === "string"){
if(!pattern9.test(data6)){
const err24 = {instancePath:instancePath+"/digest",schemaPath:"#/properties/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/digest",schemaPath:"#/properties/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.data !== undefined){
let data7 = data.data;
if(typeof data7 === "string"){
if(func3(data7) > 22369624){
const err26 = {instancePath:instancePath+"/data",schemaPath:"#/properties/data/maxLength",keyword:"maxLength",params:{limit: 22369624},message:"must NOT have more than 22369624 characters"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/data",schemaPath:"#/properties/data/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
validate120.errors = vErrors;
return errors === 0;
}
validate120.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate114(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate114.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.protocol === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "protocol"},message:"must have required property '"+"protocol"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.requestId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.operation === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operation"},message:"must have required property '"+"operation"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.status === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.renderer === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "renderer"},message:"must have required property '"+"renderer"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.profile === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profile"},message:"must have required property '"+"profile"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.artifact === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "artifact"},message:"must have required property '"+"artifact"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.diagnostics === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "diagnostics"},message:"must have required property '"+"diagnostics"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.timing === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "timing"},message:"must have required property '"+"timing"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema150.properties, key0))){
const err10 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/renderer-response.schema.json" !== data.$schema){
const err11 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/renderer-response.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.protocol !== undefined){
if("maipo-renderer-protocol" !== data.protocol){
const err12 = {instancePath:instancePath+"/protocol",schemaPath:"#/$defs/protocol/const",keyword:"const",params:{allowedValue: "maipo-renderer-protocol"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err13 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.requestId !== undefined){
let data3 = data.requestId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err14 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(func3(data3) < 1){
const err15 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(!pattern4.test(data3)){
const err16 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.operation !== undefined){
if("render" !== data.operation){
const err18 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/const",keyword:"const",params:{allowedValue: "render"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.status !== undefined){
if("ok" !== data.status){
const err19 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/const",keyword:"const",params:{allowedValue: "ok"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.renderer !== undefined){
if(!(validate110(data.renderer, {instancePath:instancePath+"/renderer",parentData:data,parentDataProperty:"renderer",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate110.errors : vErrors.concat(validate110.errors);
errors = vErrors.length;
}
}
if(data.profile !== undefined){
let data7 = data.profile;
if(typeof data7 === "string"){
if(func3(data7) > 128){
const err20 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(func3(data7) < 1){
const err21 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(!pattern4.test(data7)){
const err22 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
else {
const err23 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.artifact !== undefined){
let data8 = data.artifact;
if(data8 && typeof data8 == "object" && !Array.isArray(data8)){
if(data8.mediaType === undefined){
const err24 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "mediaType"},message:"must have required property '"+"mediaType"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data8.width === undefined){
const err25 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data8.height === undefined){
const err26 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(data8.encoding === undefined){
const err27 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "encoding"},message:"must have required property '"+"encoding"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data8.byteLength === undefined){
const err28 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data8.digest === undefined){
const err29 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data8.data === undefined){
const err30 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "data"},message:"must have required property '"+"data"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
for(const key1 in data8){
if(!(((((((key1 === "mediaType") || (key1 === "width")) || (key1 === "height")) || (key1 === "encoding")) || (key1 === "byteLength")) || (key1 === "digest")) || (key1 === "data"))){
const err31 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data8.mediaType !== undefined){
let data9 = data8.mediaType;
if(!((data9 === "image/png") || (data9 === "image/svg+xml"))){
const err32 = {instancePath:instancePath+"/artifact/mediaType",schemaPath:"#/$defs/artifact/properties/mediaType/enum",keyword:"enum",params:{allowedValues: schema155.properties.mediaType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data8.width !== undefined){
let data10 = data8.width;
if(!(((typeof data10 == "number") && (!(data10 % 1) && !isNaN(data10))) && (isFinite(data10)))){
const err33 = {instancePath:instancePath+"/artifact/width",schemaPath:"#/$defs/artifact/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if((typeof data10 == "number") && (isFinite(data10))){
if(data10 > 32768 || isNaN(data10)){
const err34 = {instancePath:instancePath+"/artifact/width",schemaPath:"#/$defs/artifact/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data10 < 1 || isNaN(data10)){
const err35 = {instancePath:instancePath+"/artifact/width",schemaPath:"#/$defs/artifact/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
}
if(data8.height !== undefined){
let data11 = data8.height;
if(!(((typeof data11 == "number") && (!(data11 % 1) && !isNaN(data11))) && (isFinite(data11)))){
const err36 = {instancePath:instancePath+"/artifact/height",schemaPath:"#/$defs/artifact/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if((typeof data11 == "number") && (isFinite(data11))){
if(data11 > 32768 || isNaN(data11)){
const err37 = {instancePath:instancePath+"/artifact/height",schemaPath:"#/$defs/artifact/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(data11 < 1 || isNaN(data11)){
const err38 = {instancePath:instancePath+"/artifact/height",schemaPath:"#/$defs/artifact/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
}
if(data8.encoding !== undefined){
if("base64" !== data8.encoding){
const err39 = {instancePath:instancePath+"/artifact/encoding",schemaPath:"#/$defs/artifact/properties/encoding/const",keyword:"const",params:{allowedValue: "base64"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data8.byteLength !== undefined){
let data13 = data8.byteLength;
if(!(((typeof data13 == "number") && (!(data13 % 1) && !isNaN(data13))) && (isFinite(data13)))){
const err40 = {instancePath:instancePath+"/artifact/byteLength",schemaPath:"#/$defs/artifact/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if((typeof data13 == "number") && (isFinite(data13))){
if(data13 > 67108864 || isNaN(data13)){
const err41 = {instancePath:instancePath+"/artifact/byteLength",schemaPath:"#/$defs/artifact/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 67108864},message:"must be <= 67108864"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data13 < 0 || isNaN(data13)){
const err42 = {instancePath:instancePath+"/artifact/byteLength",schemaPath:"#/$defs/artifact/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
}
if(data8.digest !== undefined){
let data14 = data8.digest;
if(typeof data14 === "string"){
if(!pattern9.test(data14)){
const err43 = {instancePath:instancePath+"/artifact/digest",schemaPath:"#/$defs/artifact/properties/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
else {
const err44 = {instancePath:instancePath+"/artifact/digest",schemaPath:"#/$defs/artifact/properties/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
if(data8.data !== undefined){
let data15 = data8.data;
if(typeof data15 === "string"){
if(func3(data15) > 89478488){
const err45 = {instancePath:instancePath+"/artifact/data",schemaPath:"#/$defs/artifact/properties/data/maxLength",keyword:"maxLength",params:{limit: 89478488},message:"must NOT have more than 89478488 characters"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
else {
const err46 = {instancePath:instancePath+"/artifact/data",schemaPath:"#/$defs/artifact/properties/data/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
}
else {
const err47 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
if(data.diagnostics !== undefined){
let data16 = data.diagnostics;
if(Array.isArray(data16)){
if(data16.length > 10000){
const err48 = {instancePath:instancePath+"/diagnostics",schemaPath:"#/properties/diagnostics/maxItems",keyword:"maxItems",params:{limit: 10000},message:"must NOT have more than 10000 items"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
const len0 = data16.length;
for(let i0=0; i0<len0; i0++){
if(!(validate116(data16[i0], {instancePath:instancePath+"/diagnostics/" + i0,parentData:data16,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate116.errors : vErrors.concat(validate116.errors);
errors = vErrors.length;
}
}
}
else {
const err49 = {instancePath:instancePath+"/diagnostics",schemaPath:"#/properties/diagnostics/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
if(data.nodes !== undefined){
let data18 = data.nodes;
if(Array.isArray(data18)){
if(data18.length > 100000){
const err50 = {instancePath:instancePath+"/nodes",schemaPath:"#/properties/nodes/maxItems",keyword:"maxItems",params:{limit: 100000},message:"must NOT have more than 100000 items"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
const len1 = data18.length;
for(let i1=0; i1<len1; i1++){
if(!(validate118(data18[i1], {instancePath:instancePath+"/nodes/" + i1,parentData:data18,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate118.errors : vErrors.concat(validate118.errors);
errors = vErrors.length;
}
}
}
else {
const err51 = {instancePath:instancePath+"/nodes",schemaPath:"#/properties/nodes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data.nodeMap !== undefined){
if(!(validate120(data.nodeMap, {instancePath:instancePath+"/nodeMap",parentData:data,parentDataProperty:"nodeMap",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate120.errors : vErrors.concat(validate120.errors);
errors = vErrors.length;
}
}
if(data.timing !== undefined){
let data21 = data.timing;
if(data21 && typeof data21 == "object" && !Array.isArray(data21)){
if(data21.totalMs === undefined){
const err52 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/required",keyword:"required",params:{missingProperty: "totalMs"},message:"must have required property '"+"totalMs"+"'"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
for(const key2 in data21){
if(!(key2 === "totalMs")){
const err53 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
if(data21.totalMs !== undefined){
let data22 = data21.totalMs;
if((typeof data22 == "number") && (isFinite(data22))){
if(data22 > 86400000 || isNaN(data22)){
const err54 = {instancePath:instancePath+"/timing/totalMs",schemaPath:"#/$defs/timing/properties/totalMs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 86400000},message:"must be <= 86400000"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
if(data22 < 0 || isNaN(data22)){
const err55 = {instancePath:instancePath+"/timing/totalMs",schemaPath:"#/$defs/timing/properties/totalMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
}
else {
const err56 = {instancePath:instancePath+"/timing/totalMs",schemaPath:"#/$defs/timing/properties/totalMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
}
else {
const err57 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
}
else {
const err58 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
validate114.errors = vErrors;
return errors === 0;
}
validate114.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema164 = {"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","status","error"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/renderer-response.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"enum":["capabilities","render"]},"status":{"const":"error"},"error":{"$ref":"#/$defs/protocolError"}}};
const schema168 = {"type":"object","additionalProperties":false,"required":["code","message"],"properties":{"code":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"},"message":{"type":"string","minLength":1,"maxLength":4096},"diagnostics":{"type":"array","maxItems":10000,"items":{"$ref":"#/$defs/diagnostic"}}}};

function validate124(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate124.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.code === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "code"},message:"must have required property '"+"code"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.message === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "message"},message:"must have required property '"+"message"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "code") || (key0 === "message")) || (key0 === "diagnostics"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.code !== undefined){
let data0 = data.code;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err3 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func3(data0) < 1){
const err4 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern60.test(data0)){
const err5 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.message !== undefined){
let data1 = data.message;
if(typeof data1 === "string"){
if(func3(data1) > 4096){
const err7 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/maxLength",keyword:"maxLength",params:{limit: 4096},message:"must NOT have more than 4096 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(func3(data1) < 1){
const err8 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.diagnostics !== undefined){
let data2 = data.diagnostics;
if(Array.isArray(data2)){
if(data2.length > 10000){
const err10 = {instancePath:instancePath+"/diagnostics",schemaPath:"#/properties/diagnostics/maxItems",keyword:"maxItems",params:{limit: 10000},message:"must NOT have more than 10000 items"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
const len0 = data2.length;
for(let i0=0; i0<len0; i0++){
if(!(validate116(data2[i0], {instancePath:instancePath+"/diagnostics/" + i0,parentData:data2,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate116.errors : vErrors.concat(validate116.errors);
errors = vErrors.length;
}
}
}
else {
const err11 = {instancePath:instancePath+"/diagnostics",schemaPath:"#/properties/diagnostics/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate124.errors = vErrors;
return errors === 0;
}
validate124.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate123(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate123.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.protocol === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "protocol"},message:"must have required property '"+"protocol"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.requestId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.operation === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operation"},message:"must have required property '"+"operation"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.status === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.error === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "error"},message:"must have required property '"+"error"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "$schema") || (key0 === "protocol")) || (key0 === "version")) || (key0 === "requestId")) || (key0 === "operation")) || (key0 === "status")) || (key0 === "error"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/renderer-response.schema.json" !== data.$schema){
const err7 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/renderer-response.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.protocol !== undefined){
if("maipo-renderer-protocol" !== data.protocol){
const err8 = {instancePath:instancePath+"/protocol",schemaPath:"#/$defs/protocol/const",keyword:"const",params:{allowedValue: "maipo-renderer-protocol"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err9 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.requestId !== undefined){
let data3 = data.requestId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err10 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func3(data3) < 1){
const err11 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern4.test(data3)){
const err12 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.operation !== undefined){
let data4 = data.operation;
if(!((data4 === "capabilities") || (data4 === "render"))){
const err14 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/enum",keyword:"enum",params:{allowedValues: schema164.properties.operation.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.status !== undefined){
if("error" !== data.status){
const err15 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/const",keyword:"const",params:{allowedValue: "error"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.error !== undefined){
if(!(validate124(data.error, {instancePath:instancePath+"/error",parentData:data,parentDataProperty:"error",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate124.errors : vErrors.concat(validate124.errors);
errors = vErrors.length;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate123.errors = vErrors;
return errors === 0;
}
validate123.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate107(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/renderer-response.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate107.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate108(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate108.errors : vErrors.concat(validate108.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate114(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate114.errors : vErrors.concat(validate114.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
const _errs3 = errors;
if(!(validate123(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate123.errors : vErrors.concat(validate123.errors);
errors = vErrors.length;
}
var _valid0 = _errs3 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
if(props0 !== true){
props0 = true;
}
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate107.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate107.evaluated = {"dynamicProps":true,"dynamicItems":false};

export const validateRendererRequestV02Schema = validate128;
const schema169 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.2/renderer-request.schema.json","title":"Maipo renderer process request 0.2","description":"One request line in additive Maipo renderer NDJSON protocol 0.2; scene payloads remain version 0.1.","oneOf":[{"$ref":"#/$defs/capabilitiesRequest"},{"$ref":"#/$defs/renderRequest"}],"$defs":{"protocol":{"const":"maipo-renderer-protocol"},"version":{"const":"0.2"},"requestId":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"profile":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"capabilitiesRequest":{"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.2/renderer-request.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"capabilities"}}},"renderOptions":{"type":"object","additionalProperties":false,"required":["profile","outputMediaType"],"dependentRequired":{"width":["height"],"height":["width"]},"properties":{"profile":{"$ref":"#/$defs/profile"},"outputMediaType":{"enum":["image/png","image/svg+xml"]},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"includeNodeMap":{"type":"boolean","default":false}}},"renderRequest":{"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","scene","options"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.2/renderer-request.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"render"},"scene":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json"},"options":{"$ref":"#/$defs/renderOptions"}}}}};
const schema170 = {"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.2/renderer-request.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"capabilities"}}};
const schema171 = {"const":"maipo-renderer-protocol"};
const schema172 = {"const":"0.2"};

function validate129(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate129.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.protocol === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "protocol"},message:"must have required property '"+"protocol"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.requestId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.operation === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operation"},message:"must have required property '"+"operation"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "$schema") || (key0 === "protocol")) || (key0 === "version")) || (key0 === "requestId")) || (key0 === "operation"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.2/renderer-request.schema.json" !== data.$schema){
const err5 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.2/renderer-request.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.protocol !== undefined){
if("maipo-renderer-protocol" !== data.protocol){
const err6 = {instancePath:instancePath+"/protocol",schemaPath:"#/$defs/protocol/const",keyword:"const",params:{allowedValue: "maipo-renderer-protocol"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.version !== undefined){
if("0.2" !== data.version){
const err7 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/const",keyword:"const",params:{allowedValue: "0.2"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.requestId !== undefined){
let data3 = data.requestId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err8 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func3(data3) < 1){
const err9 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!pattern4.test(data3)){
const err10 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.operation !== undefined){
if("capabilities" !== data.operation){
const err12 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/const",keyword:"const",params:{allowedValue: "capabilities"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
else {
const err13 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
validate129.errors = vErrors;
return errors === 0;
}
validate129.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema174 = {"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","scene","options"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.2/renderer-request.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"render"},"scene":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json"},"options":{"$ref":"#/$defs/renderOptions"}}};
const schema178 = {"type":"object","additionalProperties":false,"required":["profile","outputMediaType"],"dependentRequired":{"width":["height"],"height":["width"]},"properties":{"profile":{"$ref":"#/$defs/profile"},"outputMediaType":{"enum":["image/png","image/svg+xml"]},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"includeNodeMap":{"type":"boolean","default":false}}};
const schema179 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};

function validate133(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate133.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.profile === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profile"},message:"must have required property '"+"profile"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.outputMediaType === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "outputMediaType"},message:"must have required property '"+"outputMediaType"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "profile") || (key0 === "outputMediaType")) || (key0 === "width")) || (key0 === "height")) || (key0 === "includeNodeMap"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.profile !== undefined){
let data0 = data.profile;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err3 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func3(data0) < 1){
const err4 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern4.test(data0)){
const err5 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.outputMediaType !== undefined){
let data1 = data.outputMediaType;
if(!((data1 === "image/png") || (data1 === "image/svg+xml"))){
const err7 = {instancePath:instancePath+"/outputMediaType",schemaPath:"#/properties/outputMediaType/enum",keyword:"enum",params:{allowedValues: schema178.properties.outputMediaType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.width !== undefined){
let data2 = data.width;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 32768 || isNaN(data2)){
const err9 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data2 < 1 || isNaN(data2)){
const err10 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
if(data.height !== undefined){
let data3 = data.height;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err11 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 32768 || isNaN(data3)){
const err12 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data3 < 1 || isNaN(data3)){
const err13 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data.includeNodeMap !== undefined){
if(typeof data.includeNodeMap !== "boolean"){
const err14 = {instancePath:instancePath+"/includeNodeMap",schemaPath:"#/properties/includeNodeMap/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.width !== undefined){
if(data.height === undefined){
const err15 = {instancePath,schemaPath:"#/dependentRequired",keyword:"dependentRequired",params:{property: "width",
    missingProperty: "height",
    depsCount: 1,
    deps: "height"},message:"must have property height when property width is present"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.height !== undefined){
if(data.width === undefined){
const err16 = {instancePath,schemaPath:"#/dependentRequired",keyword:"dependentRequired",params:{property: "height",
    missingProperty: "width",
    depsCount: 1,
    deps: "width"},message:"must have property width when property height is present"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate133.errors = vErrors;
return errors === 0;
}
validate133.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate131(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate131.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.protocol === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "protocol"},message:"must have required property '"+"protocol"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.requestId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.operation === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operation"},message:"must have required property '"+"operation"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.scene === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "scene"},message:"must have required property '"+"scene"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.options === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "options"},message:"must have required property '"+"options"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "$schema") || (key0 === "protocol")) || (key0 === "version")) || (key0 === "requestId")) || (key0 === "operation")) || (key0 === "scene")) || (key0 === "options"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.2/renderer-request.schema.json" !== data.$schema){
const err7 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.2/renderer-request.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.protocol !== undefined){
if("maipo-renderer-protocol" !== data.protocol){
const err8 = {instancePath:instancePath+"/protocol",schemaPath:"#/$defs/protocol/const",keyword:"const",params:{allowedValue: "maipo-renderer-protocol"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.version !== undefined){
if("0.2" !== data.version){
const err9 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/const",keyword:"const",params:{allowedValue: "0.2"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.requestId !== undefined){
let data3 = data.requestId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err10 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func3(data3) < 1){
const err11 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern4.test(data3)){
const err12 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.operation !== undefined){
if("render" !== data.operation){
const err14 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/const",keyword:"const",params:{allowedValue: "render"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.scene !== undefined){
if(!(validate21(data.scene, {instancePath:instancePath+"/scene",parentData:data,parentDataProperty:"scene",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
errors = vErrors.length;
}
}
if(data.options !== undefined){
if(!(validate133(data.options, {instancePath:instancePath+"/options",parentData:data,parentDataProperty:"options",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate133.errors : vErrors.concat(validate133.errors);
errors = vErrors.length;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate131.errors = vErrors;
return errors === 0;
}
validate131.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate128(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.2/renderer-request.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate128.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate129(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate129.errors : vErrors.concat(validate129.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate131(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate131.errors : vErrors.concat(validate131.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate128.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate128.evaluated = {"dynamicProps":true,"dynamicItems":false};

export const validateRendererResponseV02Schema = validate136;
const schema180 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.2/renderer-response.schema.json","title":"Maipo renderer process response 0.2","description":"One response line in additive Maipo renderer NDJSON protocol 0.2 with runtime, font and phase metadata.","oneOf":[{"$ref":"#/$defs/capabilitiesResponse"},{"$ref":"#/$defs/renderResponse"},{"$ref":"#/$defs/errorResponse"}],"$defs":{"protocol":{"const":"maipo-renderer-protocol"},"version":{"const":"0.2"},"requestId":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"profile":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"rendererId":{"type":"string","minLength":1,"maxLength":128,"pattern":"^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"},"renderer":{"type":"object","additionalProperties":false,"required":["id","version","backend"],"properties":{"id":{"$ref":"#/$defs/rendererId"},"version":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"},"backend":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[A-Za-z0-9][A-Za-z0-9._-]*$"},"runtime":{"$ref":"#/$defs/runtime"}}},"runtime":{"type":"object","additionalProperties":false,"required":["engine","version","platform","deviceScaleFactor","colorSpace"],"properties":{"engine":{"type":"string","minLength":1,"maxLength":128},"version":{"type":"string","minLength":1,"maxLength":128},"platform":{"type":"string","minLength":1,"maxLength":128},"deviceScaleFactor":{"type":"number","exclusiveMinimum":0,"maximum":16},"colorSpace":{"const":"srgb"}}},"features":{"type":"object","additionalProperties":false,"required":["deterministic","diagnostics","nodeBounds","nodeMap","embeddedFonts"],"properties":{"deterministic":{"type":"boolean"},"diagnostics":{"type":"boolean"},"nodeBounds":{"type":"boolean"},"nodeMap":{"type":"boolean"},"embeddedFonts":{"type":"boolean"}}},"limits":{"type":"object","additionalProperties":false,"required":["maxRequestBytes","maxArtifactBytes","maxWidth","maxHeight","maxNodeMapPixels"],"properties":{"maxRequestBytes":{"type":"integer","minimum":1024,"maximum":1073741824},"maxArtifactBytes":{"type":"integer","minimum":1024,"maximum":1073741824},"maxWidth":{"type":"integer","minimum":1,"maximum":32768},"maxHeight":{"type":"integer","minimum":1,"maximum":32768},"maxNodeMapPixels":{"type":"integer","minimum":0,"maximum":4194304}}},"capabilities":{"type":"object","additionalProperties":false,"required":["renderer","profiles","outputMediaTypes","features","limits"],"properties":{"renderer":{"$ref":"#/$defs/renderer"},"profiles":{"type":"array","minItems":1,"maxItems":128,"items":{"$ref":"#/$defs/profile"}},"outputMediaTypes":{"type":"array","minItems":1,"maxItems":2,"items":{"enum":["image/png","image/svg+xml"]}},"features":{"$ref":"#/$defs/features"},"limits":{"$ref":"#/$defs/limits"}}},"diagnostic":{"type":"object","additionalProperties":false,"required":["severity","code","message"],"properties":{"severity":{"enum":["warning","error"]},"code":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"},"target":{"$ref":"#/$defs/requestId"},"message":{"type":"string","minLength":1,"maxLength":4096}}},"artifact":{"type":"object","additionalProperties":false,"required":["mediaType","width","height","encoding","byteLength","digest","data"],"properties":{"mediaType":{"enum":["image/png","image/svg+xml"]},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"encoding":{"const":"base64"},"byteLength":{"type":"integer","minimum":0,"maximum":67108864},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"data":{"type":"string","contentEncoding":"base64","maxLength":89478488}}},"bounds":{"type":"object","additionalProperties":false,"required":["x","y","width","height"],"properties":{"x":{"type":"number","minimum":-1000000000,"maximum":1000000000},"y":{"type":"number","minimum":-1000000000,"maximum":1000000000},"width":{"type":"number","minimum":0,"maximum":1000000000},"height":{"type":"number","minimum":0,"maximum":1000000000}}},"node":{"type":"object","additionalProperties":false,"required":["id","name","visible","bounds"],"properties":{"id":{"$ref":"#/$defs/requestId"},"name":{"type":"string","minLength":1,"maxLength":1024},"role":{"type":"string","minLength":1,"maxLength":128},"visible":{"type":"boolean"},"bounds":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/bounds"}]}}},"nodeMap":{"type":"object","additionalProperties":false,"required":["width","height","ids","encoding","byteLength","digest","data"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"ids":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/requestId"}},"encoding":{"const":"uint32le-base64"},"byteLength":{"type":"integer","minimum":4,"maximum":16777216},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"data":{"type":"string","contentEncoding":"base64","maxLength":22369624}}},"font":{"type":"object","additionalProperties":false,"required":["id","family","weight","style","source","status","embedding"],"properties":{"id":{"$ref":"#/$defs/requestId"},"family":{"type":"string","minLength":1,"maxLength":1024},"weight":{"type":"integer","minimum":1,"maximum":1000},"style":{"enum":["normal","italic","oblique"]},"source":{"enum":["system","embedded"]},"status":{"enum":["available","loaded","fallback"]},"fingerprint":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"embedding":{"enum":["installable","editable","preview-print","restricted","unknown"]},"fallback":{"const":"browser-default"}},"allOf":[{"if":{"properties":{"source":{"const":"embedded"}},"required":["source"]},"then":{"required":["fingerprint"],"properties":{"fingerprint":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"status":{"enum":["loaded","fallback"]}}},"else":{"not":{"properties":{"fingerprint":{}},"required":["fingerprint"]},"properties":{"status":{"enum":["available","fallback"]}}}},{"if":{"properties":{"status":{"const":"fallback"}},"required":["status"]},"then":{"required":["fallback"],"properties":{"fallback":{"const":"browser-default"}}},"else":{"not":{"properties":{"fallback":{}},"required":["fallback"]}}}]},"timing":{"type":"object","additionalProperties":false,"required":["totalMs"],"properties":{"totalMs":{"type":"number","minimum":0,"maximum":86400000},"validationMs":{"type":"number","minimum":0,"maximum":86400000},"fontMs":{"type":"number","minimum":0,"maximum":86400000},"renderMs":{"type":"number","minimum":0,"maximum":86400000},"nodeMapMs":{"type":"number","minimum":0,"maximum":86400000}}},"capabilitiesResponse":{"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","status","capabilities"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.2/renderer-response.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"capabilities"},"status":{"const":"ok"},"capabilities":{"$ref":"#/$defs/capabilities"}}},"renderResponse":{"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","status","renderer","profile","artifact","diagnostics","fonts","timing"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.2/renderer-response.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"render"},"status":{"const":"ok"},"renderer":{"$ref":"#/$defs/renderer"},"profile":{"$ref":"#/$defs/profile"},"artifact":{"$ref":"#/$defs/artifact"},"diagnostics":{"type":"array","maxItems":10000,"items":{"$ref":"#/$defs/diagnostic"}},"fonts":{"type":"array","maxItems":1024,"items":{"$ref":"#/$defs/font"}},"nodes":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/node"}},"nodeMap":{"$ref":"#/$defs/nodeMap"},"timing":{"$ref":"#/$defs/timing"}}},"protocolError":{"type":"object","additionalProperties":false,"required":["code","message"],"properties":{"code":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"},"message":{"type":"string","minLength":1,"maxLength":4096},"diagnostics":{"type":"array","maxItems":10000,"items":{"$ref":"#/$defs/diagnostic"}}}},"errorResponse":{"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","status","error"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.2/renderer-response.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"enum":["capabilities","render"]},"status":{"const":"error"},"error":{"$ref":"#/$defs/protocolError"}}}}};
const schema181 = {"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","status","capabilities"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.2/renderer-response.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"capabilities"},"status":{"const":"ok"},"capabilities":{"$ref":"#/$defs/capabilities"}}};
const schema182 = {"const":"maipo-renderer-protocol"};
const schema183 = {"const":"0.2"};
const schema184 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const schema185 = {"type":"object","additionalProperties":false,"required":["renderer","profiles","outputMediaTypes","features","limits"],"properties":{"renderer":{"$ref":"#/$defs/renderer"},"profiles":{"type":"array","minItems":1,"maxItems":128,"items":{"$ref":"#/$defs/profile"}},"outputMediaTypes":{"type":"array","minItems":1,"maxItems":2,"items":{"enum":["image/png","image/svg+xml"]}},"features":{"$ref":"#/$defs/features"},"limits":{"$ref":"#/$defs/limits"}}};
const schema189 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const schema190 = {"type":"object","additionalProperties":false,"required":["deterministic","diagnostics","nodeBounds","nodeMap","embeddedFonts"],"properties":{"deterministic":{"type":"boolean"},"diagnostics":{"type":"boolean"},"nodeBounds":{"type":"boolean"},"nodeMap":{"type":"boolean"},"embeddedFonts":{"type":"boolean"}}};
const schema191 = {"type":"object","additionalProperties":false,"required":["maxRequestBytes","maxArtifactBytes","maxWidth","maxHeight","maxNodeMapPixels"],"properties":{"maxRequestBytes":{"type":"integer","minimum":1024,"maximum":1073741824},"maxArtifactBytes":{"type":"integer","minimum":1024,"maximum":1073741824},"maxWidth":{"type":"integer","minimum":1,"maximum":32768},"maxHeight":{"type":"integer","minimum":1,"maximum":32768},"maxNodeMapPixels":{"type":"integer","minimum":0,"maximum":4194304}}};
const schema186 = {"type":"object","additionalProperties":false,"required":["id","version","backend"],"properties":{"id":{"$ref":"#/$defs/rendererId"},"version":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"},"backend":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[A-Za-z0-9][A-Za-z0-9._-]*$"},"runtime":{"$ref":"#/$defs/runtime"}}};
const schema187 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"};
const schema188 = {"type":"object","additionalProperties":false,"required":["engine","version","platform","deviceScaleFactor","colorSpace"],"properties":{"engine":{"type":"string","minLength":1,"maxLength":128},"version":{"type":"string","minLength":1,"maxLength":128},"platform":{"type":"string","minLength":1,"maxLength":128},"deviceScaleFactor":{"type":"number","exclusiveMinimum":0,"maximum":16},"colorSpace":{"const":"srgb"}}};

function validate139(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate139.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.backend === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "id") || (key0 === "version")) || (key0 === "backend")) || (key0 === "runtime"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/rendererId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(func3(data0) < 1){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/rendererId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!pattern53.test(data0)){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/rendererId/pattern",keyword:"pattern",params:{pattern: "^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"},message:"must match pattern \""+"^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/rendererId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.version !== undefined){
let data1 = data.version;
if(typeof data1 === "string"){
if(func3(data1) > 64){
const err8 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func3(data1) < 1){
const err9 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!pattern54.test(data1)){
const err10 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.backend !== undefined){
let data2 = data.backend;
if(typeof data2 === "string"){
if(func3(data2) > 64){
const err12 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(func3(data2) < 1){
const err13 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!pattern55.test(data2)){
const err14 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._-]*$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.runtime !== undefined){
let data3 = data.runtime;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.engine === undefined){
const err16 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "engine"},message:"must have required property '"+"engine"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data3.version === undefined){
const err17 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data3.platform === undefined){
const err18 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "platform"},message:"must have required property '"+"platform"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data3.deviceScaleFactor === undefined){
const err19 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "deviceScaleFactor"},message:"must have required property '"+"deviceScaleFactor"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data3.colorSpace === undefined){
const err20 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "colorSpace"},message:"must have required property '"+"colorSpace"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
for(const key1 in data3){
if(!(((((key1 === "engine") || (key1 === "version")) || (key1 === "platform")) || (key1 === "deviceScaleFactor")) || (key1 === "colorSpace"))){
const err21 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data3.engine !== undefined){
let data4 = data3.engine;
if(typeof data4 === "string"){
if(func3(data4) > 128){
const err22 = {instancePath:instancePath+"/runtime/engine",schemaPath:"#/$defs/runtime/properties/engine/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(func3(data4) < 1){
const err23 = {instancePath:instancePath+"/runtime/engine",schemaPath:"#/$defs/runtime/properties/engine/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/runtime/engine",schemaPath:"#/$defs/runtime/properties/engine/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data3.version !== undefined){
let data5 = data3.version;
if(typeof data5 === "string"){
if(func3(data5) > 128){
const err25 = {instancePath:instancePath+"/runtime/version",schemaPath:"#/$defs/runtime/properties/version/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(func3(data5) < 1){
const err26 = {instancePath:instancePath+"/runtime/version",schemaPath:"#/$defs/runtime/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/runtime/version",schemaPath:"#/$defs/runtime/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data3.platform !== undefined){
let data6 = data3.platform;
if(typeof data6 === "string"){
if(func3(data6) > 128){
const err28 = {instancePath:instancePath+"/runtime/platform",schemaPath:"#/$defs/runtime/properties/platform/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(func3(data6) < 1){
const err29 = {instancePath:instancePath+"/runtime/platform",schemaPath:"#/$defs/runtime/properties/platform/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/runtime/platform",schemaPath:"#/$defs/runtime/properties/platform/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data3.deviceScaleFactor !== undefined){
let data7 = data3.deviceScaleFactor;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 16 || isNaN(data7)){
const err31 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"#/$defs/runtime/properties/deviceScaleFactor/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16},message:"must be <= 16"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data7 <= 0 || isNaN(data7)){
const err32 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"#/$defs/runtime/properties/deviceScaleFactor/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"#/$defs/runtime/properties/deviceScaleFactor/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data3.colorSpace !== undefined){
if("srgb" !== data3.colorSpace){
const err34 = {instancePath:instancePath+"/runtime/colorSpace",schemaPath:"#/$defs/runtime/properties/colorSpace/const",keyword:"const",params:{allowedValue: "srgb"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
else {
const err35 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
}
else {
const err36 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
validate139.errors = vErrors;
return errors === 0;
}
validate139.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate138(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate138.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.renderer === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "renderer"},message:"must have required property '"+"renderer"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.profiles === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profiles"},message:"must have required property '"+"profiles"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.outputMediaTypes === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "outputMediaTypes"},message:"must have required property '"+"outputMediaTypes"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.features === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "features"},message:"must have required property '"+"features"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.limits === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "limits"},message:"must have required property '"+"limits"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "renderer") || (key0 === "profiles")) || (key0 === "outputMediaTypes")) || (key0 === "features")) || (key0 === "limits"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.renderer !== undefined){
if(!(validate139(data.renderer, {instancePath:instancePath+"/renderer",parentData:data,parentDataProperty:"renderer",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate139.errors : vErrors.concat(validate139.errors);
errors = vErrors.length;
}
}
if(data.profiles !== undefined){
let data1 = data.profiles;
if(Array.isArray(data1)){
if(data1.length > 128){
const err6 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/maxItems",keyword:"maxItems",params:{limit: 128},message:"must NOT have more than 128 items"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data1.length < 1){
const err7 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if(typeof data2 === "string"){
if(func3(data2) > 128){
const err8 = {instancePath:instancePath+"/profiles/" + i0,schemaPath:"#/$defs/profile/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func3(data2) < 1){
const err9 = {instancePath:instancePath+"/profiles/" + i0,schemaPath:"#/$defs/profile/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!pattern4.test(data2)){
const err10 = {instancePath:instancePath+"/profiles/" + i0,schemaPath:"#/$defs/profile/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/profiles/" + i0,schemaPath:"#/$defs/profile/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.outputMediaTypes !== undefined){
let data3 = data.outputMediaTypes;
if(Array.isArray(data3)){
if(data3.length > 2){
const err13 = {instancePath:instancePath+"/outputMediaTypes",schemaPath:"#/properties/outputMediaTypes/maxItems",keyword:"maxItems",params:{limit: 2},message:"must NOT have more than 2 items"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data3.length < 1){
const err14 = {instancePath:instancePath+"/outputMediaTypes",schemaPath:"#/properties/outputMediaTypes/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
const len1 = data3.length;
for(let i1=0; i1<len1; i1++){
let data4 = data3[i1];
if(!((data4 === "image/png") || (data4 === "image/svg+xml"))){
const err15 = {instancePath:instancePath+"/outputMediaTypes/" + i1,schemaPath:"#/properties/outputMediaTypes/items/enum",keyword:"enum",params:{allowedValues: schema185.properties.outputMediaTypes.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath:instancePath+"/outputMediaTypes",schemaPath:"#/properties/outputMediaTypes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.features !== undefined){
let data5 = data.features;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.deterministic === undefined){
const err17 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/required",keyword:"required",params:{missingProperty: "deterministic"},message:"must have required property '"+"deterministic"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data5.diagnostics === undefined){
const err18 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/required",keyword:"required",params:{missingProperty: "diagnostics"},message:"must have required property '"+"diagnostics"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data5.nodeBounds === undefined){
const err19 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/required",keyword:"required",params:{missingProperty: "nodeBounds"},message:"must have required property '"+"nodeBounds"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data5.nodeMap === undefined){
const err20 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/required",keyword:"required",params:{missingProperty: "nodeMap"},message:"must have required property '"+"nodeMap"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data5.embeddedFonts === undefined){
const err21 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/required",keyword:"required",params:{missingProperty: "embeddedFonts"},message:"must have required property '"+"embeddedFonts"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
for(const key1 in data5){
if(!(((((key1 === "deterministic") || (key1 === "diagnostics")) || (key1 === "nodeBounds")) || (key1 === "nodeMap")) || (key1 === "embeddedFonts"))){
const err22 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data5.deterministic !== undefined){
if(typeof data5.deterministic !== "boolean"){
const err23 = {instancePath:instancePath+"/features/deterministic",schemaPath:"#/$defs/features/properties/deterministic/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data5.diagnostics !== undefined){
if(typeof data5.diagnostics !== "boolean"){
const err24 = {instancePath:instancePath+"/features/diagnostics",schemaPath:"#/$defs/features/properties/diagnostics/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data5.nodeBounds !== undefined){
if(typeof data5.nodeBounds !== "boolean"){
const err25 = {instancePath:instancePath+"/features/nodeBounds",schemaPath:"#/$defs/features/properties/nodeBounds/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data5.nodeMap !== undefined){
if(typeof data5.nodeMap !== "boolean"){
const err26 = {instancePath:instancePath+"/features/nodeMap",schemaPath:"#/$defs/features/properties/nodeMap/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data5.embeddedFonts !== undefined){
if(typeof data5.embeddedFonts !== "boolean"){
const err27 = {instancePath:instancePath+"/features/embeddedFonts",schemaPath:"#/$defs/features/properties/embeddedFonts/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath:instancePath+"/features",schemaPath:"#/$defs/features/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.limits !== undefined){
let data11 = data.limits;
if(data11 && typeof data11 == "object" && !Array.isArray(data11)){
if(data11.maxRequestBytes === undefined){
const err29 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/required",keyword:"required",params:{missingProperty: "maxRequestBytes"},message:"must have required property '"+"maxRequestBytes"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data11.maxArtifactBytes === undefined){
const err30 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/required",keyword:"required",params:{missingProperty: "maxArtifactBytes"},message:"must have required property '"+"maxArtifactBytes"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data11.maxWidth === undefined){
const err31 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/required",keyword:"required",params:{missingProperty: "maxWidth"},message:"must have required property '"+"maxWidth"+"'"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data11.maxHeight === undefined){
const err32 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/required",keyword:"required",params:{missingProperty: "maxHeight"},message:"must have required property '"+"maxHeight"+"'"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data11.maxNodeMapPixels === undefined){
const err33 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/required",keyword:"required",params:{missingProperty: "maxNodeMapPixels"},message:"must have required property '"+"maxNodeMapPixels"+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
for(const key2 in data11){
if(!(((((key2 === "maxRequestBytes") || (key2 === "maxArtifactBytes")) || (key2 === "maxWidth")) || (key2 === "maxHeight")) || (key2 === "maxNodeMapPixels"))){
const err34 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data11.maxRequestBytes !== undefined){
let data12 = data11.maxRequestBytes;
if(!(((typeof data12 == "number") && (!(data12 % 1) && !isNaN(data12))) && (isFinite(data12)))){
const err35 = {instancePath:instancePath+"/limits/maxRequestBytes",schemaPath:"#/$defs/limits/properties/maxRequestBytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if((typeof data12 == "number") && (isFinite(data12))){
if(data12 > 1073741824 || isNaN(data12)){
const err36 = {instancePath:instancePath+"/limits/maxRequestBytes",schemaPath:"#/$defs/limits/properties/maxRequestBytes/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1073741824},message:"must be <= 1073741824"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data12 < 1024 || isNaN(data12)){
const err37 = {instancePath:instancePath+"/limits/maxRequestBytes",schemaPath:"#/$defs/limits/properties/maxRequestBytes/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1024},message:"must be >= 1024"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
if(data11.maxArtifactBytes !== undefined){
let data13 = data11.maxArtifactBytes;
if(!(((typeof data13 == "number") && (!(data13 % 1) && !isNaN(data13))) && (isFinite(data13)))){
const err38 = {instancePath:instancePath+"/limits/maxArtifactBytes",schemaPath:"#/$defs/limits/properties/maxArtifactBytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if((typeof data13 == "number") && (isFinite(data13))){
if(data13 > 1073741824 || isNaN(data13)){
const err39 = {instancePath:instancePath+"/limits/maxArtifactBytes",schemaPath:"#/$defs/limits/properties/maxArtifactBytes/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1073741824},message:"must be <= 1073741824"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data13 < 1024 || isNaN(data13)){
const err40 = {instancePath:instancePath+"/limits/maxArtifactBytes",schemaPath:"#/$defs/limits/properties/maxArtifactBytes/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1024},message:"must be >= 1024"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
if(data11.maxWidth !== undefined){
let data14 = data11.maxWidth;
if(!(((typeof data14 == "number") && (!(data14 % 1) && !isNaN(data14))) && (isFinite(data14)))){
const err41 = {instancePath:instancePath+"/limits/maxWidth",schemaPath:"#/$defs/limits/properties/maxWidth/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if((typeof data14 == "number") && (isFinite(data14))){
if(data14 > 32768 || isNaN(data14)){
const err42 = {instancePath:instancePath+"/limits/maxWidth",schemaPath:"#/$defs/limits/properties/maxWidth/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(data14 < 1 || isNaN(data14)){
const err43 = {instancePath:instancePath+"/limits/maxWidth",schemaPath:"#/$defs/limits/properties/maxWidth/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
}
if(data11.maxHeight !== undefined){
let data15 = data11.maxHeight;
if(!(((typeof data15 == "number") && (!(data15 % 1) && !isNaN(data15))) && (isFinite(data15)))){
const err44 = {instancePath:instancePath+"/limits/maxHeight",schemaPath:"#/$defs/limits/properties/maxHeight/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
if((typeof data15 == "number") && (isFinite(data15))){
if(data15 > 32768 || isNaN(data15)){
const err45 = {instancePath:instancePath+"/limits/maxHeight",schemaPath:"#/$defs/limits/properties/maxHeight/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
if(data15 < 1 || isNaN(data15)){
const err46 = {instancePath:instancePath+"/limits/maxHeight",schemaPath:"#/$defs/limits/properties/maxHeight/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
}
if(data11.maxNodeMapPixels !== undefined){
let data16 = data11.maxNodeMapPixels;
if(!(((typeof data16 == "number") && (!(data16 % 1) && !isNaN(data16))) && (isFinite(data16)))){
const err47 = {instancePath:instancePath+"/limits/maxNodeMapPixels",schemaPath:"#/$defs/limits/properties/maxNodeMapPixels/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
if((typeof data16 == "number") && (isFinite(data16))){
if(data16 > 4194304 || isNaN(data16)){
const err48 = {instancePath:instancePath+"/limits/maxNodeMapPixels",schemaPath:"#/$defs/limits/properties/maxNodeMapPixels/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4194304},message:"must be <= 4194304"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
if(data16 < 0 || isNaN(data16)){
const err49 = {instancePath:instancePath+"/limits/maxNodeMapPixels",schemaPath:"#/$defs/limits/properties/maxNodeMapPixels/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
}
}
else {
const err50 = {instancePath:instancePath+"/limits",schemaPath:"#/$defs/limits/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
}
else {
const err51 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
validate138.errors = vErrors;
return errors === 0;
}
validate138.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate137(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate137.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.protocol === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "protocol"},message:"must have required property '"+"protocol"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.requestId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.operation === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operation"},message:"must have required property '"+"operation"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.status === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.capabilities === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilities"},message:"must have required property '"+"capabilities"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "$schema") || (key0 === "protocol")) || (key0 === "version")) || (key0 === "requestId")) || (key0 === "operation")) || (key0 === "status")) || (key0 === "capabilities"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.2/renderer-response.schema.json" !== data.$schema){
const err7 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.2/renderer-response.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.protocol !== undefined){
if("maipo-renderer-protocol" !== data.protocol){
const err8 = {instancePath:instancePath+"/protocol",schemaPath:"#/$defs/protocol/const",keyword:"const",params:{allowedValue: "maipo-renderer-protocol"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.version !== undefined){
if("0.2" !== data.version){
const err9 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/const",keyword:"const",params:{allowedValue: "0.2"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.requestId !== undefined){
let data3 = data.requestId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err10 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func3(data3) < 1){
const err11 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern4.test(data3)){
const err12 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.operation !== undefined){
if("capabilities" !== data.operation){
const err14 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/const",keyword:"const",params:{allowedValue: "capabilities"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.status !== undefined){
if("ok" !== data.status){
const err15 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/const",keyword:"const",params:{allowedValue: "ok"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.capabilities !== undefined){
if(!(validate138(data.capabilities, {instancePath:instancePath+"/capabilities",parentData:data,parentDataProperty:"capabilities",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate138.errors : vErrors.concat(validate138.errors);
errors = vErrors.length;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate137.errors = vErrors;
return errors === 0;
}
validate137.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema192 = {"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","status","renderer","profile","artifact","diagnostics","fonts","timing"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.2/renderer-response.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"const":"render"},"status":{"const":"ok"},"renderer":{"$ref":"#/$defs/renderer"},"profile":{"$ref":"#/$defs/profile"},"artifact":{"$ref":"#/$defs/artifact"},"diagnostics":{"type":"array","maxItems":10000,"items":{"$ref":"#/$defs/diagnostic"}},"fonts":{"type":"array","maxItems":1024,"items":{"$ref":"#/$defs/font"}},"nodes":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/node"}},"nodeMap":{"$ref":"#/$defs/nodeMap"},"timing":{"$ref":"#/$defs/timing"}}};
const schema197 = {"type":"object","additionalProperties":false,"required":["mediaType","width","height","encoding","byteLength","digest","data"],"properties":{"mediaType":{"enum":["image/png","image/svg+xml"]},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"encoding":{"const":"base64"},"byteLength":{"type":"integer","minimum":0,"maximum":67108864},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"data":{"type":"string","contentEncoding":"base64","maxLength":89478488}}};
const schema207 = {"type":"object","additionalProperties":false,"required":["totalMs"],"properties":{"totalMs":{"type":"number","minimum":0,"maximum":86400000},"validationMs":{"type":"number","minimum":0,"maximum":86400000},"fontMs":{"type":"number","minimum":0,"maximum":86400000},"renderMs":{"type":"number","minimum":0,"maximum":86400000},"nodeMapMs":{"type":"number","minimum":0,"maximum":86400000}}};
const schema198 = {"type":"object","additionalProperties":false,"required":["severity","code","message"],"properties":{"severity":{"enum":["warning","error"]},"code":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"},"target":{"$ref":"#/$defs/requestId"},"message":{"type":"string","minLength":1,"maxLength":4096}}};

function validate145(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate145.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.severity === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "severity"},message:"must have required property '"+"severity"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.code === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "code"},message:"must have required property '"+"code"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.message === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "message"},message:"must have required property '"+"message"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "severity") || (key0 === "code")) || (key0 === "target")) || (key0 === "message"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.severity !== undefined){
let data0 = data.severity;
if(!((data0 === "warning") || (data0 === "error"))){
const err4 = {instancePath:instancePath+"/severity",schemaPath:"#/properties/severity/enum",keyword:"enum",params:{allowedValues: schema198.properties.severity.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.code !== undefined){
let data1 = data.code;
if(typeof data1 === "string"){
if(func3(data1) > 128){
const err5 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func3(data1) < 1){
const err6 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern60.test(data1)){
const err7 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.target !== undefined){
let data2 = data.target;
if(typeof data2 === "string"){
if(func3(data2) > 128){
const err9 = {instancePath:instancePath+"/target",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func3(data2) < 1){
const err10 = {instancePath:instancePath+"/target",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!pattern4.test(data2)){
const err11 = {instancePath:instancePath+"/target",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/target",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.message !== undefined){
let data3 = data.message;
if(typeof data3 === "string"){
if(func3(data3) > 4096){
const err13 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/maxLength",keyword:"maxLength",params:{limit: 4096},message:"must NOT have more than 4096 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(func3(data3) < 1){
const err14 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate145.errors = vErrors;
return errors === 0;
}
validate145.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema200 = {"type":"object","additionalProperties":false,"required":["id","family","weight","style","source","status","embedding"],"properties":{"id":{"$ref":"#/$defs/requestId"},"family":{"type":"string","minLength":1,"maxLength":1024},"weight":{"type":"integer","minimum":1,"maximum":1000},"style":{"enum":["normal","italic","oblique"]},"source":{"enum":["system","embedded"]},"status":{"enum":["available","loaded","fallback"]},"fingerprint":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"embedding":{"enum":["installable","editable","preview-print","restricted","unknown"]},"fallback":{"const":"browser-default"}},"allOf":[{"if":{"properties":{"source":{"const":"embedded"}},"required":["source"]},"then":{"required":["fingerprint"],"properties":{"fingerprint":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"status":{"enum":["loaded","fallback"]}}},"else":{"not":{"properties":{"fingerprint":{}},"required":["fingerprint"]},"properties":{"status":{"enum":["available","fallback"]}}}},{"if":{"properties":{"status":{"const":"fallback"}},"required":["status"]},"then":{"required":["fallback"],"properties":{"fallback":{"const":"browser-default"}}},"else":{"not":{"properties":{"fallback":{}},"required":["fallback"]}}}]};

function validate147(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate147.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs2 = errors;
let valid1 = true;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.source === undefined) && (missing0 = "source")){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
if(data.source !== undefined){
if("embedded" !== data.source){
const err1 = {};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
}
}
var _valid0 = _errs3 === errors;
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
let ifClause0;
if(_valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.fingerprint === undefined){
const err2 = {instancePath,schemaPath:"#/allOf/0/then/required",keyword:"required",params:{missingProperty: "fingerprint"},message:"must have required property '"+"fingerprint"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.fingerprint !== undefined){
let data1 = data.fingerprint;
if(typeof data1 === "string"){
if(!pattern9.test(data1)){
const err3 = {instancePath:instancePath+"/fingerprint",schemaPath:"#/allOf/0/then/properties/fingerprint/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/fingerprint",schemaPath:"#/allOf/0/then/properties/fingerprint/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.status !== undefined){
let data2 = data.status;
if(!((data2 === "loaded") || (data2 === "fallback"))){
const err5 = {instancePath:instancePath+"/status",schemaPath:"#/allOf/0/then/properties/status/enum",keyword:"enum",params:{allowedValues: schema200.allOf[0].then.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
var _valid0 = _errs5 === errors;
valid1 = _valid0;
if(valid1){
var props0 = {};
props0.fingerprint = true;
props0.status = true;
props0.source = true;
}
ifClause0 = "then";
}
else {
const _errs9 = errors;
const _errs10 = errors;
const _errs11 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing1;
if((data.fingerprint === undefined) && (missing1 = "fingerprint")){
const err6 = {};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
var valid4 = _errs11 === errors;
if(valid4){
const err7 = {instancePath,schemaPath:"#/allOf/0/else/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
else {
errors = _errs10;
if(vErrors !== null){
if(_errs10){
vErrors.length = _errs10;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.status !== undefined){
let data3 = data.status;
if(!((data3 === "available") || (data3 === "fallback"))){
const err8 = {instancePath:instancePath+"/status",schemaPath:"#/allOf/0/else/properties/status/enum",keyword:"enum",params:{allowedValues: schema200.allOf[0].else.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
var _valid0 = _errs9 === errors;
valid1 = _valid0;
if(valid1){
if(props0 !== true){
props0 = props0 || {};
props0.status = true;
}
}
ifClause0 = "else";
}
if(!valid1){
const err9 = {instancePath,schemaPath:"#/allOf/0/if",keyword:"if",params:{failingKeyword: ifClause0},message:"must match \""+ifClause0+"\" schema"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
const _errs14 = errors;
let valid6 = true;
const _errs15 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing2;
if((data.status === undefined) && (missing2 = "status")){
const err10 = {};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
else {
if(data.status !== undefined){
if("fallback" !== data.status){
const err11 = {};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
}
var _valid1 = _errs15 === errors;
errors = _errs14;
if(vErrors !== null){
if(_errs14){
vErrors.length = _errs14;
}
else {
vErrors = null;
}
}
let ifClause1;
if(_valid1){
const _errs17 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.fallback === undefined){
const err12 = {instancePath,schemaPath:"#/allOf/1/then/required",keyword:"required",params:{missingProperty: "fallback"},message:"must have required property '"+"fallback"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data.fallback !== undefined){
if("browser-default" !== data.fallback){
const err13 = {instancePath:instancePath+"/fallback",schemaPath:"#/allOf/1/then/properties/fallback/const",keyword:"const",params:{allowedValue: "browser-default"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
var _valid1 = _errs17 === errors;
valid6 = _valid1;
if(valid6){
var props1 = {};
props1.fallback = true;
props1.status = true;
}
ifClause1 = "then";
}
else {
const _errs19 = errors;
const _errs20 = errors;
const _errs21 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing3;
if((data.fallback === undefined) && (missing3 = "fallback")){
const err14 = {};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
var valid9 = _errs21 === errors;
if(valid9){
const err15 = {instancePath,schemaPath:"#/allOf/1/else/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
else {
errors = _errs20;
if(vErrors !== null){
if(_errs20){
vErrors.length = _errs20;
}
else {
vErrors = null;
}
}
}
var _valid1 = _errs19 === errors;
valid6 = _valid1;
ifClause1 = "else";
}
if(!valid6){
const err16 = {instancePath,schemaPath:"#/allOf/1/if",keyword:"if",params:{failingKeyword: ifClause1},message:"must match \""+ifClause1+"\" schema"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(props0 !== true && props1 !== undefined){
if(props1 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props1);
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err17 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data.family === undefined){
const err18 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "family"},message:"must have required property '"+"family"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data.weight === undefined){
const err19 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "weight"},message:"must have required property '"+"weight"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data.style === undefined){
const err20 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "style"},message:"must have required property '"+"style"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data.source === undefined){
const err21 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data.status === undefined){
const err22 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data.embedding === undefined){
const err23 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "embedding"},message:"must have required property '"+"embedding"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema200.properties, key0))){
const err24 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.id !== undefined){
let data6 = data.id;
if(typeof data6 === "string"){
if(func3(data6) > 128){
const err25 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(func3(data6) < 1){
const err26 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(!pattern4.test(data6)){
const err27 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
else {
const err28 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.family !== undefined){
let data7 = data.family;
if(typeof data7 === "string"){
if(func3(data7) > 1024){
const err29 = {instancePath:instancePath+"/family",schemaPath:"#/properties/family/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(func3(data7) < 1){
const err30 = {instancePath:instancePath+"/family",schemaPath:"#/properties/family/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
else {
const err31 = {instancePath:instancePath+"/family",schemaPath:"#/properties/family/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data.weight !== undefined){
let data8 = data.weight;
if(!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))){
const err32 = {instancePath:instancePath+"/weight",schemaPath:"#/properties/weight/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 1000 || isNaN(data8)){
const err33 = {instancePath:instancePath+"/weight",schemaPath:"#/properties/weight/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000},message:"must be <= 1000"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data8 < 1 || isNaN(data8)){
const err34 = {instancePath:instancePath+"/weight",schemaPath:"#/properties/weight/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
if(data.style !== undefined){
let data9 = data.style;
if(!(((data9 === "normal") || (data9 === "italic")) || (data9 === "oblique"))){
const err35 = {instancePath:instancePath+"/style",schemaPath:"#/properties/style/enum",keyword:"enum",params:{allowedValues: schema200.properties.style.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data.source !== undefined){
let data10 = data.source;
if(!((data10 === "system") || (data10 === "embedded"))){
const err36 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/enum",keyword:"enum",params:{allowedValues: schema200.properties.source.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
if(data.status !== undefined){
let data11 = data.status;
if(!(((data11 === "available") || (data11 === "loaded")) || (data11 === "fallback"))){
const err37 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues: schema200.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data.fingerprint !== undefined){
let data12 = data.fingerprint;
if(typeof data12 === "string"){
if(!pattern9.test(data12)){
const err38 = {instancePath:instancePath+"/fingerprint",schemaPath:"#/properties/fingerprint/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
else {
const err39 = {instancePath:instancePath+"/fingerprint",schemaPath:"#/properties/fingerprint/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data.embedding !== undefined){
let data13 = data.embedding;
if(!(((((data13 === "installable") || (data13 === "editable")) || (data13 === "preview-print")) || (data13 === "restricted")) || (data13 === "unknown"))){
const err40 = {instancePath:instancePath+"/embedding",schemaPath:"#/properties/embedding/enum",keyword:"enum",params:{allowedValues: schema200.properties.embedding.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data.fallback !== undefined){
if("browser-default" !== data.fallback){
const err41 = {instancePath:instancePath+"/fallback",schemaPath:"#/properties/fallback/const",keyword:"const",params:{allowedValue: "browser-default"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
}
else {
const err42 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
validate147.errors = vErrors;
return errors === 0;
}
validate147.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema202 = {"type":"object","additionalProperties":false,"required":["id","name","visible","bounds"],"properties":{"id":{"$ref":"#/$defs/requestId"},"name":{"type":"string","minLength":1,"maxLength":1024},"role":{"type":"string","minLength":1,"maxLength":128},"visible":{"type":"boolean"},"bounds":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/bounds"}]}}};
const schema204 = {"type":"object","additionalProperties":false,"required":["x","y","width","height"],"properties":{"x":{"type":"number","minimum":-1000000000,"maximum":1000000000},"y":{"type":"number","minimum":-1000000000,"maximum":1000000000},"width":{"type":"number","minimum":0,"maximum":1000000000},"height":{"type":"number","minimum":0,"maximum":1000000000}}};

function validate149(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate149.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.visible === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "visible"},message:"must have required property '"+"visible"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.bounds === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bounds"},message:"must have required property '"+"bounds"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "id") || (key0 === "name")) || (key0 === "role")) || (key0 === "visible")) || (key0 === "bounds"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func3(data0) < 1){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern4.test(data0)){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 === "string"){
if(func3(data1) > 1024){
const err9 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func3(data1) < 1){
const err10 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.role !== undefined){
let data2 = data.role;
if(typeof data2 === "string"){
if(func3(data2) > 128){
const err12 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(func3(data2) < 1){
const err13 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.visible !== undefined){
if(typeof data.visible !== "boolean"){
const err15 = {instancePath:instancePath+"/visible",schemaPath:"#/properties/visible/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.bounds !== undefined){
let data4 = data.bounds;
const _errs12 = errors;
let valid2 = false;
let passing0 = null;
const _errs13 = errors;
if(data4 !== null){
const err16 = {instancePath:instancePath+"/bounds",schemaPath:"#/properties/bounds/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
var _valid0 = _errs13 === errors;
if(_valid0){
valid2 = true;
passing0 = 0;
}
const _errs15 = errors;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.x === undefined){
const err17 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data4.y === undefined){
const err18 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data4.width === undefined){
const err19 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data4.height === undefined){
const err20 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
for(const key1 in data4){
if(!((((key1 === "x") || (key1 === "y")) || (key1 === "width")) || (key1 === "height"))){
const err21 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data4.x !== undefined){
let data5 = data4.x;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 1000000000 || isNaN(data5)){
const err22 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/bounds/properties/x/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data5 < -1000000000 || isNaN(data5)){
const err23 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/bounds/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/bounds/properties/x/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data4.y !== undefined){
let data6 = data4.y;
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 > 1000000000 || isNaN(data6)){
const err25 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/bounds/properties/y/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data6 < -1000000000 || isNaN(data6)){
const err26 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/bounds/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/bounds/properties/y/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data4.width !== undefined){
let data7 = data4.width;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 1000000000 || isNaN(data7)){
const err28 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/bounds/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data7 < 0 || isNaN(data7)){
const err29 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/bounds/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/bounds/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data4.height !== undefined){
let data8 = data4.height;
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 1000000000 || isNaN(data8)){
const err31 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/bounds/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data8 < 0 || isNaN(data8)){
const err32 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/bounds/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/bounds/properties/height/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
else {
const err34 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
var _valid0 = _errs15 === errors;
if(_valid0 && valid2){
valid2 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid2 = true;
passing0 = 1;
}
}
if(!valid2){
const err35 = {instancePath:instancePath+"/bounds",schemaPath:"#/properties/bounds/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
else {
errors = _errs12;
if(vErrors !== null){
if(_errs12){
vErrors.length = _errs12;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err36 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
validate149.errors = vErrors;
return errors === 0;
}
validate149.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema205 = {"type":"object","additionalProperties":false,"required":["width","height","ids","encoding","byteLength","digest","data"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"ids":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/requestId"}},"encoding":{"const":"uint32le-base64"},"byteLength":{"type":"integer","minimum":4,"maximum":16777216},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"data":{"type":"string","contentEncoding":"base64","maxLength":22369624}}};

function validate151(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate151.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.width === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.height === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.ids === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ids"},message:"must have required property '"+"ids"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.encoding === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "encoding"},message:"must have required property '"+"encoding"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.byteLength === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.digest === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.data === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "data"},message:"must have required property '"+"data"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "width") || (key0 === "height")) || (key0 === "ids")) || (key0 === "encoding")) || (key0 === "byteLength")) || (key0 === "digest")) || (key0 === "data"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.width !== undefined){
let data0 = data.width;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 32768 || isNaN(data0)){
const err9 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data0 < 1 || isNaN(data0)){
const err10 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
if(data.height !== undefined){
let data1 = data.height;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err11 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 32768 || isNaN(data1)){
const err12 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err13 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data.ids !== undefined){
let data2 = data.ids;
if(Array.isArray(data2)){
if(data2.length > 100000){
const err14 = {instancePath:instancePath+"/ids",schemaPath:"#/properties/ids/maxItems",keyword:"maxItems",params:{limit: 100000},message:"must NOT have more than 100000 items"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
const len0 = data2.length;
for(let i0=0; i0<len0; i0++){
let data3 = data2[i0];
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err15 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(func3(data3) < 1){
const err16 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(!pattern4.test(data3)){
const err17 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath:instancePath+"/ids",schemaPath:"#/properties/ids/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.encoding !== undefined){
if("uint32le-base64" !== data.encoding){
const err20 = {instancePath:instancePath+"/encoding",schemaPath:"#/properties/encoding/const",keyword:"const",params:{allowedValue: "uint32le-base64"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.byteLength !== undefined){
let data5 = data.byteLength;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err21 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 16777216 || isNaN(data5)){
const err22 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16777216},message:"must be <= 16777216"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data5 < 4 || isNaN(data5)){
const err23 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 4},message:"must be >= 4"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
if(data.digest !== undefined){
let data6 = data.digest;
if(typeof data6 === "string"){
if(!pattern9.test(data6)){
const err24 = {instancePath:instancePath+"/digest",schemaPath:"#/properties/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/digest",schemaPath:"#/properties/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.data !== undefined){
let data7 = data.data;
if(typeof data7 === "string"){
if(func3(data7) > 22369624){
const err26 = {instancePath:instancePath+"/data",schemaPath:"#/properties/data/maxLength",keyword:"maxLength",params:{limit: 22369624},message:"must NOT have more than 22369624 characters"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/data",schemaPath:"#/properties/data/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
validate151.errors = vErrors;
return errors === 0;
}
validate151.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate143(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate143.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.protocol === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "protocol"},message:"must have required property '"+"protocol"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.requestId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.operation === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operation"},message:"must have required property '"+"operation"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.status === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.renderer === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "renderer"},message:"must have required property '"+"renderer"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.profile === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profile"},message:"must have required property '"+"profile"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.artifact === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "artifact"},message:"must have required property '"+"artifact"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.diagnostics === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "diagnostics"},message:"must have required property '"+"diagnostics"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.fonts === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fonts"},message:"must have required property '"+"fonts"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.timing === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "timing"},message:"must have required property '"+"timing"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema192.properties, key0))){
const err11 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.2/renderer-response.schema.json" !== data.$schema){
const err12 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.2/renderer-response.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.protocol !== undefined){
if("maipo-renderer-protocol" !== data.protocol){
const err13 = {instancePath:instancePath+"/protocol",schemaPath:"#/$defs/protocol/const",keyword:"const",params:{allowedValue: "maipo-renderer-protocol"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.version !== undefined){
if("0.2" !== data.version){
const err14 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/const",keyword:"const",params:{allowedValue: "0.2"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.requestId !== undefined){
let data3 = data.requestId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err15 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(func3(data3) < 1){
const err16 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(!pattern4.test(data3)){
const err17 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.operation !== undefined){
if("render" !== data.operation){
const err19 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/const",keyword:"const",params:{allowedValue: "render"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.status !== undefined){
if("ok" !== data.status){
const err20 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/const",keyword:"const",params:{allowedValue: "ok"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.renderer !== undefined){
if(!(validate139(data.renderer, {instancePath:instancePath+"/renderer",parentData:data,parentDataProperty:"renderer",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate139.errors : vErrors.concat(validate139.errors);
errors = vErrors.length;
}
}
if(data.profile !== undefined){
let data7 = data.profile;
if(typeof data7 === "string"){
if(func3(data7) > 128){
const err21 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(func3(data7) < 1){
const err22 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(!pattern4.test(data7)){
const err23 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/profile/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.artifact !== undefined){
let data8 = data.artifact;
if(data8 && typeof data8 == "object" && !Array.isArray(data8)){
if(data8.mediaType === undefined){
const err25 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "mediaType"},message:"must have required property '"+"mediaType"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data8.width === undefined){
const err26 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(data8.height === undefined){
const err27 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data8.encoding === undefined){
const err28 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "encoding"},message:"must have required property '"+"encoding"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data8.byteLength === undefined){
const err29 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data8.digest === undefined){
const err30 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data8.data === undefined){
const err31 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/required",keyword:"required",params:{missingProperty: "data"},message:"must have required property '"+"data"+"'"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
for(const key1 in data8){
if(!(((((((key1 === "mediaType") || (key1 === "width")) || (key1 === "height")) || (key1 === "encoding")) || (key1 === "byteLength")) || (key1 === "digest")) || (key1 === "data"))){
const err32 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data8.mediaType !== undefined){
let data9 = data8.mediaType;
if(!((data9 === "image/png") || (data9 === "image/svg+xml"))){
const err33 = {instancePath:instancePath+"/artifact/mediaType",schemaPath:"#/$defs/artifact/properties/mediaType/enum",keyword:"enum",params:{allowedValues: schema197.properties.mediaType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data8.width !== undefined){
let data10 = data8.width;
if(!(((typeof data10 == "number") && (!(data10 % 1) && !isNaN(data10))) && (isFinite(data10)))){
const err34 = {instancePath:instancePath+"/artifact/width",schemaPath:"#/$defs/artifact/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if((typeof data10 == "number") && (isFinite(data10))){
if(data10 > 32768 || isNaN(data10)){
const err35 = {instancePath:instancePath+"/artifact/width",schemaPath:"#/$defs/artifact/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data10 < 1 || isNaN(data10)){
const err36 = {instancePath:instancePath+"/artifact/width",schemaPath:"#/$defs/artifact/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
if(data8.height !== undefined){
let data11 = data8.height;
if(!(((typeof data11 == "number") && (!(data11 % 1) && !isNaN(data11))) && (isFinite(data11)))){
const err37 = {instancePath:instancePath+"/artifact/height",schemaPath:"#/$defs/artifact/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if((typeof data11 == "number") && (isFinite(data11))){
if(data11 > 32768 || isNaN(data11)){
const err38 = {instancePath:instancePath+"/artifact/height",schemaPath:"#/$defs/artifact/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if(data11 < 1 || isNaN(data11)){
const err39 = {instancePath:instancePath+"/artifact/height",schemaPath:"#/$defs/artifact/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
}
if(data8.encoding !== undefined){
if("base64" !== data8.encoding){
const err40 = {instancePath:instancePath+"/artifact/encoding",schemaPath:"#/$defs/artifact/properties/encoding/const",keyword:"const",params:{allowedValue: "base64"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data8.byteLength !== undefined){
let data13 = data8.byteLength;
if(!(((typeof data13 == "number") && (!(data13 % 1) && !isNaN(data13))) && (isFinite(data13)))){
const err41 = {instancePath:instancePath+"/artifact/byteLength",schemaPath:"#/$defs/artifact/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if((typeof data13 == "number") && (isFinite(data13))){
if(data13 > 67108864 || isNaN(data13)){
const err42 = {instancePath:instancePath+"/artifact/byteLength",schemaPath:"#/$defs/artifact/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 67108864},message:"must be <= 67108864"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(data13 < 0 || isNaN(data13)){
const err43 = {instancePath:instancePath+"/artifact/byteLength",schemaPath:"#/$defs/artifact/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
}
if(data8.digest !== undefined){
let data14 = data8.digest;
if(typeof data14 === "string"){
if(!pattern9.test(data14)){
const err44 = {instancePath:instancePath+"/artifact/digest",schemaPath:"#/$defs/artifact/properties/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
else {
const err45 = {instancePath:instancePath+"/artifact/digest",schemaPath:"#/$defs/artifact/properties/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data8.data !== undefined){
let data15 = data8.data;
if(typeof data15 === "string"){
if(func3(data15) > 89478488){
const err46 = {instancePath:instancePath+"/artifact/data",schemaPath:"#/$defs/artifact/properties/data/maxLength",keyword:"maxLength",params:{limit: 89478488},message:"must NOT have more than 89478488 characters"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
else {
const err47 = {instancePath:instancePath+"/artifact/data",schemaPath:"#/$defs/artifact/properties/data/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
}
else {
const err48 = {instancePath:instancePath+"/artifact",schemaPath:"#/$defs/artifact/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
if(data.diagnostics !== undefined){
let data16 = data.diagnostics;
if(Array.isArray(data16)){
if(data16.length > 10000){
const err49 = {instancePath:instancePath+"/diagnostics",schemaPath:"#/properties/diagnostics/maxItems",keyword:"maxItems",params:{limit: 10000},message:"must NOT have more than 10000 items"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
const len0 = data16.length;
for(let i0=0; i0<len0; i0++){
if(!(validate145(data16[i0], {instancePath:instancePath+"/diagnostics/" + i0,parentData:data16,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate145.errors : vErrors.concat(validate145.errors);
errors = vErrors.length;
}
}
}
else {
const err50 = {instancePath:instancePath+"/diagnostics",schemaPath:"#/properties/diagnostics/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
if(data.fonts !== undefined){
let data18 = data.fonts;
if(Array.isArray(data18)){
if(data18.length > 1024){
const err51 = {instancePath:instancePath+"/fonts",schemaPath:"#/properties/fonts/maxItems",keyword:"maxItems",params:{limit: 1024},message:"must NOT have more than 1024 items"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
const len1 = data18.length;
for(let i1=0; i1<len1; i1++){
if(!(validate147(data18[i1], {instancePath:instancePath+"/fonts/" + i1,parentData:data18,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate147.errors : vErrors.concat(validate147.errors);
errors = vErrors.length;
}
}
}
else {
const err52 = {instancePath:instancePath+"/fonts",schemaPath:"#/properties/fonts/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
if(data.nodes !== undefined){
let data20 = data.nodes;
if(Array.isArray(data20)){
if(data20.length > 100000){
const err53 = {instancePath:instancePath+"/nodes",schemaPath:"#/properties/nodes/maxItems",keyword:"maxItems",params:{limit: 100000},message:"must NOT have more than 100000 items"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
const len2 = data20.length;
for(let i2=0; i2<len2; i2++){
if(!(validate149(data20[i2], {instancePath:instancePath+"/nodes/" + i2,parentData:data20,parentDataProperty:i2,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate149.errors : vErrors.concat(validate149.errors);
errors = vErrors.length;
}
}
}
else {
const err54 = {instancePath:instancePath+"/nodes",schemaPath:"#/properties/nodes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
if(data.nodeMap !== undefined){
if(!(validate151(data.nodeMap, {instancePath:instancePath+"/nodeMap",parentData:data,parentDataProperty:"nodeMap",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate151.errors : vErrors.concat(validate151.errors);
errors = vErrors.length;
}
}
if(data.timing !== undefined){
let data23 = data.timing;
if(data23 && typeof data23 == "object" && !Array.isArray(data23)){
if(data23.totalMs === undefined){
const err55 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/required",keyword:"required",params:{missingProperty: "totalMs"},message:"must have required property '"+"totalMs"+"'"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
for(const key2 in data23){
if(!(((((key2 === "totalMs") || (key2 === "validationMs")) || (key2 === "fontMs")) || (key2 === "renderMs")) || (key2 === "nodeMapMs"))){
const err56 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
if(data23.totalMs !== undefined){
let data24 = data23.totalMs;
if((typeof data24 == "number") && (isFinite(data24))){
if(data24 > 86400000 || isNaN(data24)){
const err57 = {instancePath:instancePath+"/timing/totalMs",schemaPath:"#/$defs/timing/properties/totalMs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 86400000},message:"must be <= 86400000"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
if(data24 < 0 || isNaN(data24)){
const err58 = {instancePath:instancePath+"/timing/totalMs",schemaPath:"#/$defs/timing/properties/totalMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
else {
const err59 = {instancePath:instancePath+"/timing/totalMs",schemaPath:"#/$defs/timing/properties/totalMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
}
if(data23.validationMs !== undefined){
let data25 = data23.validationMs;
if((typeof data25 == "number") && (isFinite(data25))){
if(data25 > 86400000 || isNaN(data25)){
const err60 = {instancePath:instancePath+"/timing/validationMs",schemaPath:"#/$defs/timing/properties/validationMs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 86400000},message:"must be <= 86400000"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
if(data25 < 0 || isNaN(data25)){
const err61 = {instancePath:instancePath+"/timing/validationMs",schemaPath:"#/$defs/timing/properties/validationMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
}
else {
const err62 = {instancePath:instancePath+"/timing/validationMs",schemaPath:"#/$defs/timing/properties/validationMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
}
if(data23.fontMs !== undefined){
let data26 = data23.fontMs;
if((typeof data26 == "number") && (isFinite(data26))){
if(data26 > 86400000 || isNaN(data26)){
const err63 = {instancePath:instancePath+"/timing/fontMs",schemaPath:"#/$defs/timing/properties/fontMs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 86400000},message:"must be <= 86400000"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
if(data26 < 0 || isNaN(data26)){
const err64 = {instancePath:instancePath+"/timing/fontMs",schemaPath:"#/$defs/timing/properties/fontMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
}
else {
const err65 = {instancePath:instancePath+"/timing/fontMs",schemaPath:"#/$defs/timing/properties/fontMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
}
if(data23.renderMs !== undefined){
let data27 = data23.renderMs;
if((typeof data27 == "number") && (isFinite(data27))){
if(data27 > 86400000 || isNaN(data27)){
const err66 = {instancePath:instancePath+"/timing/renderMs",schemaPath:"#/$defs/timing/properties/renderMs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 86400000},message:"must be <= 86400000"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
if(data27 < 0 || isNaN(data27)){
const err67 = {instancePath:instancePath+"/timing/renderMs",schemaPath:"#/$defs/timing/properties/renderMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
}
else {
const err68 = {instancePath:instancePath+"/timing/renderMs",schemaPath:"#/$defs/timing/properties/renderMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
}
if(data23.nodeMapMs !== undefined){
let data28 = data23.nodeMapMs;
if((typeof data28 == "number") && (isFinite(data28))){
if(data28 > 86400000 || isNaN(data28)){
const err69 = {instancePath:instancePath+"/timing/nodeMapMs",schemaPath:"#/$defs/timing/properties/nodeMapMs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 86400000},message:"must be <= 86400000"};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
if(data28 < 0 || isNaN(data28)){
const err70 = {instancePath:instancePath+"/timing/nodeMapMs",schemaPath:"#/$defs/timing/properties/nodeMapMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
}
else {
const err71 = {instancePath:instancePath+"/timing/nodeMapMs",schemaPath:"#/$defs/timing/properties/nodeMapMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
}
}
else {
const err72 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
}
}
else {
const err73 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
validate143.errors = vErrors;
return errors === 0;
}
validate143.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema208 = {"type":"object","additionalProperties":false,"required":["protocol","version","requestId","operation","status","error"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.2/renderer-response.schema.json"},"protocol":{"$ref":"#/$defs/protocol"},"version":{"$ref":"#/$defs/version"},"requestId":{"$ref":"#/$defs/requestId"},"operation":{"enum":["capabilities","render"]},"status":{"const":"error"},"error":{"$ref":"#/$defs/protocolError"}}};
const schema212 = {"type":"object","additionalProperties":false,"required":["code","message"],"properties":{"code":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"},"message":{"type":"string","minLength":1,"maxLength":4096},"diagnostics":{"type":"array","maxItems":10000,"items":{"$ref":"#/$defs/diagnostic"}}}};

function validate155(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate155.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.code === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "code"},message:"must have required property '"+"code"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.message === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "message"},message:"must have required property '"+"message"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "code") || (key0 === "message")) || (key0 === "diagnostics"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.code !== undefined){
let data0 = data.code;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err3 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func3(data0) < 1){
const err4 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern60.test(data0)){
const err5 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.message !== undefined){
let data1 = data.message;
if(typeof data1 === "string"){
if(func3(data1) > 4096){
const err7 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/maxLength",keyword:"maxLength",params:{limit: 4096},message:"must NOT have more than 4096 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(func3(data1) < 1){
const err8 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.diagnostics !== undefined){
let data2 = data.diagnostics;
if(Array.isArray(data2)){
if(data2.length > 10000){
const err10 = {instancePath:instancePath+"/diagnostics",schemaPath:"#/properties/diagnostics/maxItems",keyword:"maxItems",params:{limit: 10000},message:"must NOT have more than 10000 items"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
const len0 = data2.length;
for(let i0=0; i0<len0; i0++){
if(!(validate145(data2[i0], {instancePath:instancePath+"/diagnostics/" + i0,parentData:data2,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate145.errors : vErrors.concat(validate145.errors);
errors = vErrors.length;
}
}
}
else {
const err11 = {instancePath:instancePath+"/diagnostics",schemaPath:"#/properties/diagnostics/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate155.errors = vErrors;
return errors === 0;
}
validate155.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate154(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate154.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.protocol === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "protocol"},message:"must have required property '"+"protocol"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.requestId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.operation === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operation"},message:"must have required property '"+"operation"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.status === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.error === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "error"},message:"must have required property '"+"error"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "$schema") || (key0 === "protocol")) || (key0 === "version")) || (key0 === "requestId")) || (key0 === "operation")) || (key0 === "status")) || (key0 === "error"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.2/renderer-response.schema.json" !== data.$schema){
const err7 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.2/renderer-response.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.protocol !== undefined){
if("maipo-renderer-protocol" !== data.protocol){
const err8 = {instancePath:instancePath+"/protocol",schemaPath:"#/$defs/protocol/const",keyword:"const",params:{allowedValue: "maipo-renderer-protocol"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.version !== undefined){
if("0.2" !== data.version){
const err9 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/const",keyword:"const",params:{allowedValue: "0.2"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.requestId !== undefined){
let data3 = data.requestId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err10 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func3(data3) < 1){
const err11 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern4.test(data3)){
const err12 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.operation !== undefined){
let data4 = data.operation;
if(!((data4 === "capabilities") || (data4 === "render"))){
const err14 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/enum",keyword:"enum",params:{allowedValues: schema208.properties.operation.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.status !== undefined){
if("error" !== data.status){
const err15 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/const",keyword:"const",params:{allowedValue: "error"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.error !== undefined){
if(!(validate155(data.error, {instancePath:instancePath+"/error",parentData:data,parentDataProperty:"error",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate155.errors : vErrors.concat(validate155.errors);
errors = vErrors.length;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate154.errors = vErrors;
return errors === 0;
}
validate154.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate136(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.2/renderer-response.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate136.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate137(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate137.errors : vErrors.concat(validate137.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate143(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate143.errors : vErrors.concat(validate143.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
const _errs3 = errors;
if(!(validate154(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate154.errors : vErrors.concat(validate154.errors);
errors = vErrors.length;
}
var _valid0 = _errs3 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
if(props0 !== true){
props0 = true;
}
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate136.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate136.evaluated = {"dynamicProps":true,"dynamicItems":false};

export const validateConformanceReportSchema = validate159;
const schema213 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/conformance-report.schema.json","title":"Maipo renderer conformance report 0.1","description":"A successful, machine-readable result produced by the Maipo renderer conformance kit.","type":"object","additionalProperties":false,"required":["$schema","format","version","case","mode","passed","renderer","protocol","profile","artifact","nodeMap","checks"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/conformance-report.schema.json"},"format":{"const":"maipo-conformance-report"},"version":{"const":"0.1"},"case":{"$ref":"#/$defs/token"},"mode":{"enum":["third-party-protocol","reference-exact"]},"passed":{"const":true},"renderer":{"$ref":"#/$defs/renderer"},"protocol":{"enum":["0.1","0.2"]},"profile":{"$ref":"#/$defs/token"},"artifact":{"$ref":"#/$defs/artifact"},"nodeMap":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/nodeMap"}]},"checks":{"$ref":"#/$defs/checks"}},"allOf":[{"if":{"type":"object","properties":{"mode":{"const":"reference-exact"}},"required":["mode"]},"then":{"type":"object","properties":{"checks":{"type":"object","properties":{"referenceArtifact":{"const":true}}}}},"else":{"type":"object","properties":{"checks":{"type":"object","properties":{"referenceArtifact":{"type":"null"}}}}}}],"$defs":{"token":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"runtime":{"type":"object","additionalProperties":false,"required":["engine","version","platform","deviceScaleFactor","colorSpace"],"properties":{"engine":{"type":"string","minLength":1,"maxLength":128},"version":{"type":"string","minLength":1,"maxLength":128},"platform":{"type":"string","minLength":1,"maxLength":128},"deviceScaleFactor":{"type":"number","exclusiveMinimum":0,"maximum":16},"colorSpace":{"const":"srgb"}}},"renderer":{"type":"object","additionalProperties":false,"required":["id","version","backend"],"properties":{"id":{"type":"string","minLength":1,"maxLength":128,"pattern":"^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"},"version":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"},"backend":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[A-Za-z0-9][A-Za-z0-9._-]*$"},"runtime":{"$ref":"#/$defs/runtime"}}},"artifact":{"type":"object","additionalProperties":false,"required":["mediaType","width","height","byteLength","digest"],"properties":{"mediaType":{"enum":["image/png","image/svg+xml"]},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"byteLength":{"type":"integer","minimum":0,"maximum":67108864},"digest":{"$ref":"#/$defs/digest"}}},"nodeMap":{"type":"object","additionalProperties":false,"required":["width","height","byteLength","digest","ids"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"byteLength":{"type":"integer","minimum":4,"maximum":16777216},"digest":{"$ref":"#/$defs/digest"},"ids":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/token"}}}},"checks":{"type":"object","additionalProperties":false,"required":["schema","capabilities","profileAdmission","artifactIntegrity","repeatDeterminism","structuredErrors","scaledOutput","referenceArtifact"],"properties":{"schema":{"const":true},"capabilities":{"const":true},"profileAdmission":{"const":true},"artifactIntegrity":{"const":true},"repeatDeterminism":{"const":true},"structuredErrors":{"type":"array","minItems":4,"maxItems":128,"items":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"}},"scaledOutput":{"oneOf":[{"const":true},{"type":"null"}]},"referenceArtifact":{"oneOf":[{"const":true},{"type":"null"}]}}}}};
const schema214 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const schema223 = {"type":"object","additionalProperties":false,"required":["schema","capabilities","profileAdmission","artifactIntegrity","repeatDeterminism","structuredErrors","scaledOutput","referenceArtifact"],"properties":{"schema":{"const":true},"capabilities":{"const":true},"profileAdmission":{"const":true},"artifactIntegrity":{"const":true},"repeatDeterminism":{"const":true},"structuredErrors":{"type":"array","minItems":4,"maxItems":128,"items":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"}},"scaledOutput":{"oneOf":[{"const":true},{"type":"null"}]},"referenceArtifact":{"oneOf":[{"const":true},{"type":"null"}]}}};
const schema215 = {"type":"object","additionalProperties":false,"required":["id","version","backend"],"properties":{"id":{"type":"string","minLength":1,"maxLength":128,"pattern":"^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"},"version":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"},"backend":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[A-Za-z0-9][A-Za-z0-9._-]*$"},"runtime":{"$ref":"#/$defs/runtime"}}};
const schema216 = {"type":"object","additionalProperties":false,"required":["engine","version","platform","deviceScaleFactor","colorSpace"],"properties":{"engine":{"type":"string","minLength":1,"maxLength":128},"version":{"type":"string","minLength":1,"maxLength":128},"platform":{"type":"string","minLength":1,"maxLength":128},"deviceScaleFactor":{"type":"number","exclusiveMinimum":0,"maximum":16},"colorSpace":{"const":"srgb"}}};

function validate160(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate160.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.backend === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "id") || (key0 === "version")) || (key0 === "backend")) || (key0 === "runtime"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(func3(data0) < 1){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!pattern53.test(data0)){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/pattern",keyword:"pattern",params:{pattern: "^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"},message:"must match pattern \""+"^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.version !== undefined){
let data1 = data.version;
if(typeof data1 === "string"){
if(func3(data1) > 64){
const err8 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func3(data1) < 1){
const err9 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!pattern54.test(data1)){
const err10 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.backend !== undefined){
let data2 = data.backend;
if(typeof data2 === "string"){
if(func3(data2) > 64){
const err12 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(func3(data2) < 1){
const err13 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!pattern55.test(data2)){
const err14 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._-]*$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.runtime !== undefined){
let data3 = data.runtime;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.engine === undefined){
const err16 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "engine"},message:"must have required property '"+"engine"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data3.version === undefined){
const err17 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data3.platform === undefined){
const err18 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "platform"},message:"must have required property '"+"platform"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data3.deviceScaleFactor === undefined){
const err19 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "deviceScaleFactor"},message:"must have required property '"+"deviceScaleFactor"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data3.colorSpace === undefined){
const err20 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "colorSpace"},message:"must have required property '"+"colorSpace"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
for(const key1 in data3){
if(!(((((key1 === "engine") || (key1 === "version")) || (key1 === "platform")) || (key1 === "deviceScaleFactor")) || (key1 === "colorSpace"))){
const err21 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data3.engine !== undefined){
let data4 = data3.engine;
if(typeof data4 === "string"){
if(func3(data4) > 128){
const err22 = {instancePath:instancePath+"/runtime/engine",schemaPath:"#/$defs/runtime/properties/engine/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(func3(data4) < 1){
const err23 = {instancePath:instancePath+"/runtime/engine",schemaPath:"#/$defs/runtime/properties/engine/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/runtime/engine",schemaPath:"#/$defs/runtime/properties/engine/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data3.version !== undefined){
let data5 = data3.version;
if(typeof data5 === "string"){
if(func3(data5) > 128){
const err25 = {instancePath:instancePath+"/runtime/version",schemaPath:"#/$defs/runtime/properties/version/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(func3(data5) < 1){
const err26 = {instancePath:instancePath+"/runtime/version",schemaPath:"#/$defs/runtime/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/runtime/version",schemaPath:"#/$defs/runtime/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data3.platform !== undefined){
let data6 = data3.platform;
if(typeof data6 === "string"){
if(func3(data6) > 128){
const err28 = {instancePath:instancePath+"/runtime/platform",schemaPath:"#/$defs/runtime/properties/platform/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(func3(data6) < 1){
const err29 = {instancePath:instancePath+"/runtime/platform",schemaPath:"#/$defs/runtime/properties/platform/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/runtime/platform",schemaPath:"#/$defs/runtime/properties/platform/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data3.deviceScaleFactor !== undefined){
let data7 = data3.deviceScaleFactor;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 16 || isNaN(data7)){
const err31 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"#/$defs/runtime/properties/deviceScaleFactor/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16},message:"must be <= 16"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data7 <= 0 || isNaN(data7)){
const err32 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"#/$defs/runtime/properties/deviceScaleFactor/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"#/$defs/runtime/properties/deviceScaleFactor/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data3.colorSpace !== undefined){
if("srgb" !== data3.colorSpace){
const err34 = {instancePath:instancePath+"/runtime/colorSpace",schemaPath:"#/$defs/runtime/properties/colorSpace/const",keyword:"const",params:{allowedValue: "srgb"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
else {
const err35 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
}
else {
const err36 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
validate160.errors = vErrors;
return errors === 0;
}
validate160.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema218 = {"type":"object","additionalProperties":false,"required":["mediaType","width","height","byteLength","digest"],"properties":{"mediaType":{"enum":["image/png","image/svg+xml"]},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"byteLength":{"type":"integer","minimum":0,"maximum":67108864},"digest":{"$ref":"#/$defs/digest"}}};
const schema219 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};

function validate162(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate162.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.mediaType === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "mediaType"},message:"must have required property '"+"mediaType"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.width === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.height === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.byteLength === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.digest === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "mediaType") || (key0 === "width")) || (key0 === "height")) || (key0 === "byteLength")) || (key0 === "digest"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.mediaType !== undefined){
let data0 = data.mediaType;
if(!((data0 === "image/png") || (data0 === "image/svg+xml"))){
const err6 = {instancePath:instancePath+"/mediaType",schemaPath:"#/properties/mediaType/enum",keyword:"enum",params:{allowedValues: schema218.properties.mediaType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.width !== undefined){
let data1 = data.width;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err7 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 32768 || isNaN(data1)){
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err9 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
if(data.height !== undefined){
let data2 = data.height;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err10 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 32768 || isNaN(data2)){
const err11 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data2 < 1 || isNaN(data2)){
const err12 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
if(data.byteLength !== undefined){
let data3 = data.byteLength;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err13 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 67108864 || isNaN(data3)){
const err14 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 67108864},message:"must be <= 67108864"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data3 < 0 || isNaN(data3)){
const err15 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
if(data.digest !== undefined){
let data4 = data.digest;
if(typeof data4 === "string"){
if(!pattern9.test(data4)){
const err16 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
else {
const err18 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
validate162.errors = vErrors;
return errors === 0;
}
validate162.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema220 = {"type":"object","additionalProperties":false,"required":["width","height","byteLength","digest","ids"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"byteLength":{"type":"integer","minimum":4,"maximum":16777216},"digest":{"$ref":"#/$defs/digest"},"ids":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/token"}}}};

function validate164(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate164.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.width === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.height === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.byteLength === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.digest === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.ids === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ids"},message:"must have required property '"+"ids"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "width") || (key0 === "height")) || (key0 === "byteLength")) || (key0 === "digest")) || (key0 === "ids"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.width !== undefined){
let data0 = data.width;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err6 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 32768 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data0 < 1 || isNaN(data0)){
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
if(data.height !== undefined){
let data1 = data.height;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err9 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 32768 || isNaN(data1)){
const err10 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err11 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
if(data.byteLength !== undefined){
let data2 = data.byteLength;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err12 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 16777216 || isNaN(data2)){
const err13 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16777216},message:"must be <= 16777216"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data2 < 4 || isNaN(data2)){
const err14 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 4},message:"must be >= 4"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
if(data.digest !== undefined){
let data3 = data.digest;
if(typeof data3 === "string"){
if(!pattern9.test(data3)){
const err15 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.ids !== undefined){
let data4 = data.ids;
if(Array.isArray(data4)){
if(data4.length > 100000){
const err17 = {instancePath:instancePath+"/ids",schemaPath:"#/properties/ids/maxItems",keyword:"maxItems",params:{limit: 100000},message:"must NOT have more than 100000 items"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
const len0 = data4.length;
for(let i0=0; i0<len0; i0++){
let data5 = data4[i0];
if(typeof data5 === "string"){
if(func3(data5) > 128){
const err18 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(func3(data5) < 1){
const err19 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(!pattern4.test(data5)){
const err20 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
else {
const err22 = {instancePath:instancePath+"/ids",schemaPath:"#/properties/ids/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
validate164.errors = vErrors;
return errors === 0;
}
validate164.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate159(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/conformance-report.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate159.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs2 = errors;
let valid1 = true;
const _errs3 = errors;
if(errors === _errs3){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.mode === undefined) && (missing0 = "mode")){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
if(data.mode !== undefined){
if("reference-exact" !== data.mode){
const err1 = {};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
}
}
else {
const err2 = {};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
let ifClause0;
if(_valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.checks !== undefined){
let data1 = data.checks;
if(data1 && typeof data1 == "object" && !Array.isArray(data1)){
if(data1.referenceArtifact !== undefined){
if(true !== data1.referenceArtifact){
const err3 = {instancePath:instancePath+"/checks/referenceArtifact",schemaPath:"#/allOf/0/then/properties/checks/properties/referenceArtifact/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
else {
const err4 = {instancePath:instancePath+"/checks",schemaPath:"#/allOf/0/then/properties/checks/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/allOf/0/then/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
var _valid0 = _errs6 === errors;
valid1 = _valid0;
if(valid1){
var props0 = {};
props0.checks = true;
props0.mode = true;
}
ifClause0 = "then";
}
else {
const _errs11 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.checks !== undefined){
let data3 = data.checks;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.referenceArtifact !== undefined){
if(data3.referenceArtifact !== null){
const err6 = {instancePath:instancePath+"/checks/referenceArtifact",schemaPath:"#/allOf/0/else/properties/checks/properties/referenceArtifact/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
else {
const err7 = {instancePath:instancePath+"/checks",schemaPath:"#/allOf/0/else/properties/checks/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/allOf/0/else/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
var _valid0 = _errs11 === errors;
valid1 = _valid0;
if(valid1){
if(props0 !== true){
props0 = props0 || {};
props0.checks = true;
}
}
ifClause0 = "else";
}
if(!valid1){
const err9 = {instancePath,schemaPath:"#/allOf/0/if",keyword:"if",params:{failingKeyword: ifClause0},message:"must match \""+ifClause0+"\" schema"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data.format === undefined){
const err11 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data.version === undefined){
const err12 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data.case === undefined){
const err13 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "case"},message:"must have required property '"+"case"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data.mode === undefined){
const err14 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "mode"},message:"must have required property '"+"mode"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data.passed === undefined){
const err15 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "passed"},message:"must have required property '"+"passed"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data.renderer === undefined){
const err16 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "renderer"},message:"must have required property '"+"renderer"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data.protocol === undefined){
const err17 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "protocol"},message:"must have required property '"+"protocol"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data.profile === undefined){
const err18 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profile"},message:"must have required property '"+"profile"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data.artifact === undefined){
const err19 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "artifact"},message:"must have required property '"+"artifact"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data.nodeMap === undefined){
const err20 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nodeMap"},message:"must have required property '"+"nodeMap"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data.checks === undefined){
const err21 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "checks"},message:"must have required property '"+"checks"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema213.properties, key0))){
const err22 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/conformance-report.schema.json" !== data.$schema){
const err23 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/conformance-report.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-conformance-report" !== data.format){
const err24 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-conformance-report"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err25 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.case !== undefined){
let data8 = data.case;
if(typeof data8 === "string"){
if(func3(data8) > 128){
const err26 = {instancePath:instancePath+"/case",schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(func3(data8) < 1){
const err27 = {instancePath:instancePath+"/case",schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(!pattern4.test(data8)){
const err28 = {instancePath:instancePath+"/case",schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
else {
const err29 = {instancePath:instancePath+"/case",schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.mode !== undefined){
let data9 = data.mode;
if(!((data9 === "third-party-protocol") || (data9 === "reference-exact"))){
const err30 = {instancePath:instancePath+"/mode",schemaPath:"#/properties/mode/enum",keyword:"enum",params:{allowedValues: schema213.properties.mode.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data.passed !== undefined){
if(true !== data.passed){
const err31 = {instancePath:instancePath+"/passed",schemaPath:"#/properties/passed/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data.renderer !== undefined){
if(!(validate160(data.renderer, {instancePath:instancePath+"/renderer",parentData:data,parentDataProperty:"renderer",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate160.errors : vErrors.concat(validate160.errors);
errors = vErrors.length;
}
}
if(data.protocol !== undefined){
let data12 = data.protocol;
if(!((data12 === "0.1") || (data12 === "0.2"))){
const err32 = {instancePath:instancePath+"/protocol",schemaPath:"#/properties/protocol/enum",keyword:"enum",params:{allowedValues: schema213.properties.protocol.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.profile !== undefined){
let data13 = data.profile;
if(typeof data13 === "string"){
if(func3(data13) > 128){
const err33 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(func3(data13) < 1){
const err34 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(!pattern4.test(data13)){
const err35 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
else {
const err36 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
if(data.artifact !== undefined){
if(!(validate162(data.artifact, {instancePath:instancePath+"/artifact",parentData:data,parentDataProperty:"artifact",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate162.errors : vErrors.concat(validate162.errors);
errors = vErrors.length;
}
}
if(data.nodeMap !== undefined){
let data15 = data.nodeMap;
const _errs33 = errors;
let valid10 = false;
let passing0 = null;
const _errs34 = errors;
if(data15 !== null){
const err37 = {instancePath:instancePath+"/nodeMap",schemaPath:"#/properties/nodeMap/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
var _valid1 = _errs34 === errors;
if(_valid1){
valid10 = true;
passing0 = 0;
}
const _errs36 = errors;
if(!(validate164(data15, {instancePath:instancePath+"/nodeMap",parentData:data,parentDataProperty:"nodeMap",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate164.errors : vErrors.concat(validate164.errors);
errors = vErrors.length;
}
var _valid1 = _errs36 === errors;
if(_valid1 && valid10){
valid10 = false;
passing0 = [passing0, 1];
}
else {
if(_valid1){
valid10 = true;
passing0 = 1;
}
}
if(!valid10){
const err38 = {instancePath:instancePath+"/nodeMap",schemaPath:"#/properties/nodeMap/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
else {
errors = _errs33;
if(vErrors !== null){
if(_errs33){
vErrors.length = _errs33;
}
else {
vErrors = null;
}
}
}
}
if(data.checks !== undefined){
let data16 = data.checks;
if(data16 && typeof data16 == "object" && !Array.isArray(data16)){
if(data16.schema === undefined){
const err39 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "schema"},message:"must have required property '"+"schema"+"'"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data16.capabilities === undefined){
const err40 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "capabilities"},message:"must have required property '"+"capabilities"+"'"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if(data16.profileAdmission === undefined){
const err41 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "profileAdmission"},message:"must have required property '"+"profileAdmission"+"'"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data16.artifactIntegrity === undefined){
const err42 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "artifactIntegrity"},message:"must have required property '"+"artifactIntegrity"+"'"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(data16.repeatDeterminism === undefined){
const err43 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "repeatDeterminism"},message:"must have required property '"+"repeatDeterminism"+"'"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
if(data16.structuredErrors === undefined){
const err44 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "structuredErrors"},message:"must have required property '"+"structuredErrors"+"'"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
if(data16.scaledOutput === undefined){
const err45 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "scaledOutput"},message:"must have required property '"+"scaledOutput"+"'"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
if(data16.referenceArtifact === undefined){
const err46 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "referenceArtifact"},message:"must have required property '"+"referenceArtifact"+"'"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
for(const key1 in data16){
if(!((((((((key1 === "schema") || (key1 === "capabilities")) || (key1 === "profileAdmission")) || (key1 === "artifactIntegrity")) || (key1 === "repeatDeterminism")) || (key1 === "structuredErrors")) || (key1 === "scaledOutput")) || (key1 === "referenceArtifact"))){
const err47 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
if(data16.schema !== undefined){
if(true !== data16.schema){
const err48 = {instancePath:instancePath+"/checks/schema",schemaPath:"#/$defs/checks/properties/schema/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
if(data16.capabilities !== undefined){
if(true !== data16.capabilities){
const err49 = {instancePath:instancePath+"/checks/capabilities",schemaPath:"#/$defs/checks/properties/capabilities/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
if(data16.profileAdmission !== undefined){
if(true !== data16.profileAdmission){
const err50 = {instancePath:instancePath+"/checks/profileAdmission",schemaPath:"#/$defs/checks/properties/profileAdmission/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
if(data16.artifactIntegrity !== undefined){
if(true !== data16.artifactIntegrity){
const err51 = {instancePath:instancePath+"/checks/artifactIntegrity",schemaPath:"#/$defs/checks/properties/artifactIntegrity/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data16.repeatDeterminism !== undefined){
if(true !== data16.repeatDeterminism){
const err52 = {instancePath:instancePath+"/checks/repeatDeterminism",schemaPath:"#/$defs/checks/properties/repeatDeterminism/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
if(data16.structuredErrors !== undefined){
let data22 = data16.structuredErrors;
if(Array.isArray(data22)){
if(data22.length > 128){
const err53 = {instancePath:instancePath+"/checks/structuredErrors",schemaPath:"#/$defs/checks/properties/structuredErrors/maxItems",keyword:"maxItems",params:{limit: 128},message:"must NOT have more than 128 items"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
if(data22.length < 4){
const err54 = {instancePath:instancePath+"/checks/structuredErrors",schemaPath:"#/$defs/checks/properties/structuredErrors/minItems",keyword:"minItems",params:{limit: 4},message:"must NOT have fewer than 4 items"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
const len0 = data22.length;
for(let i0=0; i0<len0; i0++){
let data23 = data22[i0];
if(typeof data23 === "string"){
if(func3(data23) > 128){
const err55 = {instancePath:instancePath+"/checks/structuredErrors/" + i0,schemaPath:"#/$defs/checks/properties/structuredErrors/items/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
if(func3(data23) < 1){
const err56 = {instancePath:instancePath+"/checks/structuredErrors/" + i0,schemaPath:"#/$defs/checks/properties/structuredErrors/items/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
if(!pattern60.test(data23)){
const err57 = {instancePath:instancePath+"/checks/structuredErrors/" + i0,schemaPath:"#/$defs/checks/properties/structuredErrors/items/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
else {
const err58 = {instancePath:instancePath+"/checks/structuredErrors/" + i0,schemaPath:"#/$defs/checks/properties/structuredErrors/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
}
else {
const err59 = {instancePath:instancePath+"/checks/structuredErrors",schemaPath:"#/$defs/checks/properties/structuredErrors/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
}
if(data16.scaledOutput !== undefined){
let data24 = data16.scaledOutput;
const _errs51 = errors;
let valid15 = false;
let passing1 = null;
const _errs52 = errors;
if(true !== data24){
const err60 = {instancePath:instancePath+"/checks/scaledOutput",schemaPath:"#/$defs/checks/properties/scaledOutput/oneOf/0/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
var _valid2 = _errs52 === errors;
if(_valid2){
valid15 = true;
passing1 = 0;
}
const _errs53 = errors;
if(data24 !== null){
const err61 = {instancePath:instancePath+"/checks/scaledOutput",schemaPath:"#/$defs/checks/properties/scaledOutput/oneOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
var _valid2 = _errs53 === errors;
if(_valid2 && valid15){
valid15 = false;
passing1 = [passing1, 1];
}
else {
if(_valid2){
valid15 = true;
passing1 = 1;
}
}
if(!valid15){
const err62 = {instancePath:instancePath+"/checks/scaledOutput",schemaPath:"#/$defs/checks/properties/scaledOutput/oneOf",keyword:"oneOf",params:{passingSchemas: passing1},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
else {
errors = _errs51;
if(vErrors !== null){
if(_errs51){
vErrors.length = _errs51;
}
else {
vErrors = null;
}
}
}
}
if(data16.referenceArtifact !== undefined){
let data25 = data16.referenceArtifact;
const _errs56 = errors;
let valid16 = false;
let passing2 = null;
const _errs57 = errors;
if(true !== data25){
const err63 = {instancePath:instancePath+"/checks/referenceArtifact",schemaPath:"#/$defs/checks/properties/referenceArtifact/oneOf/0/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
var _valid3 = _errs57 === errors;
if(_valid3){
valid16 = true;
passing2 = 0;
}
const _errs58 = errors;
if(data25 !== null){
const err64 = {instancePath:instancePath+"/checks/referenceArtifact",schemaPath:"#/$defs/checks/properties/referenceArtifact/oneOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
var _valid3 = _errs58 === errors;
if(_valid3 && valid16){
valid16 = false;
passing2 = [passing2, 1];
}
else {
if(_valid3){
valid16 = true;
passing2 = 1;
}
}
if(!valid16){
const err65 = {instancePath:instancePath+"/checks/referenceArtifact",schemaPath:"#/$defs/checks/properties/referenceArtifact/oneOf",keyword:"oneOf",params:{passingSchemas: passing2},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
else {
errors = _errs56;
if(vErrors !== null){
if(_errs56){
vErrors.length = _errs56;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err66 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
}
}
else {
const err67 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
validate159.errors = vErrors;
return errors === 0;
}
validate159.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateConformanceReportV02Schema = validate166;
const schema224 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.2/conformance-report.schema.json","title":"Maipo renderer visual conformance report 0.2","description":"Successful protocol and decoded-pixel evidence produced by the Maipo renderer conformance kit.","type":"object","additionalProperties":false,"required":["$schema","format","version","case","mode","passed","renderer","protocol","profile","artifact","nodeMap","visual","checks"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.2/conformance-report.schema.json"},"format":{"const":"maipo-conformance-report"},"version":{"const":"0.2"},"case":{"$ref":"#/$defs/token"},"mode":{"const":"third-party-visual"},"passed":{"const":true},"renderer":{"$ref":"#/$defs/renderer"},"protocol":{"enum":["0.1","0.2"]},"profile":{"$ref":"#/$defs/token"},"artifact":{"$ref":"#/$defs/artifact"},"nodeMap":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/nodeMap"}]},"visual":{"$ref":"#/$defs/visual"},"checks":{"$ref":"#/$defs/checks"}},"$defs":{"token":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"ratio":{"type":"number","minimum":0,"maximum":1},"runtime":{"type":"object","additionalProperties":false,"required":["engine","version","platform","deviceScaleFactor","colorSpace"],"properties":{"engine":{"type":"string","minLength":1,"maxLength":128},"version":{"type":"string","minLength":1,"maxLength":128},"platform":{"type":"string","minLength":1,"maxLength":128},"deviceScaleFactor":{"type":"number","exclusiveMinimum":0,"maximum":16},"colorSpace":{"const":"srgb"}}},"renderer":{"type":"object","additionalProperties":false,"required":["id","version","backend"],"properties":{"id":{"type":"string","minLength":1,"maxLength":128,"pattern":"^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"},"version":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"},"backend":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[A-Za-z0-9][A-Za-z0-9._-]*$"},"runtime":{"$ref":"#/$defs/runtime"}}},"artifact":{"type":"object","additionalProperties":false,"required":["mediaType","width","height","byteLength","digest"],"properties":{"mediaType":{"enum":["image/png","image/svg+xml"]},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"byteLength":{"type":"integer","minimum":0,"maximum":67108864},"digest":{"$ref":"#/$defs/digest"}}},"nodeMap":{"type":"object","additionalProperties":false,"required":["width","height","byteLength","digest","ids"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"byteLength":{"type":"integer","minimum":4,"maximum":16777216},"digest":{"$ref":"#/$defs/digest"},"ids":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/token"}}}},"visual":{"type":"object","additionalProperties":false,"required":["source","pixelModel","registry","rasterizer","reference","actual","metrics","thresholds"],"properties":{"source":{"enum":["renderer-artifact","supplied-png"]},"pixelModel":{"const":"rgba8-srgb-straight-transparent-zero"},"registry":{"type":"object","additionalProperties":false,"required":["version","digest"],"properties":{"version":{"const":"0.2"},"digest":{"$ref":"#/$defs/digest"}}},"rasterizer":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/renderer"}]},"reference":{"$ref":"#/$defs/rasterEvidence"},"actual":{"$ref":"#/$defs/rasterEvidence"},"metrics":{"$ref":"#/$defs/metrics"},"thresholds":{"$ref":"#/$defs/thresholds"}}},"rasterEvidence":{"type":"object","additionalProperties":false,"required":["width","height","byteLength","pngDigest","pixelDigest"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"byteLength":{"type":"integer","minimum":8,"maximum":67108864},"pngDigest":{"$ref":"#/$defs/digest"},"pixelDigest":{"$ref":"#/$defs/digest"}}},"metrics":{"type":"object","additionalProperties":false,"required":["differentPixels","differentPixelRatio","pixelsAboveOne","pixelsAboveOneRatio","pixelsAboveFour","pixelsAboveFourRatio","pixelsAboveSixteen","pixelsAboveSixteenRatio","meanChannelDelta","maxChannelDelta"],"properties":{"differentPixels":{"type":"integer","minimum":0},"differentPixelRatio":{"$ref":"#/$defs/ratio"},"pixelsAboveOne":{"type":"integer","minimum":0},"pixelsAboveOneRatio":{"$ref":"#/$defs/ratio"},"pixelsAboveFour":{"type":"integer","minimum":0},"pixelsAboveFourRatio":{"$ref":"#/$defs/ratio"},"pixelsAboveSixteen":{"type":"integer","minimum":0},"pixelsAboveSixteenRatio":{"$ref":"#/$defs/ratio"},"meanChannelDelta":{"type":"number","minimum":0,"maximum":255},"maxChannelDelta":{"type":"integer","minimum":0,"maximum":255}}},"thresholds":{"type":"object","additionalProperties":false,"required":["maxDifferentPixelRatio","maxPixelsAboveFourRatio","maxMeanChannelDelta","maxChannelDelta"],"properties":{"maxDifferentPixelRatio":{"$ref":"#/$defs/ratio"},"maxPixelsAboveFourRatio":{"$ref":"#/$defs/ratio"},"maxMeanChannelDelta":{"type":"number","minimum":0,"maximum":255},"maxChannelDelta":{"type":"integer","minimum":0,"maximum":255}}},"checks":{"type":"object","additionalProperties":false,"required":["schema","capabilities","profileAdmission","artifactIntegrity","repeatDeterminism","structuredErrors","scaledOutput","referenceArtifact","visualComparison"],"properties":{"schema":{"const":true},"capabilities":{"const":true},"profileAdmission":{"const":true},"artifactIntegrity":{"const":true},"repeatDeterminism":{"const":true},"structuredErrors":{"type":"array","minItems":4,"maxItems":128,"items":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"}},"scaledOutput":{"oneOf":[{"const":true},{"type":"null"}]},"referenceArtifact":{"type":"null"},"visualComparison":{"const":true}}}}};
const schema225 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const schema247 = {"type":"object","additionalProperties":false,"required":["schema","capabilities","profileAdmission","artifactIntegrity","repeatDeterminism","structuredErrors","scaledOutput","referenceArtifact","visualComparison"],"properties":{"schema":{"const":true},"capabilities":{"const":true},"profileAdmission":{"const":true},"artifactIntegrity":{"const":true},"repeatDeterminism":{"const":true},"structuredErrors":{"type":"array","minItems":4,"maxItems":128,"items":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"}},"scaledOutput":{"oneOf":[{"const":true},{"type":"null"}]},"referenceArtifact":{"type":"null"},"visualComparison":{"const":true}}};
const schema226 = {"type":"object","additionalProperties":false,"required":["id","version","backend"],"properties":{"id":{"type":"string","minLength":1,"maxLength":128,"pattern":"^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"},"version":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"},"backend":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[A-Za-z0-9][A-Za-z0-9._-]*$"},"runtime":{"$ref":"#/$defs/runtime"}}};
const schema227 = {"type":"object","additionalProperties":false,"required":["engine","version","platform","deviceScaleFactor","colorSpace"],"properties":{"engine":{"type":"string","minLength":1,"maxLength":128},"version":{"type":"string","minLength":1,"maxLength":128},"platform":{"type":"string","minLength":1,"maxLength":128},"deviceScaleFactor":{"type":"number","exclusiveMinimum":0,"maximum":16},"colorSpace":{"const":"srgb"}}};

function validate167(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate167.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.backend === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "id") || (key0 === "version")) || (key0 === "backend")) || (key0 === "runtime"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(func3(data0) < 1){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!pattern53.test(data0)){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/pattern",keyword:"pattern",params:{pattern: "^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"},message:"must match pattern \""+"^(?:@[A-Za-z0-9][A-Za-z0-9._-]*/)?[A-Za-z0-9][A-Za-z0-9._/-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.version !== undefined){
let data1 = data.version;
if(typeof data1 === "string"){
if(func3(data1) > 64){
const err8 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func3(data1) < 1){
const err9 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!pattern54.test(data1)){
const err10 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+\\.[0-9]+(?:[-+][A-Za-z0-9.-]+)?$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.backend !== undefined){
let data2 = data.backend;
if(typeof data2 === "string"){
if(func3(data2) > 64){
const err12 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(func3(data2) < 1){
const err13 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!pattern55.test(data2)){
const err14 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._-]*$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.runtime !== undefined){
let data3 = data.runtime;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.engine === undefined){
const err16 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "engine"},message:"must have required property '"+"engine"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data3.version === undefined){
const err17 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data3.platform === undefined){
const err18 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "platform"},message:"must have required property '"+"platform"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data3.deviceScaleFactor === undefined){
const err19 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "deviceScaleFactor"},message:"must have required property '"+"deviceScaleFactor"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data3.colorSpace === undefined){
const err20 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "colorSpace"},message:"must have required property '"+"colorSpace"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
for(const key1 in data3){
if(!(((((key1 === "engine") || (key1 === "version")) || (key1 === "platform")) || (key1 === "deviceScaleFactor")) || (key1 === "colorSpace"))){
const err21 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data3.engine !== undefined){
let data4 = data3.engine;
if(typeof data4 === "string"){
if(func3(data4) > 128){
const err22 = {instancePath:instancePath+"/runtime/engine",schemaPath:"#/$defs/runtime/properties/engine/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(func3(data4) < 1){
const err23 = {instancePath:instancePath+"/runtime/engine",schemaPath:"#/$defs/runtime/properties/engine/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/runtime/engine",schemaPath:"#/$defs/runtime/properties/engine/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data3.version !== undefined){
let data5 = data3.version;
if(typeof data5 === "string"){
if(func3(data5) > 128){
const err25 = {instancePath:instancePath+"/runtime/version",schemaPath:"#/$defs/runtime/properties/version/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(func3(data5) < 1){
const err26 = {instancePath:instancePath+"/runtime/version",schemaPath:"#/$defs/runtime/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/runtime/version",schemaPath:"#/$defs/runtime/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data3.platform !== undefined){
let data6 = data3.platform;
if(typeof data6 === "string"){
if(func3(data6) > 128){
const err28 = {instancePath:instancePath+"/runtime/platform",schemaPath:"#/$defs/runtime/properties/platform/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(func3(data6) < 1){
const err29 = {instancePath:instancePath+"/runtime/platform",schemaPath:"#/$defs/runtime/properties/platform/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/runtime/platform",schemaPath:"#/$defs/runtime/properties/platform/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data3.deviceScaleFactor !== undefined){
let data7 = data3.deviceScaleFactor;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 16 || isNaN(data7)){
const err31 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"#/$defs/runtime/properties/deviceScaleFactor/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16},message:"must be <= 16"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data7 <= 0 || isNaN(data7)){
const err32 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"#/$defs/runtime/properties/deviceScaleFactor/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"#/$defs/runtime/properties/deviceScaleFactor/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data3.colorSpace !== undefined){
if("srgb" !== data3.colorSpace){
const err34 = {instancePath:instancePath+"/runtime/colorSpace",schemaPath:"#/$defs/runtime/properties/colorSpace/const",keyword:"const",params:{allowedValue: "srgb"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
else {
const err35 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
}
else {
const err36 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
validate167.errors = vErrors;
return errors === 0;
}
validate167.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema229 = {"type":"object","additionalProperties":false,"required":["mediaType","width","height","byteLength","digest"],"properties":{"mediaType":{"enum":["image/png","image/svg+xml"]},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"byteLength":{"type":"integer","minimum":0,"maximum":67108864},"digest":{"$ref":"#/$defs/digest"}}};
const schema230 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};

function validate169(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate169.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.mediaType === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "mediaType"},message:"must have required property '"+"mediaType"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.width === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.height === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.byteLength === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.digest === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "mediaType") || (key0 === "width")) || (key0 === "height")) || (key0 === "byteLength")) || (key0 === "digest"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.mediaType !== undefined){
let data0 = data.mediaType;
if(!((data0 === "image/png") || (data0 === "image/svg+xml"))){
const err6 = {instancePath:instancePath+"/mediaType",schemaPath:"#/properties/mediaType/enum",keyword:"enum",params:{allowedValues: schema229.properties.mediaType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.width !== undefined){
let data1 = data.width;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err7 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 32768 || isNaN(data1)){
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err9 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
if(data.height !== undefined){
let data2 = data.height;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err10 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 32768 || isNaN(data2)){
const err11 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data2 < 1 || isNaN(data2)){
const err12 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
if(data.byteLength !== undefined){
let data3 = data.byteLength;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err13 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 67108864 || isNaN(data3)){
const err14 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 67108864},message:"must be <= 67108864"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data3 < 0 || isNaN(data3)){
const err15 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
if(data.digest !== undefined){
let data4 = data.digest;
if(typeof data4 === "string"){
if(!pattern9.test(data4)){
const err16 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
else {
const err18 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
validate169.errors = vErrors;
return errors === 0;
}
validate169.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema231 = {"type":"object","additionalProperties":false,"required":["width","height","byteLength","digest","ids"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"byteLength":{"type":"integer","minimum":4,"maximum":16777216},"digest":{"$ref":"#/$defs/digest"},"ids":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/token"}}}};

function validate171(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate171.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.width === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.height === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.byteLength === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.digest === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.ids === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ids"},message:"must have required property '"+"ids"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "width") || (key0 === "height")) || (key0 === "byteLength")) || (key0 === "digest")) || (key0 === "ids"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.width !== undefined){
let data0 = data.width;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err6 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 32768 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data0 < 1 || isNaN(data0)){
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
if(data.height !== undefined){
let data1 = data.height;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err9 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 32768 || isNaN(data1)){
const err10 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err11 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
if(data.byteLength !== undefined){
let data2 = data.byteLength;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err12 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 16777216 || isNaN(data2)){
const err13 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16777216},message:"must be <= 16777216"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data2 < 4 || isNaN(data2)){
const err14 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 4},message:"must be >= 4"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
if(data.digest !== undefined){
let data3 = data.digest;
if(typeof data3 === "string"){
if(!pattern9.test(data3)){
const err15 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.ids !== undefined){
let data4 = data.ids;
if(Array.isArray(data4)){
if(data4.length > 100000){
const err17 = {instancePath:instancePath+"/ids",schemaPath:"#/properties/ids/maxItems",keyword:"maxItems",params:{limit: 100000},message:"must NOT have more than 100000 items"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
const len0 = data4.length;
for(let i0=0; i0<len0; i0++){
let data5 = data4[i0];
if(typeof data5 === "string"){
if(func3(data5) > 128){
const err18 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(func3(data5) < 1){
const err19 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(!pattern4.test(data5)){
const err20 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
else {
const err22 = {instancePath:instancePath+"/ids",schemaPath:"#/properties/ids/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
validate171.errors = vErrors;
return errors === 0;
}
validate171.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema234 = {"type":"object","additionalProperties":false,"required":["source","pixelModel","registry","rasterizer","reference","actual","metrics","thresholds"],"properties":{"source":{"enum":["renderer-artifact","supplied-png"]},"pixelModel":{"const":"rgba8-srgb-straight-transparent-zero"},"registry":{"type":"object","additionalProperties":false,"required":["version","digest"],"properties":{"version":{"const":"0.2"},"digest":{"$ref":"#/$defs/digest"}}},"rasterizer":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/renderer"}]},"reference":{"$ref":"#/$defs/rasterEvidence"},"actual":{"$ref":"#/$defs/rasterEvidence"},"metrics":{"$ref":"#/$defs/metrics"},"thresholds":{"$ref":"#/$defs/thresholds"}}};
const schema236 = {"type":"object","additionalProperties":false,"required":["width","height","byteLength","pngDigest","pixelDigest"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"byteLength":{"type":"integer","minimum":8,"maximum":67108864},"pngDigest":{"$ref":"#/$defs/digest"},"pixelDigest":{"$ref":"#/$defs/digest"}}};

function validate175(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate175.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.width === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.height === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.byteLength === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.pngDigest === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pngDigest"},message:"must have required property '"+"pngDigest"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.pixelDigest === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelDigest"},message:"must have required property '"+"pixelDigest"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "width") || (key0 === "height")) || (key0 === "byteLength")) || (key0 === "pngDigest")) || (key0 === "pixelDigest"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.width !== undefined){
let data0 = data.width;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err6 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 32768 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data0 < 1 || isNaN(data0)){
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
if(data.height !== undefined){
let data1 = data.height;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err9 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 32768 || isNaN(data1)){
const err10 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err11 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
if(data.byteLength !== undefined){
let data2 = data.byteLength;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err12 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 67108864 || isNaN(data2)){
const err13 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 67108864},message:"must be <= 67108864"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data2 < 8 || isNaN(data2)){
const err14 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 8},message:"must be >= 8"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
if(data.pngDigest !== undefined){
let data3 = data.pngDigest;
if(typeof data3 === "string"){
if(!pattern9.test(data3)){
const err15 = {instancePath:instancePath+"/pngDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/pngDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.pixelDigest !== undefined){
let data4 = data.pixelDigest;
if(typeof data4 === "string"){
if(!pattern9.test(data4)){
const err17 = {instancePath:instancePath+"/pixelDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/pixelDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
validate175.errors = vErrors;
return errors === 0;
}
validate175.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema239 = {"type":"object","additionalProperties":false,"required":["differentPixels","differentPixelRatio","pixelsAboveOne","pixelsAboveOneRatio","pixelsAboveFour","pixelsAboveFourRatio","pixelsAboveSixteen","pixelsAboveSixteenRatio","meanChannelDelta","maxChannelDelta"],"properties":{"differentPixels":{"type":"integer","minimum":0},"differentPixelRatio":{"$ref":"#/$defs/ratio"},"pixelsAboveOne":{"type":"integer","minimum":0},"pixelsAboveOneRatio":{"$ref":"#/$defs/ratio"},"pixelsAboveFour":{"type":"integer","minimum":0},"pixelsAboveFourRatio":{"$ref":"#/$defs/ratio"},"pixelsAboveSixteen":{"type":"integer","minimum":0},"pixelsAboveSixteenRatio":{"$ref":"#/$defs/ratio"},"meanChannelDelta":{"type":"number","minimum":0,"maximum":255},"maxChannelDelta":{"type":"integer","minimum":0,"maximum":255}}};
const schema240 = {"type":"number","minimum":0,"maximum":1};

function validate178(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate178.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.differentPixels === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "differentPixels"},message:"must have required property '"+"differentPixels"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.differentPixelRatio === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "differentPixelRatio"},message:"must have required property '"+"differentPixelRatio"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.pixelsAboveOne === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelsAboveOne"},message:"must have required property '"+"pixelsAboveOne"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.pixelsAboveOneRatio === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelsAboveOneRatio"},message:"must have required property '"+"pixelsAboveOneRatio"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.pixelsAboveFour === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelsAboveFour"},message:"must have required property '"+"pixelsAboveFour"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.pixelsAboveFourRatio === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelsAboveFourRatio"},message:"must have required property '"+"pixelsAboveFourRatio"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.pixelsAboveSixteen === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelsAboveSixteen"},message:"must have required property '"+"pixelsAboveSixteen"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.pixelsAboveSixteenRatio === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelsAboveSixteenRatio"},message:"must have required property '"+"pixelsAboveSixteenRatio"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.meanChannelDelta === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "meanChannelDelta"},message:"must have required property '"+"meanChannelDelta"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.maxChannelDelta === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "maxChannelDelta"},message:"must have required property '"+"maxChannelDelta"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema239.properties, key0))){
const err10 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.differentPixels !== undefined){
let data0 = data.differentPixels;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err11 = {instancePath:instancePath+"/differentPixels",schemaPath:"#/properties/differentPixels/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 < 0 || isNaN(data0)){
const err12 = {instancePath:instancePath+"/differentPixels",schemaPath:"#/properties/differentPixels/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
if(data.differentPixelRatio !== undefined){
let data1 = data.differentPixelRatio;
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 1 || isNaN(data1)){
const err13 = {instancePath:instancePath+"/differentPixelRatio",schemaPath:"#/$defs/ratio/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data1 < 0 || isNaN(data1)){
const err14 = {instancePath:instancePath+"/differentPixelRatio",schemaPath:"#/$defs/ratio/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/differentPixelRatio",schemaPath:"#/$defs/ratio/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.pixelsAboveOne !== undefined){
let data2 = data.pixelsAboveOne;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err16 = {instancePath:instancePath+"/pixelsAboveOne",schemaPath:"#/properties/pixelsAboveOne/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 < 0 || isNaN(data2)){
const err17 = {instancePath:instancePath+"/pixelsAboveOne",schemaPath:"#/properties/pixelsAboveOne/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
if(data.pixelsAboveOneRatio !== undefined){
let data3 = data.pixelsAboveOneRatio;
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 1 || isNaN(data3)){
const err18 = {instancePath:instancePath+"/pixelsAboveOneRatio",schemaPath:"#/$defs/ratio/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data3 < 0 || isNaN(data3)){
const err19 = {instancePath:instancePath+"/pixelsAboveOneRatio",schemaPath:"#/$defs/ratio/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/pixelsAboveOneRatio",schemaPath:"#/$defs/ratio/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.pixelsAboveFour !== undefined){
let data4 = data.pixelsAboveFour;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err21 = {instancePath:instancePath+"/pixelsAboveFour",schemaPath:"#/properties/pixelsAboveFour/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err22 = {instancePath:instancePath+"/pixelsAboveFour",schemaPath:"#/properties/pixelsAboveFour/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
if(data.pixelsAboveFourRatio !== undefined){
let data5 = data.pixelsAboveFourRatio;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 1 || isNaN(data5)){
const err23 = {instancePath:instancePath+"/pixelsAboveFourRatio",schemaPath:"#/$defs/ratio/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data5 < 0 || isNaN(data5)){
const err24 = {instancePath:instancePath+"/pixelsAboveFourRatio",schemaPath:"#/$defs/ratio/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/pixelsAboveFourRatio",schemaPath:"#/$defs/ratio/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.pixelsAboveSixteen !== undefined){
let data6 = data.pixelsAboveSixteen;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err26 = {instancePath:instancePath+"/pixelsAboveSixteen",schemaPath:"#/properties/pixelsAboveSixteen/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 < 0 || isNaN(data6)){
const err27 = {instancePath:instancePath+"/pixelsAboveSixteen",schemaPath:"#/properties/pixelsAboveSixteen/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
if(data.pixelsAboveSixteenRatio !== undefined){
let data7 = data.pixelsAboveSixteenRatio;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 1 || isNaN(data7)){
const err28 = {instancePath:instancePath+"/pixelsAboveSixteenRatio",schemaPath:"#/$defs/ratio/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data7 < 0 || isNaN(data7)){
const err29 = {instancePath:instancePath+"/pixelsAboveSixteenRatio",schemaPath:"#/$defs/ratio/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/pixelsAboveSixteenRatio",schemaPath:"#/$defs/ratio/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data.meanChannelDelta !== undefined){
let data8 = data.meanChannelDelta;
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 255 || isNaN(data8)){
const err31 = {instancePath:instancePath+"/meanChannelDelta",schemaPath:"#/properties/meanChannelDelta/maximum",keyword:"maximum",params:{comparison: "<=", limit: 255},message:"must be <= 255"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data8 < 0 || isNaN(data8)){
const err32 = {instancePath:instancePath+"/meanChannelDelta",schemaPath:"#/properties/meanChannelDelta/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/meanChannelDelta",schemaPath:"#/properties/meanChannelDelta/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data.maxChannelDelta !== undefined){
let data9 = data.maxChannelDelta;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err34 = {instancePath:instancePath+"/maxChannelDelta",schemaPath:"#/properties/maxChannelDelta/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 > 255 || isNaN(data9)){
const err35 = {instancePath:instancePath+"/maxChannelDelta",schemaPath:"#/properties/maxChannelDelta/maximum",keyword:"maximum",params:{comparison: "<=", limit: 255},message:"must be <= 255"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data9 < 0 || isNaN(data9)){
const err36 = {instancePath:instancePath+"/maxChannelDelta",schemaPath:"#/properties/maxChannelDelta/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
}
else {
const err37 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
validate178.errors = vErrors;
return errors === 0;
}
validate178.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema244 = {"type":"object","additionalProperties":false,"required":["maxDifferentPixelRatio","maxPixelsAboveFourRatio","maxMeanChannelDelta","maxChannelDelta"],"properties":{"maxDifferentPixelRatio":{"$ref":"#/$defs/ratio"},"maxPixelsAboveFourRatio":{"$ref":"#/$defs/ratio"},"maxMeanChannelDelta":{"type":"number","minimum":0,"maximum":255},"maxChannelDelta":{"type":"integer","minimum":0,"maximum":255}}};

function validate180(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate180.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.maxDifferentPixelRatio === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "maxDifferentPixelRatio"},message:"must have required property '"+"maxDifferentPixelRatio"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.maxPixelsAboveFourRatio === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "maxPixelsAboveFourRatio"},message:"must have required property '"+"maxPixelsAboveFourRatio"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.maxMeanChannelDelta === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "maxMeanChannelDelta"},message:"must have required property '"+"maxMeanChannelDelta"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.maxChannelDelta === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "maxChannelDelta"},message:"must have required property '"+"maxChannelDelta"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "maxDifferentPixelRatio") || (key0 === "maxPixelsAboveFourRatio")) || (key0 === "maxMeanChannelDelta")) || (key0 === "maxChannelDelta"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.maxDifferentPixelRatio !== undefined){
let data0 = data.maxDifferentPixelRatio;
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 1 || isNaN(data0)){
const err5 = {instancePath:instancePath+"/maxDifferentPixelRatio",schemaPath:"#/$defs/ratio/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data0 < 0 || isNaN(data0)){
const err6 = {instancePath:instancePath+"/maxDifferentPixelRatio",schemaPath:"#/$defs/ratio/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/maxDifferentPixelRatio",schemaPath:"#/$defs/ratio/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.maxPixelsAboveFourRatio !== undefined){
let data1 = data.maxPixelsAboveFourRatio;
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 1 || isNaN(data1)){
const err8 = {instancePath:instancePath+"/maxPixelsAboveFourRatio",schemaPath:"#/$defs/ratio/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data1 < 0 || isNaN(data1)){
const err9 = {instancePath:instancePath+"/maxPixelsAboveFourRatio",schemaPath:"#/$defs/ratio/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/maxPixelsAboveFourRatio",schemaPath:"#/$defs/ratio/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.maxMeanChannelDelta !== undefined){
let data2 = data.maxMeanChannelDelta;
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 255 || isNaN(data2)){
const err11 = {instancePath:instancePath+"/maxMeanChannelDelta",schemaPath:"#/properties/maxMeanChannelDelta/maximum",keyword:"maximum",params:{comparison: "<=", limit: 255},message:"must be <= 255"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data2 < 0 || isNaN(data2)){
const err12 = {instancePath:instancePath+"/maxMeanChannelDelta",schemaPath:"#/properties/maxMeanChannelDelta/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/maxMeanChannelDelta",schemaPath:"#/properties/maxMeanChannelDelta/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.maxChannelDelta !== undefined){
let data3 = data.maxChannelDelta;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err14 = {instancePath:instancePath+"/maxChannelDelta",schemaPath:"#/properties/maxChannelDelta/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 255 || isNaN(data3)){
const err15 = {instancePath:instancePath+"/maxChannelDelta",schemaPath:"#/properties/maxChannelDelta/maximum",keyword:"maximum",params:{comparison: "<=", limit: 255},message:"must be <= 255"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data3 < 0 || isNaN(data3)){
const err16 = {instancePath:instancePath+"/maxChannelDelta",schemaPath:"#/properties/maxChannelDelta/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate180.errors = vErrors;
return errors === 0;
}
validate180.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate173(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate173.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.source === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.pixelModel === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelModel"},message:"must have required property '"+"pixelModel"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.registry === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "registry"},message:"must have required property '"+"registry"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.rasterizer === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "rasterizer"},message:"must have required property '"+"rasterizer"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.reference === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "reference"},message:"must have required property '"+"reference"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.actual === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "actual"},message:"must have required property '"+"actual"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.metrics === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "metrics"},message:"must have required property '"+"metrics"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.thresholds === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "thresholds"},message:"must have required property '"+"thresholds"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "source") || (key0 === "pixelModel")) || (key0 === "registry")) || (key0 === "rasterizer")) || (key0 === "reference")) || (key0 === "actual")) || (key0 === "metrics")) || (key0 === "thresholds"))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.source !== undefined){
let data0 = data.source;
if(!((data0 === "renderer-artifact") || (data0 === "supplied-png"))){
const err9 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/enum",keyword:"enum",params:{allowedValues: schema234.properties.source.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.pixelModel !== undefined){
if("rgba8-srgb-straight-transparent-zero" !== data.pixelModel){
const err10 = {instancePath:instancePath+"/pixelModel",schemaPath:"#/properties/pixelModel/const",keyword:"const",params:{allowedValue: "rgba8-srgb-straight-transparent-zero"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.registry !== undefined){
let data2 = data.registry;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.version === undefined){
const err11 = {instancePath:instancePath+"/registry",schemaPath:"#/properties/registry/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data2.digest === undefined){
const err12 = {instancePath:instancePath+"/registry",schemaPath:"#/properties/registry/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
for(const key1 in data2){
if(!((key1 === "version") || (key1 === "digest"))){
const err13 = {instancePath:instancePath+"/registry",schemaPath:"#/properties/registry/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data2.version !== undefined){
if("0.2" !== data2.version){
const err14 = {instancePath:instancePath+"/registry/version",schemaPath:"#/properties/registry/properties/version/const",keyword:"const",params:{allowedValue: "0.2"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data2.digest !== undefined){
let data4 = data2.digest;
if(typeof data4 === "string"){
if(!pattern9.test(data4)){
const err15 = {instancePath:instancePath+"/registry/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/registry/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
else {
const err17 = {instancePath:instancePath+"/registry",schemaPath:"#/properties/registry/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.rasterizer !== undefined){
let data5 = data.rasterizer;
const _errs12 = errors;
let valid3 = false;
let passing0 = null;
const _errs13 = errors;
if(data5 !== null){
const err18 = {instancePath:instancePath+"/rasterizer",schemaPath:"#/properties/rasterizer/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
var _valid0 = _errs13 === errors;
if(_valid0){
valid3 = true;
passing0 = 0;
}
const _errs15 = errors;
if(!(validate167(data5, {instancePath:instancePath+"/rasterizer",parentData:data,parentDataProperty:"rasterizer",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate167.errors : vErrors.concat(validate167.errors);
errors = vErrors.length;
}
var _valid0 = _errs15 === errors;
if(_valid0 && valid3){
valid3 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid3 = true;
passing0 = 1;
}
}
if(!valid3){
const err19 = {instancePath:instancePath+"/rasterizer",schemaPath:"#/properties/rasterizer/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
else {
errors = _errs12;
if(vErrors !== null){
if(_errs12){
vErrors.length = _errs12;
}
else {
vErrors = null;
}
}
}
}
if(data.reference !== undefined){
if(!(validate175(data.reference, {instancePath:instancePath+"/reference",parentData:data,parentDataProperty:"reference",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate175.errors : vErrors.concat(validate175.errors);
errors = vErrors.length;
}
}
if(data.actual !== undefined){
if(!(validate175(data.actual, {instancePath:instancePath+"/actual",parentData:data,parentDataProperty:"actual",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate175.errors : vErrors.concat(validate175.errors);
errors = vErrors.length;
}
}
if(data.metrics !== undefined){
if(!(validate178(data.metrics, {instancePath:instancePath+"/metrics",parentData:data,parentDataProperty:"metrics",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate178.errors : vErrors.concat(validate178.errors);
errors = vErrors.length;
}
}
if(data.thresholds !== undefined){
if(!(validate180(data.thresholds, {instancePath:instancePath+"/thresholds",parentData:data,parentDataProperty:"thresholds",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate180.errors : vErrors.concat(validate180.errors);
errors = vErrors.length;
}
}
}
else {
const err20 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
validate173.errors = vErrors;
return errors === 0;
}
validate173.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate166(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.2/conformance-report.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate166.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.case === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "case"},message:"must have required property '"+"case"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.mode === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "mode"},message:"must have required property '"+"mode"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.passed === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "passed"},message:"must have required property '"+"passed"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.renderer === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "renderer"},message:"must have required property '"+"renderer"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.protocol === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "protocol"},message:"must have required property '"+"protocol"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.profile === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profile"},message:"must have required property '"+"profile"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.artifact === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "artifact"},message:"must have required property '"+"artifact"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.nodeMap === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nodeMap"},message:"must have required property '"+"nodeMap"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data.visual === undefined){
const err11 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "visual"},message:"must have required property '"+"visual"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data.checks === undefined){
const err12 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "checks"},message:"must have required property '"+"checks"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema224.properties, key0))){
const err13 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.2/conformance-report.schema.json" !== data.$schema){
const err14 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.2/conformance-report.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-conformance-report" !== data.format){
const err15 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-conformance-report"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.version !== undefined){
if("0.2" !== data.version){
const err16 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.2"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.case !== undefined){
let data3 = data.case;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err17 = {instancePath:instancePath+"/case",schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(func3(data3) < 1){
const err18 = {instancePath:instancePath+"/case",schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(!pattern4.test(data3)){
const err19 = {instancePath:instancePath+"/case",schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/case",schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.mode !== undefined){
if("third-party-visual" !== data.mode){
const err21 = {instancePath:instancePath+"/mode",schemaPath:"#/properties/mode/const",keyword:"const",params:{allowedValue: "third-party-visual"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.passed !== undefined){
if(true !== data.passed){
const err22 = {instancePath:instancePath+"/passed",schemaPath:"#/properties/passed/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.renderer !== undefined){
if(!(validate167(data.renderer, {instancePath:instancePath+"/renderer",parentData:data,parentDataProperty:"renderer",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate167.errors : vErrors.concat(validate167.errors);
errors = vErrors.length;
}
}
if(data.protocol !== undefined){
let data7 = data.protocol;
if(!((data7 === "0.1") || (data7 === "0.2"))){
const err23 = {instancePath:instancePath+"/protocol",schemaPath:"#/properties/protocol/enum",keyword:"enum",params:{allowedValues: schema224.properties.protocol.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.profile !== undefined){
let data8 = data.profile;
if(typeof data8 === "string"){
if(func3(data8) > 128){
const err24 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(func3(data8) < 1){
const err25 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(!pattern4.test(data8)){
const err26 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/profile",schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data.artifact !== undefined){
if(!(validate169(data.artifact, {instancePath:instancePath+"/artifact",parentData:data,parentDataProperty:"artifact",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate169.errors : vErrors.concat(validate169.errors);
errors = vErrors.length;
}
}
if(data.nodeMap !== undefined){
let data10 = data.nodeMap;
const _errs17 = errors;
let valid3 = false;
let passing0 = null;
const _errs18 = errors;
if(data10 !== null){
const err28 = {instancePath:instancePath+"/nodeMap",schemaPath:"#/properties/nodeMap/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
var _valid0 = _errs18 === errors;
if(_valid0){
valid3 = true;
passing0 = 0;
}
const _errs20 = errors;
if(!(validate171(data10, {instancePath:instancePath+"/nodeMap",parentData:data,parentDataProperty:"nodeMap",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate171.errors : vErrors.concat(validate171.errors);
errors = vErrors.length;
}
var _valid0 = _errs20 === errors;
if(_valid0 && valid3){
valid3 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid3 = true;
passing0 = 1;
}
}
if(!valid3){
const err29 = {instancePath:instancePath+"/nodeMap",schemaPath:"#/properties/nodeMap/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
else {
errors = _errs17;
if(vErrors !== null){
if(_errs17){
vErrors.length = _errs17;
}
else {
vErrors = null;
}
}
}
}
if(data.visual !== undefined){
if(!(validate173(data.visual, {instancePath:instancePath+"/visual",parentData:data,parentDataProperty:"visual",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate173.errors : vErrors.concat(validate173.errors);
errors = vErrors.length;
}
}
if(data.checks !== undefined){
let data12 = data.checks;
if(data12 && typeof data12 == "object" && !Array.isArray(data12)){
if(data12.schema === undefined){
const err30 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "schema"},message:"must have required property '"+"schema"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data12.capabilities === undefined){
const err31 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "capabilities"},message:"must have required property '"+"capabilities"+"'"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data12.profileAdmission === undefined){
const err32 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "profileAdmission"},message:"must have required property '"+"profileAdmission"+"'"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data12.artifactIntegrity === undefined){
const err33 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "artifactIntegrity"},message:"must have required property '"+"artifactIntegrity"+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data12.repeatDeterminism === undefined){
const err34 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "repeatDeterminism"},message:"must have required property '"+"repeatDeterminism"+"'"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data12.structuredErrors === undefined){
const err35 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "structuredErrors"},message:"must have required property '"+"structuredErrors"+"'"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data12.scaledOutput === undefined){
const err36 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "scaledOutput"},message:"must have required property '"+"scaledOutput"+"'"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data12.referenceArtifact === undefined){
const err37 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "referenceArtifact"},message:"must have required property '"+"referenceArtifact"+"'"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(data12.visualComparison === undefined){
const err38 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/required",keyword:"required",params:{missingProperty: "visualComparison"},message:"must have required property '"+"visualComparison"+"'"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
for(const key1 in data12){
if(!(func1.call(schema247.properties, key1))){
const err39 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data12.schema !== undefined){
if(true !== data12.schema){
const err40 = {instancePath:instancePath+"/checks/schema",schemaPath:"#/$defs/checks/properties/schema/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data12.capabilities !== undefined){
if(true !== data12.capabilities){
const err41 = {instancePath:instancePath+"/checks/capabilities",schemaPath:"#/$defs/checks/properties/capabilities/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
if(data12.profileAdmission !== undefined){
if(true !== data12.profileAdmission){
const err42 = {instancePath:instancePath+"/checks/profileAdmission",schemaPath:"#/$defs/checks/properties/profileAdmission/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
if(data12.artifactIntegrity !== undefined){
if(true !== data12.artifactIntegrity){
const err43 = {instancePath:instancePath+"/checks/artifactIntegrity",schemaPath:"#/$defs/checks/properties/artifactIntegrity/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data12.repeatDeterminism !== undefined){
if(true !== data12.repeatDeterminism){
const err44 = {instancePath:instancePath+"/checks/repeatDeterminism",schemaPath:"#/$defs/checks/properties/repeatDeterminism/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
if(data12.structuredErrors !== undefined){
let data18 = data12.structuredErrors;
if(Array.isArray(data18)){
if(data18.length > 128){
const err45 = {instancePath:instancePath+"/checks/structuredErrors",schemaPath:"#/$defs/checks/properties/structuredErrors/maxItems",keyword:"maxItems",params:{limit: 128},message:"must NOT have more than 128 items"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
if(data18.length < 4){
const err46 = {instancePath:instancePath+"/checks/structuredErrors",schemaPath:"#/$defs/checks/properties/structuredErrors/minItems",keyword:"minItems",params:{limit: 4},message:"must NOT have fewer than 4 items"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
const len0 = data18.length;
for(let i0=0; i0<len0; i0++){
let data19 = data18[i0];
if(typeof data19 === "string"){
if(func3(data19) > 128){
const err47 = {instancePath:instancePath+"/checks/structuredErrors/" + i0,schemaPath:"#/$defs/checks/properties/structuredErrors/items/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
if(func3(data19) < 1){
const err48 = {instancePath:instancePath+"/checks/structuredErrors/" + i0,schemaPath:"#/$defs/checks/properties/structuredErrors/items/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
if(!pattern60.test(data19)){
const err49 = {instancePath:instancePath+"/checks/structuredErrors/" + i0,schemaPath:"#/$defs/checks/properties/structuredErrors/items/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
else {
const err50 = {instancePath:instancePath+"/checks/structuredErrors/" + i0,schemaPath:"#/$defs/checks/properties/structuredErrors/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
}
else {
const err51 = {instancePath:instancePath+"/checks/structuredErrors",schemaPath:"#/$defs/checks/properties/structuredErrors/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data12.scaledOutput !== undefined){
let data20 = data12.scaledOutput;
const _errs36 = errors;
let valid8 = false;
let passing1 = null;
const _errs37 = errors;
if(true !== data20){
const err52 = {instancePath:instancePath+"/checks/scaledOutput",schemaPath:"#/$defs/checks/properties/scaledOutput/oneOf/0/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
var _valid1 = _errs37 === errors;
if(_valid1){
valid8 = true;
passing1 = 0;
}
const _errs38 = errors;
if(data20 !== null){
const err53 = {instancePath:instancePath+"/checks/scaledOutput",schemaPath:"#/$defs/checks/properties/scaledOutput/oneOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
var _valid1 = _errs38 === errors;
if(_valid1 && valid8){
valid8 = false;
passing1 = [passing1, 1];
}
else {
if(_valid1){
valid8 = true;
passing1 = 1;
}
}
if(!valid8){
const err54 = {instancePath:instancePath+"/checks/scaledOutput",schemaPath:"#/$defs/checks/properties/scaledOutput/oneOf",keyword:"oneOf",params:{passingSchemas: passing1},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
else {
errors = _errs36;
if(vErrors !== null){
if(_errs36){
vErrors.length = _errs36;
}
else {
vErrors = null;
}
}
}
}
if(data12.referenceArtifact !== undefined){
if(data12.referenceArtifact !== null){
const err55 = {instancePath:instancePath+"/checks/referenceArtifact",schemaPath:"#/$defs/checks/properties/referenceArtifact/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
}
if(data12.visualComparison !== undefined){
if(true !== data12.visualComparison){
const err56 = {instancePath:instancePath+"/checks/visualComparison",schemaPath:"#/$defs/checks/properties/visualComparison/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
}
else {
const err57 = {instancePath:instancePath+"/checks",schemaPath:"#/$defs/checks/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
}
else {
const err58 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
validate166.errors = vErrors;
return errors === 0;
}
validate166.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateVisualConformanceRegistryV02Schema = validate183;
const schema248 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.2/visual-conformance-registry.schema.json","title":"Maipo visual conformance registry 0.2","type":"object","additionalProperties":false,"required":["$schema","format","version","extends","reportSchema","pixelModel","cases"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.2/visual-conformance-registry.schema.json"},"format":{"const":"maipo-visual-conformance-registry"},"version":{"const":"0.2"},"extends":{"$ref":"#/$defs/sourceDigest"},"reportSchema":{"type":"object","additionalProperties":false,"required":["id","source","digest"],"properties":{"id":{"const":"https://maipo.design/schema/0.2/conformance-report.schema.json"},"source":{"const":"schema/maipo-conformance-report-0.2.schema.json"},"digest":{"$ref":"#/$defs/digest"}}},"pixelModel":{"$ref":"#/$defs/pixelModel"},"cases":{"type":"array","minItems":1,"maxItems":1024,"items":{"$ref":"#/$defs/case"}}},"$defs":{"token":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"sourceDigest":{"type":"object","additionalProperties":false,"required":["source","digest"],"properties":{"source":{"const":"conformance-0.1.json"},"digest":{"$ref":"#/$defs/digest"}}},"pixelModel":{"type":"object","additionalProperties":false,"required":["encoding","colorSpace","alpha","transparentRgb","channelDelta","pixelDelta","meanChannelDelta"],"properties":{"encoding":{"const":"rgba8"},"colorSpace":{"const":"srgb"},"alpha":{"const":"straight"},"transparentRgb":{"const":"zero"},"channelDelta":{"const":"absolute-byte-difference"},"pixelDelta":{"const":"maximum-channel-delta"},"meanChannelDelta":{"const":"sum-of-rgba-deltas-divided-by-four-times-pixel-count"}}},"case":{"type":"object","additionalProperties":false,"required":["id","source","reference","thresholds"],"properties":{"id":{"$ref":"#/$defs/token"},"source":{"enum":["renderer-artifact","supplied-png"]},"reference":{"type":"string","minLength":1,"maxLength":512,"pattern":"^fixtures/[A-Za-z0-9][A-Za-z0-9._/-]*\\.expected\\.json$"},"thresholds":{"$ref":"#/$defs/thresholds"}}},"ratio":{"type":"number","minimum":0,"maximum":1},"thresholds":{"type":"object","additionalProperties":false,"required":["maxDifferentPixelRatio","maxPixelsAboveFourRatio","maxMeanChannelDelta","maxChannelDelta"],"properties":{"maxDifferentPixelRatio":{"$ref":"#/$defs/ratio"},"maxPixelsAboveFourRatio":{"$ref":"#/$defs/ratio"},"maxMeanChannelDelta":{"type":"number","minimum":0,"maximum":255},"maxChannelDelta":{"type":"integer","minimum":0,"maximum":255}}}}};
const schema250 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};
const schema252 = {"type":"object","additionalProperties":false,"required":["encoding","colorSpace","alpha","transparentRgb","channelDelta","pixelDelta","meanChannelDelta"],"properties":{"encoding":{"const":"rgba8"},"colorSpace":{"const":"srgb"},"alpha":{"const":"straight"},"transparentRgb":{"const":"zero"},"channelDelta":{"const":"absolute-byte-difference"},"pixelDelta":{"const":"maximum-channel-delta"},"meanChannelDelta":{"const":"sum-of-rgba-deltas-divided-by-four-times-pixel-count"}}};
const schema249 = {"type":"object","additionalProperties":false,"required":["source","digest"],"properties":{"source":{"const":"conformance-0.1.json"},"digest":{"$ref":"#/$defs/digest"}}};

function validate184(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate184.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.source === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.digest === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "source") || (key0 === "digest"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.source !== undefined){
if("conformance-0.1.json" !== data.source){
const err3 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/const",keyword:"const",params:{allowedValue: "conformance-0.1.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.digest !== undefined){
let data1 = data.digest;
if(typeof data1 === "string"){
if(!pattern9.test(data1)){
const err4 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
validate184.errors = vErrors;
return errors === 0;
}
validate184.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema253 = {"type":"object","additionalProperties":false,"required":["id","source","reference","thresholds"],"properties":{"id":{"$ref":"#/$defs/token"},"source":{"enum":["renderer-artifact","supplied-png"]},"reference":{"type":"string","minLength":1,"maxLength":512,"pattern":"^fixtures/[A-Za-z0-9][A-Za-z0-9._/-]*\\.expected\\.json$"},"thresholds":{"$ref":"#/$defs/thresholds"}}};
const schema254 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const pattern112 = new RegExp("^fixtures/[A-Za-z0-9][A-Za-z0-9._/-]*\\.expected\\.json$", "u");
const schema255 = {"type":"object","additionalProperties":false,"required":["maxDifferentPixelRatio","maxPixelsAboveFourRatio","maxMeanChannelDelta","maxChannelDelta"],"properties":{"maxDifferentPixelRatio":{"$ref":"#/$defs/ratio"},"maxPixelsAboveFourRatio":{"$ref":"#/$defs/ratio"},"maxMeanChannelDelta":{"type":"number","minimum":0,"maximum":255},"maxChannelDelta":{"type":"integer","minimum":0,"maximum":255}}};
const schema256 = {"type":"number","minimum":0,"maximum":1};

function validate187(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate187.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.maxDifferentPixelRatio === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "maxDifferentPixelRatio"},message:"must have required property '"+"maxDifferentPixelRatio"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.maxPixelsAboveFourRatio === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "maxPixelsAboveFourRatio"},message:"must have required property '"+"maxPixelsAboveFourRatio"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.maxMeanChannelDelta === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "maxMeanChannelDelta"},message:"must have required property '"+"maxMeanChannelDelta"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.maxChannelDelta === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "maxChannelDelta"},message:"must have required property '"+"maxChannelDelta"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "maxDifferentPixelRatio") || (key0 === "maxPixelsAboveFourRatio")) || (key0 === "maxMeanChannelDelta")) || (key0 === "maxChannelDelta"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.maxDifferentPixelRatio !== undefined){
let data0 = data.maxDifferentPixelRatio;
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 1 || isNaN(data0)){
const err5 = {instancePath:instancePath+"/maxDifferentPixelRatio",schemaPath:"#/$defs/ratio/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data0 < 0 || isNaN(data0)){
const err6 = {instancePath:instancePath+"/maxDifferentPixelRatio",schemaPath:"#/$defs/ratio/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/maxDifferentPixelRatio",schemaPath:"#/$defs/ratio/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.maxPixelsAboveFourRatio !== undefined){
let data1 = data.maxPixelsAboveFourRatio;
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 1 || isNaN(data1)){
const err8 = {instancePath:instancePath+"/maxPixelsAboveFourRatio",schemaPath:"#/$defs/ratio/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data1 < 0 || isNaN(data1)){
const err9 = {instancePath:instancePath+"/maxPixelsAboveFourRatio",schemaPath:"#/$defs/ratio/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/maxPixelsAboveFourRatio",schemaPath:"#/$defs/ratio/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.maxMeanChannelDelta !== undefined){
let data2 = data.maxMeanChannelDelta;
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 255 || isNaN(data2)){
const err11 = {instancePath:instancePath+"/maxMeanChannelDelta",schemaPath:"#/properties/maxMeanChannelDelta/maximum",keyword:"maximum",params:{comparison: "<=", limit: 255},message:"must be <= 255"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data2 < 0 || isNaN(data2)){
const err12 = {instancePath:instancePath+"/maxMeanChannelDelta",schemaPath:"#/properties/maxMeanChannelDelta/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/maxMeanChannelDelta",schemaPath:"#/properties/maxMeanChannelDelta/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.maxChannelDelta !== undefined){
let data3 = data.maxChannelDelta;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err14 = {instancePath:instancePath+"/maxChannelDelta",schemaPath:"#/properties/maxChannelDelta/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 255 || isNaN(data3)){
const err15 = {instancePath:instancePath+"/maxChannelDelta",schemaPath:"#/properties/maxChannelDelta/maximum",keyword:"maximum",params:{comparison: "<=", limit: 255},message:"must be <= 255"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data3 < 0 || isNaN(data3)){
const err16 = {instancePath:instancePath+"/maxChannelDelta",schemaPath:"#/properties/maxChannelDelta/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate187.errors = vErrors;
return errors === 0;
}
validate187.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate186(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate186.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.source === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.reference === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "reference"},message:"must have required property '"+"reference"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.thresholds === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "thresholds"},message:"must have required property '"+"thresholds"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "id") || (key0 === "source")) || (key0 === "reference")) || (key0 === "thresholds"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func3(data0) < 1){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern4.test(data0)){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.source !== undefined){
let data1 = data.source;
if(!((data1 === "renderer-artifact") || (data1 === "supplied-png"))){
const err9 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/enum",keyword:"enum",params:{allowedValues: schema253.properties.source.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.reference !== undefined){
let data2 = data.reference;
if(typeof data2 === "string"){
if(func3(data2) > 512){
const err10 = {instancePath:instancePath+"/reference",schemaPath:"#/properties/reference/maxLength",keyword:"maxLength",params:{limit: 512},message:"must NOT have more than 512 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func3(data2) < 1){
const err11 = {instancePath:instancePath+"/reference",schemaPath:"#/properties/reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern112.test(data2)){
const err12 = {instancePath:instancePath+"/reference",schemaPath:"#/properties/reference/pattern",keyword:"pattern",params:{pattern: "^fixtures/[A-Za-z0-9][A-Za-z0-9._/-]*\\.expected\\.json$"},message:"must match pattern \""+"^fixtures/[A-Za-z0-9][A-Za-z0-9._/-]*\\.expected\\.json$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/reference",schemaPath:"#/properties/reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.thresholds !== undefined){
if(!(validate187(data.thresholds, {instancePath:instancePath+"/thresholds",parentData:data,parentDataProperty:"thresholds",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate187.errors : vErrors.concat(validate187.errors);
errors = vErrors.length;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate186.errors = vErrors;
return errors === 0;
}
validate186.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate183(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.2/visual-conformance-registry.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate183.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.extends === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "extends"},message:"must have required property '"+"extends"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.reportSchema === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "reportSchema"},message:"must have required property '"+"reportSchema"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.pixelModel === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelModel"},message:"must have required property '"+"pixelModel"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.cases === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "cases"},message:"must have required property '"+"cases"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "$schema") || (key0 === "format")) || (key0 === "version")) || (key0 === "extends")) || (key0 === "reportSchema")) || (key0 === "pixelModel")) || (key0 === "cases"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.2/visual-conformance-registry.schema.json" !== data.$schema){
const err8 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.2/visual-conformance-registry.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-visual-conformance-registry" !== data.format){
const err9 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-visual-conformance-registry"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.version !== undefined){
if("0.2" !== data.version){
const err10 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.2"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.extends !== undefined){
if(!(validate184(data.extends, {instancePath:instancePath+"/extends",parentData:data,parentDataProperty:"extends",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate184.errors : vErrors.concat(validate184.errors);
errors = vErrors.length;
}
}
if(data.reportSchema !== undefined){
let data4 = data.reportSchema;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.id === undefined){
const err11 = {instancePath:instancePath+"/reportSchema",schemaPath:"#/properties/reportSchema/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data4.source === undefined){
const err12 = {instancePath:instancePath+"/reportSchema",schemaPath:"#/properties/reportSchema/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data4.digest === undefined){
const err13 = {instancePath:instancePath+"/reportSchema",schemaPath:"#/properties/reportSchema/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
for(const key1 in data4){
if(!(((key1 === "id") || (key1 === "source")) || (key1 === "digest"))){
const err14 = {instancePath:instancePath+"/reportSchema",schemaPath:"#/properties/reportSchema/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data4.id !== undefined){
if("https://maipo.design/schema/0.2/conformance-report.schema.json" !== data4.id){
const err15 = {instancePath:instancePath+"/reportSchema/id",schemaPath:"#/properties/reportSchema/properties/id/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.2/conformance-report.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data4.source !== undefined){
if("schema/maipo-conformance-report-0.2.schema.json" !== data4.source){
const err16 = {instancePath:instancePath+"/reportSchema/source",schemaPath:"#/properties/reportSchema/properties/source/const",keyword:"const",params:{allowedValue: "schema/maipo-conformance-report-0.2.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data4.digest !== undefined){
let data7 = data4.digest;
if(typeof data7 === "string"){
if(!pattern9.test(data7)){
const err17 = {instancePath:instancePath+"/reportSchema/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/reportSchema/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath:instancePath+"/reportSchema",schemaPath:"#/properties/reportSchema/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.pixelModel !== undefined){
let data8 = data.pixelModel;
if(data8 && typeof data8 == "object" && !Array.isArray(data8)){
if(data8.encoding === undefined){
const err20 = {instancePath:instancePath+"/pixelModel",schemaPath:"#/$defs/pixelModel/required",keyword:"required",params:{missingProperty: "encoding"},message:"must have required property '"+"encoding"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data8.colorSpace === undefined){
const err21 = {instancePath:instancePath+"/pixelModel",schemaPath:"#/$defs/pixelModel/required",keyword:"required",params:{missingProperty: "colorSpace"},message:"must have required property '"+"colorSpace"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data8.alpha === undefined){
const err22 = {instancePath:instancePath+"/pixelModel",schemaPath:"#/$defs/pixelModel/required",keyword:"required",params:{missingProperty: "alpha"},message:"must have required property '"+"alpha"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data8.transparentRgb === undefined){
const err23 = {instancePath:instancePath+"/pixelModel",schemaPath:"#/$defs/pixelModel/required",keyword:"required",params:{missingProperty: "transparentRgb"},message:"must have required property '"+"transparentRgb"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data8.channelDelta === undefined){
const err24 = {instancePath:instancePath+"/pixelModel",schemaPath:"#/$defs/pixelModel/required",keyword:"required",params:{missingProperty: "channelDelta"},message:"must have required property '"+"channelDelta"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data8.pixelDelta === undefined){
const err25 = {instancePath:instancePath+"/pixelModel",schemaPath:"#/$defs/pixelModel/required",keyword:"required",params:{missingProperty: "pixelDelta"},message:"must have required property '"+"pixelDelta"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data8.meanChannelDelta === undefined){
const err26 = {instancePath:instancePath+"/pixelModel",schemaPath:"#/$defs/pixelModel/required",keyword:"required",params:{missingProperty: "meanChannelDelta"},message:"must have required property '"+"meanChannelDelta"+"'"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
for(const key2 in data8){
if(!(((((((key2 === "encoding") || (key2 === "colorSpace")) || (key2 === "alpha")) || (key2 === "transparentRgb")) || (key2 === "channelDelta")) || (key2 === "pixelDelta")) || (key2 === "meanChannelDelta"))){
const err27 = {instancePath:instancePath+"/pixelModel",schemaPath:"#/$defs/pixelModel/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data8.encoding !== undefined){
if("rgba8" !== data8.encoding){
const err28 = {instancePath:instancePath+"/pixelModel/encoding",schemaPath:"#/$defs/pixelModel/properties/encoding/const",keyword:"const",params:{allowedValue: "rgba8"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data8.colorSpace !== undefined){
if("srgb" !== data8.colorSpace){
const err29 = {instancePath:instancePath+"/pixelModel/colorSpace",schemaPath:"#/$defs/pixelModel/properties/colorSpace/const",keyword:"const",params:{allowedValue: "srgb"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data8.alpha !== undefined){
if("straight" !== data8.alpha){
const err30 = {instancePath:instancePath+"/pixelModel/alpha",schemaPath:"#/$defs/pixelModel/properties/alpha/const",keyword:"const",params:{allowedValue: "straight"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data8.transparentRgb !== undefined){
if("zero" !== data8.transparentRgb){
const err31 = {instancePath:instancePath+"/pixelModel/transparentRgb",schemaPath:"#/$defs/pixelModel/properties/transparentRgb/const",keyword:"const",params:{allowedValue: "zero"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data8.channelDelta !== undefined){
if("absolute-byte-difference" !== data8.channelDelta){
const err32 = {instancePath:instancePath+"/pixelModel/channelDelta",schemaPath:"#/$defs/pixelModel/properties/channelDelta/const",keyword:"const",params:{allowedValue: "absolute-byte-difference"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data8.pixelDelta !== undefined){
if("maximum-channel-delta" !== data8.pixelDelta){
const err33 = {instancePath:instancePath+"/pixelModel/pixelDelta",schemaPath:"#/$defs/pixelModel/properties/pixelDelta/const",keyword:"const",params:{allowedValue: "maximum-channel-delta"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data8.meanChannelDelta !== undefined){
if("sum-of-rgba-deltas-divided-by-four-times-pixel-count" !== data8.meanChannelDelta){
const err34 = {instancePath:instancePath+"/pixelModel/meanChannelDelta",schemaPath:"#/$defs/pixelModel/properties/meanChannelDelta/const",keyword:"const",params:{allowedValue: "sum-of-rgba-deltas-divided-by-four-times-pixel-count"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
else {
const err35 = {instancePath:instancePath+"/pixelModel",schemaPath:"#/$defs/pixelModel/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data.cases !== undefined){
let data16 = data.cases;
if(Array.isArray(data16)){
if(data16.length > 1024){
const err36 = {instancePath:instancePath+"/cases",schemaPath:"#/properties/cases/maxItems",keyword:"maxItems",params:{limit: 1024},message:"must NOT have more than 1024 items"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data16.length < 1){
const err37 = {instancePath:instancePath+"/cases",schemaPath:"#/properties/cases/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
const len0 = data16.length;
for(let i0=0; i0<len0; i0++){
if(!(validate186(data16[i0], {instancePath:instancePath+"/cases/" + i0,parentData:data16,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate186.errors : vErrors.concat(validate186.errors);
errors = vErrors.length;
}
}
}
else {
const err38 = {instancePath:instancePath+"/cases",schemaPath:"#/properties/cases/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
}
else {
const err39 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
validate183.errors = vErrors;
return errors === 0;
}
validate183.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateTextShapingPlanSchema = validate190;
const schema258 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/text-shaping-plan.schema.json","title":"Maipo text shaping plan 0.1","description":"Backend-neutral positioned-glyph evidence for editable Unicode text and exact font bytes.","type":"object","additionalProperties":false,"required":["$schema","format","version","source","font","model","runs"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/text-shaping-plan.schema.json"},"format":{"const":"maipo-text-shaping-plan"},"version":{"const":"0.1"},"source":{"$ref":"#/$defs/source"},"font":{"$ref":"#/$defs/font"},"model":{"$ref":"#/$defs/model"},"runs":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/run"}}},"$defs":{"id":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"tag":{"type":"string","pattern":"^[ -~]{4}$"},"position":{"type":"integer","minimum":-2147483648,"maximum":2147483647},"scalarIndex":{"type":"integer","minimum":0,"maximum":1000000},"source":{"type":"object","additionalProperties":false,"required":["documentId","revision","nodeId","text","textDigest"],"properties":{"documentId":{"$ref":"#/$defs/id"},"revision":{"type":"integer","minimum":0},"nodeId":{"$ref":"#/$defs/id"},"text":{"type":"string","maxLength":1000000},"textDigest":{"$ref":"#/$defs/digest"}}},"variation":{"type":"object","additionalProperties":false,"required":["tag","value"],"properties":{"tag":{"$ref":"#/$defs/tag"},"value":{"type":"number","minimum":-1000000,"maximum":1000000}}},"font":{"type":"object","additionalProperties":false,"required":["fontRef","digest","faceIndex","unitsPerEm","variations"],"properties":{"fontRef":{"$ref":"#/$defs/id"},"digest":{"$ref":"#/$defs/digest"},"faceIndex":{"type":"integer","minimum":0,"maximum":65535},"unitsPerEm":{"type":"integer","minimum":16,"maximum":16384},"variations":{"type":"array","maxItems":64,"items":{"$ref":"#/$defs/variation"}}}},"model":{"type":"object","additionalProperties":false,"required":["id","version","clusterUnit","clusterLevel"],"properties":{"id":{"const":"maipo-opentype-glyph-plan"},"version":{"const":"0.1"},"clusterUnit":{"const":"unicode-scalar-index"},"clusterLevel":{"const":"monotone-graphemes"}}},"origin":{"type":"object","additionalProperties":false,"required":["x","y"],"properties":{"x":{"$ref":"#/$defs/position"},"y":{"$ref":"#/$defs/position"}}},"feature":{"type":"object","additionalProperties":false,"required":["tag","value"],"properties":{"tag":{"$ref":"#/$defs/tag"},"value":{"type":"integer","minimum":0,"maximum":4294967295}}},"glyph":{"type":"object","additionalProperties":false,"required":["id","cluster","xAdvance","yAdvance","xOffset","yOffset"],"properties":{"id":{"type":"integer","minimum":0,"maximum":4294967295},"cluster":{"$ref":"#/$defs/scalarIndex"},"xAdvance":{"$ref":"#/$defs/position"},"yAdvance":{"$ref":"#/$defs/position"},"xOffset":{"$ref":"#/$defs/position"},"yOffset":{"$ref":"#/$defs/position"},"flags":{"type":"array","maxItems":3,"items":{"enum":["unsafe-to-break","unsafe-to-concat","safe-to-insert-tatweel"]}}}},"run":{"type":"object","additionalProperties":false,"required":["id","sourceStart","sourceEnd","direction","script","language","origin","features","glyphs"],"properties":{"id":{"$ref":"#/$defs/id"},"sourceStart":{"$ref":"#/$defs/scalarIndex"},"sourceEnd":{"$ref":"#/$defs/scalarIndex"},"direction":{"enum":["ltr","rtl","ttb","btt"]},"script":{"type":"string","pattern":"^[A-Z][a-z]{3}$"},"language":{"type":"string","minLength":2,"maxLength":64,"pattern":"^[a-z]{2,8}(?:-[a-z0-9]{1,8})*$"},"origin":{"$ref":"#/$defs/origin"},"features":{"type":"array","maxItems":256,"items":{"$ref":"#/$defs/feature"}},"glyphs":{"type":"array","maxItems":1000000,"items":{"$ref":"#/$defs/glyph"}}}}}};
const schema268 = {"type":"object","additionalProperties":false,"required":["id","version","clusterUnit","clusterLevel"],"properties":{"id":{"const":"maipo-opentype-glyph-plan"},"version":{"const":"0.1"},"clusterUnit":{"const":"unicode-scalar-index"},"clusterLevel":{"const":"monotone-graphemes"}}};
const schema259 = {"type":"object","additionalProperties":false,"required":["documentId","revision","nodeId","text","textDigest"],"properties":{"documentId":{"$ref":"#/$defs/id"},"revision":{"type":"integer","minimum":0},"nodeId":{"$ref":"#/$defs/id"},"text":{"type":"string","maxLength":1000000},"textDigest":{"$ref":"#/$defs/digest"}}};
const schema260 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const schema262 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};

function validate191(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate191.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.documentId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "documentId"},message:"must have required property '"+"documentId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.revision === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "revision"},message:"must have required property '"+"revision"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.nodeId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nodeId"},message:"must have required property '"+"nodeId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.text === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "text"},message:"must have required property '"+"text"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.textDigest === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "textDigest"},message:"must have required property '"+"textDigest"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "documentId") || (key0 === "revision")) || (key0 === "nodeId")) || (key0 === "text")) || (key0 === "textDigest"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.documentId !== undefined){
let data0 = data.documentId;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err6 = {instancePath:instancePath+"/documentId",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(func3(data0) < 1){
const err7 = {instancePath:instancePath+"/documentId",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!pattern4.test(data0)){
const err8 = {instancePath:instancePath+"/documentId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/documentId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.revision !== undefined){
let data1 = data.revision;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err10 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 < 0 || isNaN(data1)){
const err11 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
if(data.nodeId !== undefined){
let data2 = data.nodeId;
if(typeof data2 === "string"){
if(func3(data2) > 128){
const err12 = {instancePath:instancePath+"/nodeId",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(func3(data2) < 1){
const err13 = {instancePath:instancePath+"/nodeId",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!pattern4.test(data2)){
const err14 = {instancePath:instancePath+"/nodeId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/nodeId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.text !== undefined){
let data3 = data.text;
if(typeof data3 === "string"){
if(func3(data3) > 1000000){
const err16 = {instancePath:instancePath+"/text",schemaPath:"#/properties/text/maxLength",keyword:"maxLength",params:{limit: 1000000},message:"must NOT have more than 1000000 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/text",schemaPath:"#/properties/text/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.textDigest !== undefined){
let data4 = data.textDigest;
if(typeof data4 === "string"){
if(!pattern9.test(data4)){
const err18 = {instancePath:instancePath+"/textDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/textDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
else {
const err20 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
validate191.errors = vErrors;
return errors === 0;
}
validate191.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema263 = {"type":"object","additionalProperties":false,"required":["fontRef","digest","faceIndex","unitsPerEm","variations"],"properties":{"fontRef":{"$ref":"#/$defs/id"},"digest":{"$ref":"#/$defs/digest"},"faceIndex":{"type":"integer","minimum":0,"maximum":65535},"unitsPerEm":{"type":"integer","minimum":16,"maximum":16384},"variations":{"type":"array","maxItems":64,"items":{"$ref":"#/$defs/variation"}}}};
const schema266 = {"type":"object","additionalProperties":false,"required":["tag","value"],"properties":{"tag":{"$ref":"#/$defs/tag"},"value":{"type":"number","minimum":-1000000,"maximum":1000000}}};
const schema267 = {"type":"string","pattern":"^[ -~]{4}$"};
const pattern118 = new RegExp("^[ -~]{4}$", "u");

function validate194(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate194.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.tag === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "tag"},message:"must have required property '"+"tag"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.value === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "value"},message:"must have required property '"+"value"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "tag") || (key0 === "value"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.tag !== undefined){
let data0 = data.tag;
if(typeof data0 === "string"){
if(!pattern118.test(data0)){
const err3 = {instancePath:instancePath+"/tag",schemaPath:"#/$defs/tag/pattern",keyword:"pattern",params:{pattern: "^[ -~]{4}$"},message:"must match pattern \""+"^[ -~]{4}$"+"\""};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/tag",schemaPath:"#/$defs/tag/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.value !== undefined){
let data1 = data.value;
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 1000000 || isNaN(data1)){
const err5 = {instancePath:instancePath+"/value",schemaPath:"#/properties/value/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data1 < -1000000 || isNaN(data1)){
const err6 = {instancePath:instancePath+"/value",schemaPath:"#/properties/value/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000},message:"must be >= -1000000"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/value",schemaPath:"#/properties/value/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate194.errors = vErrors;
return errors === 0;
}
validate194.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate193(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate193.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.fontRef === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fontRef"},message:"must have required property '"+"fontRef"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.digest === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.faceIndex === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "faceIndex"},message:"must have required property '"+"faceIndex"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.unitsPerEm === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "unitsPerEm"},message:"must have required property '"+"unitsPerEm"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.variations === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "variations"},message:"must have required property '"+"variations"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "fontRef") || (key0 === "digest")) || (key0 === "faceIndex")) || (key0 === "unitsPerEm")) || (key0 === "variations"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.fontRef !== undefined){
let data0 = data.fontRef;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err6 = {instancePath:instancePath+"/fontRef",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(func3(data0) < 1){
const err7 = {instancePath:instancePath+"/fontRef",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!pattern4.test(data0)){
const err8 = {instancePath:instancePath+"/fontRef",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/fontRef",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.digest !== undefined){
let data1 = data.digest;
if(typeof data1 === "string"){
if(!pattern9.test(data1)){
const err10 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.faceIndex !== undefined){
let data2 = data.faceIndex;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err12 = {instancePath:instancePath+"/faceIndex",schemaPath:"#/properties/faceIndex/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 65535 || isNaN(data2)){
const err13 = {instancePath:instancePath+"/faceIndex",schemaPath:"#/properties/faceIndex/maximum",keyword:"maximum",params:{comparison: "<=", limit: 65535},message:"must be <= 65535"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data2 < 0 || isNaN(data2)){
const err14 = {instancePath:instancePath+"/faceIndex",schemaPath:"#/properties/faceIndex/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
if(data.unitsPerEm !== undefined){
let data3 = data.unitsPerEm;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err15 = {instancePath:instancePath+"/unitsPerEm",schemaPath:"#/properties/unitsPerEm/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 16384 || isNaN(data3)){
const err16 = {instancePath:instancePath+"/unitsPerEm",schemaPath:"#/properties/unitsPerEm/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16384},message:"must be <= 16384"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data3 < 16 || isNaN(data3)){
const err17 = {instancePath:instancePath+"/unitsPerEm",schemaPath:"#/properties/unitsPerEm/minimum",keyword:"minimum",params:{comparison: ">=", limit: 16},message:"must be >= 16"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
if(data.variations !== undefined){
let data4 = data.variations;
if(Array.isArray(data4)){
if(data4.length > 64){
const err18 = {instancePath:instancePath+"/variations",schemaPath:"#/properties/variations/maxItems",keyword:"maxItems",params:{limit: 64},message:"must NOT have more than 64 items"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
const len0 = data4.length;
for(let i0=0; i0<len0; i0++){
if(!(validate194(data4[i0], {instancePath:instancePath+"/variations/" + i0,parentData:data4,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate194.errors : vErrors.concat(validate194.errors);
errors = vErrors.length;
}
}
}
else {
const err19 = {instancePath:instancePath+"/variations",schemaPath:"#/properties/variations/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
else {
const err20 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
validate193.errors = vErrors;
return errors === 0;
}
validate193.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema269 = {"type":"object","additionalProperties":false,"required":["id","sourceStart","sourceEnd","direction","script","language","origin","features","glyphs"],"properties":{"id":{"$ref":"#/$defs/id"},"sourceStart":{"$ref":"#/$defs/scalarIndex"},"sourceEnd":{"$ref":"#/$defs/scalarIndex"},"direction":{"enum":["ltr","rtl","ttb","btt"]},"script":{"type":"string","pattern":"^[A-Z][a-z]{3}$"},"language":{"type":"string","minLength":2,"maxLength":64,"pattern":"^[a-z]{2,8}(?:-[a-z0-9]{1,8})*$"},"origin":{"$ref":"#/$defs/origin"},"features":{"type":"array","maxItems":256,"items":{"$ref":"#/$defs/feature"}},"glyphs":{"type":"array","maxItems":1000000,"items":{"$ref":"#/$defs/glyph"}}}};
const schema271 = {"type":"integer","minimum":0,"maximum":1000000};
const pattern120 = new RegExp("^[A-Z][a-z]{3}$", "u");
const pattern121 = new RegExp("^[a-z]{2,8}(?:-[a-z0-9]{1,8})*$", "u");
const schema273 = {"type":"object","additionalProperties":false,"required":["x","y"],"properties":{"x":{"$ref":"#/$defs/position"},"y":{"$ref":"#/$defs/position"}}};
const schema274 = {"type":"integer","minimum":-2147483648,"maximum":2147483647};

function validate198(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate198.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.x === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.y === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "x") || (key0 === "y"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.x !== undefined){
let data0 = data.x;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err3 = {instancePath:instancePath+"/x",schemaPath:"#/$defs/position/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 2147483647 || isNaN(data0)){
const err4 = {instancePath:instancePath+"/x",schemaPath:"#/$defs/position/maximum",keyword:"maximum",params:{comparison: "<=", limit: 2147483647},message:"must be <= 2147483647"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data0 < -2147483648 || isNaN(data0)){
const err5 = {instancePath:instancePath+"/x",schemaPath:"#/$defs/position/minimum",keyword:"minimum",params:{comparison: ">=", limit: -2147483648},message:"must be >= -2147483648"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
if(data.y !== undefined){
let data1 = data.y;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err6 = {instancePath:instancePath+"/y",schemaPath:"#/$defs/position/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 2147483647 || isNaN(data1)){
const err7 = {instancePath:instancePath+"/y",schemaPath:"#/$defs/position/maximum",keyword:"maximum",params:{comparison: "<=", limit: 2147483647},message:"must be <= 2147483647"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data1 < -2147483648 || isNaN(data1)){
const err8 = {instancePath:instancePath+"/y",schemaPath:"#/$defs/position/minimum",keyword:"minimum",params:{comparison: ">=", limit: -2147483648},message:"must be >= -2147483648"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate198.errors = vErrors;
return errors === 0;
}
validate198.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema276 = {"type":"object","additionalProperties":false,"required":["tag","value"],"properties":{"tag":{"$ref":"#/$defs/tag"},"value":{"type":"integer","minimum":0,"maximum":4294967295}}};

function validate200(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate200.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.tag === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "tag"},message:"must have required property '"+"tag"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.value === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "value"},message:"must have required property '"+"value"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "tag") || (key0 === "value"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.tag !== undefined){
let data0 = data.tag;
if(typeof data0 === "string"){
if(!pattern118.test(data0)){
const err3 = {instancePath:instancePath+"/tag",schemaPath:"#/$defs/tag/pattern",keyword:"pattern",params:{pattern: "^[ -~]{4}$"},message:"must match pattern \""+"^[ -~]{4}$"+"\""};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/tag",schemaPath:"#/$defs/tag/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.value !== undefined){
let data1 = data.value;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err5 = {instancePath:instancePath+"/value",schemaPath:"#/properties/value/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 4294967295 || isNaN(data1)){
const err6 = {instancePath:instancePath+"/value",schemaPath:"#/properties/value/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4294967295},message:"must be <= 4294967295"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data1 < 0 || isNaN(data1)){
const err7 = {instancePath:instancePath+"/value",schemaPath:"#/properties/value/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate200.errors = vErrors;
return errors === 0;
}
validate200.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema278 = {"type":"object","additionalProperties":false,"required":["id","cluster","xAdvance","yAdvance","xOffset","yOffset"],"properties":{"id":{"type":"integer","minimum":0,"maximum":4294967295},"cluster":{"$ref":"#/$defs/scalarIndex"},"xAdvance":{"$ref":"#/$defs/position"},"yAdvance":{"$ref":"#/$defs/position"},"xOffset":{"$ref":"#/$defs/position"},"yOffset":{"$ref":"#/$defs/position"},"flags":{"type":"array","maxItems":3,"items":{"enum":["unsafe-to-break","unsafe-to-concat","safe-to-insert-tatweel"]}}}};

function validate202(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate202.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.cluster === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "cluster"},message:"must have required property '"+"cluster"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.xAdvance === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "xAdvance"},message:"must have required property '"+"xAdvance"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.yAdvance === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "yAdvance"},message:"must have required property '"+"yAdvance"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.xOffset === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "xOffset"},message:"must have required property '"+"xOffset"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.yOffset === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "yOffset"},message:"must have required property '"+"yOffset"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "id") || (key0 === "cluster")) || (key0 === "xAdvance")) || (key0 === "yAdvance")) || (key0 === "xOffset")) || (key0 === "yOffset")) || (key0 === "flags"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 4294967295 || isNaN(data0)){
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4294967295},message:"must be <= 4294967295"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data0 < 0 || isNaN(data0)){
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
if(data.cluster !== undefined){
let data1 = data.cluster;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err10 = {instancePath:instancePath+"/cluster",schemaPath:"#/$defs/scalarIndex/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 1000000 || isNaN(data1)){
const err11 = {instancePath:instancePath+"/cluster",schemaPath:"#/$defs/scalarIndex/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data1 < 0 || isNaN(data1)){
const err12 = {instancePath:instancePath+"/cluster",schemaPath:"#/$defs/scalarIndex/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
if(data.xAdvance !== undefined){
let data2 = data.xAdvance;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err13 = {instancePath:instancePath+"/xAdvance",schemaPath:"#/$defs/position/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 2147483647 || isNaN(data2)){
const err14 = {instancePath:instancePath+"/xAdvance",schemaPath:"#/$defs/position/maximum",keyword:"maximum",params:{comparison: "<=", limit: 2147483647},message:"must be <= 2147483647"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data2 < -2147483648 || isNaN(data2)){
const err15 = {instancePath:instancePath+"/xAdvance",schemaPath:"#/$defs/position/minimum",keyword:"minimum",params:{comparison: ">=", limit: -2147483648},message:"must be >= -2147483648"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
if(data.yAdvance !== undefined){
let data3 = data.yAdvance;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err16 = {instancePath:instancePath+"/yAdvance",schemaPath:"#/$defs/position/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 2147483647 || isNaN(data3)){
const err17 = {instancePath:instancePath+"/yAdvance",schemaPath:"#/$defs/position/maximum",keyword:"maximum",params:{comparison: "<=", limit: 2147483647},message:"must be <= 2147483647"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data3 < -2147483648 || isNaN(data3)){
const err18 = {instancePath:instancePath+"/yAdvance",schemaPath:"#/$defs/position/minimum",keyword:"minimum",params:{comparison: ">=", limit: -2147483648},message:"must be >= -2147483648"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
if(data.xOffset !== undefined){
let data4 = data.xOffset;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err19 = {instancePath:instancePath+"/xOffset",schemaPath:"#/$defs/position/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 2147483647 || isNaN(data4)){
const err20 = {instancePath:instancePath+"/xOffset",schemaPath:"#/$defs/position/maximum",keyword:"maximum",params:{comparison: "<=", limit: 2147483647},message:"must be <= 2147483647"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data4 < -2147483648 || isNaN(data4)){
const err21 = {instancePath:instancePath+"/xOffset",schemaPath:"#/$defs/position/minimum",keyword:"minimum",params:{comparison: ">=", limit: -2147483648},message:"must be >= -2147483648"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
if(data.yOffset !== undefined){
let data5 = data.yOffset;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err22 = {instancePath:instancePath+"/yOffset",schemaPath:"#/$defs/position/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 2147483647 || isNaN(data5)){
const err23 = {instancePath:instancePath+"/yOffset",schemaPath:"#/$defs/position/maximum",keyword:"maximum",params:{comparison: "<=", limit: 2147483647},message:"must be <= 2147483647"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data5 < -2147483648 || isNaN(data5)){
const err24 = {instancePath:instancePath+"/yOffset",schemaPath:"#/$defs/position/minimum",keyword:"minimum",params:{comparison: ">=", limit: -2147483648},message:"must be >= -2147483648"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
if(data.flags !== undefined){
let data6 = data.flags;
if(Array.isArray(data6)){
if(data6.length > 3){
const err25 = {instancePath:instancePath+"/flags",schemaPath:"#/properties/flags/maxItems",keyword:"maxItems",params:{limit: 3},message:"must NOT have more than 3 items"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
const len0 = data6.length;
for(let i0=0; i0<len0; i0++){
let data7 = data6[i0];
if(!(((data7 === "unsafe-to-break") || (data7 === "unsafe-to-concat")) || (data7 === "safe-to-insert-tatweel"))){
const err26 = {instancePath:instancePath+"/flags/" + i0,schemaPath:"#/properties/flags/items/enum",keyword:"enum",params:{allowedValues: schema278.properties.flags.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
else {
const err27 = {instancePath:instancePath+"/flags",schemaPath:"#/properties/flags/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
validate202.errors = vErrors;
return errors === 0;
}
validate202.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate197(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate197.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.sourceStart === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceStart"},message:"must have required property '"+"sourceStart"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.sourceEnd === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceEnd"},message:"must have required property '"+"sourceEnd"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.direction === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "direction"},message:"must have required property '"+"direction"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.script === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "script"},message:"must have required property '"+"script"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.language === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "language"},message:"must have required property '"+"language"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.origin === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "origin"},message:"must have required property '"+"origin"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.features === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "features"},message:"must have required property '"+"features"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.glyphs === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "glyphs"},message:"must have required property '"+"glyphs"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema269.properties, key0))){
const err9 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func3(data0) < 1){
const err11 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern4.test(data0)){
const err12 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.sourceStart !== undefined){
let data1 = data.sourceStart;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err14 = {instancePath:instancePath+"/sourceStart",schemaPath:"#/$defs/scalarIndex/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 1000000 || isNaN(data1)){
const err15 = {instancePath:instancePath+"/sourceStart",schemaPath:"#/$defs/scalarIndex/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data1 < 0 || isNaN(data1)){
const err16 = {instancePath:instancePath+"/sourceStart",schemaPath:"#/$defs/scalarIndex/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
if(data.sourceEnd !== undefined){
let data2 = data.sourceEnd;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err17 = {instancePath:instancePath+"/sourceEnd",schemaPath:"#/$defs/scalarIndex/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000000 || isNaN(data2)){
const err18 = {instancePath:instancePath+"/sourceEnd",schemaPath:"#/$defs/scalarIndex/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data2 < 0 || isNaN(data2)){
const err19 = {instancePath:instancePath+"/sourceEnd",schemaPath:"#/$defs/scalarIndex/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
if(data.direction !== undefined){
let data3 = data.direction;
if(!((((data3 === "ltr") || (data3 === "rtl")) || (data3 === "ttb")) || (data3 === "btt"))){
const err20 = {instancePath:instancePath+"/direction",schemaPath:"#/properties/direction/enum",keyword:"enum",params:{allowedValues: schema269.properties.direction.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.script !== undefined){
let data4 = data.script;
if(typeof data4 === "string"){
if(!pattern120.test(data4)){
const err21 = {instancePath:instancePath+"/script",schemaPath:"#/properties/script/pattern",keyword:"pattern",params:{pattern: "^[A-Z][a-z]{3}$"},message:"must match pattern \""+"^[A-Z][a-z]{3}$"+"\""};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/script",schemaPath:"#/properties/script/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.language !== undefined){
let data5 = data.language;
if(typeof data5 === "string"){
if(func3(data5) > 64){
const err23 = {instancePath:instancePath+"/language",schemaPath:"#/properties/language/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(func3(data5) < 2){
const err24 = {instancePath:instancePath+"/language",schemaPath:"#/properties/language/minLength",keyword:"minLength",params:{limit: 2},message:"must NOT have fewer than 2 characters"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(!pattern121.test(data5)){
const err25 = {instancePath:instancePath+"/language",schemaPath:"#/properties/language/pattern",keyword:"pattern",params:{pattern: "^[a-z]{2,8}(?:-[a-z0-9]{1,8})*$"},message:"must match pattern \""+"^[a-z]{2,8}(?:-[a-z0-9]{1,8})*$"+"\""};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
else {
const err26 = {instancePath:instancePath+"/language",schemaPath:"#/properties/language/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.origin !== undefined){
if(!(validate198(data.origin, {instancePath:instancePath+"/origin",parentData:data,parentDataProperty:"origin",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate198.errors : vErrors.concat(validate198.errors);
errors = vErrors.length;
}
}
if(data.features !== undefined){
let data7 = data.features;
if(Array.isArray(data7)){
if(data7.length > 256){
const err27 = {instancePath:instancePath+"/features",schemaPath:"#/properties/features/maxItems",keyword:"maxItems",params:{limit: 256},message:"must NOT have more than 256 items"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
const len0 = data7.length;
for(let i0=0; i0<len0; i0++){
if(!(validate200(data7[i0], {instancePath:instancePath+"/features/" + i0,parentData:data7,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate200.errors : vErrors.concat(validate200.errors);
errors = vErrors.length;
}
}
}
else {
const err28 = {instancePath:instancePath+"/features",schemaPath:"#/properties/features/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.glyphs !== undefined){
let data9 = data.glyphs;
if(Array.isArray(data9)){
if(data9.length > 1000000){
const err29 = {instancePath:instancePath+"/glyphs",schemaPath:"#/properties/glyphs/maxItems",keyword:"maxItems",params:{limit: 1000000},message:"must NOT have more than 1000000 items"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
const len1 = data9.length;
for(let i1=0; i1<len1; i1++){
if(!(validate202(data9[i1], {instancePath:instancePath+"/glyphs/" + i1,parentData:data9,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate202.errors : vErrors.concat(validate202.errors);
errors = vErrors.length;
}
}
}
else {
const err30 = {instancePath:instancePath+"/glyphs",schemaPath:"#/properties/glyphs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
}
else {
const err31 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
validate197.errors = vErrors;
return errors === 0;
}
validate197.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate190(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/text-shaping-plan.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate190.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.source === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.font === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "font"},message:"must have required property '"+"font"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.model === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "model"},message:"must have required property '"+"model"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.runs === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "runs"},message:"must have required property '"+"runs"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "$schema") || (key0 === "format")) || (key0 === "version")) || (key0 === "source")) || (key0 === "font")) || (key0 === "model")) || (key0 === "runs"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/text-shaping-plan.schema.json" !== data.$schema){
const err8 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/text-shaping-plan.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-text-shaping-plan" !== data.format){
const err9 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-text-shaping-plan"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err10 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.source !== undefined){
if(!(validate191(data.source, {instancePath:instancePath+"/source",parentData:data,parentDataProperty:"source",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate191.errors : vErrors.concat(validate191.errors);
errors = vErrors.length;
}
}
if(data.font !== undefined){
if(!(validate193(data.font, {instancePath:instancePath+"/font",parentData:data,parentDataProperty:"font",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate193.errors : vErrors.concat(validate193.errors);
errors = vErrors.length;
}
}
if(data.model !== undefined){
let data5 = data.model;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.id === undefined){
const err11 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data5.version === undefined){
const err12 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data5.clusterUnit === undefined){
const err13 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "clusterUnit"},message:"must have required property '"+"clusterUnit"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data5.clusterLevel === undefined){
const err14 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "clusterLevel"},message:"must have required property '"+"clusterLevel"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
for(const key1 in data5){
if(!((((key1 === "id") || (key1 === "version")) || (key1 === "clusterUnit")) || (key1 === "clusterLevel"))){
const err15 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data5.id !== undefined){
if("maipo-opentype-glyph-plan" !== data5.id){
const err16 = {instancePath:instancePath+"/model/id",schemaPath:"#/$defs/model/properties/id/const",keyword:"const",params:{allowedValue: "maipo-opentype-glyph-plan"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data5.version !== undefined){
if("0.1" !== data5.version){
const err17 = {instancePath:instancePath+"/model/version",schemaPath:"#/$defs/model/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data5.clusterUnit !== undefined){
if("unicode-scalar-index" !== data5.clusterUnit){
const err18 = {instancePath:instancePath+"/model/clusterUnit",schemaPath:"#/$defs/model/properties/clusterUnit/const",keyword:"const",params:{allowedValue: "unicode-scalar-index"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data5.clusterLevel !== undefined){
if("monotone-graphemes" !== data5.clusterLevel){
const err19 = {instancePath:instancePath+"/model/clusterLevel",schemaPath:"#/$defs/model/properties/clusterLevel/const",keyword:"const",params:{allowedValue: "monotone-graphemes"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
else {
const err20 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.runs !== undefined){
let data10 = data.runs;
if(Array.isArray(data10)){
if(data10.length > 100000){
const err21 = {instancePath:instancePath+"/runs",schemaPath:"#/properties/runs/maxItems",keyword:"maxItems",params:{limit: 100000},message:"must NOT have more than 100000 items"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
const len0 = data10.length;
for(let i0=0; i0<len0; i0++){
if(!(validate197(data10[i0], {instancePath:instancePath+"/runs/" + i0,parentData:data10,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate197.errors : vErrors.concat(validate197.errors);
errors = vErrors.length;
}
}
}
else {
const err22 = {instancePath:instancePath+"/runs",schemaPath:"#/properties/runs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
validate190.errors = vErrors;
return errors === 0;
}
validate190.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateTextShapingRegistrySchema = validate205;
const schema284 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/text-shaping-registry.schema.json","title":"Maipo text shaping conformance registry 0.1","type":"object","additionalProperties":false,"required":["$schema","format","version","planSchema","model","referenceShaper","font","cases","scope"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/text-shaping-registry.schema.json"},"format":{"const":"maipo-text-shaping-registry"},"version":{"const":"0.1"},"planSchema":{"type":"object","additionalProperties":false,"required":["id","source","digest"],"properties":{"id":{"const":"https://maipo.design/schema/0.1/text-shaping-plan.schema.json"},"source":{"const":"schema/maipo-text-shaping-plan-0.1.schema.json"},"digest":{"$ref":"#/$defs/digest"}}},"model":{"type":"object","additionalProperties":false,"required":["id","version","coordinateSpace","clusterUnit","clusterLevel","runOrder"],"properties":{"id":{"const":"maipo-opentype-glyph-plan"},"version":{"const":"0.1"},"coordinateSpace":{"const":"integer-font-units"},"clusterUnit":{"const":"unicode-scalar-index"},"clusterLevel":{"const":"monotone-graphemes"},"runOrder":{"const":"visual-paint-order"}}},"referenceShaper":{"type":"object","additionalProperties":false,"required":["package","version","engine","engineVersion","implementation","implementationVersion","wasmDigest"],"properties":{"package":{"const":"@maipo/text-shaping"},"version":{"const":"0.1.0"},"engine":{"const":"harfbuzz"},"engineVersion":{"type":"string","pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+$"},"implementation":{"const":"harfbuzzjs"},"implementationVersion":{"type":"string","pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+$"},"wasmDigest":{"$ref":"#/$defs/digest"}}},"font":{"$ref":"#/$defs/font"},"cases":{"type":"array","minItems":1,"maxItems":1024,"items":{"$ref":"#/$defs/case"}},"scope":{"type":"object","additionalProperties":false,"required":["verified","notYetDefined"],"properties":{"verified":{"$ref":"#/$defs/uniqueTokens"},"notYetDefined":{"$ref":"#/$defs/uniqueTokens"}}}},"$defs":{"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"token":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9.-]*$"},"uniqueTokens":{"type":"array","minItems":1,"maxItems":128,"items":{"$ref":"#/$defs/token"}},"font":{"type":"object","additionalProperties":false,"required":["source","license","mediaType","byteLength","digest"],"properties":{"source":{"type":"string","pattern":"^fixtures/fonts/[A-Za-z0-9._-]+\\.(?:ttf|otf|woff2?)$"},"license":{"type":"string","pattern":"^fixtures/fonts/[A-Za-z0-9._-]+\\.txt$"},"mediaType":{"enum":["font/ttf","font/otf","font/woff","font/woff2"]},"byteLength":{"type":"integer","minimum":1,"maximum":67108864},"digest":{"$ref":"#/$defs/digest"}}},"case":{"type":"object","additionalProperties":false,"required":["id","plan","digest","assertions"],"properties":{"id":{"$ref":"#/$defs/token"},"plan":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.plan\\.json$"},"digest":{"$ref":"#/$defs/digest"},"assertions":{"type":"object","additionalProperties":false,"required":["direction","scalarCount","glyphCount","missingGlyphCount","zeroAdvanceGlyphs","positionedGlyphs"],"properties":{"direction":{"enum":["ltr","rtl","ttb","btt"]},"scalarCount":{"type":"integer","minimum":0,"maximum":1000000},"glyphCount":{"type":"integer","minimum":0,"maximum":1000000},"missingGlyphCount":{"type":"integer","minimum":0,"maximum":1000000},"zeroAdvanceGlyphs":{"type":"integer","minimum":0,"maximum":1000000},"positionedGlyphs":{"type":"integer","minimum":0,"maximum":1000000}}}}}}};
const schema285 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};
const pattern124 = new RegExp("^[0-9]+\\.[0-9]+\\.[0-9]+$", "u");
const schema287 = {"type":"object","additionalProperties":false,"required":["source","license","mediaType","byteLength","digest"],"properties":{"source":{"type":"string","pattern":"^fixtures/fonts/[A-Za-z0-9._-]+\\.(?:ttf|otf|woff2?)$"},"license":{"type":"string","pattern":"^fixtures/fonts/[A-Za-z0-9._-]+\\.txt$"},"mediaType":{"enum":["font/ttf","font/otf","font/woff","font/woff2"]},"byteLength":{"type":"integer","minimum":1,"maximum":67108864},"digest":{"$ref":"#/$defs/digest"}}};
const pattern127 = new RegExp("^fixtures/fonts/[A-Za-z0-9._-]+\\.(?:ttf|otf|woff2?)$", "u");
const pattern128 = new RegExp("^fixtures/fonts/[A-Za-z0-9._-]+\\.txt$", "u");

function validate206(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate206.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.source === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.license === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "license"},message:"must have required property '"+"license"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.mediaType === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "mediaType"},message:"must have required property '"+"mediaType"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.byteLength === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.digest === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "source") || (key0 === "license")) || (key0 === "mediaType")) || (key0 === "byteLength")) || (key0 === "digest"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.source !== undefined){
let data0 = data.source;
if(typeof data0 === "string"){
if(!pattern127.test(data0)){
const err6 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/pattern",keyword:"pattern",params:{pattern: "^fixtures/fonts/[A-Za-z0-9._-]+\\.(?:ttf|otf|woff2?)$"},message:"must match pattern \""+"^fixtures/fonts/[A-Za-z0-9._-]+\\.(?:ttf|otf|woff2?)$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.license !== undefined){
let data1 = data.license;
if(typeof data1 === "string"){
if(!pattern128.test(data1)){
const err8 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/pattern",keyword:"pattern",params:{pattern: "^fixtures/fonts/[A-Za-z0-9._-]+\\.txt$"},message:"must match pattern \""+"^fixtures/fonts/[A-Za-z0-9._-]+\\.txt$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.mediaType !== undefined){
let data2 = data.mediaType;
if(!((((data2 === "font/ttf") || (data2 === "font/otf")) || (data2 === "font/woff")) || (data2 === "font/woff2"))){
const err10 = {instancePath:instancePath+"/mediaType",schemaPath:"#/properties/mediaType/enum",keyword:"enum",params:{allowedValues: schema287.properties.mediaType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.byteLength !== undefined){
let data3 = data.byteLength;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err11 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 67108864 || isNaN(data3)){
const err12 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 67108864},message:"must be <= 67108864"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data3 < 1 || isNaN(data3)){
const err13 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data.digest !== undefined){
let data4 = data.digest;
if(typeof data4 === "string"){
if(!pattern9.test(data4)){
const err14 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate206.errors = vErrors;
return errors === 0;
}
validate206.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema289 = {"type":"object","additionalProperties":false,"required":["id","plan","digest","assertions"],"properties":{"id":{"$ref":"#/$defs/token"},"plan":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.plan\\.json$"},"digest":{"$ref":"#/$defs/digest"},"assertions":{"type":"object","additionalProperties":false,"required":["direction","scalarCount","glyphCount","missingGlyphCount","zeroAdvanceGlyphs","positionedGlyphs"],"properties":{"direction":{"enum":["ltr","rtl","ttb","btt"]},"scalarCount":{"type":"integer","minimum":0,"maximum":1000000},"glyphCount":{"type":"integer","minimum":0,"maximum":1000000},"missingGlyphCount":{"type":"integer","minimum":0,"maximum":1000000},"zeroAdvanceGlyphs":{"type":"integer","minimum":0,"maximum":1000000},"positionedGlyphs":{"type":"integer","minimum":0,"maximum":1000000}}}}};
const schema290 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9.-]*$"};
const pattern130 = new RegExp("^[a-z0-9][a-z0-9.-]*$", "u");
const pattern131 = new RegExp("^fixtures/[A-Za-z0-9._-]+\\.plan\\.json$", "u");

function validate208(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate208.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.plan === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "plan"},message:"must have required property '"+"plan"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.digest === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.assertions === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assertions"},message:"must have required property '"+"assertions"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "id") || (key0 === "plan")) || (key0 === "digest")) || (key0 === "assertions"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func3(data0) < 1){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern130.test(data0)){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9.-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9.-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.plan !== undefined){
let data1 = data.plan;
if(typeof data1 === "string"){
if(!pattern131.test(data1)){
const err9 = {instancePath:instancePath+"/plan",schemaPath:"#/properties/plan/pattern",keyword:"pattern",params:{pattern: "^fixtures/[A-Za-z0-9._-]+\\.plan\\.json$"},message:"must match pattern \""+"^fixtures/[A-Za-z0-9._-]+\\.plan\\.json$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/plan",schemaPath:"#/properties/plan/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.digest !== undefined){
let data2 = data.digest;
if(typeof data2 === "string"){
if(!pattern9.test(data2)){
const err11 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.assertions !== undefined){
let data3 = data.assertions;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.direction === undefined){
const err13 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "direction"},message:"must have required property '"+"direction"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data3.scalarCount === undefined){
const err14 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "scalarCount"},message:"must have required property '"+"scalarCount"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data3.glyphCount === undefined){
const err15 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "glyphCount"},message:"must have required property '"+"glyphCount"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data3.missingGlyphCount === undefined){
const err16 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "missingGlyphCount"},message:"must have required property '"+"missingGlyphCount"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data3.zeroAdvanceGlyphs === undefined){
const err17 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "zeroAdvanceGlyphs"},message:"must have required property '"+"zeroAdvanceGlyphs"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data3.positionedGlyphs === undefined){
const err18 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "positionedGlyphs"},message:"must have required property '"+"positionedGlyphs"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
for(const key1 in data3){
if(!((((((key1 === "direction") || (key1 === "scalarCount")) || (key1 === "glyphCount")) || (key1 === "missingGlyphCount")) || (key1 === "zeroAdvanceGlyphs")) || (key1 === "positionedGlyphs"))){
const err19 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data3.direction !== undefined){
let data4 = data3.direction;
if(!((((data4 === "ltr") || (data4 === "rtl")) || (data4 === "ttb")) || (data4 === "btt"))){
const err20 = {instancePath:instancePath+"/assertions/direction",schemaPath:"#/properties/assertions/properties/direction/enum",keyword:"enum",params:{allowedValues: schema289.properties.assertions.properties.direction.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data3.scalarCount !== undefined){
let data5 = data3.scalarCount;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err21 = {instancePath:instancePath+"/assertions/scalarCount",schemaPath:"#/properties/assertions/properties/scalarCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 1000000 || isNaN(data5)){
const err22 = {instancePath:instancePath+"/assertions/scalarCount",schemaPath:"#/properties/assertions/properties/scalarCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data5 < 0 || isNaN(data5)){
const err23 = {instancePath:instancePath+"/assertions/scalarCount",schemaPath:"#/properties/assertions/properties/scalarCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
if(data3.glyphCount !== undefined){
let data6 = data3.glyphCount;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err24 = {instancePath:instancePath+"/assertions/glyphCount",schemaPath:"#/properties/assertions/properties/glyphCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 > 1000000 || isNaN(data6)){
const err25 = {instancePath:instancePath+"/assertions/glyphCount",schemaPath:"#/properties/assertions/properties/glyphCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data6 < 0 || isNaN(data6)){
const err26 = {instancePath:instancePath+"/assertions/glyphCount",schemaPath:"#/properties/assertions/properties/glyphCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
if(data3.missingGlyphCount !== undefined){
let data7 = data3.missingGlyphCount;
if(!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))){
const err27 = {instancePath:instancePath+"/assertions/missingGlyphCount",schemaPath:"#/properties/assertions/properties/missingGlyphCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 1000000 || isNaN(data7)){
const err28 = {instancePath:instancePath+"/assertions/missingGlyphCount",schemaPath:"#/properties/assertions/properties/missingGlyphCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data7 < 0 || isNaN(data7)){
const err29 = {instancePath:instancePath+"/assertions/missingGlyphCount",schemaPath:"#/properties/assertions/properties/missingGlyphCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
if(data3.zeroAdvanceGlyphs !== undefined){
let data8 = data3.zeroAdvanceGlyphs;
if(!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))){
const err30 = {instancePath:instancePath+"/assertions/zeroAdvanceGlyphs",schemaPath:"#/properties/assertions/properties/zeroAdvanceGlyphs/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 1000000 || isNaN(data8)){
const err31 = {instancePath:instancePath+"/assertions/zeroAdvanceGlyphs",schemaPath:"#/properties/assertions/properties/zeroAdvanceGlyphs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data8 < 0 || isNaN(data8)){
const err32 = {instancePath:instancePath+"/assertions/zeroAdvanceGlyphs",schemaPath:"#/properties/assertions/properties/zeroAdvanceGlyphs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
}
if(data3.positionedGlyphs !== undefined){
let data9 = data3.positionedGlyphs;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err33 = {instancePath:instancePath+"/assertions/positionedGlyphs",schemaPath:"#/properties/assertions/properties/positionedGlyphs/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 > 1000000 || isNaN(data9)){
const err34 = {instancePath:instancePath+"/assertions/positionedGlyphs",schemaPath:"#/properties/assertions/properties/positionedGlyphs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data9 < 0 || isNaN(data9)){
const err35 = {instancePath:instancePath+"/assertions/positionedGlyphs",schemaPath:"#/properties/assertions/properties/positionedGlyphs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
}
}
else {
const err36 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
else {
const err37 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
validate208.errors = vErrors;
return errors === 0;
}
validate208.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema292 = {"type":"array","minItems":1,"maxItems":128,"items":{"$ref":"#/$defs/token"}};

function validate210(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate210.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(Array.isArray(data)){
if(data.length > 128){
const err0 = {instancePath,schemaPath:"#/maxItems",keyword:"maxItems",params:{limit: 128},message:"must NOT have more than 128 items"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.length < 1){
const err1 = {instancePath,schemaPath:"#/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
const len0 = data.length;
for(let i0=0; i0<len0; i0++){
let data0 = data[i0];
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err2 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(func3(data0) < 1){
const err3 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(!pattern130.test(data0)){
const err4 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9.-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9.-]*$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
validate210.errors = vErrors;
return errors === 0;
}
validate210.evaluated = {"items":true,"dynamicProps":false,"dynamicItems":false};


function validate205(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/text-shaping-registry.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate205.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.planSchema === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "planSchema"},message:"must have required property '"+"planSchema"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.model === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "model"},message:"must have required property '"+"model"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.referenceShaper === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "referenceShaper"},message:"must have required property '"+"referenceShaper"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.font === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "font"},message:"must have required property '"+"font"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.cases === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "cases"},message:"must have required property '"+"cases"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.scope === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "scope"},message:"must have required property '"+"scope"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema284.properties, key0))){
const err9 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/text-shaping-registry.schema.json" !== data.$schema){
const err10 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/text-shaping-registry.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-text-shaping-registry" !== data.format){
const err11 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-text-shaping-registry"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err12 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.planSchema !== undefined){
let data3 = data.planSchema;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.id === undefined){
const err13 = {instancePath:instancePath+"/planSchema",schemaPath:"#/properties/planSchema/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data3.source === undefined){
const err14 = {instancePath:instancePath+"/planSchema",schemaPath:"#/properties/planSchema/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data3.digest === undefined){
const err15 = {instancePath:instancePath+"/planSchema",schemaPath:"#/properties/planSchema/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
for(const key1 in data3){
if(!(((key1 === "id") || (key1 === "source")) || (key1 === "digest"))){
const err16 = {instancePath:instancePath+"/planSchema",schemaPath:"#/properties/planSchema/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data3.id !== undefined){
if("https://maipo.design/schema/0.1/text-shaping-plan.schema.json" !== data3.id){
const err17 = {instancePath:instancePath+"/planSchema/id",schemaPath:"#/properties/planSchema/properties/id/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/text-shaping-plan.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data3.source !== undefined){
if("schema/maipo-text-shaping-plan-0.1.schema.json" !== data3.source){
const err18 = {instancePath:instancePath+"/planSchema/source",schemaPath:"#/properties/planSchema/properties/source/const",keyword:"const",params:{allowedValue: "schema/maipo-text-shaping-plan-0.1.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data3.digest !== undefined){
let data6 = data3.digest;
if(typeof data6 === "string"){
if(!pattern9.test(data6)){
const err19 = {instancePath:instancePath+"/planSchema/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/planSchema/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath:instancePath+"/planSchema",schemaPath:"#/properties/planSchema/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.model !== undefined){
let data7 = data.model;
if(data7 && typeof data7 == "object" && !Array.isArray(data7)){
if(data7.id === undefined){
const err22 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data7.version === undefined){
const err23 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data7.coordinateSpace === undefined){
const err24 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "coordinateSpace"},message:"must have required property '"+"coordinateSpace"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data7.clusterUnit === undefined){
const err25 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "clusterUnit"},message:"must have required property '"+"clusterUnit"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data7.clusterLevel === undefined){
const err26 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "clusterLevel"},message:"must have required property '"+"clusterLevel"+"'"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(data7.runOrder === undefined){
const err27 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "runOrder"},message:"must have required property '"+"runOrder"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
for(const key2 in data7){
if(!((((((key2 === "id") || (key2 === "version")) || (key2 === "coordinateSpace")) || (key2 === "clusterUnit")) || (key2 === "clusterLevel")) || (key2 === "runOrder"))){
const err28 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data7.id !== undefined){
if("maipo-opentype-glyph-plan" !== data7.id){
const err29 = {instancePath:instancePath+"/model/id",schemaPath:"#/properties/model/properties/id/const",keyword:"const",params:{allowedValue: "maipo-opentype-glyph-plan"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data7.version !== undefined){
if("0.1" !== data7.version){
const err30 = {instancePath:instancePath+"/model/version",schemaPath:"#/properties/model/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data7.coordinateSpace !== undefined){
if("integer-font-units" !== data7.coordinateSpace){
const err31 = {instancePath:instancePath+"/model/coordinateSpace",schemaPath:"#/properties/model/properties/coordinateSpace/const",keyword:"const",params:{allowedValue: "integer-font-units"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data7.clusterUnit !== undefined){
if("unicode-scalar-index" !== data7.clusterUnit){
const err32 = {instancePath:instancePath+"/model/clusterUnit",schemaPath:"#/properties/model/properties/clusterUnit/const",keyword:"const",params:{allowedValue: "unicode-scalar-index"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data7.clusterLevel !== undefined){
if("monotone-graphemes" !== data7.clusterLevel){
const err33 = {instancePath:instancePath+"/model/clusterLevel",schemaPath:"#/properties/model/properties/clusterLevel/const",keyword:"const",params:{allowedValue: "monotone-graphemes"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data7.runOrder !== undefined){
if("visual-paint-order" !== data7.runOrder){
const err34 = {instancePath:instancePath+"/model/runOrder",schemaPath:"#/properties/model/properties/runOrder/const",keyword:"const",params:{allowedValue: "visual-paint-order"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
else {
const err35 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data.referenceShaper !== undefined){
let data14 = data.referenceShaper;
if(data14 && typeof data14 == "object" && !Array.isArray(data14)){
if(data14.package === undefined){
const err36 = {instancePath:instancePath+"/referenceShaper",schemaPath:"#/properties/referenceShaper/required",keyword:"required",params:{missingProperty: "package"},message:"must have required property '"+"package"+"'"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data14.version === undefined){
const err37 = {instancePath:instancePath+"/referenceShaper",schemaPath:"#/properties/referenceShaper/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(data14.engine === undefined){
const err38 = {instancePath:instancePath+"/referenceShaper",schemaPath:"#/properties/referenceShaper/required",keyword:"required",params:{missingProperty: "engine"},message:"must have required property '"+"engine"+"'"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if(data14.engineVersion === undefined){
const err39 = {instancePath:instancePath+"/referenceShaper",schemaPath:"#/properties/referenceShaper/required",keyword:"required",params:{missingProperty: "engineVersion"},message:"must have required property '"+"engineVersion"+"'"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data14.implementation === undefined){
const err40 = {instancePath:instancePath+"/referenceShaper",schemaPath:"#/properties/referenceShaper/required",keyword:"required",params:{missingProperty: "implementation"},message:"must have required property '"+"implementation"+"'"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if(data14.implementationVersion === undefined){
const err41 = {instancePath:instancePath+"/referenceShaper",schemaPath:"#/properties/referenceShaper/required",keyword:"required",params:{missingProperty: "implementationVersion"},message:"must have required property '"+"implementationVersion"+"'"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data14.wasmDigest === undefined){
const err42 = {instancePath:instancePath+"/referenceShaper",schemaPath:"#/properties/referenceShaper/required",keyword:"required",params:{missingProperty: "wasmDigest"},message:"must have required property '"+"wasmDigest"+"'"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
for(const key3 in data14){
if(!(((((((key3 === "package") || (key3 === "version")) || (key3 === "engine")) || (key3 === "engineVersion")) || (key3 === "implementation")) || (key3 === "implementationVersion")) || (key3 === "wasmDigest"))){
const err43 = {instancePath:instancePath+"/referenceShaper",schemaPath:"#/properties/referenceShaper/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data14.package !== undefined){
if("@maipo/text-shaping" !== data14.package){
const err44 = {instancePath:instancePath+"/referenceShaper/package",schemaPath:"#/properties/referenceShaper/properties/package/const",keyword:"const",params:{allowedValue: "@maipo/text-shaping"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
if(data14.version !== undefined){
if("0.1.0" !== data14.version){
const err45 = {instancePath:instancePath+"/referenceShaper/version",schemaPath:"#/properties/referenceShaper/properties/version/const",keyword:"const",params:{allowedValue: "0.1.0"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data14.engine !== undefined){
if("harfbuzz" !== data14.engine){
const err46 = {instancePath:instancePath+"/referenceShaper/engine",schemaPath:"#/properties/referenceShaper/properties/engine/const",keyword:"const",params:{allowedValue: "harfbuzz"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
if(data14.engineVersion !== undefined){
let data18 = data14.engineVersion;
if(typeof data18 === "string"){
if(!pattern124.test(data18)){
const err47 = {instancePath:instancePath+"/referenceShaper/engineVersion",schemaPath:"#/properties/referenceShaper/properties/engineVersion/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+\\.[0-9]+$"+"\""};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
else {
const err48 = {instancePath:instancePath+"/referenceShaper/engineVersion",schemaPath:"#/properties/referenceShaper/properties/engineVersion/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
if(data14.implementation !== undefined){
if("harfbuzzjs" !== data14.implementation){
const err49 = {instancePath:instancePath+"/referenceShaper/implementation",schemaPath:"#/properties/referenceShaper/properties/implementation/const",keyword:"const",params:{allowedValue: "harfbuzzjs"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
if(data14.implementationVersion !== undefined){
let data20 = data14.implementationVersion;
if(typeof data20 === "string"){
if(!pattern124.test(data20)){
const err50 = {instancePath:instancePath+"/referenceShaper/implementationVersion",schemaPath:"#/properties/referenceShaper/properties/implementationVersion/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+\\.[0-9]+$"+"\""};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
else {
const err51 = {instancePath:instancePath+"/referenceShaper/implementationVersion",schemaPath:"#/properties/referenceShaper/properties/implementationVersion/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data14.wasmDigest !== undefined){
let data21 = data14.wasmDigest;
if(typeof data21 === "string"){
if(!pattern9.test(data21)){
const err52 = {instancePath:instancePath+"/referenceShaper/wasmDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
else {
const err53 = {instancePath:instancePath+"/referenceShaper/wasmDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
}
else {
const err54 = {instancePath:instancePath+"/referenceShaper",schemaPath:"#/properties/referenceShaper/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
if(data.font !== undefined){
if(!(validate206(data.font, {instancePath:instancePath+"/font",parentData:data,parentDataProperty:"font",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate206.errors : vErrors.concat(validate206.errors);
errors = vErrors.length;
}
}
if(data.cases !== undefined){
let data23 = data.cases;
if(Array.isArray(data23)){
if(data23.length > 1024){
const err55 = {instancePath:instancePath+"/cases",schemaPath:"#/properties/cases/maxItems",keyword:"maxItems",params:{limit: 1024},message:"must NOT have more than 1024 items"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
if(data23.length < 1){
const err56 = {instancePath:instancePath+"/cases",schemaPath:"#/properties/cases/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
const len0 = data23.length;
for(let i0=0; i0<len0; i0++){
if(!(validate208(data23[i0], {instancePath:instancePath+"/cases/" + i0,parentData:data23,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate208.errors : vErrors.concat(validate208.errors);
errors = vErrors.length;
}
}
}
else {
const err57 = {instancePath:instancePath+"/cases",schemaPath:"#/properties/cases/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
if(data.scope !== undefined){
let data25 = data.scope;
if(data25 && typeof data25 == "object" && !Array.isArray(data25)){
if(data25.verified === undefined){
const err58 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/required",keyword:"required",params:{missingProperty: "verified"},message:"must have required property '"+"verified"+"'"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
if(data25.notYetDefined === undefined){
const err59 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/required",keyword:"required",params:{missingProperty: "notYetDefined"},message:"must have required property '"+"notYetDefined"+"'"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
for(const key4 in data25){
if(!((key4 === "verified") || (key4 === "notYetDefined"))){
const err60 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key4},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
if(data25.verified !== undefined){
if(!(validate210(data25.verified, {instancePath:instancePath+"/scope/verified",parentData:data25,parentDataProperty:"verified",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate210.errors : vErrors.concat(validate210.errors);
errors = vErrors.length;
}
}
if(data25.notYetDefined !== undefined){
if(!(validate210(data25.notYetDefined, {instancePath:instancePath+"/scope/notYetDefined",parentData:data25,parentDataProperty:"notYetDefined",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate210.errors : vErrors.concat(validate210.errors);
errors = vErrors.length;
}
}
}
else {
const err61 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
}
}
else {
const err62 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
validate205.errors = vErrors;
return errors === 0;
}
validate205.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateGlyphOutlineProjectionSchema = validate213;
const schema294 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/glyph-outline-projection.schema.json","title":"Maipo glyph outline projection 0.1","description":"Backend-neutral OpenType glyph outlines derived from a content-addressed Maipo text shaping plan and exact font bytes.","type":"object","additionalProperties":false,"required":["$schema","format","version","planDigest","fontDigest","unitsPerEm","model","bounds","runs"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/glyph-outline-projection.schema.json"},"format":{"const":"maipo-glyph-outline-projection"},"version":{"const":"0.1"},"planDigest":{"$ref":"#/$defs/digest"},"fontDigest":{"$ref":"#/$defs/digest"},"unitsPerEm":{"type":"integer","minimum":16,"maximum":16384},"model":{"type":"object","additionalProperties":false,"required":["id","version","coordinateSpace","pathModel"],"properties":{"id":{"const":"maipo-opentype-outline-projection"},"version":{"const":"0.1"},"coordinateSpace":{"const":"font-units-y-up"},"pathModel":{"const":"absolute-m-l-q-c-z"}}},"bounds":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/bounds"}]},"runs":{"type":"array","maxItems":100000,"items":{"$ref":"#/$defs/run"}}},"$defs":{"id":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"finite":{"type":"number","minimum":-1000000000,"maximum":1000000000},"scalarIndex":{"type":"integer","minimum":0,"maximum":1000000},"point":{"type":"object","additionalProperties":false,"required":["x","y"],"properties":{"x":{"$ref":"#/$defs/finite"},"y":{"$ref":"#/$defs/finite"}}},"bounds":{"type":"object","additionalProperties":false,"required":["xMin","yMin","xMax","yMax"],"properties":{"xMin":{"$ref":"#/$defs/finite"},"yMin":{"$ref":"#/$defs/finite"},"xMax":{"$ref":"#/$defs/finite"},"yMax":{"$ref":"#/$defs/finite"}}},"move":{"type":"object","additionalProperties":false,"required":["op","values"],"properties":{"op":{"const":"M"},"values":{"type":"array","minItems":2,"maxItems":2,"items":{"$ref":"#/$defs/finite"}}}},"line":{"type":"object","additionalProperties":false,"required":["op","values"],"properties":{"op":{"const":"L"},"values":{"type":"array","minItems":2,"maxItems":2,"items":{"$ref":"#/$defs/finite"}}}},"quadratic":{"type":"object","additionalProperties":false,"required":["op","values"],"properties":{"op":{"const":"Q"},"values":{"type":"array","minItems":4,"maxItems":4,"items":{"$ref":"#/$defs/finite"}}}},"cubic":{"type":"object","additionalProperties":false,"required":["op","values"],"properties":{"op":{"const":"C"},"values":{"type":"array","minItems":6,"maxItems":6,"items":{"$ref":"#/$defs/finite"}}}},"close":{"type":"object","additionalProperties":false,"required":["op","values"],"properties":{"op":{"const":"Z"},"values":{"type":"array","maxItems":0}}},"command":{"oneOf":[{"$ref":"#/$defs/move"},{"$ref":"#/$defs/line"},{"$ref":"#/$defs/quadratic"},{"$ref":"#/$defs/cubic"},{"$ref":"#/$defs/close"}]},"glyph":{"type":"object","additionalProperties":false,"required":["glyphId","cluster","origin","bounds","path"],"properties":{"glyphId":{"type":"integer","minimum":0,"maximum":4294967295},"cluster":{"$ref":"#/$defs/scalarIndex"},"origin":{"$ref":"#/$defs/point"},"bounds":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/bounds"}]},"path":{"type":"array","maxItems":1000000,"items":{"$ref":"#/$defs/command"}}}},"run":{"type":"object","additionalProperties":false,"required":["runId","glyphs"],"properties":{"runId":{"$ref":"#/$defs/id"},"glyphs":{"type":"array","maxItems":1000000,"items":{"$ref":"#/$defs/glyph"}}}}}};
const schema295 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};
const schema297 = {"type":"object","additionalProperties":false,"required":["xMin","yMin","xMax","yMax"],"properties":{"xMin":{"$ref":"#/$defs/finite"},"yMin":{"$ref":"#/$defs/finite"},"xMax":{"$ref":"#/$defs/finite"},"yMax":{"$ref":"#/$defs/finite"}}};
const schema298 = {"type":"number","minimum":-1000000000,"maximum":1000000000};

function validate214(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate214.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.xMin === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "xMin"},message:"must have required property '"+"xMin"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.yMin === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "yMin"},message:"must have required property '"+"yMin"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.xMax === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "xMax"},message:"must have required property '"+"xMax"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.yMax === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "yMax"},message:"must have required property '"+"yMax"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "xMin") || (key0 === "yMin")) || (key0 === "xMax")) || (key0 === "yMax"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.xMin !== undefined){
let data0 = data.xMin;
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 1000000000 || isNaN(data0)){
const err5 = {instancePath:instancePath+"/xMin",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data0 < -1000000000 || isNaN(data0)){
const err6 = {instancePath:instancePath+"/xMin",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/xMin",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.yMin !== undefined){
let data1 = data.yMin;
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 1000000000 || isNaN(data1)){
const err8 = {instancePath:instancePath+"/yMin",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data1 < -1000000000 || isNaN(data1)){
const err9 = {instancePath:instancePath+"/yMin",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/yMin",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.xMax !== undefined){
let data2 = data.xMax;
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000000000 || isNaN(data2)){
const err11 = {instancePath:instancePath+"/xMax",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data2 < -1000000000 || isNaN(data2)){
const err12 = {instancePath:instancePath+"/xMax",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/xMax",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.yMax !== undefined){
let data3 = data.yMax;
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 1000000000 || isNaN(data3)){
const err14 = {instancePath:instancePath+"/yMax",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data3 < -1000000000 || isNaN(data3)){
const err15 = {instancePath:instancePath+"/yMax",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/yMax",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate214.errors = vErrors;
return errors === 0;
}
validate214.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema302 = {"type":"object","additionalProperties":false,"required":["runId","glyphs"],"properties":{"runId":{"$ref":"#/$defs/id"},"glyphs":{"type":"array","maxItems":1000000,"items":{"$ref":"#/$defs/glyph"}}}};
const schema303 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const schema304 = {"type":"object","additionalProperties":false,"required":["glyphId","cluster","origin","bounds","path"],"properties":{"glyphId":{"type":"integer","minimum":0,"maximum":4294967295},"cluster":{"$ref":"#/$defs/scalarIndex"},"origin":{"$ref":"#/$defs/point"},"bounds":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/bounds"}]},"path":{"type":"array","maxItems":1000000,"items":{"$ref":"#/$defs/command"}}}};
const schema305 = {"type":"integer","minimum":0,"maximum":1000000};
const schema306 = {"type":"object","additionalProperties":false,"required":["x","y"],"properties":{"x":{"$ref":"#/$defs/finite"},"y":{"$ref":"#/$defs/finite"}}};

function validate218(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate218.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.x === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.y === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "x") || (key0 === "y"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.x !== undefined){
let data0 = data.x;
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 1000000000 || isNaN(data0)){
const err3 = {instancePath:instancePath+"/x",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data0 < -1000000000 || isNaN(data0)){
const err4 = {instancePath:instancePath+"/x",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/x",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.y !== undefined){
let data1 = data.y;
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 1000000000 || isNaN(data1)){
const err6 = {instancePath:instancePath+"/y",schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data1 < -1000000000 || isNaN(data1)){
const err7 = {instancePath:instancePath+"/y",schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/y",schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate218.errors = vErrors;
return errors === 0;
}
validate218.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema309 = {"oneOf":[{"$ref":"#/$defs/move"},{"$ref":"#/$defs/line"},{"$ref":"#/$defs/quadratic"},{"$ref":"#/$defs/cubic"},{"$ref":"#/$defs/close"}]};
const schema318 = {"type":"object","additionalProperties":false,"required":["op","values"],"properties":{"op":{"const":"Z"},"values":{"type":"array","maxItems":0}}};
const schema310 = {"type":"object","additionalProperties":false,"required":["op","values"],"properties":{"op":{"const":"M"},"values":{"type":"array","minItems":2,"maxItems":2,"items":{"$ref":"#/$defs/finite"}}}};

function validate222(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate222.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.op === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "op"},message:"must have required property '"+"op"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.values === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "values"},message:"must have required property '"+"values"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "op") || (key0 === "values"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.op !== undefined){
if("M" !== data.op){
const err3 = {instancePath:instancePath+"/op",schemaPath:"#/properties/op/const",keyword:"const",params:{allowedValue: "M"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.values !== undefined){
let data1 = data.values;
if(Array.isArray(data1)){
if(data1.length > 2){
const err4 = {instancePath:instancePath+"/values",schemaPath:"#/properties/values/maxItems",keyword:"maxItems",params:{limit: 2},message:"must NOT have more than 2 items"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data1.length < 2){
const err5 = {instancePath:instancePath+"/values",schemaPath:"#/properties/values/minItems",keyword:"minItems",params:{limit: 2},message:"must NOT have fewer than 2 items"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000000000 || isNaN(data2)){
const err6 = {instancePath:instancePath+"/values/" + i0,schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2 < -1000000000 || isNaN(data2)){
const err7 = {instancePath:instancePath+"/values/" + i0,schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/values/" + i0,schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath:instancePath+"/values",schemaPath:"#/properties/values/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
validate222.errors = vErrors;
return errors === 0;
}
validate222.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema312 = {"type":"object","additionalProperties":false,"required":["op","values"],"properties":{"op":{"const":"L"},"values":{"type":"array","minItems":2,"maxItems":2,"items":{"$ref":"#/$defs/finite"}}}};

function validate224(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate224.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.op === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "op"},message:"must have required property '"+"op"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.values === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "values"},message:"must have required property '"+"values"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "op") || (key0 === "values"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.op !== undefined){
if("L" !== data.op){
const err3 = {instancePath:instancePath+"/op",schemaPath:"#/properties/op/const",keyword:"const",params:{allowedValue: "L"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.values !== undefined){
let data1 = data.values;
if(Array.isArray(data1)){
if(data1.length > 2){
const err4 = {instancePath:instancePath+"/values",schemaPath:"#/properties/values/maxItems",keyword:"maxItems",params:{limit: 2},message:"must NOT have more than 2 items"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data1.length < 2){
const err5 = {instancePath:instancePath+"/values",schemaPath:"#/properties/values/minItems",keyword:"minItems",params:{limit: 2},message:"must NOT have fewer than 2 items"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000000000 || isNaN(data2)){
const err6 = {instancePath:instancePath+"/values/" + i0,schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2 < -1000000000 || isNaN(data2)){
const err7 = {instancePath:instancePath+"/values/" + i0,schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/values/" + i0,schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath:instancePath+"/values",schemaPath:"#/properties/values/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
validate224.errors = vErrors;
return errors === 0;
}
validate224.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema314 = {"type":"object","additionalProperties":false,"required":["op","values"],"properties":{"op":{"const":"Q"},"values":{"type":"array","minItems":4,"maxItems":4,"items":{"$ref":"#/$defs/finite"}}}};

function validate226(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate226.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.op === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "op"},message:"must have required property '"+"op"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.values === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "values"},message:"must have required property '"+"values"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "op") || (key0 === "values"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.op !== undefined){
if("Q" !== data.op){
const err3 = {instancePath:instancePath+"/op",schemaPath:"#/properties/op/const",keyword:"const",params:{allowedValue: "Q"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.values !== undefined){
let data1 = data.values;
if(Array.isArray(data1)){
if(data1.length > 4){
const err4 = {instancePath:instancePath+"/values",schemaPath:"#/properties/values/maxItems",keyword:"maxItems",params:{limit: 4},message:"must NOT have more than 4 items"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data1.length < 4){
const err5 = {instancePath:instancePath+"/values",schemaPath:"#/properties/values/minItems",keyword:"minItems",params:{limit: 4},message:"must NOT have fewer than 4 items"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000000000 || isNaN(data2)){
const err6 = {instancePath:instancePath+"/values/" + i0,schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2 < -1000000000 || isNaN(data2)){
const err7 = {instancePath:instancePath+"/values/" + i0,schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/values/" + i0,schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath:instancePath+"/values",schemaPath:"#/properties/values/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
validate226.errors = vErrors;
return errors === 0;
}
validate226.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema316 = {"type":"object","additionalProperties":false,"required":["op","values"],"properties":{"op":{"const":"C"},"values":{"type":"array","minItems":6,"maxItems":6,"items":{"$ref":"#/$defs/finite"}}}};

function validate228(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate228.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.op === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "op"},message:"must have required property '"+"op"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.values === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "values"},message:"must have required property '"+"values"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "op") || (key0 === "values"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.op !== undefined){
if("C" !== data.op){
const err3 = {instancePath:instancePath+"/op",schemaPath:"#/properties/op/const",keyword:"const",params:{allowedValue: "C"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.values !== undefined){
let data1 = data.values;
if(Array.isArray(data1)){
if(data1.length > 6){
const err4 = {instancePath:instancePath+"/values",schemaPath:"#/properties/values/maxItems",keyword:"maxItems",params:{limit: 6},message:"must NOT have more than 6 items"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data1.length < 6){
const err5 = {instancePath:instancePath+"/values",schemaPath:"#/properties/values/minItems",keyword:"minItems",params:{limit: 6},message:"must NOT have fewer than 6 items"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000000000 || isNaN(data2)){
const err6 = {instancePath:instancePath+"/values/" + i0,schemaPath:"#/$defs/finite/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2 < -1000000000 || isNaN(data2)){
const err7 = {instancePath:instancePath+"/values/" + i0,schemaPath:"#/$defs/finite/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/values/" + i0,schemaPath:"#/$defs/finite/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath:instancePath+"/values",schemaPath:"#/properties/values/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
validate228.errors = vErrors;
return errors === 0;
}
validate228.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate221(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate221.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate222(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate222.errors : vErrors.concat(validate222.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate224(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate224.errors : vErrors.concat(validate224.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
const _errs3 = errors;
if(!(validate226(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate226.errors : vErrors.concat(validate226.errors);
errors = vErrors.length;
}
var _valid0 = _errs3 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
if(props0 !== true){
props0 = true;
}
}
const _errs4 = errors;
if(!(validate228(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate228.errors : vErrors.concat(validate228.errors);
errors = vErrors.length;
}
var _valid0 = _errs4 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 3];
}
else {
if(_valid0){
valid0 = true;
passing0 = 3;
if(props0 !== true){
props0 = true;
}
}
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.op === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/close/required",keyword:"required",params:{missingProperty: "op"},message:"must have required property '"+"op"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.values === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/close/required",keyword:"required",params:{missingProperty: "values"},message:"must have required property '"+"values"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "op") || (key0 === "values"))){
const err2 = {instancePath,schemaPath:"#/$defs/close/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.op !== undefined){
if("Z" !== data.op){
const err3 = {instancePath:instancePath+"/op",schemaPath:"#/$defs/close/properties/op/const",keyword:"const",params:{allowedValue: "Z"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.values !== undefined){
let data1 = data.values;
if(Array.isArray(data1)){
if(data1.length > 0){
const err4 = {instancePath:instancePath+"/values",schemaPath:"#/$defs/close/properties/values/maxItems",keyword:"maxItems",params:{limit: 0},message:"must NOT have more than 0 items"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/values",schemaPath:"#/$defs/close/properties/values/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/$defs/close/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
var _valid0 = _errs5 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 4];
}
else {
if(_valid0){
valid0 = true;
passing0 = 4;
if(props0 !== true){
props0 = true;
}
}
}
}
}
}
if(!valid0){
const err7 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate221.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate221.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate217(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate217.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.glyphId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "glyphId"},message:"must have required property '"+"glyphId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.cluster === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "cluster"},message:"must have required property '"+"cluster"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.origin === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "origin"},message:"must have required property '"+"origin"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.bounds === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bounds"},message:"must have required property '"+"bounds"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.path === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "path"},message:"must have required property '"+"path"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "glyphId") || (key0 === "cluster")) || (key0 === "origin")) || (key0 === "bounds")) || (key0 === "path"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.glyphId !== undefined){
let data0 = data.glyphId;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err6 = {instancePath:instancePath+"/glyphId",schemaPath:"#/properties/glyphId/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 4294967295 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/glyphId",schemaPath:"#/properties/glyphId/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4294967295},message:"must be <= 4294967295"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data0 < 0 || isNaN(data0)){
const err8 = {instancePath:instancePath+"/glyphId",schemaPath:"#/properties/glyphId/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
if(data.cluster !== undefined){
let data1 = data.cluster;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err9 = {instancePath:instancePath+"/cluster",schemaPath:"#/$defs/scalarIndex/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 1000000 || isNaN(data1)){
const err10 = {instancePath:instancePath+"/cluster",schemaPath:"#/$defs/scalarIndex/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data1 < 0 || isNaN(data1)){
const err11 = {instancePath:instancePath+"/cluster",schemaPath:"#/$defs/scalarIndex/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
if(data.origin !== undefined){
if(!(validate218(data.origin, {instancePath:instancePath+"/origin",parentData:data,parentDataProperty:"origin",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate218.errors : vErrors.concat(validate218.errors);
errors = vErrors.length;
}
}
if(data.bounds !== undefined){
let data3 = data.bounds;
const _errs9 = errors;
let valid2 = false;
let passing0 = null;
const _errs10 = errors;
if(data3 !== null){
const err12 = {instancePath:instancePath+"/bounds",schemaPath:"#/properties/bounds/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
var _valid0 = _errs10 === errors;
if(_valid0){
valid2 = true;
passing0 = 0;
}
const _errs12 = errors;
if(!(validate214(data3, {instancePath:instancePath+"/bounds",parentData:data,parentDataProperty:"bounds",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate214.errors : vErrors.concat(validate214.errors);
errors = vErrors.length;
}
var _valid0 = _errs12 === errors;
if(_valid0 && valid2){
valid2 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid2 = true;
passing0 = 1;
}
}
if(!valid2){
const err13 = {instancePath:instancePath+"/bounds",schemaPath:"#/properties/bounds/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
else {
errors = _errs9;
if(vErrors !== null){
if(_errs9){
vErrors.length = _errs9;
}
else {
vErrors = null;
}
}
}
}
if(data.path !== undefined){
let data4 = data.path;
if(Array.isArray(data4)){
if(data4.length > 1000000){
const err14 = {instancePath:instancePath+"/path",schemaPath:"#/properties/path/maxItems",keyword:"maxItems",params:{limit: 1000000},message:"must NOT have more than 1000000 items"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
const len0 = data4.length;
for(let i0=0; i0<len0; i0++){
if(!(validate221(data4[i0], {instancePath:instancePath+"/path/" + i0,parentData:data4,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate221.errors : vErrors.concat(validate221.errors);
errors = vErrors.length;
}
}
}
else {
const err15 = {instancePath:instancePath+"/path",schemaPath:"#/properties/path/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate217.errors = vErrors;
return errors === 0;
}
validate217.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate216(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate216.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.runId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "runId"},message:"must have required property '"+"runId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.glyphs === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "glyphs"},message:"must have required property '"+"glyphs"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "runId") || (key0 === "glyphs"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.runId !== undefined){
let data0 = data.runId;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err3 = {instancePath:instancePath+"/runId",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func3(data0) < 1){
const err4 = {instancePath:instancePath+"/runId",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern4.test(data0)){
const err5 = {instancePath:instancePath+"/runId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/runId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.glyphs !== undefined){
let data1 = data.glyphs;
if(Array.isArray(data1)){
if(data1.length > 1000000){
const err7 = {instancePath:instancePath+"/glyphs",schemaPath:"#/properties/glyphs/maxItems",keyword:"maxItems",params:{limit: 1000000},message:"must NOT have more than 1000000 items"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
if(!(validate217(data1[i0], {instancePath:instancePath+"/glyphs/" + i0,parentData:data1,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate217.errors : vErrors.concat(validate217.errors);
errors = vErrors.length;
}
}
}
else {
const err8 = {instancePath:instancePath+"/glyphs",schemaPath:"#/properties/glyphs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate216.errors = vErrors;
return errors === 0;
}
validate216.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate213(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/glyph-outline-projection.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate213.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.planDigest === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "planDigest"},message:"must have required property '"+"planDigest"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.fontDigest === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fontDigest"},message:"must have required property '"+"fontDigest"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.unitsPerEm === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "unitsPerEm"},message:"must have required property '"+"unitsPerEm"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.model === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "model"},message:"must have required property '"+"model"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.bounds === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bounds"},message:"must have required property '"+"bounds"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.runs === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "runs"},message:"must have required property '"+"runs"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema294.properties, key0))){
const err9 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/glyph-outline-projection.schema.json" !== data.$schema){
const err10 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/glyph-outline-projection.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-glyph-outline-projection" !== data.format){
const err11 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-glyph-outline-projection"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err12 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.planDigest !== undefined){
let data3 = data.planDigest;
if(typeof data3 === "string"){
if(!pattern9.test(data3)){
const err13 = {instancePath:instancePath+"/planDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/planDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.fontDigest !== undefined){
let data4 = data.fontDigest;
if(typeof data4 === "string"){
if(!pattern9.test(data4)){
const err15 = {instancePath:instancePath+"/fontDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/fontDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.unitsPerEm !== undefined){
let data5 = data.unitsPerEm;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err17 = {instancePath:instancePath+"/unitsPerEm",schemaPath:"#/properties/unitsPerEm/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 16384 || isNaN(data5)){
const err18 = {instancePath:instancePath+"/unitsPerEm",schemaPath:"#/properties/unitsPerEm/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16384},message:"must be <= 16384"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data5 < 16 || isNaN(data5)){
const err19 = {instancePath:instancePath+"/unitsPerEm",schemaPath:"#/properties/unitsPerEm/minimum",keyword:"minimum",params:{comparison: ">=", limit: 16},message:"must be >= 16"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
if(data.model !== undefined){
let data6 = data.model;
if(data6 && typeof data6 == "object" && !Array.isArray(data6)){
if(data6.id === undefined){
const err20 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data6.version === undefined){
const err21 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data6.coordinateSpace === undefined){
const err22 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "coordinateSpace"},message:"must have required property '"+"coordinateSpace"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data6.pathModel === undefined){
const err23 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "pathModel"},message:"must have required property '"+"pathModel"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
for(const key1 in data6){
if(!((((key1 === "id") || (key1 === "version")) || (key1 === "coordinateSpace")) || (key1 === "pathModel"))){
const err24 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data6.id !== undefined){
if("maipo-opentype-outline-projection" !== data6.id){
const err25 = {instancePath:instancePath+"/model/id",schemaPath:"#/properties/model/properties/id/const",keyword:"const",params:{allowedValue: "maipo-opentype-outline-projection"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data6.version !== undefined){
if("0.1" !== data6.version){
const err26 = {instancePath:instancePath+"/model/version",schemaPath:"#/properties/model/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data6.coordinateSpace !== undefined){
if("font-units-y-up" !== data6.coordinateSpace){
const err27 = {instancePath:instancePath+"/model/coordinateSpace",schemaPath:"#/properties/model/properties/coordinateSpace/const",keyword:"const",params:{allowedValue: "font-units-y-up"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data6.pathModel !== undefined){
if("absolute-m-l-q-c-z" !== data6.pathModel){
const err28 = {instancePath:instancePath+"/model/pathModel",schemaPath:"#/properties/model/properties/pathModel/const",keyword:"const",params:{allowedValue: "absolute-m-l-q-c-z"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
}
else {
const err29 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.bounds !== undefined){
let data11 = data.bounds;
const _errs21 = errors;
let valid4 = false;
let passing0 = null;
const _errs22 = errors;
if(data11 !== null){
const err30 = {instancePath:instancePath+"/bounds",schemaPath:"#/properties/bounds/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
var _valid0 = _errs22 === errors;
if(_valid0){
valid4 = true;
passing0 = 0;
}
const _errs24 = errors;
if(!(validate214(data11, {instancePath:instancePath+"/bounds",parentData:data,parentDataProperty:"bounds",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate214.errors : vErrors.concat(validate214.errors);
errors = vErrors.length;
}
var _valid0 = _errs24 === errors;
if(_valid0 && valid4){
valid4 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid4 = true;
passing0 = 1;
}
}
if(!valid4){
const err31 = {instancePath:instancePath+"/bounds",schemaPath:"#/properties/bounds/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
else {
errors = _errs21;
if(vErrors !== null){
if(_errs21){
vErrors.length = _errs21;
}
else {
vErrors = null;
}
}
}
}
if(data.runs !== undefined){
let data12 = data.runs;
if(Array.isArray(data12)){
if(data12.length > 100000){
const err32 = {instancePath:instancePath+"/runs",schemaPath:"#/properties/runs/maxItems",keyword:"maxItems",params:{limit: 100000},message:"must NOT have more than 100000 items"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
const len0 = data12.length;
for(let i0=0; i0<len0; i0++){
if(!(validate216(data12[i0], {instancePath:instancePath+"/runs/" + i0,parentData:data12,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate216.errors : vErrors.concat(validate216.errors);
errors = vErrors.length;
}
}
}
else {
const err33 = {instancePath:instancePath+"/runs",schemaPath:"#/properties/runs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
else {
const err34 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
validate213.errors = vErrors;
return errors === 0;
}
validate213.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateGlyphOutlineRegistrySchema = validate233;
const schema319 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/glyph-outline-registry.schema.json","title":"Maipo glyph outline conformance registry 0.1","type":"object","additionalProperties":false,"required":["$schema","format","version","projectionSchema","shapingRegistry","model","referenceProjector","font","cases","scope"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/glyph-outline-registry.schema.json"},"format":{"const":"maipo-glyph-outline-registry"},"version":{"const":"0.1"},"projectionSchema":{"$ref":"#/$defs/resource"},"shapingRegistry":{"$ref":"#/$defs/sourceResource"},"model":{"type":"object","additionalProperties":false,"required":["id","version","coordinateSpace","pathModel","boundsMeaning","runOrder","svgProjection"],"properties":{"id":{"const":"maipo-opentype-outline-projection"},"version":{"const":"0.1"},"coordinateSpace":{"const":"font-units-y-up"},"pathModel":{"const":"absolute-m-l-q-c-z"},"boundsMeaning":{"const":"opentype-outline-extents-union"},"runOrder":{"const":"shaping-plan-order"},"svgProjection":{"const":"svg-2-paths-y-axis-flip"}}},"referenceProjector":{"type":"object","additionalProperties":false,"required":["package","version","engine","engineVersion","implementation","implementationVersion","wasmDigest"],"properties":{"package":{"const":"@maipo/glyph-outlines"},"version":{"const":"0.1.0"},"engine":{"const":"harfbuzz"},"engineVersion":{"type":"string","pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+$"},"implementation":{"const":"harfbuzzjs"},"implementationVersion":{"type":"string","pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+$"},"wasmDigest":{"$ref":"#/$defs/digest"}}},"font":{"$ref":"#/$defs/font"},"cases":{"type":"array","minItems":1,"maxItems":1024,"items":{"$ref":"#/$defs/case"}},"scope":{"type":"object","additionalProperties":false,"required":["verified","notYetDefined"],"properties":{"verified":{"$ref":"#/$defs/uniqueTokens"},"notYetDefined":{"$ref":"#/$defs/uniqueTokens"}}}},"$defs":{"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"token":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9.-]*$"},"uniqueTokens":{"type":"array","minItems":1,"maxItems":128,"items":{"$ref":"#/$defs/token"}},"sourceResource":{"type":"object","additionalProperties":false,"required":["source","digest"],"properties":{"source":{"type":"string","minLength":1,"maxLength":256,"pattern":"^[A-Za-z0-9._/-]+$"},"digest":{"$ref":"#/$defs/digest"}}},"resource":{"type":"object","additionalProperties":false,"required":["id","source","digest"],"properties":{"id":{"const":"https://maipo.design/schema/0.1/glyph-outline-projection.schema.json"},"source":{"const":"schema/maipo-glyph-outline-projection-0.1.schema.json"},"digest":{"$ref":"#/$defs/digest"}}},"bounds":{"type":"object","additionalProperties":false,"required":["xMin","yMin","xMax","yMax"],"properties":{"xMin":{"type":"number","minimum":-1000000000,"maximum":1000000000},"yMin":{"type":"number","minimum":-1000000000,"maximum":1000000000},"xMax":{"type":"number","minimum":-1000000000,"maximum":1000000000},"yMax":{"type":"number","minimum":-1000000000,"maximum":1000000000}}},"font":{"type":"object","additionalProperties":false,"required":["source","license","mediaType","byteLength","digest"],"properties":{"source":{"type":"string","pattern":"^fixtures/fonts/[A-Za-z0-9._-]+\\.(?:ttf|otf|woff2?)$"},"license":{"type":"string","pattern":"^fixtures/fonts/[A-Za-z0-9._-]+\\.txt$"},"mediaType":{"enum":["font/ttf","font/otf","font/woff","font/woff2"]},"byteLength":{"type":"integer","minimum":1,"maximum":67108864},"digest":{"$ref":"#/$defs/digest"}}},"case":{"type":"object","additionalProperties":false,"required":["id","plan","projection","svg","planDigest","projectionDigest","svgDigest","assertions"],"properties":{"id":{"$ref":"#/$defs/token"},"plan":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.plan\\.json$"},"projection":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.outlines\\.json$"},"svg":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.outlines\\.svg$"},"planDigest":{"$ref":"#/$defs/digest"},"projectionDigest":{"$ref":"#/$defs/digest"},"svgDigest":{"$ref":"#/$defs/digest"},"assertions":{"type":"object","additionalProperties":false,"required":["runCount","glyphCount","outlineGlyphCount","pathCommandCount","bounds"],"properties":{"runCount":{"type":"integer","minimum":0,"maximum":100000},"glyphCount":{"type":"integer","minimum":0,"maximum":1000000},"outlineGlyphCount":{"type":"integer","minimum":0,"maximum":1000000},"pathCommandCount":{"type":"integer","minimum":0,"maximum":100000000},"bounds":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/bounds"}]}}}}}}};
const schema321 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};
const schema320 = {"type":"object","additionalProperties":false,"required":["id","source","digest"],"properties":{"id":{"const":"https://maipo.design/schema/0.1/glyph-outline-projection.schema.json"},"source":{"const":"schema/maipo-glyph-outline-projection-0.1.schema.json"},"digest":{"$ref":"#/$defs/digest"}}};

function validate234(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate234.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.source === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.digest === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "id") || (key0 === "source")) || (key0 === "digest"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
if("https://maipo.design/schema/0.1/glyph-outline-projection.schema.json" !== data.id){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/glyph-outline-projection.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.source !== undefined){
if("schema/maipo-glyph-outline-projection-0.1.schema.json" !== data.source){
const err5 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/const",keyword:"const",params:{allowedValue: "schema/maipo-glyph-outline-projection-0.1.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.digest !== undefined){
let data2 = data.digest;
if(typeof data2 === "string"){
if(!pattern9.test(data2)){
const err6 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate234.errors = vErrors;
return errors === 0;
}
validate234.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema322 = {"type":"object","additionalProperties":false,"required":["source","digest"],"properties":{"source":{"type":"string","minLength":1,"maxLength":256,"pattern":"^[A-Za-z0-9._/-]+$"},"digest":{"$ref":"#/$defs/digest"}}};
const pattern138 = new RegExp("^[A-Za-z0-9._/-]+$", "u");

function validate236(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate236.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.source === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.digest === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "source") || (key0 === "digest"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.source !== undefined){
let data0 = data.source;
if(typeof data0 === "string"){
if(func3(data0) > 256){
const err3 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func3(data0) < 1){
const err4 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern138.test(data0)){
const err5 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9._/-]+$"},message:"must match pattern \""+"^[A-Za-z0-9._/-]+$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.digest !== undefined){
let data1 = data.digest;
if(typeof data1 === "string"){
if(!pattern9.test(data1)){
const err7 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate236.errors = vErrors;
return errors === 0;
}
validate236.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema325 = {"type":"object","additionalProperties":false,"required":["source","license","mediaType","byteLength","digest"],"properties":{"source":{"type":"string","pattern":"^fixtures/fonts/[A-Za-z0-9._-]+\\.(?:ttf|otf|woff2?)$"},"license":{"type":"string","pattern":"^fixtures/fonts/[A-Za-z0-9._-]+\\.txt$"},"mediaType":{"enum":["font/ttf","font/otf","font/woff","font/woff2"]},"byteLength":{"type":"integer","minimum":1,"maximum":67108864},"digest":{"$ref":"#/$defs/digest"}}};

function validate238(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate238.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.source === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.license === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "license"},message:"must have required property '"+"license"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.mediaType === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "mediaType"},message:"must have required property '"+"mediaType"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.byteLength === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.digest === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "source") || (key0 === "license")) || (key0 === "mediaType")) || (key0 === "byteLength")) || (key0 === "digest"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.source !== undefined){
let data0 = data.source;
if(typeof data0 === "string"){
if(!pattern127.test(data0)){
const err6 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/pattern",keyword:"pattern",params:{pattern: "^fixtures/fonts/[A-Za-z0-9._-]+\\.(?:ttf|otf|woff2?)$"},message:"must match pattern \""+"^fixtures/fonts/[A-Za-z0-9._-]+\\.(?:ttf|otf|woff2?)$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.license !== undefined){
let data1 = data.license;
if(typeof data1 === "string"){
if(!pattern128.test(data1)){
const err8 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/pattern",keyword:"pattern",params:{pattern: "^fixtures/fonts/[A-Za-z0-9._-]+\\.txt$"},message:"must match pattern \""+"^fixtures/fonts/[A-Za-z0-9._-]+\\.txt$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.mediaType !== undefined){
let data2 = data.mediaType;
if(!((((data2 === "font/ttf") || (data2 === "font/otf")) || (data2 === "font/woff")) || (data2 === "font/woff2"))){
const err10 = {instancePath:instancePath+"/mediaType",schemaPath:"#/properties/mediaType/enum",keyword:"enum",params:{allowedValues: schema325.properties.mediaType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.byteLength !== undefined){
let data3 = data.byteLength;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err11 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 67108864 || isNaN(data3)){
const err12 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 67108864},message:"must be <= 67108864"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data3 < 1 || isNaN(data3)){
const err13 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data.digest !== undefined){
let data4 = data.digest;
if(typeof data4 === "string"){
if(!pattern9.test(data4)){
const err14 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate238.errors = vErrors;
return errors === 0;
}
validate238.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema327 = {"type":"object","additionalProperties":false,"required":["id","plan","projection","svg","planDigest","projectionDigest","svgDigest","assertions"],"properties":{"id":{"$ref":"#/$defs/token"},"plan":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.plan\\.json$"},"projection":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.outlines\\.json$"},"svg":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.outlines\\.svg$"},"planDigest":{"$ref":"#/$defs/digest"},"projectionDigest":{"$ref":"#/$defs/digest"},"svgDigest":{"$ref":"#/$defs/digest"},"assertions":{"type":"object","additionalProperties":false,"required":["runCount","glyphCount","outlineGlyphCount","pathCommandCount","bounds"],"properties":{"runCount":{"type":"integer","minimum":0,"maximum":100000},"glyphCount":{"type":"integer","minimum":0,"maximum":1000000},"outlineGlyphCount":{"type":"integer","minimum":0,"maximum":1000000},"pathCommandCount":{"type":"integer","minimum":0,"maximum":100000000},"bounds":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/bounds"}]}}}}};
const schema328 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9.-]*$"};
const schema332 = {"type":"object","additionalProperties":false,"required":["xMin","yMin","xMax","yMax"],"properties":{"xMin":{"type":"number","minimum":-1000000000,"maximum":1000000000},"yMin":{"type":"number","minimum":-1000000000,"maximum":1000000000},"xMax":{"type":"number","minimum":-1000000000,"maximum":1000000000},"yMax":{"type":"number","minimum":-1000000000,"maximum":1000000000}}};
const pattern148 = new RegExp("^fixtures/[A-Za-z0-9._-]+\\.outlines\\.json$", "u");
const pattern149 = new RegExp("^fixtures/[A-Za-z0-9._-]+\\.outlines\\.svg$", "u");

function validate240(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate240.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.plan === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "plan"},message:"must have required property '"+"plan"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.projection === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "projection"},message:"must have required property '"+"projection"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.svg === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "svg"},message:"must have required property '"+"svg"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.planDigest === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "planDigest"},message:"must have required property '"+"planDigest"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.projectionDigest === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "projectionDigest"},message:"must have required property '"+"projectionDigest"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.svgDigest === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "svgDigest"},message:"must have required property '"+"svgDigest"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.assertions === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assertions"},message:"must have required property '"+"assertions"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "id") || (key0 === "plan")) || (key0 === "projection")) || (key0 === "svg")) || (key0 === "planDigest")) || (key0 === "projectionDigest")) || (key0 === "svgDigest")) || (key0 === "assertions"))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func3(data0) < 1){
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!pattern130.test(data0)){
const err11 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9.-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9.-]*$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.plan !== undefined){
let data1 = data.plan;
if(typeof data1 === "string"){
if(!pattern131.test(data1)){
const err13 = {instancePath:instancePath+"/plan",schemaPath:"#/properties/plan/pattern",keyword:"pattern",params:{pattern: "^fixtures/[A-Za-z0-9._-]+\\.plan\\.json$"},message:"must match pattern \""+"^fixtures/[A-Za-z0-9._-]+\\.plan\\.json$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/plan",schemaPath:"#/properties/plan/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.projection !== undefined){
let data2 = data.projection;
if(typeof data2 === "string"){
if(!pattern148.test(data2)){
const err15 = {instancePath:instancePath+"/projection",schemaPath:"#/properties/projection/pattern",keyword:"pattern",params:{pattern: "^fixtures/[A-Za-z0-9._-]+\\.outlines\\.json$"},message:"must match pattern \""+"^fixtures/[A-Za-z0-9._-]+\\.outlines\\.json$"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/projection",schemaPath:"#/properties/projection/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.svg !== undefined){
let data3 = data.svg;
if(typeof data3 === "string"){
if(!pattern149.test(data3)){
const err17 = {instancePath:instancePath+"/svg",schemaPath:"#/properties/svg/pattern",keyword:"pattern",params:{pattern: "^fixtures/[A-Za-z0-9._-]+\\.outlines\\.svg$"},message:"must match pattern \""+"^fixtures/[A-Za-z0-9._-]+\\.outlines\\.svg$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/svg",schemaPath:"#/properties/svg/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.planDigest !== undefined){
let data4 = data.planDigest;
if(typeof data4 === "string"){
if(!pattern9.test(data4)){
const err19 = {instancePath:instancePath+"/planDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/planDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.projectionDigest !== undefined){
let data5 = data.projectionDigest;
if(typeof data5 === "string"){
if(!pattern9.test(data5)){
const err21 = {instancePath:instancePath+"/projectionDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/projectionDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.svgDigest !== undefined){
let data6 = data.svgDigest;
if(typeof data6 === "string"){
if(!pattern9.test(data6)){
const err23 = {instancePath:instancePath+"/svgDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/svgDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.assertions !== undefined){
let data7 = data.assertions;
if(data7 && typeof data7 == "object" && !Array.isArray(data7)){
if(data7.runCount === undefined){
const err25 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "runCount"},message:"must have required property '"+"runCount"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data7.glyphCount === undefined){
const err26 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "glyphCount"},message:"must have required property '"+"glyphCount"+"'"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(data7.outlineGlyphCount === undefined){
const err27 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "outlineGlyphCount"},message:"must have required property '"+"outlineGlyphCount"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data7.pathCommandCount === undefined){
const err28 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "pathCommandCount"},message:"must have required property '"+"pathCommandCount"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data7.bounds === undefined){
const err29 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "bounds"},message:"must have required property '"+"bounds"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
for(const key1 in data7){
if(!(((((key1 === "runCount") || (key1 === "glyphCount")) || (key1 === "outlineGlyphCount")) || (key1 === "pathCommandCount")) || (key1 === "bounds"))){
const err30 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data7.runCount !== undefined){
let data8 = data7.runCount;
if(!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))){
const err31 = {instancePath:instancePath+"/assertions/runCount",schemaPath:"#/properties/assertions/properties/runCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 100000 || isNaN(data8)){
const err32 = {instancePath:instancePath+"/assertions/runCount",schemaPath:"#/properties/assertions/properties/runCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 100000},message:"must be <= 100000"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data8 < 0 || isNaN(data8)){
const err33 = {instancePath:instancePath+"/assertions/runCount",schemaPath:"#/properties/assertions/properties/runCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
if(data7.glyphCount !== undefined){
let data9 = data7.glyphCount;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err34 = {instancePath:instancePath+"/assertions/glyphCount",schemaPath:"#/properties/assertions/properties/glyphCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 > 1000000 || isNaN(data9)){
const err35 = {instancePath:instancePath+"/assertions/glyphCount",schemaPath:"#/properties/assertions/properties/glyphCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data9 < 0 || isNaN(data9)){
const err36 = {instancePath:instancePath+"/assertions/glyphCount",schemaPath:"#/properties/assertions/properties/glyphCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
if(data7.outlineGlyphCount !== undefined){
let data10 = data7.outlineGlyphCount;
if(!(((typeof data10 == "number") && (!(data10 % 1) && !isNaN(data10))) && (isFinite(data10)))){
const err37 = {instancePath:instancePath+"/assertions/outlineGlyphCount",schemaPath:"#/properties/assertions/properties/outlineGlyphCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if((typeof data10 == "number") && (isFinite(data10))){
if(data10 > 1000000 || isNaN(data10)){
const err38 = {instancePath:instancePath+"/assertions/outlineGlyphCount",schemaPath:"#/properties/assertions/properties/outlineGlyphCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if(data10 < 0 || isNaN(data10)){
const err39 = {instancePath:instancePath+"/assertions/outlineGlyphCount",schemaPath:"#/properties/assertions/properties/outlineGlyphCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
}
if(data7.pathCommandCount !== undefined){
let data11 = data7.pathCommandCount;
if(!(((typeof data11 == "number") && (!(data11 % 1) && !isNaN(data11))) && (isFinite(data11)))){
const err40 = {instancePath:instancePath+"/assertions/pathCommandCount",schemaPath:"#/properties/assertions/properties/pathCommandCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if((typeof data11 == "number") && (isFinite(data11))){
if(data11 > 100000000 || isNaN(data11)){
const err41 = {instancePath:instancePath+"/assertions/pathCommandCount",schemaPath:"#/properties/assertions/properties/pathCommandCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 100000000},message:"must be <= 100000000"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data11 < 0 || isNaN(data11)){
const err42 = {instancePath:instancePath+"/assertions/pathCommandCount",schemaPath:"#/properties/assertions/properties/pathCommandCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
}
if(data7.bounds !== undefined){
let data12 = data7.bounds;
const _errs32 = errors;
let valid6 = false;
let passing0 = null;
const _errs33 = errors;
if(data12 !== null){
const err43 = {instancePath:instancePath+"/assertions/bounds",schemaPath:"#/properties/assertions/properties/bounds/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
var _valid0 = _errs33 === errors;
if(_valid0){
valid6 = true;
passing0 = 0;
}
const _errs35 = errors;
if(data12 && typeof data12 == "object" && !Array.isArray(data12)){
if(data12.xMin === undefined){
const err44 = {instancePath:instancePath+"/assertions/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "xMin"},message:"must have required property '"+"xMin"+"'"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
if(data12.yMin === undefined){
const err45 = {instancePath:instancePath+"/assertions/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "yMin"},message:"must have required property '"+"yMin"+"'"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
if(data12.xMax === undefined){
const err46 = {instancePath:instancePath+"/assertions/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "xMax"},message:"must have required property '"+"xMax"+"'"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
if(data12.yMax === undefined){
const err47 = {instancePath:instancePath+"/assertions/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "yMax"},message:"must have required property '"+"yMax"+"'"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
for(const key2 in data12){
if(!((((key2 === "xMin") || (key2 === "yMin")) || (key2 === "xMax")) || (key2 === "yMax"))){
const err48 = {instancePath:instancePath+"/assertions/bounds",schemaPath:"#/$defs/bounds/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
if(data12.xMin !== undefined){
let data13 = data12.xMin;
if((typeof data13 == "number") && (isFinite(data13))){
if(data13 > 1000000000 || isNaN(data13)){
const err49 = {instancePath:instancePath+"/assertions/bounds/xMin",schemaPath:"#/$defs/bounds/properties/xMin/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
if(data13 < -1000000000 || isNaN(data13)){
const err50 = {instancePath:instancePath+"/assertions/bounds/xMin",schemaPath:"#/$defs/bounds/properties/xMin/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
else {
const err51 = {instancePath:instancePath+"/assertions/bounds/xMin",schemaPath:"#/$defs/bounds/properties/xMin/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data12.yMin !== undefined){
let data14 = data12.yMin;
if((typeof data14 == "number") && (isFinite(data14))){
if(data14 > 1000000000 || isNaN(data14)){
const err52 = {instancePath:instancePath+"/assertions/bounds/yMin",schemaPath:"#/$defs/bounds/properties/yMin/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
if(data14 < -1000000000 || isNaN(data14)){
const err53 = {instancePath:instancePath+"/assertions/bounds/yMin",schemaPath:"#/$defs/bounds/properties/yMin/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
else {
const err54 = {instancePath:instancePath+"/assertions/bounds/yMin",schemaPath:"#/$defs/bounds/properties/yMin/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
if(data12.xMax !== undefined){
let data15 = data12.xMax;
if((typeof data15 == "number") && (isFinite(data15))){
if(data15 > 1000000000 || isNaN(data15)){
const err55 = {instancePath:instancePath+"/assertions/bounds/xMax",schemaPath:"#/$defs/bounds/properties/xMax/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
if(data15 < -1000000000 || isNaN(data15)){
const err56 = {instancePath:instancePath+"/assertions/bounds/xMax",schemaPath:"#/$defs/bounds/properties/xMax/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
else {
const err57 = {instancePath:instancePath+"/assertions/bounds/xMax",schemaPath:"#/$defs/bounds/properties/xMax/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
if(data12.yMax !== undefined){
let data16 = data12.yMax;
if((typeof data16 == "number") && (isFinite(data16))){
if(data16 > 1000000000 || isNaN(data16)){
const err58 = {instancePath:instancePath+"/assertions/bounds/yMax",schemaPath:"#/$defs/bounds/properties/yMax/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000000},message:"must be <= 1000000000"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
if(data16 < -1000000000 || isNaN(data16)){
const err59 = {instancePath:instancePath+"/assertions/bounds/yMax",schemaPath:"#/$defs/bounds/properties/yMax/minimum",keyword:"minimum",params:{comparison: ">=", limit: -1000000000},message:"must be >= -1000000000"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
}
else {
const err60 = {instancePath:instancePath+"/assertions/bounds/yMax",schemaPath:"#/$defs/bounds/properties/yMax/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
}
else {
const err61 = {instancePath:instancePath+"/assertions/bounds",schemaPath:"#/$defs/bounds/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
var _valid0 = _errs35 === errors;
if(_valid0 && valid6){
valid6 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid6 = true;
passing0 = 1;
}
}
if(!valid6){
const err62 = {instancePath:instancePath+"/assertions/bounds",schemaPath:"#/properties/assertions/properties/bounds/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
else {
errors = _errs32;
if(vErrors !== null){
if(_errs32){
vErrors.length = _errs32;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err63 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
}
}
else {
const err64 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
validate240.errors = vErrors;
return errors === 0;
}
validate240.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema333 = {"type":"array","minItems":1,"maxItems":128,"items":{"$ref":"#/$defs/token"}};

function validate242(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate242.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(Array.isArray(data)){
if(data.length > 128){
const err0 = {instancePath,schemaPath:"#/maxItems",keyword:"maxItems",params:{limit: 128},message:"must NOT have more than 128 items"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.length < 1){
const err1 = {instancePath,schemaPath:"#/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
const len0 = data.length;
for(let i0=0; i0<len0; i0++){
let data0 = data[i0];
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err2 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(func3(data0) < 1){
const err3 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(!pattern130.test(data0)){
const err4 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9.-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9.-]*$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
validate242.errors = vErrors;
return errors === 0;
}
validate242.evaluated = {"items":true,"dynamicProps":false,"dynamicItems":false};


function validate233(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/glyph-outline-registry.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate233.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.projectionSchema === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "projectionSchema"},message:"must have required property '"+"projectionSchema"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.shapingRegistry === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "shapingRegistry"},message:"must have required property '"+"shapingRegistry"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.model === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "model"},message:"must have required property '"+"model"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.referenceProjector === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "referenceProjector"},message:"must have required property '"+"referenceProjector"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.font === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "font"},message:"must have required property '"+"font"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.cases === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "cases"},message:"must have required property '"+"cases"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.scope === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "scope"},message:"must have required property '"+"scope"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema319.properties, key0))){
const err10 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/glyph-outline-registry.schema.json" !== data.$schema){
const err11 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/glyph-outline-registry.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-glyph-outline-registry" !== data.format){
const err12 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-glyph-outline-registry"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err13 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.projectionSchema !== undefined){
if(!(validate234(data.projectionSchema, {instancePath:instancePath+"/projectionSchema",parentData:data,parentDataProperty:"projectionSchema",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate234.errors : vErrors.concat(validate234.errors);
errors = vErrors.length;
}
}
if(data.shapingRegistry !== undefined){
if(!(validate236(data.shapingRegistry, {instancePath:instancePath+"/shapingRegistry",parentData:data,parentDataProperty:"shapingRegistry",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate236.errors : vErrors.concat(validate236.errors);
errors = vErrors.length;
}
}
if(data.model !== undefined){
let data5 = data.model;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.id === undefined){
const err14 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data5.version === undefined){
const err15 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data5.coordinateSpace === undefined){
const err16 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "coordinateSpace"},message:"must have required property '"+"coordinateSpace"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data5.pathModel === undefined){
const err17 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "pathModel"},message:"must have required property '"+"pathModel"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data5.boundsMeaning === undefined){
const err18 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "boundsMeaning"},message:"must have required property '"+"boundsMeaning"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data5.runOrder === undefined){
const err19 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "runOrder"},message:"must have required property '"+"runOrder"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data5.svgProjection === undefined){
const err20 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/required",keyword:"required",params:{missingProperty: "svgProjection"},message:"must have required property '"+"svgProjection"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
for(const key1 in data5){
if(!(((((((key1 === "id") || (key1 === "version")) || (key1 === "coordinateSpace")) || (key1 === "pathModel")) || (key1 === "boundsMeaning")) || (key1 === "runOrder")) || (key1 === "svgProjection"))){
const err21 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data5.id !== undefined){
if("maipo-opentype-outline-projection" !== data5.id){
const err22 = {instancePath:instancePath+"/model/id",schemaPath:"#/properties/model/properties/id/const",keyword:"const",params:{allowedValue: "maipo-opentype-outline-projection"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data5.version !== undefined){
if("0.1" !== data5.version){
const err23 = {instancePath:instancePath+"/model/version",schemaPath:"#/properties/model/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data5.coordinateSpace !== undefined){
if("font-units-y-up" !== data5.coordinateSpace){
const err24 = {instancePath:instancePath+"/model/coordinateSpace",schemaPath:"#/properties/model/properties/coordinateSpace/const",keyword:"const",params:{allowedValue: "font-units-y-up"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data5.pathModel !== undefined){
if("absolute-m-l-q-c-z" !== data5.pathModel){
const err25 = {instancePath:instancePath+"/model/pathModel",schemaPath:"#/properties/model/properties/pathModel/const",keyword:"const",params:{allowedValue: "absolute-m-l-q-c-z"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data5.boundsMeaning !== undefined){
if("opentype-outline-extents-union" !== data5.boundsMeaning){
const err26 = {instancePath:instancePath+"/model/boundsMeaning",schemaPath:"#/properties/model/properties/boundsMeaning/const",keyword:"const",params:{allowedValue: "opentype-outline-extents-union"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data5.runOrder !== undefined){
if("shaping-plan-order" !== data5.runOrder){
const err27 = {instancePath:instancePath+"/model/runOrder",schemaPath:"#/properties/model/properties/runOrder/const",keyword:"const",params:{allowedValue: "shaping-plan-order"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data5.svgProjection !== undefined){
if("svg-2-paths-y-axis-flip" !== data5.svgProjection){
const err28 = {instancePath:instancePath+"/model/svgProjection",schemaPath:"#/properties/model/properties/svgProjection/const",keyword:"const",params:{allowedValue: "svg-2-paths-y-axis-flip"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
}
else {
const err29 = {instancePath:instancePath+"/model",schemaPath:"#/properties/model/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.referenceProjector !== undefined){
let data13 = data.referenceProjector;
if(data13 && typeof data13 == "object" && !Array.isArray(data13)){
if(data13.package === undefined){
const err30 = {instancePath:instancePath+"/referenceProjector",schemaPath:"#/properties/referenceProjector/required",keyword:"required",params:{missingProperty: "package"},message:"must have required property '"+"package"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data13.version === undefined){
const err31 = {instancePath:instancePath+"/referenceProjector",schemaPath:"#/properties/referenceProjector/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data13.engine === undefined){
const err32 = {instancePath:instancePath+"/referenceProjector",schemaPath:"#/properties/referenceProjector/required",keyword:"required",params:{missingProperty: "engine"},message:"must have required property '"+"engine"+"'"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data13.engineVersion === undefined){
const err33 = {instancePath:instancePath+"/referenceProjector",schemaPath:"#/properties/referenceProjector/required",keyword:"required",params:{missingProperty: "engineVersion"},message:"must have required property '"+"engineVersion"+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data13.implementation === undefined){
const err34 = {instancePath:instancePath+"/referenceProjector",schemaPath:"#/properties/referenceProjector/required",keyword:"required",params:{missingProperty: "implementation"},message:"must have required property '"+"implementation"+"'"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data13.implementationVersion === undefined){
const err35 = {instancePath:instancePath+"/referenceProjector",schemaPath:"#/properties/referenceProjector/required",keyword:"required",params:{missingProperty: "implementationVersion"},message:"must have required property '"+"implementationVersion"+"'"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data13.wasmDigest === undefined){
const err36 = {instancePath:instancePath+"/referenceProjector",schemaPath:"#/properties/referenceProjector/required",keyword:"required",params:{missingProperty: "wasmDigest"},message:"must have required property '"+"wasmDigest"+"'"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
for(const key2 in data13){
if(!(((((((key2 === "package") || (key2 === "version")) || (key2 === "engine")) || (key2 === "engineVersion")) || (key2 === "implementation")) || (key2 === "implementationVersion")) || (key2 === "wasmDigest"))){
const err37 = {instancePath:instancePath+"/referenceProjector",schemaPath:"#/properties/referenceProjector/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data13.package !== undefined){
if("@maipo/glyph-outlines" !== data13.package){
const err38 = {instancePath:instancePath+"/referenceProjector/package",schemaPath:"#/properties/referenceProjector/properties/package/const",keyword:"const",params:{allowedValue: "@maipo/glyph-outlines"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data13.version !== undefined){
if("0.1.0" !== data13.version){
const err39 = {instancePath:instancePath+"/referenceProjector/version",schemaPath:"#/properties/referenceProjector/properties/version/const",keyword:"const",params:{allowedValue: "0.1.0"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data13.engine !== undefined){
if("harfbuzz" !== data13.engine){
const err40 = {instancePath:instancePath+"/referenceProjector/engine",schemaPath:"#/properties/referenceProjector/properties/engine/const",keyword:"const",params:{allowedValue: "harfbuzz"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data13.engineVersion !== undefined){
let data17 = data13.engineVersion;
if(typeof data17 === "string"){
if(!pattern124.test(data17)){
const err41 = {instancePath:instancePath+"/referenceProjector/engineVersion",schemaPath:"#/properties/referenceProjector/properties/engineVersion/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+\\.[0-9]+$"+"\""};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
else {
const err42 = {instancePath:instancePath+"/referenceProjector/engineVersion",schemaPath:"#/properties/referenceProjector/properties/engineVersion/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
if(data13.implementation !== undefined){
if("harfbuzzjs" !== data13.implementation){
const err43 = {instancePath:instancePath+"/referenceProjector/implementation",schemaPath:"#/properties/referenceProjector/properties/implementation/const",keyword:"const",params:{allowedValue: "harfbuzzjs"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data13.implementationVersion !== undefined){
let data19 = data13.implementationVersion;
if(typeof data19 === "string"){
if(!pattern124.test(data19)){
const err44 = {instancePath:instancePath+"/referenceProjector/implementationVersion",schemaPath:"#/properties/referenceProjector/properties/implementationVersion/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+\\.[0-9]+$"+"\""};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
else {
const err45 = {instancePath:instancePath+"/referenceProjector/implementationVersion",schemaPath:"#/properties/referenceProjector/properties/implementationVersion/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data13.wasmDigest !== undefined){
let data20 = data13.wasmDigest;
if(typeof data20 === "string"){
if(!pattern9.test(data20)){
const err46 = {instancePath:instancePath+"/referenceProjector/wasmDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
else {
const err47 = {instancePath:instancePath+"/referenceProjector/wasmDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
}
else {
const err48 = {instancePath:instancePath+"/referenceProjector",schemaPath:"#/properties/referenceProjector/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
if(data.font !== undefined){
if(!(validate238(data.font, {instancePath:instancePath+"/font",parentData:data,parentDataProperty:"font",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate238.errors : vErrors.concat(validate238.errors);
errors = vErrors.length;
}
}
if(data.cases !== undefined){
let data22 = data.cases;
if(Array.isArray(data22)){
if(data22.length > 1024){
const err49 = {instancePath:instancePath+"/cases",schemaPath:"#/properties/cases/maxItems",keyword:"maxItems",params:{limit: 1024},message:"must NOT have more than 1024 items"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
if(data22.length < 1){
const err50 = {instancePath:instancePath+"/cases",schemaPath:"#/properties/cases/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
const len0 = data22.length;
for(let i0=0; i0<len0; i0++){
if(!(validate240(data22[i0], {instancePath:instancePath+"/cases/" + i0,parentData:data22,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate240.errors : vErrors.concat(validate240.errors);
errors = vErrors.length;
}
}
}
else {
const err51 = {instancePath:instancePath+"/cases",schemaPath:"#/properties/cases/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data.scope !== undefined){
let data24 = data.scope;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.verified === undefined){
const err52 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/required",keyword:"required",params:{missingProperty: "verified"},message:"must have required property '"+"verified"+"'"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
if(data24.notYetDefined === undefined){
const err53 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/required",keyword:"required",params:{missingProperty: "notYetDefined"},message:"must have required property '"+"notYetDefined"+"'"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
for(const key3 in data24){
if(!((key3 === "verified") || (key3 === "notYetDefined"))){
const err54 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
if(data24.verified !== undefined){
if(!(validate242(data24.verified, {instancePath:instancePath+"/scope/verified",parentData:data24,parentDataProperty:"verified",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate242.errors : vErrors.concat(validate242.errors);
errors = vErrors.length;
}
}
if(data24.notYetDefined !== undefined){
if(!(validate242(data24.notYetDefined, {instancePath:instancePath+"/scope/notYetDefined",parentData:data24,parentDataProperty:"notYetDefined",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate242.errors : vErrors.concat(validate242.errors);
errors = vErrors.length;
}
}
}
else {
const err55 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
}
}
else {
const err56 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
validate233.errors = vErrors;
return errors === 0;
}
validate233.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateGlyphRasterRequestSchema = validate245;
const schema335 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/glyph-raster-request.schema.json","title":"Maipo glyph raster request 0.1","description":"A bounded fixed-size raster request for a content-addressed Maipo glyph outline projection.","type":"object","additionalProperties":false,"required":["$schema","format","version","requestId","projection","options"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/glyph-raster-request.schema.json"},"format":{"const":"maipo-glyph-raster-request"},"version":{"const":"0.1"},"requestId":{"$ref":"#/$defs/id"},"projection":{"$ref":"https://maipo.design/schema/0.1/glyph-outline-projection.schema.json"},"options":{"$ref":"#/$defs/options"}},"$defs":{"id":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"color":{"type":"string","pattern":"^#[0-9A-Fa-f]{6}$"},"background":{"oneOf":[{"type":"object","additionalProperties":false,"required":["type"],"properties":{"type":{"const":"transparent"}}},{"type":"object","additionalProperties":false,"required":["type","color"],"properties":{"type":{"const":"solid"},"color":{"$ref":"#/$defs/color"}}}]},"options":{"type":"object","additionalProperties":false,"required":["width","height","padding","fit","fill","background","includeGlyphMap"],"properties":{"width":{"type":"integer","minimum":1,"maximum":4096},"height":{"type":"integer","minimum":1,"maximum":4096},"padding":{"type":"integer","minimum":0,"maximum":1024},"fit":{"const":"contain"},"fill":{"$ref":"#/$defs/color"},"background":{"$ref":"#/$defs/background"},"includeGlyphMap":{"type":"boolean"}}}}};
const schema336 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const schema337 = {"type":"object","additionalProperties":false,"required":["width","height","padding","fit","fill","background","includeGlyphMap"],"properties":{"width":{"type":"integer","minimum":1,"maximum":4096},"height":{"type":"integer","minimum":1,"maximum":4096},"padding":{"type":"integer","minimum":0,"maximum":1024},"fit":{"const":"contain"},"fill":{"$ref":"#/$defs/color"},"background":{"$ref":"#/$defs/background"},"includeGlyphMap":{"type":"boolean"}}};
const schema338 = {"type":"string","pattern":"^#[0-9A-Fa-f]{6}$"};
const schema339 = {"oneOf":[{"type":"object","additionalProperties":false,"required":["type"],"properties":{"type":{"const":"transparent"}}},{"type":"object","additionalProperties":false,"required":["type","color"],"properties":{"type":{"const":"solid"},"color":{"$ref":"#/$defs/color"}}}]};

function validate248(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate248.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.type === undefined){
const err0 = {instancePath,schemaPath:"#/oneOf/0/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "type")){
const err1 = {instancePath,schemaPath:"#/oneOf/0/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.type !== undefined){
if("transparent" !== data.type){
const err2 = {instancePath:instancePath+"/type",schemaPath:"#/oneOf/0/properties/type/const",keyword:"const",params:{allowedValue: "transparent"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
}
else {
const err3 = {instancePath,schemaPath:"#/oneOf/0/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.type === undefined){
const err4 = {instancePath,schemaPath:"#/oneOf/1/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.color === undefined){
const err5 = {instancePath,schemaPath:"#/oneOf/1/required",keyword:"required",params:{missingProperty: "color"},message:"must have required property '"+"color"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key1 in data){
if(!((key1 === "type") || (key1 === "color"))){
const err6 = {instancePath,schemaPath:"#/oneOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.type !== undefined){
if("solid" !== data.type){
const err7 = {instancePath:instancePath+"/type",schemaPath:"#/oneOf/1/properties/type/const",keyword:"const",params:{allowedValue: "solid"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.color !== undefined){
let data2 = data.color;
if(typeof data2 === "string"){
if(!pattern5.test(data2)){
const err8 = {instancePath:instancePath+"/color",schemaPath:"#/$defs/color/pattern",keyword:"pattern",params:{pattern: "^#[0-9A-Fa-f]{6}$"},message:"must match pattern \""+"^#[0-9A-Fa-f]{6}$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/color",schemaPath:"#/$defs/color/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/oneOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
var _valid0 = _errs5 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid0){
const err11 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate248.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate248.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate247(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate247.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.width === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.height === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.padding === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "padding"},message:"must have required property '"+"padding"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.fit === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fit"},message:"must have required property '"+"fit"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.fill === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fill"},message:"must have required property '"+"fill"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.background === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "background"},message:"must have required property '"+"background"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.includeGlyphMap === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "includeGlyphMap"},message:"must have required property '"+"includeGlyphMap"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "width") || (key0 === "height")) || (key0 === "padding")) || (key0 === "fit")) || (key0 === "fill")) || (key0 === "background")) || (key0 === "includeGlyphMap"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.width !== undefined){
let data0 = data.width;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 4096 || isNaN(data0)){
const err9 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data0 < 1 || isNaN(data0)){
const err10 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
if(data.height !== undefined){
let data1 = data.height;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err11 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 4096 || isNaN(data1)){
const err12 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err13 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data.padding !== undefined){
let data2 = data.padding;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err14 = {instancePath:instancePath+"/padding",schemaPath:"#/properties/padding/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1024 || isNaN(data2)){
const err15 = {instancePath:instancePath+"/padding",schemaPath:"#/properties/padding/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1024},message:"must be <= 1024"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data2 < 0 || isNaN(data2)){
const err16 = {instancePath:instancePath+"/padding",schemaPath:"#/properties/padding/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
if(data.fit !== undefined){
if("contain" !== data.fit){
const err17 = {instancePath:instancePath+"/fit",schemaPath:"#/properties/fit/const",keyword:"const",params:{allowedValue: "contain"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.fill !== undefined){
let data4 = data.fill;
if(typeof data4 === "string"){
if(!pattern5.test(data4)){
const err18 = {instancePath:instancePath+"/fill",schemaPath:"#/$defs/color/pattern",keyword:"pattern",params:{pattern: "^#[0-9A-Fa-f]{6}$"},message:"must match pattern \""+"^#[0-9A-Fa-f]{6}$"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/fill",schemaPath:"#/$defs/color/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.background !== undefined){
if(!(validate248(data.background, {instancePath:instancePath+"/background",parentData:data,parentDataProperty:"background",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate248.errors : vErrors.concat(validate248.errors);
errors = vErrors.length;
}
}
if(data.includeGlyphMap !== undefined){
if(typeof data.includeGlyphMap !== "boolean"){
const err20 = {instancePath:instancePath+"/includeGlyphMap",schemaPath:"#/properties/includeGlyphMap/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
validate247.errors = vErrors;
return errors === 0;
}
validate247.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate245(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/glyph-raster-request.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate245.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.requestId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.projection === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "projection"},message:"must have required property '"+"projection"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.options === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "options"},message:"must have required property '"+"options"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "$schema") || (key0 === "format")) || (key0 === "version")) || (key0 === "requestId")) || (key0 === "projection")) || (key0 === "options"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/glyph-raster-request.schema.json" !== data.$schema){
const err7 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/glyph-raster-request.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-glyph-raster-request" !== data.format){
const err8 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-glyph-raster-request"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err9 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.requestId !== undefined){
let data3 = data.requestId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err10 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func3(data3) < 1){
const err11 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern4.test(data3)){
const err12 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.projection !== undefined){
if(!(validate213(data.projection, {instancePath:instancePath+"/projection",parentData:data,parentDataProperty:"projection",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate213.errors : vErrors.concat(validate213.errors);
errors = vErrors.length;
}
}
if(data.options !== undefined){
if(!(validate247(data.options, {instancePath:instancePath+"/options",parentData:data,parentDataProperty:"options",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate247.errors : vErrors.concat(validate247.errors);
errors = vErrors.length;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate245.errors = vErrors;
return errors === 0;
}
validate245.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateGlyphRasterResultSchema = validate251;
const schema341 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/glyph-raster-result.schema.json","title":"Maipo glyph raster result 0.1","description":"Content-verified PNG, pixel digest, glyph metadata, diagnostics and optional glyph-addressed pixel map for a glyph outline projection.","type":"object","additionalProperties":false,"required":["$schema","format","version","requestId","projectionDigest","rasterizer","options","artifact","pixelModel","pixelDigest","glyphs","glyphMap","diagnostics","timing"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/glyph-raster-result.schema.json"},"format":{"const":"maipo-glyph-raster-result"},"version":{"const":"0.1"},"requestId":{"$ref":"#/$defs/id"},"projectionDigest":{"$ref":"#/$defs/digest"},"rasterizer":{"$ref":"#/$defs/rasterizer"},"options":{"$ref":"https://maipo.design/schema/0.1/glyph-raster-request.schema.json#/$defs/options"},"artifact":{"$ref":"#/$defs/artifact"},"pixelModel":{"const":"rgba8-srgb-straight-transparent-zero"},"pixelDigest":{"$ref":"#/$defs/digest"},"glyphs":{"type":"array","maxItems":1000000,"items":{"$ref":"#/$defs/glyph"}},"glyphMap":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/glyphMap"}]},"diagnostics":{"type":"array","maxItems":10000,"items":{"$ref":"#/$defs/diagnostic"}},"timing":{"$ref":"#/$defs/timing"}},"$defs":{"id":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"glyphMetadataId":{"type":"string","minLength":1,"maxLength":160,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"base64":{"type":"string","pattern":"^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$"},"runtime":{"type":"object","additionalProperties":false,"required":["engine","version","platform","deviceScaleFactor","colorSpace"],"properties":{"engine":{"type":"string","minLength":1,"maxLength":128},"version":{"type":"string","minLength":1,"maxLength":128},"platform":{"type":"string","minLength":1,"maxLength":128},"deviceScaleFactor":{"type":"number","exclusiveMinimum":0,"maximum":16},"colorSpace":{"const":"srgb"}}},"rasterizer":{"type":"object","additionalProperties":false,"required":["id","version","backend","runtime"],"properties":{"id":{"const":"@maipo/glyph-rasterizer"},"version":{"const":"0.1.0"},"backend":{"const":"canvas2d"},"runtime":{"$ref":"#/$defs/runtime"}}},"artifact":{"type":"object","additionalProperties":false,"required":["mediaType","width","height","encoding","byteLength","digest","data"],"properties":{"mediaType":{"const":"image/png"},"width":{"type":"integer","minimum":1,"maximum":4096},"height":{"type":"integer","minimum":1,"maximum":4096},"encoding":{"const":"base64"},"byteLength":{"type":"integer","minimum":8,"maximum":67108864},"digest":{"$ref":"#/$defs/digest"},"data":{"$ref":"#/$defs/base64"}}},"bounds":{"type":"object","additionalProperties":false,"required":["x","y","width","height"],"properties":{"x":{"type":"integer","minimum":0,"maximum":4096},"y":{"type":"integer","minimum":0,"maximum":4096},"width":{"type":"integer","minimum":0,"maximum":4096},"height":{"type":"integer","minimum":0,"maximum":4096}}},"glyph":{"type":"object","additionalProperties":false,"required":["id","runId","glyphIndex","glyphId","cluster","visible","bounds"],"properties":{"id":{"$ref":"#/$defs/glyphMetadataId"},"runId":{"$ref":"#/$defs/id"},"glyphIndex":{"type":"integer","minimum":0,"maximum":1000000},"glyphId":{"type":"integer","minimum":0,"maximum":4294967295},"cluster":{"type":"integer","minimum":0,"maximum":1000000},"visible":{"type":"boolean"},"bounds":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/bounds"}]}}},"glyphMap":{"type":"object","additionalProperties":false,"required":["width","height","ids","encoding","byteLength","digest","data"],"properties":{"width":{"type":"integer","minimum":1,"maximum":4096},"height":{"type":"integer","minimum":1,"maximum":4096},"ids":{"type":"array","maxItems":1000000,"items":{"$ref":"#/$defs/glyphMetadataId"}},"encoding":{"const":"uint32le-base64"},"byteLength":{"type":"integer","minimum":4,"maximum":16777216},"digest":{"$ref":"#/$defs/digest"},"data":{"$ref":"#/$defs/base64"}}},"diagnostic":{"type":"object","additionalProperties":false,"required":["severity","code","message"],"properties":{"severity":{"enum":["warning","error"]},"code":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"},"target":{"$ref":"#/$defs/id"},"message":{"type":"string","minLength":1,"maxLength":4096}}},"timing":{"type":"object","additionalProperties":false,"required":["validationMs","renderMs","glyphMapMs","encodeMs","totalMs"],"properties":{"validationMs":{"type":"number","minimum":0,"maximum":86400000},"renderMs":{"type":"number","minimum":0,"maximum":86400000},"glyphMapMs":{"type":"number","minimum":0,"maximum":86400000},"encodeMs":{"type":"number","minimum":0,"maximum":86400000},"totalMs":{"type":"number","minimum":0,"maximum":86400000}}}}};
const schema342 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const schema343 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};
const schema362 = {"type":"object","additionalProperties":false,"required":["validationMs","renderMs","glyphMapMs","encodeMs","totalMs"],"properties":{"validationMs":{"type":"number","minimum":0,"maximum":86400000},"renderMs":{"type":"number","minimum":0,"maximum":86400000},"glyphMapMs":{"type":"number","minimum":0,"maximum":86400000},"encodeMs":{"type":"number","minimum":0,"maximum":86400000},"totalMs":{"type":"number","minimum":0,"maximum":86400000}}};
const schema344 = {"type":"object","additionalProperties":false,"required":["id","version","backend","runtime"],"properties":{"id":{"const":"@maipo/glyph-rasterizer"},"version":{"const":"0.1.0"},"backend":{"const":"canvas2d"},"runtime":{"$ref":"#/$defs/runtime"}}};
const schema345 = {"type":"object","additionalProperties":false,"required":["engine","version","platform","deviceScaleFactor","colorSpace"],"properties":{"engine":{"type":"string","minLength":1,"maxLength":128},"version":{"type":"string","minLength":1,"maxLength":128},"platform":{"type":"string","minLength":1,"maxLength":128},"deviceScaleFactor":{"type":"number","exclusiveMinimum":0,"maximum":16},"colorSpace":{"const":"srgb"}}};

function validate252(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate252.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.backend === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.runtime === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "runtime"},message:"must have required property '"+"runtime"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "id") || (key0 === "version")) || (key0 === "backend")) || (key0 === "runtime"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.id !== undefined){
if("@maipo/glyph-rasterizer" !== data.id){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/const",keyword:"const",params:{allowedValue: "@maipo/glyph-rasterizer"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1.0" !== data.version){
const err6 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1.0"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.backend !== undefined){
if("canvas2d" !== data.backend){
const err7 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/const",keyword:"const",params:{allowedValue: "canvas2d"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.runtime !== undefined){
let data3 = data.runtime;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.engine === undefined){
const err8 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "engine"},message:"must have required property '"+"engine"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data3.version === undefined){
const err9 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data3.platform === undefined){
const err10 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "platform"},message:"must have required property '"+"platform"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data3.deviceScaleFactor === undefined){
const err11 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "deviceScaleFactor"},message:"must have required property '"+"deviceScaleFactor"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data3.colorSpace === undefined){
const err12 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/required",keyword:"required",params:{missingProperty: "colorSpace"},message:"must have required property '"+"colorSpace"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
for(const key1 in data3){
if(!(((((key1 === "engine") || (key1 === "version")) || (key1 === "platform")) || (key1 === "deviceScaleFactor")) || (key1 === "colorSpace"))){
const err13 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data3.engine !== undefined){
let data4 = data3.engine;
if(typeof data4 === "string"){
if(func3(data4) > 128){
const err14 = {instancePath:instancePath+"/runtime/engine",schemaPath:"#/$defs/runtime/properties/engine/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(func3(data4) < 1){
const err15 = {instancePath:instancePath+"/runtime/engine",schemaPath:"#/$defs/runtime/properties/engine/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/runtime/engine",schemaPath:"#/$defs/runtime/properties/engine/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data3.version !== undefined){
let data5 = data3.version;
if(typeof data5 === "string"){
if(func3(data5) > 128){
const err17 = {instancePath:instancePath+"/runtime/version",schemaPath:"#/$defs/runtime/properties/version/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(func3(data5) < 1){
const err18 = {instancePath:instancePath+"/runtime/version",schemaPath:"#/$defs/runtime/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/runtime/version",schemaPath:"#/$defs/runtime/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data3.platform !== undefined){
let data6 = data3.platform;
if(typeof data6 === "string"){
if(func3(data6) > 128){
const err20 = {instancePath:instancePath+"/runtime/platform",schemaPath:"#/$defs/runtime/properties/platform/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(func3(data6) < 1){
const err21 = {instancePath:instancePath+"/runtime/platform",schemaPath:"#/$defs/runtime/properties/platform/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/runtime/platform",schemaPath:"#/$defs/runtime/properties/platform/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data3.deviceScaleFactor !== undefined){
let data7 = data3.deviceScaleFactor;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 16 || isNaN(data7)){
const err23 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"#/$defs/runtime/properties/deviceScaleFactor/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16},message:"must be <= 16"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data7 <= 0 || isNaN(data7)){
const err24 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"#/$defs/runtime/properties/deviceScaleFactor/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"#/$defs/runtime/properties/deviceScaleFactor/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data3.colorSpace !== undefined){
if("srgb" !== data3.colorSpace){
const err26 = {instancePath:instancePath+"/runtime/colorSpace",schemaPath:"#/$defs/runtime/properties/colorSpace/const",keyword:"const",params:{allowedValue: "srgb"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
else {
const err27 = {instancePath:instancePath+"/runtime",schemaPath:"#/$defs/runtime/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
validate252.errors = vErrors;
return errors === 0;
}
validate252.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate254(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate254.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.width === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.height === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.padding === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "padding"},message:"must have required property '"+"padding"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.fit === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fit"},message:"must have required property '"+"fit"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.fill === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fill"},message:"must have required property '"+"fill"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.background === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "background"},message:"must have required property '"+"background"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.includeGlyphMap === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "includeGlyphMap"},message:"must have required property '"+"includeGlyphMap"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "width") || (key0 === "height")) || (key0 === "padding")) || (key0 === "fit")) || (key0 === "fill")) || (key0 === "background")) || (key0 === "includeGlyphMap"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.width !== undefined){
let data0 = data.width;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 4096 || isNaN(data0)){
const err9 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data0 < 1 || isNaN(data0)){
const err10 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
if(data.height !== undefined){
let data1 = data.height;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err11 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 4096 || isNaN(data1)){
const err12 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err13 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data.padding !== undefined){
let data2 = data.padding;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err14 = {instancePath:instancePath+"/padding",schemaPath:"#/properties/padding/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1024 || isNaN(data2)){
const err15 = {instancePath:instancePath+"/padding",schemaPath:"#/properties/padding/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1024},message:"must be <= 1024"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data2 < 0 || isNaN(data2)){
const err16 = {instancePath:instancePath+"/padding",schemaPath:"#/properties/padding/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
if(data.fit !== undefined){
if("contain" !== data.fit){
const err17 = {instancePath:instancePath+"/fit",schemaPath:"#/properties/fit/const",keyword:"const",params:{allowedValue: "contain"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.fill !== undefined){
let data4 = data.fill;
if(typeof data4 === "string"){
if(!pattern5.test(data4)){
const err18 = {instancePath:instancePath+"/fill",schemaPath:"#/$defs/color/pattern",keyword:"pattern",params:{pattern: "^#[0-9A-Fa-f]{6}$"},message:"must match pattern \""+"^#[0-9A-Fa-f]{6}$"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/fill",schemaPath:"#/$defs/color/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.background !== undefined){
if(!(validate248(data.background, {instancePath:instancePath+"/background",parentData:data,parentDataProperty:"background",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate248.errors : vErrors.concat(validate248.errors);
errors = vErrors.length;
}
}
if(data.includeGlyphMap !== undefined){
if(typeof data.includeGlyphMap !== "boolean"){
const err20 = {instancePath:instancePath+"/includeGlyphMap",schemaPath:"#/properties/includeGlyphMap/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
validate254.errors = vErrors;
return errors === 0;
}
validate254.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema348 = {"type":"object","additionalProperties":false,"required":["mediaType","width","height","encoding","byteLength","digest","data"],"properties":{"mediaType":{"const":"image/png"},"width":{"type":"integer","minimum":1,"maximum":4096},"height":{"type":"integer","minimum":1,"maximum":4096},"encoding":{"const":"base64"},"byteLength":{"type":"integer","minimum":8,"maximum":67108864},"digest":{"$ref":"#/$defs/digest"},"data":{"$ref":"#/$defs/base64"}}};
const schema350 = {"type":"string","pattern":"^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$"};
const pattern161 = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$", "u");

function validate257(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate257.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.mediaType === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "mediaType"},message:"must have required property '"+"mediaType"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.width === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.height === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.encoding === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "encoding"},message:"must have required property '"+"encoding"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.byteLength === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.digest === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.data === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "data"},message:"must have required property '"+"data"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "mediaType") || (key0 === "width")) || (key0 === "height")) || (key0 === "encoding")) || (key0 === "byteLength")) || (key0 === "digest")) || (key0 === "data"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.mediaType !== undefined){
if("image/png" !== data.mediaType){
const err8 = {instancePath:instancePath+"/mediaType",schemaPath:"#/properties/mediaType/const",keyword:"const",params:{allowedValue: "image/png"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.width !== undefined){
let data1 = data.width;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err9 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 4096 || isNaN(data1)){
const err10 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err11 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
if(data.height !== undefined){
let data2 = data.height;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err12 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 4096 || isNaN(data2)){
const err13 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data2 < 1 || isNaN(data2)){
const err14 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
if(data.encoding !== undefined){
if("base64" !== data.encoding){
const err15 = {instancePath:instancePath+"/encoding",schemaPath:"#/properties/encoding/const",keyword:"const",params:{allowedValue: "base64"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.byteLength !== undefined){
let data4 = data.byteLength;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err16 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 67108864 || isNaN(data4)){
const err17 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 67108864},message:"must be <= 67108864"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data4 < 8 || isNaN(data4)){
const err18 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 8},message:"must be >= 8"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
if(data.digest !== undefined){
let data5 = data.digest;
if(typeof data5 === "string"){
if(!pattern9.test(data5)){
const err19 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.data !== undefined){
let data6 = data.data;
if(typeof data6 === "string"){
if(!pattern161.test(data6)){
const err21 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/base64/pattern",keyword:"pattern",params:{pattern: "^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$"},message:"must match pattern \""+"^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$"+"\""};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/base64/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
validate257.errors = vErrors;
return errors === 0;
}
validate257.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema352 = {"type":"object","additionalProperties":false,"required":["id","runId","glyphIndex","glyphId","cluster","visible","bounds"],"properties":{"id":{"$ref":"#/$defs/glyphMetadataId"},"runId":{"$ref":"#/$defs/id"},"glyphIndex":{"type":"integer","minimum":0,"maximum":1000000},"glyphId":{"type":"integer","minimum":0,"maximum":4294967295},"cluster":{"type":"integer","minimum":0,"maximum":1000000},"visible":{"type":"boolean"},"bounds":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/bounds"}]}}};
const schema353 = {"type":"string","minLength":1,"maxLength":160,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};
const schema355 = {"type":"object","additionalProperties":false,"required":["x","y","width","height"],"properties":{"x":{"type":"integer","minimum":0,"maximum":4096},"y":{"type":"integer","minimum":0,"maximum":4096},"width":{"type":"integer","minimum":0,"maximum":4096},"height":{"type":"integer","minimum":0,"maximum":4096}}};

function validate259(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate259.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.runId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "runId"},message:"must have required property '"+"runId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.glyphIndex === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "glyphIndex"},message:"must have required property '"+"glyphIndex"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.glyphId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "glyphId"},message:"must have required property '"+"glyphId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.cluster === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "cluster"},message:"must have required property '"+"cluster"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.visible === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "visible"},message:"must have required property '"+"visible"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.bounds === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bounds"},message:"must have required property '"+"bounds"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "id") || (key0 === "runId")) || (key0 === "glyphIndex")) || (key0 === "glyphId")) || (key0 === "cluster")) || (key0 === "visible")) || (key0 === "bounds"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 160){
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/glyphMetadataId/maxLength",keyword:"maxLength",params:{limit: 160},message:"must NOT have more than 160 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func3(data0) < 1){
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/glyphMetadataId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!pattern4.test(data0)){
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/glyphMetadataId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/glyphMetadataId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.runId !== undefined){
let data1 = data.runId;
if(typeof data1 === "string"){
if(func3(data1) > 128){
const err12 = {instancePath:instancePath+"/runId",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(func3(data1) < 1){
const err13 = {instancePath:instancePath+"/runId",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!pattern4.test(data1)){
const err14 = {instancePath:instancePath+"/runId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/runId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.glyphIndex !== undefined){
let data2 = data.glyphIndex;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err16 = {instancePath:instancePath+"/glyphIndex",schemaPath:"#/properties/glyphIndex/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000000 || isNaN(data2)){
const err17 = {instancePath:instancePath+"/glyphIndex",schemaPath:"#/properties/glyphIndex/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data2 < 0 || isNaN(data2)){
const err18 = {instancePath:instancePath+"/glyphIndex",schemaPath:"#/properties/glyphIndex/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
if(data.glyphId !== undefined){
let data3 = data.glyphId;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err19 = {instancePath:instancePath+"/glyphId",schemaPath:"#/properties/glyphId/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 4294967295 || isNaN(data3)){
const err20 = {instancePath:instancePath+"/glyphId",schemaPath:"#/properties/glyphId/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4294967295},message:"must be <= 4294967295"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data3 < 0 || isNaN(data3)){
const err21 = {instancePath:instancePath+"/glyphId",schemaPath:"#/properties/glyphId/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
if(data.cluster !== undefined){
let data4 = data.cluster;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err22 = {instancePath:instancePath+"/cluster",schemaPath:"#/properties/cluster/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 1000000 || isNaN(data4)){
const err23 = {instancePath:instancePath+"/cluster",schemaPath:"#/properties/cluster/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data4 < 0 || isNaN(data4)){
const err24 = {instancePath:instancePath+"/cluster",schemaPath:"#/properties/cluster/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
if(data.visible !== undefined){
if(typeof data.visible !== "boolean"){
const err25 = {instancePath:instancePath+"/visible",schemaPath:"#/properties/visible/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.bounds !== undefined){
let data6 = data.bounds;
const _errs17 = errors;
let valid3 = false;
let passing0 = null;
const _errs18 = errors;
if(data6 !== null){
const err26 = {instancePath:instancePath+"/bounds",schemaPath:"#/properties/bounds/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
var _valid0 = _errs18 === errors;
if(_valid0){
valid3 = true;
passing0 = 0;
}
const _errs20 = errors;
if(data6 && typeof data6 == "object" && !Array.isArray(data6)){
if(data6.x === undefined){
const err27 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data6.y === undefined){
const err28 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data6.width === undefined){
const err29 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data6.height === undefined){
const err30 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
for(const key1 in data6){
if(!((((key1 === "x") || (key1 === "y")) || (key1 === "width")) || (key1 === "height"))){
const err31 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data6.x !== undefined){
let data7 = data6.x;
if(!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))){
const err32 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/bounds/properties/x/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 4096 || isNaN(data7)){
const err33 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/bounds/properties/x/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data7 < 0 || isNaN(data7)){
const err34 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/bounds/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
if(data6.y !== undefined){
let data8 = data6.y;
if(!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))){
const err35 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/bounds/properties/y/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 4096 || isNaN(data8)){
const err36 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/bounds/properties/y/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data8 < 0 || isNaN(data8)){
const err37 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/bounds/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
if(data6.width !== undefined){
let data9 = data6.width;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err38 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/bounds/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 > 4096 || isNaN(data9)){
const err39 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/bounds/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data9 < 0 || isNaN(data9)){
const err40 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/bounds/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
if(data6.height !== undefined){
let data10 = data6.height;
if(!(((typeof data10 == "number") && (!(data10 % 1) && !isNaN(data10))) && (isFinite(data10)))){
const err41 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/bounds/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if((typeof data10 == "number") && (isFinite(data10))){
if(data10 > 4096 || isNaN(data10)){
const err42 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/bounds/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(data10 < 0 || isNaN(data10)){
const err43 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/bounds/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
}
}
else {
const err44 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
var _valid0 = _errs20 === errors;
if(_valid0 && valid3){
valid3 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid3 = true;
passing0 = 1;
}
}
if(!valid3){
const err45 = {instancePath:instancePath+"/bounds",schemaPath:"#/properties/bounds/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
else {
errors = _errs17;
if(vErrors !== null){
if(_errs17){
vErrors.length = _errs17;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err46 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
validate259.errors = vErrors;
return errors === 0;
}
validate259.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema356 = {"type":"object","additionalProperties":false,"required":["width","height","ids","encoding","byteLength","digest","data"],"properties":{"width":{"type":"integer","minimum":1,"maximum":4096},"height":{"type":"integer","minimum":1,"maximum":4096},"ids":{"type":"array","maxItems":1000000,"items":{"$ref":"#/$defs/glyphMetadataId"}},"encoding":{"const":"uint32le-base64"},"byteLength":{"type":"integer","minimum":4,"maximum":16777216},"digest":{"$ref":"#/$defs/digest"},"data":{"$ref":"#/$defs/base64"}}};

function validate261(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate261.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.width === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.height === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.ids === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ids"},message:"must have required property '"+"ids"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.encoding === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "encoding"},message:"must have required property '"+"encoding"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.byteLength === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "byteLength"},message:"must have required property '"+"byteLength"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.digest === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.data === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "data"},message:"must have required property '"+"data"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "width") || (key0 === "height")) || (key0 === "ids")) || (key0 === "encoding")) || (key0 === "byteLength")) || (key0 === "digest")) || (key0 === "data"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.width !== undefined){
let data0 = data.width;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err8 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 4096 || isNaN(data0)){
const err9 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data0 < 1 || isNaN(data0)){
const err10 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
if(data.height !== undefined){
let data1 = data.height;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err11 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 4096 || isNaN(data1)){
const err12 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err13 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data.ids !== undefined){
let data2 = data.ids;
if(Array.isArray(data2)){
if(data2.length > 1000000){
const err14 = {instancePath:instancePath+"/ids",schemaPath:"#/properties/ids/maxItems",keyword:"maxItems",params:{limit: 1000000},message:"must NOT have more than 1000000 items"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
const len0 = data2.length;
for(let i0=0; i0<len0; i0++){
let data3 = data2[i0];
if(typeof data3 === "string"){
if(func3(data3) > 160){
const err15 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/glyphMetadataId/maxLength",keyword:"maxLength",params:{limit: 160},message:"must NOT have more than 160 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(func3(data3) < 1){
const err16 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/glyphMetadataId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(!pattern4.test(data3)){
const err17 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/glyphMetadataId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/glyphMetadataId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath:instancePath+"/ids",schemaPath:"#/properties/ids/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.encoding !== undefined){
if("uint32le-base64" !== data.encoding){
const err20 = {instancePath:instancePath+"/encoding",schemaPath:"#/properties/encoding/const",keyword:"const",params:{allowedValue: "uint32le-base64"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.byteLength !== undefined){
let data5 = data.byteLength;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err21 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 16777216 || isNaN(data5)){
const err22 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16777216},message:"must be <= 16777216"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data5 < 4 || isNaN(data5)){
const err23 = {instancePath:instancePath+"/byteLength",schemaPath:"#/properties/byteLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 4},message:"must be >= 4"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
if(data.digest !== undefined){
let data6 = data.digest;
if(typeof data6 === "string"){
if(!pattern9.test(data6)){
const err24 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.data !== undefined){
let data7 = data.data;
if(typeof data7 === "string"){
if(!pattern161.test(data7)){
const err26 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/base64/pattern",keyword:"pattern",params:{pattern: "^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$"},message:"must match pattern \""+"^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$"+"\""};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/base64/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
validate261.errors = vErrors;
return errors === 0;
}
validate261.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema360 = {"type":"object","additionalProperties":false,"required":["severity","code","message"],"properties":{"severity":{"enum":["warning","error"]},"code":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9-]*$"},"target":{"$ref":"#/$defs/id"},"message":{"type":"string","minLength":1,"maxLength":4096}}};

function validate263(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate263.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.severity === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "severity"},message:"must have required property '"+"severity"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.code === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "code"},message:"must have required property '"+"code"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.message === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "message"},message:"must have required property '"+"message"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "severity") || (key0 === "code")) || (key0 === "target")) || (key0 === "message"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.severity !== undefined){
let data0 = data.severity;
if(!((data0 === "warning") || (data0 === "error"))){
const err4 = {instancePath:instancePath+"/severity",schemaPath:"#/properties/severity/enum",keyword:"enum",params:{allowedValues: schema360.properties.severity.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.code !== undefined){
let data1 = data.code;
if(typeof data1 === "string"){
if(func3(data1) > 128){
const err5 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func3(data1) < 1){
const err6 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern60.test(data1)){
const err7 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/code",schemaPath:"#/properties/code/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.target !== undefined){
let data2 = data.target;
if(typeof data2 === "string"){
if(func3(data2) > 128){
const err9 = {instancePath:instancePath+"/target",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func3(data2) < 1){
const err10 = {instancePath:instancePath+"/target",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!pattern4.test(data2)){
const err11 = {instancePath:instancePath+"/target",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/target",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.message !== undefined){
let data3 = data.message;
if(typeof data3 === "string"){
if(func3(data3) > 4096){
const err13 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/maxLength",keyword:"maxLength",params:{limit: 4096},message:"must NOT have more than 4096 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(func3(data3) < 1){
const err14 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate263.errors = vErrors;
return errors === 0;
}
validate263.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate251(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/glyph-raster-result.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate251.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.requestId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.projectionDigest === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "projectionDigest"},message:"must have required property '"+"projectionDigest"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.rasterizer === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "rasterizer"},message:"must have required property '"+"rasterizer"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.options === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "options"},message:"must have required property '"+"options"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.artifact === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "artifact"},message:"must have required property '"+"artifact"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.pixelModel === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelModel"},message:"must have required property '"+"pixelModel"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.pixelDigest === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelDigest"},message:"must have required property '"+"pixelDigest"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.glyphs === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "glyphs"},message:"must have required property '"+"glyphs"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data.glyphMap === undefined){
const err11 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "glyphMap"},message:"must have required property '"+"glyphMap"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data.diagnostics === undefined){
const err12 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "diagnostics"},message:"must have required property '"+"diagnostics"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data.timing === undefined){
const err13 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "timing"},message:"must have required property '"+"timing"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema341.properties, key0))){
const err14 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/glyph-raster-result.schema.json" !== data.$schema){
const err15 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/glyph-raster-result.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-glyph-raster-result" !== data.format){
const err16 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-glyph-raster-result"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err17 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.requestId !== undefined){
let data3 = data.requestId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err18 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(func3(data3) < 1){
const err19 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(!pattern4.test(data3)){
const err20 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/requestId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.projectionDigest !== undefined){
let data4 = data.projectionDigest;
if(typeof data4 === "string"){
if(!pattern9.test(data4)){
const err22 = {instancePath:instancePath+"/projectionDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
else {
const err23 = {instancePath:instancePath+"/projectionDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.rasterizer !== undefined){
if(!(validate252(data.rasterizer, {instancePath:instancePath+"/rasterizer",parentData:data,parentDataProperty:"rasterizer",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate252.errors : vErrors.concat(validate252.errors);
errors = vErrors.length;
}
}
if(data.options !== undefined){
if(!(validate254(data.options, {instancePath:instancePath+"/options",parentData:data,parentDataProperty:"options",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate254.errors : vErrors.concat(validate254.errors);
errors = vErrors.length;
}
}
if(data.artifact !== undefined){
if(!(validate257(data.artifact, {instancePath:instancePath+"/artifact",parentData:data,parentDataProperty:"artifact",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate257.errors : vErrors.concat(validate257.errors);
errors = vErrors.length;
}
}
if(data.pixelModel !== undefined){
if("rgba8-srgb-straight-transparent-zero" !== data.pixelModel){
const err24 = {instancePath:instancePath+"/pixelModel",schemaPath:"#/properties/pixelModel/const",keyword:"const",params:{allowedValue: "rgba8-srgb-straight-transparent-zero"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.pixelDigest !== undefined){
let data9 = data.pixelDigest;
if(typeof data9 === "string"){
if(!pattern9.test(data9)){
const err25 = {instancePath:instancePath+"/pixelDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
else {
const err26 = {instancePath:instancePath+"/pixelDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.glyphs !== undefined){
let data10 = data.glyphs;
if(Array.isArray(data10)){
if(data10.length > 1000000){
const err27 = {instancePath:instancePath+"/glyphs",schemaPath:"#/properties/glyphs/maxItems",keyword:"maxItems",params:{limit: 1000000},message:"must NOT have more than 1000000 items"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
const len0 = data10.length;
for(let i0=0; i0<len0; i0++){
if(!(validate259(data10[i0], {instancePath:instancePath+"/glyphs/" + i0,parentData:data10,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate259.errors : vErrors.concat(validate259.errors);
errors = vErrors.length;
}
}
}
else {
const err28 = {instancePath:instancePath+"/glyphs",schemaPath:"#/properties/glyphs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.glyphMap !== undefined){
let data12 = data.glyphMap;
const _errs22 = errors;
let valid6 = false;
let passing0 = null;
const _errs23 = errors;
if(data12 !== null){
const err29 = {instancePath:instancePath+"/glyphMap",schemaPath:"#/properties/glyphMap/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
var _valid0 = _errs23 === errors;
if(_valid0){
valid6 = true;
passing0 = 0;
}
const _errs25 = errors;
if(!(validate261(data12, {instancePath:instancePath+"/glyphMap",parentData:data,parentDataProperty:"glyphMap",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate261.errors : vErrors.concat(validate261.errors);
errors = vErrors.length;
}
var _valid0 = _errs25 === errors;
if(_valid0 && valid6){
valid6 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid6 = true;
passing0 = 1;
}
}
if(!valid6){
const err30 = {instancePath:instancePath+"/glyphMap",schemaPath:"#/properties/glyphMap/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
else {
errors = _errs22;
if(vErrors !== null){
if(_errs22){
vErrors.length = _errs22;
}
else {
vErrors = null;
}
}
}
}
if(data.diagnostics !== undefined){
let data13 = data.diagnostics;
if(Array.isArray(data13)){
if(data13.length > 10000){
const err31 = {instancePath:instancePath+"/diagnostics",schemaPath:"#/properties/diagnostics/maxItems",keyword:"maxItems",params:{limit: 10000},message:"must NOT have more than 10000 items"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
const len1 = data13.length;
for(let i1=0; i1<len1; i1++){
if(!(validate263(data13[i1], {instancePath:instancePath+"/diagnostics/" + i1,parentData:data13,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate263.errors : vErrors.concat(validate263.errors);
errors = vErrors.length;
}
}
}
else {
const err32 = {instancePath:instancePath+"/diagnostics",schemaPath:"#/properties/diagnostics/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.timing !== undefined){
let data15 = data.timing;
if(data15 && typeof data15 == "object" && !Array.isArray(data15)){
if(data15.validationMs === undefined){
const err33 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/required",keyword:"required",params:{missingProperty: "validationMs"},message:"must have required property '"+"validationMs"+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data15.renderMs === undefined){
const err34 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/required",keyword:"required",params:{missingProperty: "renderMs"},message:"must have required property '"+"renderMs"+"'"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data15.glyphMapMs === undefined){
const err35 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/required",keyword:"required",params:{missingProperty: "glyphMapMs"},message:"must have required property '"+"glyphMapMs"+"'"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data15.encodeMs === undefined){
const err36 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/required",keyword:"required",params:{missingProperty: "encodeMs"},message:"must have required property '"+"encodeMs"+"'"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data15.totalMs === undefined){
const err37 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/required",keyword:"required",params:{missingProperty: "totalMs"},message:"must have required property '"+"totalMs"+"'"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
for(const key1 in data15){
if(!(((((key1 === "validationMs") || (key1 === "renderMs")) || (key1 === "glyphMapMs")) || (key1 === "encodeMs")) || (key1 === "totalMs"))){
const err38 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data15.validationMs !== undefined){
let data16 = data15.validationMs;
if((typeof data16 == "number") && (isFinite(data16))){
if(data16 > 86400000 || isNaN(data16)){
const err39 = {instancePath:instancePath+"/timing/validationMs",schemaPath:"#/$defs/timing/properties/validationMs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 86400000},message:"must be <= 86400000"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data16 < 0 || isNaN(data16)){
const err40 = {instancePath:instancePath+"/timing/validationMs",schemaPath:"#/$defs/timing/properties/validationMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
else {
const err41 = {instancePath:instancePath+"/timing/validationMs",schemaPath:"#/$defs/timing/properties/validationMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
if(data15.renderMs !== undefined){
let data17 = data15.renderMs;
if((typeof data17 == "number") && (isFinite(data17))){
if(data17 > 86400000 || isNaN(data17)){
const err42 = {instancePath:instancePath+"/timing/renderMs",schemaPath:"#/$defs/timing/properties/renderMs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 86400000},message:"must be <= 86400000"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(data17 < 0 || isNaN(data17)){
const err43 = {instancePath:instancePath+"/timing/renderMs",schemaPath:"#/$defs/timing/properties/renderMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
else {
const err44 = {instancePath:instancePath+"/timing/renderMs",schemaPath:"#/$defs/timing/properties/renderMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
if(data15.glyphMapMs !== undefined){
let data18 = data15.glyphMapMs;
if((typeof data18 == "number") && (isFinite(data18))){
if(data18 > 86400000 || isNaN(data18)){
const err45 = {instancePath:instancePath+"/timing/glyphMapMs",schemaPath:"#/$defs/timing/properties/glyphMapMs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 86400000},message:"must be <= 86400000"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
if(data18 < 0 || isNaN(data18)){
const err46 = {instancePath:instancePath+"/timing/glyphMapMs",schemaPath:"#/$defs/timing/properties/glyphMapMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
else {
const err47 = {instancePath:instancePath+"/timing/glyphMapMs",schemaPath:"#/$defs/timing/properties/glyphMapMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
if(data15.encodeMs !== undefined){
let data19 = data15.encodeMs;
if((typeof data19 == "number") && (isFinite(data19))){
if(data19 > 86400000 || isNaN(data19)){
const err48 = {instancePath:instancePath+"/timing/encodeMs",schemaPath:"#/$defs/timing/properties/encodeMs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 86400000},message:"must be <= 86400000"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
if(data19 < 0 || isNaN(data19)){
const err49 = {instancePath:instancePath+"/timing/encodeMs",schemaPath:"#/$defs/timing/properties/encodeMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
else {
const err50 = {instancePath:instancePath+"/timing/encodeMs",schemaPath:"#/$defs/timing/properties/encodeMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
if(data15.totalMs !== undefined){
let data20 = data15.totalMs;
if((typeof data20 == "number") && (isFinite(data20))){
if(data20 > 86400000 || isNaN(data20)){
const err51 = {instancePath:instancePath+"/timing/totalMs",schemaPath:"#/$defs/timing/properties/totalMs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 86400000},message:"must be <= 86400000"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
if(data20 < 0 || isNaN(data20)){
const err52 = {instancePath:instancePath+"/timing/totalMs",schemaPath:"#/$defs/timing/properties/totalMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
else {
const err53 = {instancePath:instancePath+"/timing/totalMs",schemaPath:"#/$defs/timing/properties/totalMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
}
else {
const err54 = {instancePath:instancePath+"/timing",schemaPath:"#/$defs/timing/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
}
else {
const err55 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
validate251.errors = vErrors;
return errors === 0;
}
validate251.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateGlyphRasterRegistrySchema = validate265;
const schema363 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/glyph-raster-registry.schema.json","title":"Maipo glyph raster conformance registry 0.1","type":"object","additionalProperties":false,"required":["$schema","format","version","requestSchema","resultSchema","outlineRegistry","model","referenceRasterizer","cases","scope"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/glyph-raster-registry.schema.json"},"format":{"const":"maipo-glyph-raster-registry"},"version":{"const":"0.1"},"requestSchema":{"$ref":"#/$defs/requestSchema"},"resultSchema":{"$ref":"#/$defs/resultSchema"},"outlineRegistry":{"$ref":"#/$defs/sourceResource"},"model":{"$ref":"#/$defs/model"},"referenceRasterizer":{"$ref":"#/$defs/referenceRasterizer"},"cases":{"type":"array","minItems":1,"maxItems":1024,"items":{"$ref":"#/$defs/case"}},"scope":{"type":"object","additionalProperties":false,"required":["verified","notYetDefined"],"properties":{"verified":{"$ref":"#/$defs/uniqueTokens"},"notYetDefined":{"$ref":"#/$defs/uniqueTokens"}}}},"$defs":{"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"token":{"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9.-]*$"},"uniqueTokens":{"type":"array","minItems":1,"maxItems":128,"items":{"$ref":"#/$defs/token"}},"sourceResource":{"type":"object","additionalProperties":false,"required":["source","digest"],"properties":{"source":{"type":"string","minLength":1,"maxLength":256,"pattern":"^[A-Za-z0-9._/-]+$"},"digest":{"$ref":"#/$defs/digest"}}},"requestSchema":{"type":"object","additionalProperties":false,"required":["id","source","digest"],"properties":{"id":{"const":"https://maipo.design/schema/0.1/glyph-raster-request.schema.json"},"source":{"const":"schema/maipo-glyph-raster-request-0.1.schema.json"},"digest":{"$ref":"#/$defs/digest"}}},"resultSchema":{"type":"object","additionalProperties":false,"required":["id","source","digest"],"properties":{"id":{"const":"https://maipo.design/schema/0.1/glyph-raster-result.schema.json"},"source":{"const":"schema/maipo-glyph-raster-result-0.1.schema.json"},"digest":{"$ref":"#/$defs/digest"}}},"model":{"type":"object","additionalProperties":false,"required":["inputCoordinateSpace","fit","compositing","fillRule","glyphBoundsMeaning","pixelModel","pngEncoding","glyphMapEncoding","glyphMapOwnerRule"],"properties":{"inputCoordinateSpace":{"const":"font-units-y-up"},"fit":{"const":"contain-with-integer-padding"},"compositing":{"const":"source-over-run-glyph-order"},"fillRule":{"const":"nonzero"},"glyphBoundsMeaning":{"const":"transformed-clipped-opentype-extents"},"pixelModel":{"const":"rgba8-srgb-straight-transparent-zero"},"pngEncoding":{"const":"canvas-to-blob-image-png"},"glyphMapEncoding":{"const":"uint32le"},"glyphMapOwnerRule":{"const":"nonzero-alpha-last-painted-wins"}}},"referenceRasterizer":{"type":"object","additionalProperties":false,"required":["package","version","backend","runtime"],"properties":{"package":{"const":"@maipo/glyph-rasterizer"},"version":{"const":"0.1.0"},"backend":{"const":"canvas2d"},"runtime":{"$ref":"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime"}}},"case":{"type":"object","additionalProperties":false,"required":["id","projection","request","png","glyphMap","projectionDigest","requestDigest","pngDigest","pixelDigest","glyphMapDigest","glyphs","assertions"],"properties":{"id":{"$ref":"#/$defs/token"},"projection":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.outlines\\.json$"},"request":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.raster-request\\.json$"},"png":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.raster\\.png$"},"glyphMap":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.glyphmap\\.bin$"},"projectionDigest":{"$ref":"#/$defs/digest"},"requestDigest":{"$ref":"#/$defs/digest"},"pngDigest":{"$ref":"#/$defs/digest"},"pixelDigest":{"$ref":"#/$defs/digest"},"glyphMapDigest":{"$ref":"#/$defs/digest"},"glyphs":{"type":"array","maxItems":1000000,"items":{"$ref":"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/glyph"}},"assertions":{"type":"object","additionalProperties":false,"required":["width","height","glyphCount","outlineGlyphCount","ownedPixelCount"],"properties":{"width":{"type":"integer","minimum":1,"maximum":4096},"height":{"type":"integer","minimum":1,"maximum":4096},"glyphCount":{"type":"integer","minimum":0,"maximum":1000000},"outlineGlyphCount":{"type":"integer","minimum":0,"maximum":1000000},"ownedPixelCount":{"type":"integer","minimum":0,"maximum":4194304}}}}}}};
const schema370 = {"type":"object","additionalProperties":false,"required":["inputCoordinateSpace","fit","compositing","fillRule","glyphBoundsMeaning","pixelModel","pngEncoding","glyphMapEncoding","glyphMapOwnerRule"],"properties":{"inputCoordinateSpace":{"const":"font-units-y-up"},"fit":{"const":"contain-with-integer-padding"},"compositing":{"const":"source-over-run-glyph-order"},"fillRule":{"const":"nonzero"},"glyphBoundsMeaning":{"const":"transformed-clipped-opentype-extents"},"pixelModel":{"const":"rgba8-srgb-straight-transparent-zero"},"pngEncoding":{"const":"canvas-to-blob-image-png"},"glyphMapEncoding":{"const":"uint32le"},"glyphMapOwnerRule":{"const":"nonzero-alpha-last-painted-wins"}}};
const schema364 = {"type":"object","additionalProperties":false,"required":["id","source","digest"],"properties":{"id":{"const":"https://maipo.design/schema/0.1/glyph-raster-request.schema.json"},"source":{"const":"schema/maipo-glyph-raster-request-0.1.schema.json"},"digest":{"$ref":"#/$defs/digest"}}};
const schema365 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};

function validate266(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate266.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.source === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.digest === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "id") || (key0 === "source")) || (key0 === "digest"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
if("https://maipo.design/schema/0.1/glyph-raster-request.schema.json" !== data.id){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/glyph-raster-request.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.source !== undefined){
if("schema/maipo-glyph-raster-request-0.1.schema.json" !== data.source){
const err5 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/const",keyword:"const",params:{allowedValue: "schema/maipo-glyph-raster-request-0.1.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.digest !== undefined){
let data2 = data.digest;
if(typeof data2 === "string"){
if(!pattern9.test(data2)){
const err6 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate266.errors = vErrors;
return errors === 0;
}
validate266.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema366 = {"type":"object","additionalProperties":false,"required":["id","source","digest"],"properties":{"id":{"const":"https://maipo.design/schema/0.1/glyph-raster-result.schema.json"},"source":{"const":"schema/maipo-glyph-raster-result-0.1.schema.json"},"digest":{"$ref":"#/$defs/digest"}}};

function validate268(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate268.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.source === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.digest === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "id") || (key0 === "source")) || (key0 === "digest"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
if("https://maipo.design/schema/0.1/glyph-raster-result.schema.json" !== data.id){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/glyph-raster-result.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.source !== undefined){
if("schema/maipo-glyph-raster-result-0.1.schema.json" !== data.source){
const err5 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/const",keyword:"const",params:{allowedValue: "schema/maipo-glyph-raster-result-0.1.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.digest !== undefined){
let data2 = data.digest;
if(typeof data2 === "string"){
if(!pattern9.test(data2)){
const err6 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate268.errors = vErrors;
return errors === 0;
}
validate268.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema368 = {"type":"object","additionalProperties":false,"required":["source","digest"],"properties":{"source":{"type":"string","minLength":1,"maxLength":256,"pattern":"^[A-Za-z0-9._/-]+$"},"digest":{"$ref":"#/$defs/digest"}}};

function validate270(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate270.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.source === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.digest === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "source") || (key0 === "digest"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.source !== undefined){
let data0 = data.source;
if(typeof data0 === "string"){
if(func3(data0) > 256){
const err3 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func3(data0) < 1){
const err4 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern138.test(data0)){
const err5 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9._/-]+$"},message:"must match pattern \""+"^[A-Za-z0-9._/-]+$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.digest !== undefined){
let data1 = data.digest;
if(typeof data1 === "string"){
if(!pattern9.test(data1)){
const err7 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate270.errors = vErrors;
return errors === 0;
}
validate270.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema371 = {"type":"object","additionalProperties":false,"required":["package","version","backend","runtime"],"properties":{"package":{"const":"@maipo/glyph-rasterizer"},"version":{"const":"0.1.0"},"backend":{"const":"canvas2d"},"runtime":{"$ref":"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime"}}};

function validate272(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate272.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.package === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "package"},message:"must have required property '"+"package"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.backend === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.runtime === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "runtime"},message:"must have required property '"+"runtime"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "package") || (key0 === "version")) || (key0 === "backend")) || (key0 === "runtime"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.package !== undefined){
if("@maipo/glyph-rasterizer" !== data.package){
const err5 = {instancePath:instancePath+"/package",schemaPath:"#/properties/package/const",keyword:"const",params:{allowedValue: "@maipo/glyph-rasterizer"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1.0" !== data.version){
const err6 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1.0"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.backend !== undefined){
if("canvas2d" !== data.backend){
const err7 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/const",keyword:"const",params:{allowedValue: "canvas2d"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.runtime !== undefined){
let data3 = data.runtime;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.engine === undefined){
const err8 = {instancePath:instancePath+"/runtime",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/required",keyword:"required",params:{missingProperty: "engine"},message:"must have required property '"+"engine"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data3.version === undefined){
const err9 = {instancePath:instancePath+"/runtime",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data3.platform === undefined){
const err10 = {instancePath:instancePath+"/runtime",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/required",keyword:"required",params:{missingProperty: "platform"},message:"must have required property '"+"platform"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data3.deviceScaleFactor === undefined){
const err11 = {instancePath:instancePath+"/runtime",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/required",keyword:"required",params:{missingProperty: "deviceScaleFactor"},message:"must have required property '"+"deviceScaleFactor"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data3.colorSpace === undefined){
const err12 = {instancePath:instancePath+"/runtime",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/required",keyword:"required",params:{missingProperty: "colorSpace"},message:"must have required property '"+"colorSpace"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
for(const key1 in data3){
if(!(((((key1 === "engine") || (key1 === "version")) || (key1 === "platform")) || (key1 === "deviceScaleFactor")) || (key1 === "colorSpace"))){
const err13 = {instancePath:instancePath+"/runtime",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data3.engine !== undefined){
let data4 = data3.engine;
if(typeof data4 === "string"){
if(func3(data4) > 128){
const err14 = {instancePath:instancePath+"/runtime/engine",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/engine/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(func3(data4) < 1){
const err15 = {instancePath:instancePath+"/runtime/engine",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/engine/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/runtime/engine",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/engine/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data3.version !== undefined){
let data5 = data3.version;
if(typeof data5 === "string"){
if(func3(data5) > 128){
const err17 = {instancePath:instancePath+"/runtime/version",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/version/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(func3(data5) < 1){
const err18 = {instancePath:instancePath+"/runtime/version",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/runtime/version",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data3.platform !== undefined){
let data6 = data3.platform;
if(typeof data6 === "string"){
if(func3(data6) > 128){
const err20 = {instancePath:instancePath+"/runtime/platform",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/platform/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(func3(data6) < 1){
const err21 = {instancePath:instancePath+"/runtime/platform",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/platform/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/runtime/platform",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/platform/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data3.deviceScaleFactor !== undefined){
let data7 = data3.deviceScaleFactor;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 16 || isNaN(data7)){
const err23 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/deviceScaleFactor/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16},message:"must be <= 16"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data7 <= 0 || isNaN(data7)){
const err24 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/deviceScaleFactor/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/runtime/deviceScaleFactor",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/deviceScaleFactor/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data3.colorSpace !== undefined){
if("srgb" !== data3.colorSpace){
const err26 = {instancePath:instancePath+"/runtime/colorSpace",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/properties/colorSpace/const",keyword:"const",params:{allowedValue: "srgb"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
else {
const err27 = {instancePath:instancePath+"/runtime",schemaPath:"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/runtime/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
validate272.errors = vErrors;
return errors === 0;
}
validate272.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema373 = {"type":"object","additionalProperties":false,"required":["id","projection","request","png","glyphMap","projectionDigest","requestDigest","pngDigest","pixelDigest","glyphMapDigest","glyphs","assertions"],"properties":{"id":{"$ref":"#/$defs/token"},"projection":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.outlines\\.json$"},"request":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.raster-request\\.json$"},"png":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.raster\\.png$"},"glyphMap":{"type":"string","pattern":"^fixtures/[A-Za-z0-9._-]+\\.glyphmap\\.bin$"},"projectionDigest":{"$ref":"#/$defs/digest"},"requestDigest":{"$ref":"#/$defs/digest"},"pngDigest":{"$ref":"#/$defs/digest"},"pixelDigest":{"$ref":"#/$defs/digest"},"glyphMapDigest":{"$ref":"#/$defs/digest"},"glyphs":{"type":"array","maxItems":1000000,"items":{"$ref":"https://maipo.design/schema/0.1/glyph-raster-result.schema.json#/$defs/glyph"}},"assertions":{"type":"object","additionalProperties":false,"required":["width","height","glyphCount","outlineGlyphCount","ownedPixelCount"],"properties":{"width":{"type":"integer","minimum":1,"maximum":4096},"height":{"type":"integer","minimum":1,"maximum":4096},"glyphCount":{"type":"integer","minimum":0,"maximum":1000000},"outlineGlyphCount":{"type":"integer","minimum":0,"maximum":1000000},"ownedPixelCount":{"type":"integer","minimum":0,"maximum":4194304}}}}};
const schema374 = {"type":"string","minLength":1,"maxLength":128,"pattern":"^[a-z0-9][a-z0-9.-]*$"};
const pattern176 = new RegExp("^fixtures/[A-Za-z0-9._-]+\\.raster-request\\.json$", "u");
const pattern177 = new RegExp("^fixtures/[A-Za-z0-9._-]+\\.raster\\.png$", "u");
const pattern178 = new RegExp("^fixtures/[A-Za-z0-9._-]+\\.glyphmap\\.bin$", "u");

function validate275(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate275.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.runId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "runId"},message:"must have required property '"+"runId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.glyphIndex === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "glyphIndex"},message:"must have required property '"+"glyphIndex"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.glyphId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "glyphId"},message:"must have required property '"+"glyphId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.cluster === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "cluster"},message:"must have required property '"+"cluster"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.visible === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "visible"},message:"must have required property '"+"visible"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.bounds === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bounds"},message:"must have required property '"+"bounds"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "id") || (key0 === "runId")) || (key0 === "glyphIndex")) || (key0 === "glyphId")) || (key0 === "cluster")) || (key0 === "visible")) || (key0 === "bounds"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 160){
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/glyphMetadataId/maxLength",keyword:"maxLength",params:{limit: 160},message:"must NOT have more than 160 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func3(data0) < 1){
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/glyphMetadataId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!pattern4.test(data0)){
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/glyphMetadataId/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/glyphMetadataId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.runId !== undefined){
let data1 = data.runId;
if(typeof data1 === "string"){
if(func3(data1) > 128){
const err12 = {instancePath:instancePath+"/runId",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(func3(data1) < 1){
const err13 = {instancePath:instancePath+"/runId",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!pattern4.test(data1)){
const err14 = {instancePath:instancePath+"/runId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/runId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.glyphIndex !== undefined){
let data2 = data.glyphIndex;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err16 = {instancePath:instancePath+"/glyphIndex",schemaPath:"#/properties/glyphIndex/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1000000 || isNaN(data2)){
const err17 = {instancePath:instancePath+"/glyphIndex",schemaPath:"#/properties/glyphIndex/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data2 < 0 || isNaN(data2)){
const err18 = {instancePath:instancePath+"/glyphIndex",schemaPath:"#/properties/glyphIndex/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
if(data.glyphId !== undefined){
let data3 = data.glyphId;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err19 = {instancePath:instancePath+"/glyphId",schemaPath:"#/properties/glyphId/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 4294967295 || isNaN(data3)){
const err20 = {instancePath:instancePath+"/glyphId",schemaPath:"#/properties/glyphId/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4294967295},message:"must be <= 4294967295"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data3 < 0 || isNaN(data3)){
const err21 = {instancePath:instancePath+"/glyphId",schemaPath:"#/properties/glyphId/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
if(data.cluster !== undefined){
let data4 = data.cluster;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err22 = {instancePath:instancePath+"/cluster",schemaPath:"#/properties/cluster/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 1000000 || isNaN(data4)){
const err23 = {instancePath:instancePath+"/cluster",schemaPath:"#/properties/cluster/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data4 < 0 || isNaN(data4)){
const err24 = {instancePath:instancePath+"/cluster",schemaPath:"#/properties/cluster/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
if(data.visible !== undefined){
if(typeof data.visible !== "boolean"){
const err25 = {instancePath:instancePath+"/visible",schemaPath:"#/properties/visible/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.bounds !== undefined){
let data6 = data.bounds;
const _errs17 = errors;
let valid3 = false;
let passing0 = null;
const _errs18 = errors;
if(data6 !== null){
const err26 = {instancePath:instancePath+"/bounds",schemaPath:"#/properties/bounds/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
var _valid0 = _errs18 === errors;
if(_valid0){
valid3 = true;
passing0 = 0;
}
const _errs20 = errors;
if(data6 && typeof data6 == "object" && !Array.isArray(data6)){
if(data6.x === undefined){
const err27 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data6.y === undefined){
const err28 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data6.width === undefined){
const err29 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data6.height === undefined){
const err30 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
for(const key1 in data6){
if(!((((key1 === "x") || (key1 === "y")) || (key1 === "width")) || (key1 === "height"))){
const err31 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data6.x !== undefined){
let data7 = data6.x;
if(!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))){
const err32 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/bounds/properties/x/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 4096 || isNaN(data7)){
const err33 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/bounds/properties/x/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data7 < 0 || isNaN(data7)){
const err34 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/bounds/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
if(data6.y !== undefined){
let data8 = data6.y;
if(!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))){
const err35 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/bounds/properties/y/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 4096 || isNaN(data8)){
const err36 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/bounds/properties/y/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data8 < 0 || isNaN(data8)){
const err37 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/bounds/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
if(data6.width !== undefined){
let data9 = data6.width;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err38 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/bounds/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 > 4096 || isNaN(data9)){
const err39 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/bounds/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data9 < 0 || isNaN(data9)){
const err40 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/bounds/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
if(data6.height !== undefined){
let data10 = data6.height;
if(!(((typeof data10 == "number") && (!(data10 % 1) && !isNaN(data10))) && (isFinite(data10)))){
const err41 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/bounds/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if((typeof data10 == "number") && (isFinite(data10))){
if(data10 > 4096 || isNaN(data10)){
const err42 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/bounds/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(data10 < 0 || isNaN(data10)){
const err43 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/bounds/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
}
}
else {
const err44 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/bounds/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
var _valid0 = _errs20 === errors;
if(_valid0 && valid3){
valid3 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid3 = true;
passing0 = 1;
}
}
if(!valid3){
const err45 = {instancePath:instancePath+"/bounds",schemaPath:"#/properties/bounds/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
else {
errors = _errs17;
if(vErrors !== null){
if(_errs17){
vErrors.length = _errs17;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err46 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
validate275.errors = vErrors;
return errors === 0;
}
validate275.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate274(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate274.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.projection === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "projection"},message:"must have required property '"+"projection"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.request === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "request"},message:"must have required property '"+"request"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.png === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "png"},message:"must have required property '"+"png"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.glyphMap === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "glyphMap"},message:"must have required property '"+"glyphMap"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.projectionDigest === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "projectionDigest"},message:"must have required property '"+"projectionDigest"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.requestDigest === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestDigest"},message:"must have required property '"+"requestDigest"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.pngDigest === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pngDigest"},message:"must have required property '"+"pngDigest"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.pixelDigest === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelDigest"},message:"must have required property '"+"pixelDigest"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.glyphMapDigest === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "glyphMapDigest"},message:"must have required property '"+"glyphMapDigest"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.glyphs === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "glyphs"},message:"must have required property '"+"glyphs"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data.assertions === undefined){
const err11 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assertions"},message:"must have required property '"+"assertions"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema373.properties, key0))){
const err12 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err13 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(func3(data0) < 1){
const err14 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(!pattern130.test(data0)){
const err15 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9.-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9.-]*$"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.projection !== undefined){
let data1 = data.projection;
if(typeof data1 === "string"){
if(!pattern148.test(data1)){
const err17 = {instancePath:instancePath+"/projection",schemaPath:"#/properties/projection/pattern",keyword:"pattern",params:{pattern: "^fixtures/[A-Za-z0-9._-]+\\.outlines\\.json$"},message:"must match pattern \""+"^fixtures/[A-Za-z0-9._-]+\\.outlines\\.json$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/projection",schemaPath:"#/properties/projection/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.request !== undefined){
let data2 = data.request;
if(typeof data2 === "string"){
if(!pattern176.test(data2)){
const err19 = {instancePath:instancePath+"/request",schemaPath:"#/properties/request/pattern",keyword:"pattern",params:{pattern: "^fixtures/[A-Za-z0-9._-]+\\.raster-request\\.json$"},message:"must match pattern \""+"^fixtures/[A-Za-z0-9._-]+\\.raster-request\\.json$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/request",schemaPath:"#/properties/request/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.png !== undefined){
let data3 = data.png;
if(typeof data3 === "string"){
if(!pattern177.test(data3)){
const err21 = {instancePath:instancePath+"/png",schemaPath:"#/properties/png/pattern",keyword:"pattern",params:{pattern: "^fixtures/[A-Za-z0-9._-]+\\.raster\\.png$"},message:"must match pattern \""+"^fixtures/[A-Za-z0-9._-]+\\.raster\\.png$"+"\""};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/png",schemaPath:"#/properties/png/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.glyphMap !== undefined){
let data4 = data.glyphMap;
if(typeof data4 === "string"){
if(!pattern178.test(data4)){
const err23 = {instancePath:instancePath+"/glyphMap",schemaPath:"#/properties/glyphMap/pattern",keyword:"pattern",params:{pattern: "^fixtures/[A-Za-z0-9._-]+\\.glyphmap\\.bin$"},message:"must match pattern \""+"^fixtures/[A-Za-z0-9._-]+\\.glyphmap\\.bin$"+"\""};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/glyphMap",schemaPath:"#/properties/glyphMap/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.projectionDigest !== undefined){
let data5 = data.projectionDigest;
if(typeof data5 === "string"){
if(!pattern9.test(data5)){
const err25 = {instancePath:instancePath+"/projectionDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
else {
const err26 = {instancePath:instancePath+"/projectionDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.requestDigest !== undefined){
let data6 = data.requestDigest;
if(typeof data6 === "string"){
if(!pattern9.test(data6)){
const err27 = {instancePath:instancePath+"/requestDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
else {
const err28 = {instancePath:instancePath+"/requestDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.pngDigest !== undefined){
let data7 = data.pngDigest;
if(typeof data7 === "string"){
if(!pattern9.test(data7)){
const err29 = {instancePath:instancePath+"/pngDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/pngDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data.pixelDigest !== undefined){
let data8 = data.pixelDigest;
if(typeof data8 === "string"){
if(!pattern9.test(data8)){
const err31 = {instancePath:instancePath+"/pixelDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
else {
const err32 = {instancePath:instancePath+"/pixelDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.glyphMapDigest !== undefined){
let data9 = data.glyphMapDigest;
if(typeof data9 === "string"){
if(!pattern9.test(data9)){
const err33 = {instancePath:instancePath+"/glyphMapDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
else {
const err34 = {instancePath:instancePath+"/glyphMapDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data.glyphs !== undefined){
let data10 = data.glyphs;
if(Array.isArray(data10)){
if(data10.length > 1000000){
const err35 = {instancePath:instancePath+"/glyphs",schemaPath:"#/properties/glyphs/maxItems",keyword:"maxItems",params:{limit: 1000000},message:"must NOT have more than 1000000 items"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
const len0 = data10.length;
for(let i0=0; i0<len0; i0++){
if(!(validate275(data10[i0], {instancePath:instancePath+"/glyphs/" + i0,parentData:data10,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate275.errors : vErrors.concat(validate275.errors);
errors = vErrors.length;
}
}
}
else {
const err36 = {instancePath:instancePath+"/glyphs",schemaPath:"#/properties/glyphs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
if(data.assertions !== undefined){
let data12 = data.assertions;
if(data12 && typeof data12 == "object" && !Array.isArray(data12)){
if(data12.width === undefined){
const err37 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(data12.height === undefined){
const err38 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if(data12.glyphCount === undefined){
const err39 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "glyphCount"},message:"must have required property '"+"glyphCount"+"'"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data12.outlineGlyphCount === undefined){
const err40 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "outlineGlyphCount"},message:"must have required property '"+"outlineGlyphCount"+"'"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if(data12.ownedPixelCount === undefined){
const err41 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/required",keyword:"required",params:{missingProperty: "ownedPixelCount"},message:"must have required property '"+"ownedPixelCount"+"'"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
for(const key1 in data12){
if(!(((((key1 === "width") || (key1 === "height")) || (key1 === "glyphCount")) || (key1 === "outlineGlyphCount")) || (key1 === "ownedPixelCount"))){
const err42 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
if(data12.width !== undefined){
let data13 = data12.width;
if(!(((typeof data13 == "number") && (!(data13 % 1) && !isNaN(data13))) && (isFinite(data13)))){
const err43 = {instancePath:instancePath+"/assertions/width",schemaPath:"#/properties/assertions/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
if((typeof data13 == "number") && (isFinite(data13))){
if(data13 > 4096 || isNaN(data13)){
const err44 = {instancePath:instancePath+"/assertions/width",schemaPath:"#/properties/assertions/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
if(data13 < 1 || isNaN(data13)){
const err45 = {instancePath:instancePath+"/assertions/width",schemaPath:"#/properties/assertions/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
}
if(data12.height !== undefined){
let data14 = data12.height;
if(!(((typeof data14 == "number") && (!(data14 % 1) && !isNaN(data14))) && (isFinite(data14)))){
const err46 = {instancePath:instancePath+"/assertions/height",schemaPath:"#/properties/assertions/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
if((typeof data14 == "number") && (isFinite(data14))){
if(data14 > 4096 || isNaN(data14)){
const err47 = {instancePath:instancePath+"/assertions/height",schemaPath:"#/properties/assertions/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
if(data14 < 1 || isNaN(data14)){
const err48 = {instancePath:instancePath+"/assertions/height",schemaPath:"#/properties/assertions/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
}
if(data12.glyphCount !== undefined){
let data15 = data12.glyphCount;
if(!(((typeof data15 == "number") && (!(data15 % 1) && !isNaN(data15))) && (isFinite(data15)))){
const err49 = {instancePath:instancePath+"/assertions/glyphCount",schemaPath:"#/properties/assertions/properties/glyphCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
if((typeof data15 == "number") && (isFinite(data15))){
if(data15 > 1000000 || isNaN(data15)){
const err50 = {instancePath:instancePath+"/assertions/glyphCount",schemaPath:"#/properties/assertions/properties/glyphCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
if(data15 < 0 || isNaN(data15)){
const err51 = {instancePath:instancePath+"/assertions/glyphCount",schemaPath:"#/properties/assertions/properties/glyphCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
}
if(data12.outlineGlyphCount !== undefined){
let data16 = data12.outlineGlyphCount;
if(!(((typeof data16 == "number") && (!(data16 % 1) && !isNaN(data16))) && (isFinite(data16)))){
const err52 = {instancePath:instancePath+"/assertions/outlineGlyphCount",schemaPath:"#/properties/assertions/properties/outlineGlyphCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
if((typeof data16 == "number") && (isFinite(data16))){
if(data16 > 1000000 || isNaN(data16)){
const err53 = {instancePath:instancePath+"/assertions/outlineGlyphCount",schemaPath:"#/properties/assertions/properties/outlineGlyphCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
if(data16 < 0 || isNaN(data16)){
const err54 = {instancePath:instancePath+"/assertions/outlineGlyphCount",schemaPath:"#/properties/assertions/properties/outlineGlyphCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
}
if(data12.ownedPixelCount !== undefined){
let data17 = data12.ownedPixelCount;
if(!(((typeof data17 == "number") && (!(data17 % 1) && !isNaN(data17))) && (isFinite(data17)))){
const err55 = {instancePath:instancePath+"/assertions/ownedPixelCount",schemaPath:"#/properties/assertions/properties/ownedPixelCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
if((typeof data17 == "number") && (isFinite(data17))){
if(data17 > 4194304 || isNaN(data17)){
const err56 = {instancePath:instancePath+"/assertions/ownedPixelCount",schemaPath:"#/properties/assertions/properties/ownedPixelCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4194304},message:"must be <= 4194304"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
if(data17 < 0 || isNaN(data17)){
const err57 = {instancePath:instancePath+"/assertions/ownedPixelCount",schemaPath:"#/properties/assertions/properties/ownedPixelCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
}
}
else {
const err58 = {instancePath:instancePath+"/assertions",schemaPath:"#/properties/assertions/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
}
else {
const err59 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
validate274.errors = vErrors;
return errors === 0;
}
validate274.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema384 = {"type":"array","minItems":1,"maxItems":128,"items":{"$ref":"#/$defs/token"}};

function validate278(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate278.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(Array.isArray(data)){
if(data.length > 128){
const err0 = {instancePath,schemaPath:"#/maxItems",keyword:"maxItems",params:{limit: 128},message:"must NOT have more than 128 items"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.length < 1){
const err1 = {instancePath,schemaPath:"#/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
const len0 = data.length;
for(let i0=0; i0<len0; i0++){
let data0 = data[i0];
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err2 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/token/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(func3(data0) < 1){
const err3 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/token/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(!pattern130.test(data0)){
const err4 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/token/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9.-]*$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9.-]*$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
validate278.errors = vErrors;
return errors === 0;
}
validate278.evaluated = {"items":true,"dynamicProps":false,"dynamicItems":false};


function validate265(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/glyph-raster-registry.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate265.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.requestSchema === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestSchema"},message:"must have required property '"+"requestSchema"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.resultSchema === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "resultSchema"},message:"must have required property '"+"resultSchema"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.outlineRegistry === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "outlineRegistry"},message:"must have required property '"+"outlineRegistry"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.model === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "model"},message:"must have required property '"+"model"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.referenceRasterizer === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "referenceRasterizer"},message:"must have required property '"+"referenceRasterizer"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.cases === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "cases"},message:"must have required property '"+"cases"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.scope === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "scope"},message:"must have required property '"+"scope"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema363.properties, key0))){
const err10 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/glyph-raster-registry.schema.json" !== data.$schema){
const err11 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/glyph-raster-registry.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-glyph-raster-registry" !== data.format){
const err12 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-glyph-raster-registry"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err13 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.requestSchema !== undefined){
if(!(validate266(data.requestSchema, {instancePath:instancePath+"/requestSchema",parentData:data,parentDataProperty:"requestSchema",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate266.errors : vErrors.concat(validate266.errors);
errors = vErrors.length;
}
}
if(data.resultSchema !== undefined){
if(!(validate268(data.resultSchema, {instancePath:instancePath+"/resultSchema",parentData:data,parentDataProperty:"resultSchema",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate268.errors : vErrors.concat(validate268.errors);
errors = vErrors.length;
}
}
if(data.outlineRegistry !== undefined){
if(!(validate270(data.outlineRegistry, {instancePath:instancePath+"/outlineRegistry",parentData:data,parentDataProperty:"outlineRegistry",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate270.errors : vErrors.concat(validate270.errors);
errors = vErrors.length;
}
}
if(data.model !== undefined){
let data6 = data.model;
if(data6 && typeof data6 == "object" && !Array.isArray(data6)){
if(data6.inputCoordinateSpace === undefined){
const err14 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "inputCoordinateSpace"},message:"must have required property '"+"inputCoordinateSpace"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data6.fit === undefined){
const err15 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "fit"},message:"must have required property '"+"fit"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data6.compositing === undefined){
const err16 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "compositing"},message:"must have required property '"+"compositing"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data6.fillRule === undefined){
const err17 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "fillRule"},message:"must have required property '"+"fillRule"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data6.glyphBoundsMeaning === undefined){
const err18 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "glyphBoundsMeaning"},message:"must have required property '"+"glyphBoundsMeaning"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data6.pixelModel === undefined){
const err19 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "pixelModel"},message:"must have required property '"+"pixelModel"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data6.pngEncoding === undefined){
const err20 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "pngEncoding"},message:"must have required property '"+"pngEncoding"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data6.glyphMapEncoding === undefined){
const err21 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "glyphMapEncoding"},message:"must have required property '"+"glyphMapEncoding"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data6.glyphMapOwnerRule === undefined){
const err22 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/required",keyword:"required",params:{missingProperty: "glyphMapOwnerRule"},message:"must have required property '"+"glyphMapOwnerRule"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
for(const key1 in data6){
if(!(func1.call(schema370.properties, key1))){
const err23 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data6.inputCoordinateSpace !== undefined){
if("font-units-y-up" !== data6.inputCoordinateSpace){
const err24 = {instancePath:instancePath+"/model/inputCoordinateSpace",schemaPath:"#/$defs/model/properties/inputCoordinateSpace/const",keyword:"const",params:{allowedValue: "font-units-y-up"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data6.fit !== undefined){
if("contain-with-integer-padding" !== data6.fit){
const err25 = {instancePath:instancePath+"/model/fit",schemaPath:"#/$defs/model/properties/fit/const",keyword:"const",params:{allowedValue: "contain-with-integer-padding"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data6.compositing !== undefined){
if("source-over-run-glyph-order" !== data6.compositing){
const err26 = {instancePath:instancePath+"/model/compositing",schemaPath:"#/$defs/model/properties/compositing/const",keyword:"const",params:{allowedValue: "source-over-run-glyph-order"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data6.fillRule !== undefined){
if("nonzero" !== data6.fillRule){
const err27 = {instancePath:instancePath+"/model/fillRule",schemaPath:"#/$defs/model/properties/fillRule/const",keyword:"const",params:{allowedValue: "nonzero"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data6.glyphBoundsMeaning !== undefined){
if("transformed-clipped-opentype-extents" !== data6.glyphBoundsMeaning){
const err28 = {instancePath:instancePath+"/model/glyphBoundsMeaning",schemaPath:"#/$defs/model/properties/glyphBoundsMeaning/const",keyword:"const",params:{allowedValue: "transformed-clipped-opentype-extents"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data6.pixelModel !== undefined){
if("rgba8-srgb-straight-transparent-zero" !== data6.pixelModel){
const err29 = {instancePath:instancePath+"/model/pixelModel",schemaPath:"#/$defs/model/properties/pixelModel/const",keyword:"const",params:{allowedValue: "rgba8-srgb-straight-transparent-zero"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data6.pngEncoding !== undefined){
if("canvas-to-blob-image-png" !== data6.pngEncoding){
const err30 = {instancePath:instancePath+"/model/pngEncoding",schemaPath:"#/$defs/model/properties/pngEncoding/const",keyword:"const",params:{allowedValue: "canvas-to-blob-image-png"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data6.glyphMapEncoding !== undefined){
if("uint32le" !== data6.glyphMapEncoding){
const err31 = {instancePath:instancePath+"/model/glyphMapEncoding",schemaPath:"#/$defs/model/properties/glyphMapEncoding/const",keyword:"const",params:{allowedValue: "uint32le"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data6.glyphMapOwnerRule !== undefined){
if("nonzero-alpha-last-painted-wins" !== data6.glyphMapOwnerRule){
const err32 = {instancePath:instancePath+"/model/glyphMapOwnerRule",schemaPath:"#/$defs/model/properties/glyphMapOwnerRule/const",keyword:"const",params:{allowedValue: "nonzero-alpha-last-painted-wins"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
}
else {
const err33 = {instancePath:instancePath+"/model",schemaPath:"#/$defs/model/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data.referenceRasterizer !== undefined){
if(!(validate272(data.referenceRasterizer, {instancePath:instancePath+"/referenceRasterizer",parentData:data,parentDataProperty:"referenceRasterizer",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate272.errors : vErrors.concat(validate272.errors);
errors = vErrors.length;
}
}
if(data.cases !== undefined){
let data17 = data.cases;
if(Array.isArray(data17)){
if(data17.length > 1024){
const err34 = {instancePath:instancePath+"/cases",schemaPath:"#/properties/cases/maxItems",keyword:"maxItems",params:{limit: 1024},message:"must NOT have more than 1024 items"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data17.length < 1){
const err35 = {instancePath:instancePath+"/cases",schemaPath:"#/properties/cases/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
const len0 = data17.length;
for(let i0=0; i0<len0; i0++){
if(!(validate274(data17[i0], {instancePath:instancePath+"/cases/" + i0,parentData:data17,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate274.errors : vErrors.concat(validate274.errors);
errors = vErrors.length;
}
}
}
else {
const err36 = {instancePath:instancePath+"/cases",schemaPath:"#/properties/cases/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
if(data.scope !== undefined){
let data19 = data.scope;
if(data19 && typeof data19 == "object" && !Array.isArray(data19)){
if(data19.verified === undefined){
const err37 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/required",keyword:"required",params:{missingProperty: "verified"},message:"must have required property '"+"verified"+"'"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(data19.notYetDefined === undefined){
const err38 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/required",keyword:"required",params:{missingProperty: "notYetDefined"},message:"must have required property '"+"notYetDefined"+"'"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
for(const key2 in data19){
if(!((key2 === "verified") || (key2 === "notYetDefined"))){
const err39 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data19.verified !== undefined){
if(!(validate278(data19.verified, {instancePath:instancePath+"/scope/verified",parentData:data19,parentDataProperty:"verified",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate278.errors : vErrors.concat(validate278.errors);
errors = vErrors.length;
}
}
if(data19.notYetDefined !== undefined){
if(!(validate278(data19.notYetDefined, {instancePath:instancePath+"/scope/notYetDefined",parentData:data19,parentDataProperty:"notYetDefined",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate278.errors : vErrors.concat(validate278.errors);
errors = vErrors.length;
}
}
}
else {
const err40 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
else {
const err41 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
validate265.errors = vErrors;
return errors === 0;
}
validate265.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validatePixelMapInspectionSchema = validate281;
const schema386 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/pixel-map-inspection.schema.json","title":"Maipo pixel-map inspection 0.1","description":"A bounded, digest-linked point/region ownership report over a verified Maipo node or glyph pixel map.","type":"object","additionalProperties":false,"required":["$schema","format","version","source","region","pixelCount","unownedPixels","owners"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/pixel-map-inspection.schema.json"},"format":{"const":"maipo-pixel-map-inspection"},"version":{"const":"0.1"},"source":{"$ref":"#/$defs/source"},"region":{"$ref":"#/$defs/region"},"pixelCount":{"type":"integer","minimum":1,"maximum":4194304},"unownedPixels":{"type":"integer","minimum":0,"maximum":4194304},"owners":{"type":"array","maxItems":1000000,"items":{"$ref":"#/$defs/owner"}}},"$defs":{"id":{"type":"string","minLength":1,"maxLength":160,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"source":{"type":"object","additionalProperties":false,"required":["width","height","digest","ids"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"digest":{"$ref":"#/$defs/digest"},"ids":{"type":"array","maxItems":1000000,"items":{"$ref":"#/$defs/id"}}}},"region":{"type":"object","additionalProperties":false,"required":["x","y","width","height"],"properties":{"x":{"type":"integer","minimum":0,"maximum":32768},"y":{"type":"integer","minimum":0,"maximum":32768},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768}}},"owner":{"type":"object","additionalProperties":false,"required":["owner","id","pixels","coverage","bounds"],"properties":{"owner":{"type":"integer","minimum":1,"maximum":1000000},"id":{"$ref":"#/$defs/id"},"pixels":{"type":"integer","minimum":1,"maximum":4194304},"coverage":{"type":"number","exclusiveMinimum":0,"maximum":1},"bounds":{"$ref":"#/$defs/region"}}}}};
const schema390 = {"type":"object","additionalProperties":false,"required":["x","y","width","height"],"properties":{"x":{"type":"integer","minimum":0,"maximum":32768},"y":{"type":"integer","minimum":0,"maximum":32768},"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768}}};
const schema387 = {"type":"object","additionalProperties":false,"required":["width","height","digest","ids"],"properties":{"width":{"type":"integer","minimum":1,"maximum":32768},"height":{"type":"integer","minimum":1,"maximum":32768},"digest":{"$ref":"#/$defs/digest"},"ids":{"type":"array","maxItems":1000000,"items":{"$ref":"#/$defs/id"}}}};
const schema388 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};
const schema389 = {"type":"string","minLength":1,"maxLength":160,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"};

function validate282(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate282.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.width === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.height === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.digest === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.ids === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ids"},message:"must have required property '"+"ids"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "width") || (key0 === "height")) || (key0 === "digest")) || (key0 === "ids"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.width !== undefined){
let data0 = data.width;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err5 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 32768 || isNaN(data0)){
const err6 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data0 < 1 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
if(data.height !== undefined){
let data1 = data.height;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err8 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 32768 || isNaN(data1)){
const err9 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data1 < 1 || isNaN(data1)){
const err10 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
if(data.digest !== undefined){
let data2 = data.digest;
if(typeof data2 === "string"){
if(!pattern9.test(data2)){
const err11 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.ids !== undefined){
let data3 = data.ids;
if(Array.isArray(data3)){
if(data3.length > 1000000){
const err13 = {instancePath:instancePath+"/ids",schemaPath:"#/properties/ids/maxItems",keyword:"maxItems",params:{limit: 1000000},message:"must NOT have more than 1000000 items"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
const len0 = data3.length;
for(let i0=0; i0<len0; i0++){
let data4 = data3[i0];
if(typeof data4 === "string"){
if(func3(data4) > 160){
const err14 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 160},message:"must NOT have more than 160 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(func3(data4) < 1){
const err15 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(!pattern4.test(data4)){
const err16 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/ids/" + i0,schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
else {
const err18 = {instancePath:instancePath+"/ids",schemaPath:"#/properties/ids/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
validate282.errors = vErrors;
return errors === 0;
}
validate282.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema391 = {"type":"object","additionalProperties":false,"required":["owner","id","pixels","coverage","bounds"],"properties":{"owner":{"type":"integer","minimum":1,"maximum":1000000},"id":{"$ref":"#/$defs/id"},"pixels":{"type":"integer","minimum":1,"maximum":4194304},"coverage":{"type":"number","exclusiveMinimum":0,"maximum":1},"bounds":{"$ref":"#/$defs/region"}}};

function validate284(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate284.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.owner === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "owner"},message:"must have required property '"+"owner"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.id === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.pixels === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixels"},message:"must have required property '"+"pixels"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.coverage === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "coverage"},message:"must have required property '"+"coverage"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.bounds === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bounds"},message:"must have required property '"+"bounds"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "owner") || (key0 === "id")) || (key0 === "pixels")) || (key0 === "coverage")) || (key0 === "bounds"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.owner !== undefined){
let data0 = data.owner;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err6 = {instancePath:instancePath+"/owner",schemaPath:"#/properties/owner/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 1000000 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/owner",schemaPath:"#/properties/owner/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000000},message:"must be <= 1000000"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data0 < 1 || isNaN(data0)){
const err8 = {instancePath:instancePath+"/owner",schemaPath:"#/properties/owner/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
if(data.id !== undefined){
let data1 = data.id;
if(typeof data1 === "string"){
if(func3(data1) > 160){
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 160},message:"must NOT have more than 160 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func3(data1) < 1){
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!pattern4.test(data1)){
const err11 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.pixels !== undefined){
let data2 = data.pixels;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err13 = {instancePath:instancePath+"/pixels",schemaPath:"#/properties/pixels/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 4194304 || isNaN(data2)){
const err14 = {instancePath:instancePath+"/pixels",schemaPath:"#/properties/pixels/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4194304},message:"must be <= 4194304"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data2 < 1 || isNaN(data2)){
const err15 = {instancePath:instancePath+"/pixels",schemaPath:"#/properties/pixels/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
if(data.coverage !== undefined){
let data3 = data.coverage;
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 1 || isNaN(data3)){
const err16 = {instancePath:instancePath+"/coverage",schemaPath:"#/properties/coverage/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data3 <= 0 || isNaN(data3)){
const err17 = {instancePath:instancePath+"/coverage",schemaPath:"#/properties/coverage/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/coverage",schemaPath:"#/properties/coverage/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.bounds !== undefined){
let data4 = data.bounds;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.x === undefined){
const err19 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/region/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data4.y === undefined){
const err20 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/region/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data4.width === undefined){
const err21 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/region/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data4.height === undefined){
const err22 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/region/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
for(const key1 in data4){
if(!((((key1 === "x") || (key1 === "y")) || (key1 === "width")) || (key1 === "height"))){
const err23 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/region/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data4.x !== undefined){
let data5 = data4.x;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err24 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/region/properties/x/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 32768 || isNaN(data5)){
const err25 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/region/properties/x/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data5 < 0 || isNaN(data5)){
const err26 = {instancePath:instancePath+"/bounds/x",schemaPath:"#/$defs/region/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
if(data4.y !== undefined){
let data6 = data4.y;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err27 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/region/properties/y/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 > 32768 || isNaN(data6)){
const err28 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/region/properties/y/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data6 < 0 || isNaN(data6)){
const err29 = {instancePath:instancePath+"/bounds/y",schemaPath:"#/$defs/region/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
if(data4.width !== undefined){
let data7 = data4.width;
if(!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))){
const err30 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/region/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 32768 || isNaN(data7)){
const err31 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/region/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data7 < 1 || isNaN(data7)){
const err32 = {instancePath:instancePath+"/bounds/width",schemaPath:"#/$defs/region/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
}
if(data4.height !== undefined){
let data8 = data4.height;
if(!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))){
const err33 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/region/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 32768 || isNaN(data8)){
const err34 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/region/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data8 < 1 || isNaN(data8)){
const err35 = {instancePath:instancePath+"/bounds/height",schemaPath:"#/$defs/region/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
}
}
else {
const err36 = {instancePath:instancePath+"/bounds",schemaPath:"#/$defs/region/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
else {
const err37 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
validate284.errors = vErrors;
return errors === 0;
}
validate284.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate281(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/pixel-map-inspection.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate281.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.source === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.region === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "region"},message:"must have required property '"+"region"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.pixelCount === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pixelCount"},message:"must have required property '"+"pixelCount"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.unownedPixels === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "unownedPixels"},message:"must have required property '"+"unownedPixels"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.owners === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "owners"},message:"must have required property '"+"owners"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "$schema") || (key0 === "format")) || (key0 === "version")) || (key0 === "source")) || (key0 === "region")) || (key0 === "pixelCount")) || (key0 === "unownedPixels")) || (key0 === "owners"))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/pixel-map-inspection.schema.json" !== data.$schema){
const err9 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/pixel-map-inspection.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-pixel-map-inspection" !== data.format){
const err10 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-pixel-map-inspection"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err11 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.source !== undefined){
if(!(validate282(data.source, {instancePath:instancePath+"/source",parentData:data,parentDataProperty:"source",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate282.errors : vErrors.concat(validate282.errors);
errors = vErrors.length;
}
}
if(data.region !== undefined){
let data4 = data.region;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.x === undefined){
const err12 = {instancePath:instancePath+"/region",schemaPath:"#/$defs/region/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data4.y === undefined){
const err13 = {instancePath:instancePath+"/region",schemaPath:"#/$defs/region/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data4.width === undefined){
const err14 = {instancePath:instancePath+"/region",schemaPath:"#/$defs/region/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data4.height === undefined){
const err15 = {instancePath:instancePath+"/region",schemaPath:"#/$defs/region/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
for(const key1 in data4){
if(!((((key1 === "x") || (key1 === "y")) || (key1 === "width")) || (key1 === "height"))){
const err16 = {instancePath:instancePath+"/region",schemaPath:"#/$defs/region/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data4.x !== undefined){
let data5 = data4.x;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err17 = {instancePath:instancePath+"/region/x",schemaPath:"#/$defs/region/properties/x/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 32768 || isNaN(data5)){
const err18 = {instancePath:instancePath+"/region/x",schemaPath:"#/$defs/region/properties/x/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data5 < 0 || isNaN(data5)){
const err19 = {instancePath:instancePath+"/region/x",schemaPath:"#/$defs/region/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
if(data4.y !== undefined){
let data6 = data4.y;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err20 = {instancePath:instancePath+"/region/y",schemaPath:"#/$defs/region/properties/y/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 > 32768 || isNaN(data6)){
const err21 = {instancePath:instancePath+"/region/y",schemaPath:"#/$defs/region/properties/y/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data6 < 0 || isNaN(data6)){
const err22 = {instancePath:instancePath+"/region/y",schemaPath:"#/$defs/region/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
if(data4.width !== undefined){
let data7 = data4.width;
if(!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))){
const err23 = {instancePath:instancePath+"/region/width",schemaPath:"#/$defs/region/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 > 32768 || isNaN(data7)){
const err24 = {instancePath:instancePath+"/region/width",schemaPath:"#/$defs/region/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data7 < 1 || isNaN(data7)){
const err25 = {instancePath:instancePath+"/region/width",schemaPath:"#/$defs/region/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
}
if(data4.height !== undefined){
let data8 = data4.height;
if(!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))){
const err26 = {instancePath:instancePath+"/region/height",schemaPath:"#/$defs/region/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 32768 || isNaN(data8)){
const err27 = {instancePath:instancePath+"/region/height",schemaPath:"#/$defs/region/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 32768},message:"must be <= 32768"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data8 < 1 || isNaN(data8)){
const err28 = {instancePath:instancePath+"/region/height",schemaPath:"#/$defs/region/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
}
}
else {
const err29 = {instancePath:instancePath+"/region",schemaPath:"#/$defs/region/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.pixelCount !== undefined){
let data9 = data.pixelCount;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err30 = {instancePath:instancePath+"/pixelCount",schemaPath:"#/properties/pixelCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 > 4194304 || isNaN(data9)){
const err31 = {instancePath:instancePath+"/pixelCount",schemaPath:"#/properties/pixelCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4194304},message:"must be <= 4194304"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data9 < 1 || isNaN(data9)){
const err32 = {instancePath:instancePath+"/pixelCount",schemaPath:"#/properties/pixelCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
}
if(data.unownedPixels !== undefined){
let data10 = data.unownedPixels;
if(!(((typeof data10 == "number") && (!(data10 % 1) && !isNaN(data10))) && (isFinite(data10)))){
const err33 = {instancePath:instancePath+"/unownedPixels",schemaPath:"#/properties/unownedPixels/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if((typeof data10 == "number") && (isFinite(data10))){
if(data10 > 4194304 || isNaN(data10)){
const err34 = {instancePath:instancePath+"/unownedPixels",schemaPath:"#/properties/unownedPixels/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4194304},message:"must be <= 4194304"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data10 < 0 || isNaN(data10)){
const err35 = {instancePath:instancePath+"/unownedPixels",schemaPath:"#/properties/unownedPixels/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
}
if(data.owners !== undefined){
let data11 = data.owners;
if(Array.isArray(data11)){
if(data11.length > 1000000){
const err36 = {instancePath:instancePath+"/owners",schemaPath:"#/properties/owners/maxItems",keyword:"maxItems",params:{limit: 1000000},message:"must NOT have more than 1000000 items"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
const len0 = data11.length;
for(let i0=0; i0<len0; i0++){
if(!(validate284(data11[i0], {instancePath:instancePath+"/owners/" + i0,parentData:data11,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate284.errors : vErrors.concat(validate284.errors);
errors = vErrors.length;
}
}
}
else {
const err37 = {instancePath:instancePath+"/owners",schemaPath:"#/properties/owners/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
else {
const err38 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
validate281.errors = vErrors;
return errors === 0;
}
validate281.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validatePatchApplicationSchema = validate286;
const schema394 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/patch-application.schema.json","title":"Maipo patch application 0.1","description":"Deterministic evidence that one atomic Maipo patch transforms an exact canonical source scene into an exact canonical result scene.","type":"object","additionalProperties":false,"required":["$schema","format","version","status","documentId","clientPatchId","baseRevision","resultRevision","operationCount","sourceSceneDigest","patchDigest","resultSceneDigest"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/patch-application.schema.json"},"format":{"const":"maipo-patch-application"},"version":{"const":"0.1"},"status":{"const":"applied"},"documentId":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"clientPatchId":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"baseRevision":{"type":"integer","minimum":0},"resultRevision":{"type":"integer","minimum":1},"operationCount":{"type":"integer","minimum":1,"maximum":10000},"sourceSceneDigest":{"$ref":"#/$defs/digest"},"patchDigest":{"$ref":"#/$defs/digest"},"resultSceneDigest":{"$ref":"#/$defs/digest"}},"$defs":{"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"}}};
const schema397 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};

function validate286(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/patch-application.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate286.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.status === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.documentId === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "documentId"},message:"must have required property '"+"documentId"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.clientPatchId === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "clientPatchId"},message:"must have required property '"+"clientPatchId"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.baseRevision === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "baseRevision"},message:"must have required property '"+"baseRevision"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.resultRevision === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "resultRevision"},message:"must have required property '"+"resultRevision"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.operationCount === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operationCount"},message:"must have required property '"+"operationCount"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.sourceSceneDigest === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceSceneDigest"},message:"must have required property '"+"sourceSceneDigest"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.patchDigest === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "patchDigest"},message:"must have required property '"+"patchDigest"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data.resultSceneDigest === undefined){
const err11 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "resultSceneDigest"},message:"must have required property '"+"resultSceneDigest"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema394.properties, key0))){
const err12 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/patch-application.schema.json" !== data.$schema){
const err13 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/patch-application.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-patch-application" !== data.format){
const err14 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-patch-application"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err15 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.status !== undefined){
if("applied" !== data.status){
const err16 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/const",keyword:"const",params:{allowedValue: "applied"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.documentId !== undefined){
let data4 = data.documentId;
if(typeof data4 === "string"){
if(func3(data4) > 128){
const err17 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(func3(data4) < 1){
const err18 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(!pattern4.test(data4)){
const err19 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.clientPatchId !== undefined){
let data5 = data.clientPatchId;
if(typeof data5 === "string"){
if(func3(data5) > 128){
const err21 = {instancePath:instancePath+"/clientPatchId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(func3(data5) < 1){
const err22 = {instancePath:instancePath+"/clientPatchId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(!pattern4.test(data5)){
const err23 = {instancePath:instancePath+"/clientPatchId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/clientPatchId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.baseRevision !== undefined){
let data6 = data.baseRevision;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err25 = {instancePath:instancePath+"/baseRevision",schemaPath:"#/properties/baseRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 < 0 || isNaN(data6)){
const err26 = {instancePath:instancePath+"/baseRevision",schemaPath:"#/properties/baseRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
if(data.resultRevision !== undefined){
let data7 = data.resultRevision;
if(!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))){
const err27 = {instancePath:instancePath+"/resultRevision",schemaPath:"#/properties/resultRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 < 1 || isNaN(data7)){
const err28 = {instancePath:instancePath+"/resultRevision",schemaPath:"#/properties/resultRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
}
if(data.operationCount !== undefined){
let data8 = data.operationCount;
if(!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))){
const err29 = {instancePath:instancePath+"/operationCount",schemaPath:"#/properties/operationCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 > 10000 || isNaN(data8)){
const err30 = {instancePath:instancePath+"/operationCount",schemaPath:"#/properties/operationCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 10000},message:"must be <= 10000"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data8 < 1 || isNaN(data8)){
const err31 = {instancePath:instancePath+"/operationCount",schemaPath:"#/properties/operationCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
}
if(data.sourceSceneDigest !== undefined){
let data9 = data.sourceSceneDigest;
if(typeof data9 === "string"){
if(!pattern9.test(data9)){
const err32 = {instancePath:instancePath+"/sourceSceneDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/sourceSceneDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data.patchDigest !== undefined){
let data10 = data.patchDigest;
if(typeof data10 === "string"){
if(!pattern9.test(data10)){
const err34 = {instancePath:instancePath+"/patchDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
else {
const err35 = {instancePath:instancePath+"/patchDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data.resultSceneDigest !== undefined){
let data11 = data.resultSceneDigest;
if(typeof data11 === "string"){
if(!pattern9.test(data11)){
const err36 = {instancePath:instancePath+"/resultSceneDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
else {
const err37 = {instancePath:instancePath+"/resultSceneDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
else {
const err38 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
validate286.errors = vErrors;
return errors === 0;
}
validate286.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validatePatchRejectionSchema = validate287;
const schema400 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/patch-rejection.schema.json","title":"Maipo patch rejection 0.1","description":"Deterministic evidence that one schema-valid atomic Maipo patch was rejected against one exact canonical source scene.","type":"object","additionalProperties":false,"required":["$schema","format","version","status","documentId","sourceDocumentId","clientPatchId","baseRevision","sourceRevision","operationCount","sourceSceneDigest","patchDigest","reason"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/patch-rejection.schema.json"},"format":{"const":"maipo-patch-rejection"},"version":{"const":"0.1"},"status":{"const":"rejected"},"documentId":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"sourceDocumentId":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"clientPatchId":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"baseRevision":{"type":"integer","minimum":0},"sourceRevision":{"type":"integer","minimum":0},"operationCount":{"type":"integer","minimum":1,"maximum":10000},"sourceSceneDigest":{"$ref":"#/$defs/digest"},"patchDigest":{"$ref":"#/$defs/digest"},"reason":{"enum":["document-mismatch","stale-revision","target-missing","target-not-structural","parent-not-group","sibling-missing","id-conflict","self-parent","descendant-cycle","path-conflict","result-invalid"]},"operationIndex":{"type":"integer","minimum":0,"maximum":9999},"target":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"parent":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"before":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"path":{"$ref":"https://maipo.design/schema/0.1/patch.schema.json#/$defs/editablePath"}},"allOf":[{"if":{"properties":{"reason":{"enum":["target-missing","target-not-structural","id-conflict"]}}},"then":{"properties":{"operationIndex":true,"target":true},"required":["operationIndex","target"]}},{"if":{"properties":{"reason":{"const":"parent-not-group"}}},"then":{"properties":{"operationIndex":true,"parent":true},"required":["operationIndex","parent"]}},{"if":{"properties":{"reason":{"const":"sibling-missing"}}},"then":{"properties":{"operationIndex":true,"before":true},"required":["operationIndex","before"]}},{"if":{"properties":{"reason":{"enum":["self-parent","descendant-cycle"]}}},"then":{"properties":{"operationIndex":true,"target":true,"parent":true},"required":["operationIndex","target","parent"]}},{"if":{"properties":{"reason":{"const":"path-conflict"}}},"then":{"properties":{"operationIndex":true,"target":true,"path":true},"required":["operationIndex","target","path"]}}],"$defs":{"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"}}};
const schema404 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};

function validate287(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/patch-rejection.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate287.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs2 = errors;
let valid1 = true;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.reason !== undefined){
let data0 = data.reason;
if(!(((data0 === "target-missing") || (data0 === "target-not-structural")) || (data0 === "id-conflict"))){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
var _valid0 = _errs3 === errors;
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
if(_valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operationIndex === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/0/then/required",keyword:"required",params:{missingProperty: "operationIndex"},message:"must have required property '"+"operationIndex"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.target === undefined){
const err2 = {instancePath,schemaPath:"#/allOf/0/then/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid1 = _valid0;
if(valid1){
var props0 = {};
props0.operationIndex = true;
props0.target = true;
props0.reason = true;
}
}
if(!valid1){
const err3 = {instancePath,schemaPath:"#/allOf/0/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const _errs7 = errors;
let valid3 = true;
const _errs8 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.reason !== undefined){
if("parent-not-group" !== data.reason){
const err4 = {};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
var _valid1 = _errs8 === errors;
errors = _errs7;
if(vErrors !== null){
if(_errs7){
vErrors.length = _errs7;
}
else {
vErrors = null;
}
}
if(_valid1){
const _errs10 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operationIndex === undefined){
const err5 = {instancePath,schemaPath:"#/allOf/1/then/required",keyword:"required",params:{missingProperty: "operationIndex"},message:"must have required property '"+"operationIndex"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.parent === undefined){
const err6 = {instancePath,schemaPath:"#/allOf/1/then/required",keyword:"required",params:{missingProperty: "parent"},message:"must have required property '"+"parent"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
var _valid1 = _errs10 === errors;
valid3 = _valid1;
if(valid3){
var props1 = {};
props1.operationIndex = true;
props1.parent = true;
props1.reason = true;
}
}
if(!valid3){
const err7 = {instancePath,schemaPath:"#/allOf/1/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(props0 !== true && props1 !== undefined){
if(props1 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props1);
}
}
const _errs12 = errors;
let valid5 = true;
const _errs13 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.reason !== undefined){
if("sibling-missing" !== data.reason){
const err8 = {};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
var _valid2 = _errs13 === errors;
errors = _errs12;
if(vErrors !== null){
if(_errs12){
vErrors.length = _errs12;
}
else {
vErrors = null;
}
}
if(_valid2){
const _errs15 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operationIndex === undefined){
const err9 = {instancePath,schemaPath:"#/allOf/2/then/required",keyword:"required",params:{missingProperty: "operationIndex"},message:"must have required property '"+"operationIndex"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.before === undefined){
const err10 = {instancePath,schemaPath:"#/allOf/2/then/required",keyword:"required",params:{missingProperty: "before"},message:"must have required property '"+"before"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
var _valid2 = _errs15 === errors;
valid5 = _valid2;
if(valid5){
var props2 = {};
props2.operationIndex = true;
props2.before = true;
props2.reason = true;
}
}
if(!valid5){
const err11 = {instancePath,schemaPath:"#/allOf/2/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(props0 !== true && props2 !== undefined){
if(props2 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props2);
}
}
const _errs17 = errors;
let valid7 = true;
const _errs18 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.reason !== undefined){
let data3 = data.reason;
if(!((data3 === "self-parent") || (data3 === "descendant-cycle"))){
const err12 = {};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
var _valid3 = _errs18 === errors;
errors = _errs17;
if(vErrors !== null){
if(_errs17){
vErrors.length = _errs17;
}
else {
vErrors = null;
}
}
if(_valid3){
const _errs20 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operationIndex === undefined){
const err13 = {instancePath,schemaPath:"#/allOf/3/then/required",keyword:"required",params:{missingProperty: "operationIndex"},message:"must have required property '"+"operationIndex"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data.target === undefined){
const err14 = {instancePath,schemaPath:"#/allOf/3/then/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data.parent === undefined){
const err15 = {instancePath,schemaPath:"#/allOf/3/then/required",keyword:"required",params:{missingProperty: "parent"},message:"must have required property '"+"parent"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
var _valid3 = _errs20 === errors;
valid7 = _valid3;
if(valid7){
var props3 = {};
props3.operationIndex = true;
props3.target = true;
props3.parent = true;
props3.reason = true;
}
}
if(!valid7){
const err16 = {instancePath,schemaPath:"#/allOf/3/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(props0 !== true && props3 !== undefined){
if(props3 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props3);
}
}
const _errs22 = errors;
let valid9 = true;
const _errs23 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.reason !== undefined){
if("path-conflict" !== data.reason){
const err17 = {};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
var _valid4 = _errs23 === errors;
errors = _errs22;
if(vErrors !== null){
if(_errs22){
vErrors.length = _errs22;
}
else {
vErrors = null;
}
}
if(_valid4){
const _errs25 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operationIndex === undefined){
const err18 = {instancePath,schemaPath:"#/allOf/4/then/required",keyword:"required",params:{missingProperty: "operationIndex"},message:"must have required property '"+"operationIndex"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data.target === undefined){
const err19 = {instancePath,schemaPath:"#/allOf/4/then/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data.path === undefined){
const err20 = {instancePath,schemaPath:"#/allOf/4/then/required",keyword:"required",params:{missingProperty: "path"},message:"must have required property '"+"path"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
var _valid4 = _errs25 === errors;
valid9 = _valid4;
if(valid9){
var props4 = {};
props4.operationIndex = true;
props4.target = true;
props4.path = true;
props4.reason = true;
}
}
if(!valid9){
const err21 = {instancePath,schemaPath:"#/allOf/4/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(props0 !== true && props4 !== undefined){
if(props4 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props4);
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err22 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data.format === undefined){
const err23 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data.version === undefined){
const err24 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data.status === undefined){
const err25 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data.documentId === undefined){
const err26 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "documentId"},message:"must have required property '"+"documentId"+"'"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(data.sourceDocumentId === undefined){
const err27 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceDocumentId"},message:"must have required property '"+"sourceDocumentId"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data.clientPatchId === undefined){
const err28 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "clientPatchId"},message:"must have required property '"+"clientPatchId"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data.baseRevision === undefined){
const err29 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "baseRevision"},message:"must have required property '"+"baseRevision"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data.sourceRevision === undefined){
const err30 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceRevision"},message:"must have required property '"+"sourceRevision"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data.operationCount === undefined){
const err31 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operationCount"},message:"must have required property '"+"operationCount"+"'"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data.sourceSceneDigest === undefined){
const err32 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceSceneDigest"},message:"must have required property '"+"sourceSceneDigest"+"'"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data.patchDigest === undefined){
const err33 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "patchDigest"},message:"must have required property '"+"patchDigest"+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data.reason === undefined){
const err34 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "reason"},message:"must have required property '"+"reason"+"'"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema400.properties, key0))){
const err35 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/patch-rejection.schema.json" !== data.$schema){
const err36 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/patch-rejection.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-patch-rejection" !== data.format){
const err37 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-patch-rejection"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err38 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data.status !== undefined){
if("rejected" !== data.status){
const err39 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/const",keyword:"const",params:{allowedValue: "rejected"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data.documentId !== undefined){
let data9 = data.documentId;
if(typeof data9 === "string"){
if(func3(data9) > 128){
const err40 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if(func3(data9) < 1){
const err41 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(!pattern4.test(data9)){
const err42 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
else {
const err43 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data.sourceDocumentId !== undefined){
let data10 = data.sourceDocumentId;
if(typeof data10 === "string"){
if(func3(data10) > 128){
const err44 = {instancePath:instancePath+"/sourceDocumentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
if(func3(data10) < 1){
const err45 = {instancePath:instancePath+"/sourceDocumentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
if(!pattern4.test(data10)){
const err46 = {instancePath:instancePath+"/sourceDocumentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
else {
const err47 = {instancePath:instancePath+"/sourceDocumentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
if(data.clientPatchId !== undefined){
let data11 = data.clientPatchId;
if(typeof data11 === "string"){
if(func3(data11) > 128){
const err48 = {instancePath:instancePath+"/clientPatchId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
if(func3(data11) < 1){
const err49 = {instancePath:instancePath+"/clientPatchId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
if(!pattern4.test(data11)){
const err50 = {instancePath:instancePath+"/clientPatchId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
else {
const err51 = {instancePath:instancePath+"/clientPatchId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data.baseRevision !== undefined){
let data12 = data.baseRevision;
if(!(((typeof data12 == "number") && (!(data12 % 1) && !isNaN(data12))) && (isFinite(data12)))){
const err52 = {instancePath:instancePath+"/baseRevision",schemaPath:"#/properties/baseRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
if((typeof data12 == "number") && (isFinite(data12))){
if(data12 < 0 || isNaN(data12)){
const err53 = {instancePath:instancePath+"/baseRevision",schemaPath:"#/properties/baseRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
}
if(data.sourceRevision !== undefined){
let data13 = data.sourceRevision;
if(!(((typeof data13 == "number") && (!(data13 % 1) && !isNaN(data13))) && (isFinite(data13)))){
const err54 = {instancePath:instancePath+"/sourceRevision",schemaPath:"#/properties/sourceRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
if((typeof data13 == "number") && (isFinite(data13))){
if(data13 < 0 || isNaN(data13)){
const err55 = {instancePath:instancePath+"/sourceRevision",schemaPath:"#/properties/sourceRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
}
}
if(data.operationCount !== undefined){
let data14 = data.operationCount;
if(!(((typeof data14 == "number") && (!(data14 % 1) && !isNaN(data14))) && (isFinite(data14)))){
const err56 = {instancePath:instancePath+"/operationCount",schemaPath:"#/properties/operationCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
if((typeof data14 == "number") && (isFinite(data14))){
if(data14 > 10000 || isNaN(data14)){
const err57 = {instancePath:instancePath+"/operationCount",schemaPath:"#/properties/operationCount/maximum",keyword:"maximum",params:{comparison: "<=", limit: 10000},message:"must be <= 10000"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
if(data14 < 1 || isNaN(data14)){
const err58 = {instancePath:instancePath+"/operationCount",schemaPath:"#/properties/operationCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
}
if(data.sourceSceneDigest !== undefined){
let data15 = data.sourceSceneDigest;
if(typeof data15 === "string"){
if(!pattern9.test(data15)){
const err59 = {instancePath:instancePath+"/sourceSceneDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
}
else {
const err60 = {instancePath:instancePath+"/sourceSceneDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
if(data.patchDigest !== undefined){
let data16 = data.patchDigest;
if(typeof data16 === "string"){
if(!pattern9.test(data16)){
const err61 = {instancePath:instancePath+"/patchDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
}
else {
const err62 = {instancePath:instancePath+"/patchDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
}
if(data.reason !== undefined){
let data17 = data.reason;
if(!(((((((((((data17 === "document-mismatch") || (data17 === "stale-revision")) || (data17 === "target-missing")) || (data17 === "target-not-structural")) || (data17 === "parent-not-group")) || (data17 === "sibling-missing")) || (data17 === "id-conflict")) || (data17 === "self-parent")) || (data17 === "descendant-cycle")) || (data17 === "path-conflict")) || (data17 === "result-invalid"))){
const err63 = {instancePath:instancePath+"/reason",schemaPath:"#/properties/reason/enum",keyword:"enum",params:{allowedValues: schema400.properties.reason.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
}
if(data.operationIndex !== undefined){
let data18 = data.operationIndex;
if(!(((typeof data18 == "number") && (!(data18 % 1) && !isNaN(data18))) && (isFinite(data18)))){
const err64 = {instancePath:instancePath+"/operationIndex",schemaPath:"#/properties/operationIndex/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
if((typeof data18 == "number") && (isFinite(data18))){
if(data18 > 9999 || isNaN(data18)){
const err65 = {instancePath:instancePath+"/operationIndex",schemaPath:"#/properties/operationIndex/maximum",keyword:"maximum",params:{comparison: "<=", limit: 9999},message:"must be <= 9999"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
if(data18 < 0 || isNaN(data18)){
const err66 = {instancePath:instancePath+"/operationIndex",schemaPath:"#/properties/operationIndex/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
}
}
if(data.target !== undefined){
let data19 = data.target;
if(typeof data19 === "string"){
if(func3(data19) > 128){
const err67 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
if(func3(data19) < 1){
const err68 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
if(!pattern4.test(data19)){
const err69 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
}
else {
const err70 = {instancePath:instancePath+"/target",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
}
if(data.parent !== undefined){
let data20 = data.parent;
if(typeof data20 === "string"){
if(func3(data20) > 128){
const err71 = {instancePath:instancePath+"/parent",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
if(func3(data20) < 1){
const err72 = {instancePath:instancePath+"/parent",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
if(!pattern4.test(data20)){
const err73 = {instancePath:instancePath+"/parent",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
}
else {
const err74 = {instancePath:instancePath+"/parent",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
}
if(data.before !== undefined){
let data21 = data.before;
if(typeof data21 === "string"){
if(func3(data21) > 128){
const err75 = {instancePath:instancePath+"/before",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
if(func3(data21) < 1){
const err76 = {instancePath:instancePath+"/before",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err76];
}
else {
vErrors.push(err76);
}
errors++;
}
if(!pattern4.test(data21)){
const err77 = {instancePath:instancePath+"/before",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err77];
}
else {
vErrors.push(err77);
}
errors++;
}
}
else {
const err78 = {instancePath:instancePath+"/before",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err78];
}
else {
vErrors.push(err78);
}
errors++;
}
}
if(data.path !== undefined){
let data22 = data.path;
if(typeof data22 !== "string"){
const err79 = {instancePath:instancePath+"/path",schemaPath:"https://maipo.design/schema/0.1/patch.schema.json#/$defs/editablePath/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err79];
}
else {
vErrors.push(err79);
}
errors++;
}
if(!(((((((((((((((((((((((((((((((((data22 === "/name") || (data22 === "/role")) || (data22 === "/visible")) || (data22 === "/opacity")) || (data22 === "/fillOpacity")) || (data22 === "/blendMode")) || (data22 === "/locked")) || (data22 === "/clipping")) || (data22 === "/transform")) || (data22 === "/transform/x")) || (data22 === "/transform/y")) || (data22 === "/transform/rotation")) || (data22 === "/transform/scaleX")) || (data22 === "/transform/scaleY")) || (data22 === "/transform/skewX")) || (data22 === "/text")) || (data22 === "/frame")) || (data22 === "/frame/width")) || (data22 === "/frame/height")) || (data22 === "/frame/autoHeight")) || (data22 === "/frame/fit")) || (data22 === "/style")) || (data22 === "/style/fontRef")) || (data22 === "/style/fontFamily")) || (data22 === "/style/fontWeight")) || (data22 === "/style/fontSize")) || (data22 === "/style/lineHeight")) || (data22 === "/style/letterSpacing")) || (data22 === "/style/textAlign")) || (data22 === "/style/color")) || (data22 === "/fill")) || (data22 === "/stroke")) || (data22 === "/geometry"))){
const err80 = {instancePath:instancePath+"/path",schemaPath:"https://maipo.design/schema/0.1/patch.schema.json#/$defs/editablePath/enum",keyword:"enum",params:{allowedValues: schema115.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err80];
}
else {
vErrors.push(err80);
}
errors++;
}
}
}
else {
const err81 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err81];
}
else {
vErrors.push(err81);
}
errors++;
}
validate287.errors = vErrors;
return errors === 0;
}
validate287.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateHistorySchema = validate288;
const schema410 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/history.schema.json","title":"Maipo portable history 0.1","description":"A deterministic, append-only chain of successful Maipo patch-application receipts.","type":"object","additionalProperties":false,"required":["$schema","format","version","documentId","genesis","entries"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/history.schema.json"},"format":{"const":"maipo-history"},"version":{"const":"0.1"},"documentId":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"genesis":{"type":"object","additionalProperties":false,"required":["revision","sceneDigest"],"properties":{"revision":{"type":"integer","minimum":0},"sceneDigest":{"$ref":"#/$defs/digest"}}},"entries":{"type":"array","maxItems":10000,"items":{"$ref":"#/$defs/entry"}}},"$defs":{"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"entry":{"type":"object","additionalProperties":false,"required":["sequence","previousEntryDigest","entryDigest","application"],"properties":{"sequence":{"type":"integer","minimum":1,"maximum":10000},"previousEntryDigest":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/digest"}]},"entryDigest":{"$ref":"#/$defs/digest"},"application":{"$ref":"https://maipo.design/schema/0.1/patch-application.schema.json"}}}}};
const schema412 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};
const schema413 = {"type":"object","additionalProperties":false,"required":["sequence","previousEntryDigest","entryDigest","application"],"properties":{"sequence":{"type":"integer","minimum":1,"maximum":10000},"previousEntryDigest":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/digest"}]},"entryDigest":{"$ref":"#/$defs/digest"},"application":{"$ref":"https://maipo.design/schema/0.1/patch-application.schema.json"}}};

function validate289(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate289.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.sequence === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sequence"},message:"must have required property '"+"sequence"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.previousEntryDigest === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "previousEntryDigest"},message:"must have required property '"+"previousEntryDigest"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.entryDigest === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "entryDigest"},message:"must have required property '"+"entryDigest"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.application === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "application"},message:"must have required property '"+"application"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "sequence") || (key0 === "previousEntryDigest")) || (key0 === "entryDigest")) || (key0 === "application"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.sequence !== undefined){
let data0 = data.sequence;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err5 = {instancePath:instancePath+"/sequence",schemaPath:"#/properties/sequence/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 10000 || isNaN(data0)){
const err6 = {instancePath:instancePath+"/sequence",schemaPath:"#/properties/sequence/maximum",keyword:"maximum",params:{comparison: "<=", limit: 10000},message:"must be <= 10000"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data0 < 1 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/sequence",schemaPath:"#/properties/sequence/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
if(data.previousEntryDigest !== undefined){
let data1 = data.previousEntryDigest;
const _errs5 = errors;
let valid1 = false;
let passing0 = null;
const _errs6 = errors;
if(data1 !== null){
const err8 = {instancePath:instancePath+"/previousEntryDigest",schemaPath:"#/properties/previousEntryDigest/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
var _valid0 = _errs6 === errors;
if(_valid0){
valid1 = true;
passing0 = 0;
}
const _errs8 = errors;
if(typeof data1 === "string"){
if(!pattern9.test(data1)){
const err9 = {instancePath:instancePath+"/previousEntryDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/previousEntryDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
var _valid0 = _errs8 === errors;
if(_valid0 && valid1){
valid1 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid1 = true;
passing0 = 1;
}
}
if(!valid1){
const err11 = {instancePath:instancePath+"/previousEntryDigest",schemaPath:"#/properties/previousEntryDigest/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
else {
errors = _errs5;
if(vErrors !== null){
if(_errs5){
vErrors.length = _errs5;
}
else {
vErrors = null;
}
}
}
}
if(data.entryDigest !== undefined){
let data2 = data.entryDigest;
if(typeof data2 === "string"){
if(!pattern9.test(data2)){
const err12 = {instancePath:instancePath+"/entryDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/entryDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.application !== undefined){
if(!(validate286(data.application, {instancePath:instancePath+"/application",parentData:data,parentDataProperty:"application",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate286.errors : vErrors.concat(validate286.errors);
errors = vErrors.length;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate289.errors = vErrors;
return errors === 0;
}
validate289.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate288(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/history.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate288.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.documentId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "documentId"},message:"must have required property '"+"documentId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.genesis === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "genesis"},message:"must have required property '"+"genesis"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.entries === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "entries"},message:"must have required property '"+"entries"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "$schema") || (key0 === "format")) || (key0 === "version")) || (key0 === "documentId")) || (key0 === "genesis")) || (key0 === "entries"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/history.schema.json" !== data.$schema){
const err7 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/history.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-history" !== data.format){
const err8 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-history"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err9 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.documentId !== undefined){
let data3 = data.documentId;
if(typeof data3 === "string"){
if(func3(data3) > 128){
const err10 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func3(data3) < 1){
const err11 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern4.test(data3)){
const err12 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.genesis !== undefined){
let data4 = data.genesis;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.revision === undefined){
const err14 = {instancePath:instancePath+"/genesis",schemaPath:"#/properties/genesis/required",keyword:"required",params:{missingProperty: "revision"},message:"must have required property '"+"revision"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data4.sceneDigest === undefined){
const err15 = {instancePath:instancePath+"/genesis",schemaPath:"#/properties/genesis/required",keyword:"required",params:{missingProperty: "sceneDigest"},message:"must have required property '"+"sceneDigest"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
for(const key1 in data4){
if(!((key1 === "revision") || (key1 === "sceneDigest"))){
const err16 = {instancePath:instancePath+"/genesis",schemaPath:"#/properties/genesis/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data4.revision !== undefined){
let data5 = data4.revision;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err17 = {instancePath:instancePath+"/genesis/revision",schemaPath:"#/properties/genesis/properties/revision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 0 || isNaN(data5)){
const err18 = {instancePath:instancePath+"/genesis/revision",schemaPath:"#/properties/genesis/properties/revision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
if(data4.sceneDigest !== undefined){
let data6 = data4.sceneDigest;
if(typeof data6 === "string"){
if(!pattern9.test(data6)){
const err19 = {instancePath:instancePath+"/genesis/sceneDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/genesis/sceneDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath:instancePath+"/genesis",schemaPath:"#/properties/genesis/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.entries !== undefined){
let data7 = data.entries;
if(Array.isArray(data7)){
if(data7.length > 10000){
const err22 = {instancePath:instancePath+"/entries",schemaPath:"#/properties/entries/maxItems",keyword:"maxItems",params:{limit: 10000},message:"must NOT have more than 10000 items"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
const len0 = data7.length;
for(let i0=0; i0<len0; i0++){
if(!(validate289(data7[i0], {instancePath:instancePath+"/entries/" + i0,parentData:data7,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate289.errors : vErrors.concat(validate289.errors);
errors = vErrors.length;
}
}
}
else {
const err23 = {instancePath:instancePath+"/entries",schemaPath:"#/properties/entries/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
else {
const err24 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
validate288.errors = vErrors;
return errors === 0;
}
validate288.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateHistorySignatureSchema = validate292;
const schema416 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/history-signature.schema.json","title":"Maipo history signature 0.1","description":"A detached Ed25519 attribution or approval attestation for one exact Maipo history entry.","type":"object","additionalProperties":false,"required":["$schema","format","version","target","claim","signer","algorithm","publicKey","keyFingerprint","signature"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/history-signature.schema.json"},"format":{"const":"maipo-history-signature"},"version":{"const":"0.1"},"target":{"type":"object","additionalProperties":false,"required":["documentId","sequence","entryDigest"],"properties":{"documentId":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"sequence":{"type":"integer","minimum":1,"maximum":10000},"entryDigest":{"$ref":"#/$defs/digest"}}},"claim":{"enum":["authored","approved"]},"signer":{"type":"object","additionalProperties":false,"required":["id"],"properties":{"id":{"$ref":"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id"},"name":{"type":"string","minLength":1,"maxLength":256}}},"algorithm":{"const":"Ed25519"},"publicKey":{"type":"string","pattern":"^[A-Za-z0-9_-]{43}$"},"keyFingerprint":{"$ref":"#/$defs/digest"},"signature":{"type":"string","pattern":"^[A-Za-z0-9_-]{86}$"}},"$defs":{"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"}}};
const schema418 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};
const pattern210 = new RegExp("^[A-Za-z0-9_-]{43}$", "u");
const pattern212 = new RegExp("^[A-Za-z0-9_-]{86}$", "u");

function validate292(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/history-signature.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate292.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.target === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.claim === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "claim"},message:"must have required property '"+"claim"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.signer === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "signer"},message:"must have required property '"+"signer"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.algorithm === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "algorithm"},message:"must have required property '"+"algorithm"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.publicKey === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "publicKey"},message:"must have required property '"+"publicKey"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.keyFingerprint === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "keyFingerprint"},message:"must have required property '"+"keyFingerprint"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.signature === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "signature"},message:"must have required property '"+"signature"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema416.properties, key0))){
const err10 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/history-signature.schema.json" !== data.$schema){
const err11 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/history-signature.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-history-signature" !== data.format){
const err12 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-history-signature"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err13 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.target !== undefined){
let data3 = data.target;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.documentId === undefined){
const err14 = {instancePath:instancePath+"/target",schemaPath:"#/properties/target/required",keyword:"required",params:{missingProperty: "documentId"},message:"must have required property '"+"documentId"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data3.sequence === undefined){
const err15 = {instancePath:instancePath+"/target",schemaPath:"#/properties/target/required",keyword:"required",params:{missingProperty: "sequence"},message:"must have required property '"+"sequence"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data3.entryDigest === undefined){
const err16 = {instancePath:instancePath+"/target",schemaPath:"#/properties/target/required",keyword:"required",params:{missingProperty: "entryDigest"},message:"must have required property '"+"entryDigest"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
for(const key1 in data3){
if(!(((key1 === "documentId") || (key1 === "sequence")) || (key1 === "entryDigest"))){
const err17 = {instancePath:instancePath+"/target",schemaPath:"#/properties/target/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data3.documentId !== undefined){
let data4 = data3.documentId;
if(typeof data4 === "string"){
if(func3(data4) > 128){
const err18 = {instancePath:instancePath+"/target/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(func3(data4) < 1){
const err19 = {instancePath:instancePath+"/target/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(!pattern4.test(data4)){
const err20 = {instancePath:instancePath+"/target/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/target/documentId",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data3.sequence !== undefined){
let data5 = data3.sequence;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err22 = {instancePath:instancePath+"/target/sequence",schemaPath:"#/properties/target/properties/sequence/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 10000 || isNaN(data5)){
const err23 = {instancePath:instancePath+"/target/sequence",schemaPath:"#/properties/target/properties/sequence/maximum",keyword:"maximum",params:{comparison: "<=", limit: 10000},message:"must be <= 10000"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data5 < 1 || isNaN(data5)){
const err24 = {instancePath:instancePath+"/target/sequence",schemaPath:"#/properties/target/properties/sequence/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
if(data3.entryDigest !== undefined){
let data6 = data3.entryDigest;
if(typeof data6 === "string"){
if(!pattern9.test(data6)){
const err25 = {instancePath:instancePath+"/target/entryDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
else {
const err26 = {instancePath:instancePath+"/target/entryDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
else {
const err27 = {instancePath:instancePath+"/target",schemaPath:"#/properties/target/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data.claim !== undefined){
let data7 = data.claim;
if(!((data7 === "authored") || (data7 === "approved"))){
const err28 = {instancePath:instancePath+"/claim",schemaPath:"#/properties/claim/enum",keyword:"enum",params:{allowedValues: schema416.properties.claim.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.signer !== undefined){
let data8 = data.signer;
if(data8 && typeof data8 == "object" && !Array.isArray(data8)){
if(data8.id === undefined){
const err29 = {instancePath:instancePath+"/signer",schemaPath:"#/properties/signer/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
for(const key2 in data8){
if(!((key2 === "id") || (key2 === "name"))){
const err30 = {instancePath:instancePath+"/signer",schemaPath:"#/properties/signer/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data8.id !== undefined){
let data9 = data8.id;
if(typeof data9 === "string"){
if(func3(data9) > 128){
const err31 = {instancePath:instancePath+"/signer/id",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(func3(data9) < 1){
const err32 = {instancePath:instancePath+"/signer/id",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(!pattern4.test(data9)){
const err33 = {instancePath:instancePath+"/signer/id",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:/-]*$"+"\""};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
else {
const err34 = {instancePath:instancePath+"/signer/id",schemaPath:"https://maipo.design/schema/0.1/scene.schema.json#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data8.name !== undefined){
let data10 = data8.name;
if(typeof data10 === "string"){
if(func3(data10) > 256){
const err35 = {instancePath:instancePath+"/signer/name",schemaPath:"#/properties/signer/properties/name/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(func3(data10) < 1){
const err36 = {instancePath:instancePath+"/signer/name",schemaPath:"#/properties/signer/properties/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
else {
const err37 = {instancePath:instancePath+"/signer/name",schemaPath:"#/properties/signer/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
else {
const err38 = {instancePath:instancePath+"/signer",schemaPath:"#/properties/signer/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data.algorithm !== undefined){
if("Ed25519" !== data.algorithm){
const err39 = {instancePath:instancePath+"/algorithm",schemaPath:"#/properties/algorithm/const",keyword:"const",params:{allowedValue: "Ed25519"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data.publicKey !== undefined){
let data12 = data.publicKey;
if(typeof data12 === "string"){
if(!pattern210.test(data12)){
const err40 = {instancePath:instancePath+"/publicKey",schemaPath:"#/properties/publicKey/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]{43}$"},message:"must match pattern \""+"^[A-Za-z0-9_-]{43}$"+"\""};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
else {
const err41 = {instancePath:instancePath+"/publicKey",schemaPath:"#/properties/publicKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
if(data.keyFingerprint !== undefined){
let data13 = data.keyFingerprint;
if(typeof data13 === "string"){
if(!pattern9.test(data13)){
const err42 = {instancePath:instancePath+"/keyFingerprint",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
else {
const err43 = {instancePath:instancePath+"/keyFingerprint",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data.signature !== undefined){
let data14 = data.signature;
if(typeof data14 === "string"){
if(!pattern212.test(data14)){
const err44 = {instancePath:instancePath+"/signature",schemaPath:"#/properties/signature/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]{86}$"},message:"must match pattern \""+"^[A-Za-z0-9_-]{86}$"+"\""};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
else {
const err45 = {instancePath:instancePath+"/signature",schemaPath:"#/properties/signature/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
}
else {
const err46 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
validate292.errors = vErrors;
return errors === 0;
}
validate292.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateExtensionRegistrySchema = validate293;
const schema421 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/extension-registry.schema.json","title":"Maipo extension registry 0.1","description":"Registry for inert, declared metadata extensions used by Maipo public formats.","type":"object","additionalProperties":false,"required":["$schema","format","version","sceneVersion","policy","reserved","entries"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/extension-registry.schema.json"},"format":{"const":"maipo-extension-registry"},"version":{"const":"0.1"},"sceneVersion":{"const":"0.1"},"policy":{"type":"object","additionalProperties":false,"required":["execution","networkAccess","renderingEffect","unknownBehavior","maipoNamespace","externalNamespace"],"properties":{"execution":{"const":"forbidden"},"networkAccess":{"const":"forbidden"},"renderingEffect":{"const":"forbidden"},"unknownBehavior":{"const":"preserve-opaque"},"maipoNamespace":{"const":"reserved"},"externalNamespace":{"const":"reverse-domain-prefix"}}},"reserved":{"type":"array","maxItems":64,"items":{"$ref":"#/$defs/reserved"}},"entries":{"type":"array","maxItems":4096,"items":{"$ref":"#/$defs/entry"}}},"$defs":{"key":{"type":"string","pattern":"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},"reserved":{"type":"object","additionalProperties":false,"required":["key","owner","purpose"],"properties":{"key":{"$ref":"#/$defs/key"},"owner":{"const":"Maipo reference adapter"},"purpose":{"type":"string","minLength":1,"maxLength":512}}},"entry":{"type":"object","additionalProperties":false,"required":["key","version","kind","status","owner","purpose","schema","security"],"properties":{"key":{"$ref":"#/$defs/key"},"version":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[0-9A-Za-z][0-9A-Za-z._+-]*$"},"kind":{"const":"metadata"},"status":{"enum":["test-only","provisional","stable","deprecated"]},"owner":{"type":"string","minLength":1,"maxLength":256},"purpose":{"type":"string","minLength":1,"maxLength":1024},"schema":{"oneOf":[{"type":"null"},{"type":"object","additionalProperties":false,"required":["id","digest"],"properties":{"id":{"type":"string","minLength":1,"maxLength":2048},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"}}}]},"security":{"type":"object","additionalProperties":false,"required":["executable","networkAccess","affectsRendering"],"properties":{"executable":{"const":false},"networkAccess":{"const":false},"affectsRendering":{"const":false}}}}}}};
const schema422 = {"type":"object","additionalProperties":false,"required":["key","owner","purpose"],"properties":{"key":{"$ref":"#/$defs/key"},"owner":{"const":"Maipo reference adapter"},"purpose":{"type":"string","minLength":1,"maxLength":512}}};
const schema423 = {"type":"string","pattern":"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"};

function validate294(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate294.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.key === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "key"},message:"must have required property '"+"key"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.owner === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "owner"},message:"must have required property '"+"owner"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.purpose === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "purpose"},message:"must have required property '"+"purpose"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "key") || (key0 === "owner")) || (key0 === "purpose"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.key !== undefined){
let data0 = data.key;
if(typeof data0 === "string"){
if(!pattern12.test(data0)){
const err4 = {instancePath:instancePath+"/key",schemaPath:"#/$defs/key/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},message:"must match pattern \""+"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/key",schemaPath:"#/$defs/key/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.owner !== undefined){
if("Maipo reference adapter" !== data.owner){
const err6 = {instancePath:instancePath+"/owner",schemaPath:"#/properties/owner/const",keyword:"const",params:{allowedValue: "Maipo reference adapter"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.purpose !== undefined){
let data2 = data.purpose;
if(typeof data2 === "string"){
if(func3(data2) > 512){
const err7 = {instancePath:instancePath+"/purpose",schemaPath:"#/properties/purpose/maxLength",keyword:"maxLength",params:{limit: 512},message:"must NOT have more than 512 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(func3(data2) < 1){
const err8 = {instancePath:instancePath+"/purpose",schemaPath:"#/properties/purpose/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/purpose",schemaPath:"#/properties/purpose/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
validate294.errors = vErrors;
return errors === 0;
}
validate294.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema424 = {"type":"object","additionalProperties":false,"required":["key","version","kind","status","owner","purpose","schema","security"],"properties":{"key":{"$ref":"#/$defs/key"},"version":{"type":"string","minLength":1,"maxLength":64,"pattern":"^[0-9A-Za-z][0-9A-Za-z._+-]*$"},"kind":{"const":"metadata"},"status":{"enum":["test-only","provisional","stable","deprecated"]},"owner":{"type":"string","minLength":1,"maxLength":256},"purpose":{"type":"string","minLength":1,"maxLength":1024},"schema":{"oneOf":[{"type":"null"},{"type":"object","additionalProperties":false,"required":["id","digest"],"properties":{"id":{"type":"string","minLength":1,"maxLength":2048},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"}}}]},"security":{"type":"object","additionalProperties":false,"required":["executable","networkAccess","affectsRendering"],"properties":{"executable":{"const":false},"networkAccess":{"const":false},"affectsRendering":{"const":false}}}}};

function validate296(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate296.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.key === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "key"},message:"must have required property '"+"key"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.version === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.kind === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.status === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.owner === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "owner"},message:"must have required property '"+"owner"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.purpose === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "purpose"},message:"must have required property '"+"purpose"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.schema === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schema"},message:"must have required property '"+"schema"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.security === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "security"},message:"must have required property '"+"security"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "key") || (key0 === "version")) || (key0 === "kind")) || (key0 === "status")) || (key0 === "owner")) || (key0 === "purpose")) || (key0 === "schema")) || (key0 === "security"))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.key !== undefined){
let data0 = data.key;
if(typeof data0 === "string"){
if(!pattern12.test(data0)){
const err9 = {instancePath:instancePath+"/key",schemaPath:"#/$defs/key/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"},message:"must match pattern \""+"^[a-z][a-z0-9.-]*:[A-Za-z0-9._-]+$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/key",schemaPath:"#/$defs/key/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.version !== undefined){
let data1 = data.version;
if(typeof data1 === "string"){
if(func3(data1) > 64){
const err11 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(func3(data1) < 1){
const err12 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(!pattern25.test(data1)){
const err13 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/pattern",keyword:"pattern",params:{pattern: "^[0-9A-Za-z][0-9A-Za-z._+-]*$"},message:"must match pattern \""+"^[0-9A-Za-z][0-9A-Za-z._+-]*$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.kind !== undefined){
if("metadata" !== data.kind){
const err15 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/const",keyword:"const",params:{allowedValue: "metadata"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.status !== undefined){
let data3 = data.status;
if(!((((data3 === "test-only") || (data3 === "provisional")) || (data3 === "stable")) || (data3 === "deprecated"))){
const err16 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues: schema424.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.owner !== undefined){
let data4 = data.owner;
if(typeof data4 === "string"){
if(func3(data4) > 256){
const err17 = {instancePath:instancePath+"/owner",schemaPath:"#/properties/owner/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(func3(data4) < 1){
const err18 = {instancePath:instancePath+"/owner",schemaPath:"#/properties/owner/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/owner",schemaPath:"#/properties/owner/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.purpose !== undefined){
let data5 = data.purpose;
if(typeof data5 === "string"){
if(func3(data5) > 1024){
const err20 = {instancePath:instancePath+"/purpose",schemaPath:"#/properties/purpose/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(func3(data5) < 1){
const err21 = {instancePath:instancePath+"/purpose",schemaPath:"#/properties/purpose/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/purpose",schemaPath:"#/properties/purpose/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.schema !== undefined){
let data6 = data.schema;
const _errs14 = errors;
let valid2 = false;
let passing0 = null;
const _errs15 = errors;
if(data6 !== null){
const err23 = {instancePath:instancePath+"/schema",schemaPath:"#/properties/schema/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
var _valid0 = _errs15 === errors;
if(_valid0){
valid2 = true;
passing0 = 0;
}
const _errs17 = errors;
if(data6 && typeof data6 == "object" && !Array.isArray(data6)){
if(data6.id === undefined){
const err24 = {instancePath:instancePath+"/schema",schemaPath:"#/properties/schema/oneOf/1/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data6.digest === undefined){
const err25 = {instancePath:instancePath+"/schema",schemaPath:"#/properties/schema/oneOf/1/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
for(const key1 in data6){
if(!((key1 === "id") || (key1 === "digest"))){
const err26 = {instancePath:instancePath+"/schema",schemaPath:"#/properties/schema/oneOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data6.id !== undefined){
let data7 = data6.id;
if(typeof data7 === "string"){
if(func3(data7) > 2048){
const err27 = {instancePath:instancePath+"/schema/id",schemaPath:"#/properties/schema/oneOf/1/properties/id/maxLength",keyword:"maxLength",params:{limit: 2048},message:"must NOT have more than 2048 characters"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(func3(data7) < 1){
const err28 = {instancePath:instancePath+"/schema/id",schemaPath:"#/properties/schema/oneOf/1/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
else {
const err29 = {instancePath:instancePath+"/schema/id",schemaPath:"#/properties/schema/oneOf/1/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data6.digest !== undefined){
let data8 = data6.digest;
if(typeof data8 === "string"){
if(!pattern9.test(data8)){
const err30 = {instancePath:instancePath+"/schema/digest",schemaPath:"#/properties/schema/oneOf/1/properties/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
else {
const err31 = {instancePath:instancePath+"/schema/digest",schemaPath:"#/properties/schema/oneOf/1/properties/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
}
else {
const err32 = {instancePath:instancePath+"/schema",schemaPath:"#/properties/schema/oneOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
var _valid0 = _errs17 === errors;
if(_valid0 && valid2){
valid2 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid2 = true;
passing0 = 1;
}
}
if(!valid2){
const err33 = {instancePath:instancePath+"/schema",schemaPath:"#/properties/schema/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
else {
errors = _errs14;
if(vErrors !== null){
if(_errs14){
vErrors.length = _errs14;
}
else {
vErrors = null;
}
}
}
}
if(data.security !== undefined){
let data9 = data.security;
if(data9 && typeof data9 == "object" && !Array.isArray(data9)){
if(data9.executable === undefined){
const err34 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/required",keyword:"required",params:{missingProperty: "executable"},message:"must have required property '"+"executable"+"'"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data9.networkAccess === undefined){
const err35 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/required",keyword:"required",params:{missingProperty: "networkAccess"},message:"must have required property '"+"networkAccess"+"'"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data9.affectsRendering === undefined){
const err36 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/required",keyword:"required",params:{missingProperty: "affectsRendering"},message:"must have required property '"+"affectsRendering"+"'"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
for(const key2 in data9){
if(!(((key2 === "executable") || (key2 === "networkAccess")) || (key2 === "affectsRendering"))){
const err37 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data9.executable !== undefined){
if(false !== data9.executable){
const err38 = {instancePath:instancePath+"/security/executable",schemaPath:"#/properties/security/properties/executable/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data9.networkAccess !== undefined){
if(false !== data9.networkAccess){
const err39 = {instancePath:instancePath+"/security/networkAccess",schemaPath:"#/properties/security/properties/networkAccess/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data9.affectsRendering !== undefined){
if(false !== data9.affectsRendering){
const err40 = {instancePath:instancePath+"/security/affectsRendering",schemaPath:"#/properties/security/properties/affectsRendering/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
else {
const err41 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
}
else {
const err42 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
validate296.errors = vErrors;
return errors === 0;
}
validate296.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate293(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/extension-registry.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate293.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.sceneVersion === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sceneVersion"},message:"must have required property '"+"sceneVersion"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.policy === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "policy"},message:"must have required property '"+"policy"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.reserved === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "reserved"},message:"must have required property '"+"reserved"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.entries === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "entries"},message:"must have required property '"+"entries"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "$schema") || (key0 === "format")) || (key0 === "version")) || (key0 === "sceneVersion")) || (key0 === "policy")) || (key0 === "reserved")) || (key0 === "entries"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/extension-registry.schema.json" !== data.$schema){
const err8 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/extension-registry.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-extension-registry" !== data.format){
const err9 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-extension-registry"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err10 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.sceneVersion !== undefined){
if("0.1" !== data.sceneVersion){
const err11 = {instancePath:instancePath+"/sceneVersion",schemaPath:"#/properties/sceneVersion/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.policy !== undefined){
let data4 = data.policy;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.execution === undefined){
const err12 = {instancePath:instancePath+"/policy",schemaPath:"#/properties/policy/required",keyword:"required",params:{missingProperty: "execution"},message:"must have required property '"+"execution"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data4.networkAccess === undefined){
const err13 = {instancePath:instancePath+"/policy",schemaPath:"#/properties/policy/required",keyword:"required",params:{missingProperty: "networkAccess"},message:"must have required property '"+"networkAccess"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data4.renderingEffect === undefined){
const err14 = {instancePath:instancePath+"/policy",schemaPath:"#/properties/policy/required",keyword:"required",params:{missingProperty: "renderingEffect"},message:"must have required property '"+"renderingEffect"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data4.unknownBehavior === undefined){
const err15 = {instancePath:instancePath+"/policy",schemaPath:"#/properties/policy/required",keyword:"required",params:{missingProperty: "unknownBehavior"},message:"must have required property '"+"unknownBehavior"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data4.maipoNamespace === undefined){
const err16 = {instancePath:instancePath+"/policy",schemaPath:"#/properties/policy/required",keyword:"required",params:{missingProperty: "maipoNamespace"},message:"must have required property '"+"maipoNamespace"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data4.externalNamespace === undefined){
const err17 = {instancePath:instancePath+"/policy",schemaPath:"#/properties/policy/required",keyword:"required",params:{missingProperty: "externalNamespace"},message:"must have required property '"+"externalNamespace"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
for(const key1 in data4){
if(!((((((key1 === "execution") || (key1 === "networkAccess")) || (key1 === "renderingEffect")) || (key1 === "unknownBehavior")) || (key1 === "maipoNamespace")) || (key1 === "externalNamespace"))){
const err18 = {instancePath:instancePath+"/policy",schemaPath:"#/properties/policy/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data4.execution !== undefined){
if("forbidden" !== data4.execution){
const err19 = {instancePath:instancePath+"/policy/execution",schemaPath:"#/properties/policy/properties/execution/const",keyword:"const",params:{allowedValue: "forbidden"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data4.networkAccess !== undefined){
if("forbidden" !== data4.networkAccess){
const err20 = {instancePath:instancePath+"/policy/networkAccess",schemaPath:"#/properties/policy/properties/networkAccess/const",keyword:"const",params:{allowedValue: "forbidden"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data4.renderingEffect !== undefined){
if("forbidden" !== data4.renderingEffect){
const err21 = {instancePath:instancePath+"/policy/renderingEffect",schemaPath:"#/properties/policy/properties/renderingEffect/const",keyword:"const",params:{allowedValue: "forbidden"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data4.unknownBehavior !== undefined){
if("preserve-opaque" !== data4.unknownBehavior){
const err22 = {instancePath:instancePath+"/policy/unknownBehavior",schemaPath:"#/properties/policy/properties/unknownBehavior/const",keyword:"const",params:{allowedValue: "preserve-opaque"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data4.maipoNamespace !== undefined){
if("reserved" !== data4.maipoNamespace){
const err23 = {instancePath:instancePath+"/policy/maipoNamespace",schemaPath:"#/properties/policy/properties/maipoNamespace/const",keyword:"const",params:{allowedValue: "reserved"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data4.externalNamespace !== undefined){
if("reverse-domain-prefix" !== data4.externalNamespace){
const err24 = {instancePath:instancePath+"/policy/externalNamespace",schemaPath:"#/properties/policy/properties/externalNamespace/const",keyword:"const",params:{allowedValue: "reverse-domain-prefix"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
else {
const err25 = {instancePath:instancePath+"/policy",schemaPath:"#/properties/policy/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.reserved !== undefined){
let data11 = data.reserved;
if(Array.isArray(data11)){
if(data11.length > 64){
const err26 = {instancePath:instancePath+"/reserved",schemaPath:"#/properties/reserved/maxItems",keyword:"maxItems",params:{limit: 64},message:"must NOT have more than 64 items"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
const len0 = data11.length;
for(let i0=0; i0<len0; i0++){
if(!(validate294(data11[i0], {instancePath:instancePath+"/reserved/" + i0,parentData:data11,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate294.errors : vErrors.concat(validate294.errors);
errors = vErrors.length;
}
}
}
else {
const err27 = {instancePath:instancePath+"/reserved",schemaPath:"#/properties/reserved/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data.entries !== undefined){
let data13 = data.entries;
if(Array.isArray(data13)){
if(data13.length > 4096){
const err28 = {instancePath:instancePath+"/entries",schemaPath:"#/properties/entries/maxItems",keyword:"maxItems",params:{limit: 4096},message:"must NOT have more than 4096 items"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
const len1 = data13.length;
for(let i1=0; i1<len1; i1++){
if(!(validate296(data13[i1], {instancePath:instancePath+"/entries/" + i1,parentData:data13,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate296.errors : vErrors.concat(validate296.errors);
errors = vErrors.length;
}
}
}
else {
const err29 = {instancePath:instancePath+"/entries",schemaPath:"#/properties/entries/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
else {
const err30 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
validate293.errors = vErrors;
return errors === 0;
}
validate293.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateReadinessReportSchema = validate298;
const schema426 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://maipo.design/schema/0.1/readiness-report.schema.json","title":"Maipo 1.0 readiness report 0.1","description":"Evidence-backed, machine-readable assessment of a candidate Maipo stable release.","type":"object","additionalProperties":false,"required":["$schema","format","version","candidate","assessedPublication","status","summary","requirements"],"properties":{"$schema":{"const":"https://maipo.design/schema/0.1/readiness-report.schema.json"},"format":{"const":"maipo-readiness-report"},"version":{"const":"0.1"},"candidate":{"const":"1.0"},"assessedPublication":{"type":"string","pattern":"^[0-9]+\\.[0-9]+$"},"status":{"enum":["not-ready","ready-for-ratification","ratified"]},"summary":{"type":"object","additionalProperties":false,"required":["achieved","partial","missing","total"],"properties":{"achieved":{"type":"integer","minimum":0},"partial":{"type":"integer","minimum":0},"missing":{"type":"integer","minimum":0},"total":{"type":"integer","minimum":1}}},"requirements":{"type":"array","minItems":1,"maxItems":256,"items":{"$ref":"#/$defs/requirement"}}},"$defs":{"evidence":{"type":"object","additionalProperties":false,"required":["kind","ref"],"properties":{"kind":{"enum":["schema","implementation","test","fixture","policy","production"]},"ref":{"type":"string","minLength":1,"maxLength":2048}}},"requirement":{"type":"object","additionalProperties":false,"required":["id","requirement","status","evidence","gaps","exitCriteria"],"properties":{"id":{"type":"string","pattern":"^[a-z][a-z0-9-]*$","maxLength":128},"requirement":{"type":"string","minLength":1,"maxLength":512},"status":{"enum":["achieved","partial","missing"]},"evidence":{"type":"array","maxItems":32,"items":{"$ref":"#/$defs/evidence"}},"gaps":{"type":"array","maxItems":32,"items":{"type":"string","minLength":1,"maxLength":1024}},"exitCriteria":{"type":"array","maxItems":32,"items":{"type":"string","minLength":1,"maxLength":1024}}}}}};
const pattern217 = new RegExp("^[0-9]+\\.[0-9]+$", "u");
const schema427 = {"type":"object","additionalProperties":false,"required":["id","requirement","status","evidence","gaps","exitCriteria"],"properties":{"id":{"type":"string","pattern":"^[a-z][a-z0-9-]*$","maxLength":128},"requirement":{"type":"string","minLength":1,"maxLength":512},"status":{"enum":["achieved","partial","missing"]},"evidence":{"type":"array","maxItems":32,"items":{"$ref":"#/$defs/evidence"}},"gaps":{"type":"array","maxItems":32,"items":{"type":"string","minLength":1,"maxLength":1024}},"exitCriteria":{"type":"array","maxItems":32,"items":{"type":"string","minLength":1,"maxLength":1024}}}};
const schema428 = {"type":"object","additionalProperties":false,"required":["kind","ref"],"properties":{"kind":{"enum":["schema","implementation","test","fixture","policy","production"]},"ref":{"type":"string","minLength":1,"maxLength":2048}}};
const pattern218 = new RegExp("^[a-z][a-z0-9-]*$", "u");

function validate299(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate299.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.requirement === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requirement"},message:"must have required property '"+"requirement"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.status === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.evidence === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "evidence"},message:"must have required property '"+"evidence"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.gaps === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "gaps"},message:"must have required property '"+"gaps"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.exitCriteria === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "exitCriteria"},message:"must have required property '"+"exitCriteria"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "id") || (key0 === "requirement")) || (key0 === "status")) || (key0 === "evidence")) || (key0 === "gaps")) || (key0 === "exitCriteria"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func3(data0) > 128){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!pattern218.test(data0)){
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.requirement !== undefined){
let data1 = data.requirement;
if(typeof data1 === "string"){
if(func3(data1) > 512){
const err10 = {instancePath:instancePath+"/requirement",schemaPath:"#/properties/requirement/maxLength",keyword:"maxLength",params:{limit: 512},message:"must NOT have more than 512 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func3(data1) < 1){
const err11 = {instancePath:instancePath+"/requirement",schemaPath:"#/properties/requirement/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/requirement",schemaPath:"#/properties/requirement/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.status !== undefined){
let data2 = data.status;
if(!(((data2 === "achieved") || (data2 === "partial")) || (data2 === "missing"))){
const err13 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues: schema427.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.evidence !== undefined){
let data3 = data.evidence;
if(Array.isArray(data3)){
if(data3.length > 32){
const err14 = {instancePath:instancePath+"/evidence",schemaPath:"#/properties/evidence/maxItems",keyword:"maxItems",params:{limit: 32},message:"must NOT have more than 32 items"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
const len0 = data3.length;
for(let i0=0; i0<len0; i0++){
let data4 = data3[i0];
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.kind === undefined){
const err15 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/evidence/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data4.ref === undefined){
const err16 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/evidence/required",keyword:"required",params:{missingProperty: "ref"},message:"must have required property '"+"ref"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
for(const key1 in data4){
if(!((key1 === "kind") || (key1 === "ref"))){
const err17 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/evidence/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data4.kind !== undefined){
let data5 = data4.kind;
if(!((((((data5 === "schema") || (data5 === "implementation")) || (data5 === "test")) || (data5 === "fixture")) || (data5 === "policy")) || (data5 === "production"))){
const err18 = {instancePath:instancePath+"/evidence/" + i0+"/kind",schemaPath:"#/$defs/evidence/properties/kind/enum",keyword:"enum",params:{allowedValues: schema428.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data4.ref !== undefined){
let data6 = data4.ref;
if(typeof data6 === "string"){
if(func3(data6) > 2048){
const err19 = {instancePath:instancePath+"/evidence/" + i0+"/ref",schemaPath:"#/$defs/evidence/properties/ref/maxLength",keyword:"maxLength",params:{limit: 2048},message:"must NOT have more than 2048 characters"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(func3(data6) < 1){
const err20 = {instancePath:instancePath+"/evidence/" + i0+"/ref",schemaPath:"#/$defs/evidence/properties/ref/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/evidence/" + i0+"/ref",schemaPath:"#/$defs/evidence/properties/ref/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
else {
const err22 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/evidence/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath:instancePath+"/evidence",schemaPath:"#/properties/evidence/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.gaps !== undefined){
let data7 = data.gaps;
if(Array.isArray(data7)){
if(data7.length > 32){
const err24 = {instancePath:instancePath+"/gaps",schemaPath:"#/properties/gaps/maxItems",keyword:"maxItems",params:{limit: 32},message:"must NOT have more than 32 items"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
const len1 = data7.length;
for(let i1=0; i1<len1; i1++){
let data8 = data7[i1];
if(typeof data8 === "string"){
if(func3(data8) > 1024){
const err25 = {instancePath:instancePath+"/gaps/" + i1,schemaPath:"#/properties/gaps/items/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(func3(data8) < 1){
const err26 = {instancePath:instancePath+"/gaps/" + i1,schemaPath:"#/properties/gaps/items/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/gaps/" + i1,schemaPath:"#/properties/gaps/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath:instancePath+"/gaps",schemaPath:"#/properties/gaps/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.exitCriteria !== undefined){
let data9 = data.exitCriteria;
if(Array.isArray(data9)){
if(data9.length > 32){
const err29 = {instancePath:instancePath+"/exitCriteria",schemaPath:"#/properties/exitCriteria/maxItems",keyword:"maxItems",params:{limit: 32},message:"must NOT have more than 32 items"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
const len2 = data9.length;
for(let i2=0; i2<len2; i2++){
let data10 = data9[i2];
if(typeof data10 === "string"){
if(func3(data10) > 1024){
const err30 = {instancePath:instancePath+"/exitCriteria/" + i2,schemaPath:"#/properties/exitCriteria/items/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(func3(data10) < 1){
const err31 = {instancePath:instancePath+"/exitCriteria/" + i2,schemaPath:"#/properties/exitCriteria/items/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
else {
const err32 = {instancePath:instancePath+"/exitCriteria/" + i2,schemaPath:"#/properties/exitCriteria/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
}
else {
const err33 = {instancePath:instancePath+"/exitCriteria",schemaPath:"#/properties/exitCriteria/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
else {
const err34 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
validate299.errors = vErrors;
return errors === 0;
}
validate299.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate298(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://maipo.design/schema/0.1/readiness-report.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate298.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.format === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "format"},message:"must have required property '"+"format"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.candidate === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "candidate"},message:"must have required property '"+"candidate"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.assessedPublication === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assessedPublication"},message:"must have required property '"+"assessedPublication"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.status === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.summary === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "summary"},message:"must have required property '"+"summary"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.requirements === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requirements"},message:"must have required property '"+"requirements"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "$schema") || (key0 === "format")) || (key0 === "version")) || (key0 === "candidate")) || (key0 === "assessedPublication")) || (key0 === "status")) || (key0 === "summary")) || (key0 === "requirements"))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.$schema !== undefined){
if("https://maipo.design/schema/0.1/readiness-report.schema.json" !== data.$schema){
const err9 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "https://maipo.design/schema/0.1/readiness-report.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.format !== undefined){
if("maipo-readiness-report" !== data.format){
const err10 = {instancePath:instancePath+"/format",schemaPath:"#/properties/format/const",keyword:"const",params:{allowedValue: "maipo-readiness-report"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.version !== undefined){
if("0.1" !== data.version){
const err11 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue: "0.1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.candidate !== undefined){
if("1.0" !== data.candidate){
const err12 = {instancePath:instancePath+"/candidate",schemaPath:"#/properties/candidate/const",keyword:"const",params:{allowedValue: "1.0"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.assessedPublication !== undefined){
let data4 = data.assessedPublication;
if(typeof data4 === "string"){
if(!pattern217.test(data4)){
const err13 = {instancePath:instancePath+"/assessedPublication",schemaPath:"#/properties/assessedPublication/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/assessedPublication",schemaPath:"#/properties/assessedPublication/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.status !== undefined){
let data5 = data.status;
if(!(((data5 === "not-ready") || (data5 === "ready-for-ratification")) || (data5 === "ratified"))){
const err15 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues: schema426.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.summary !== undefined){
let data6 = data.summary;
if(data6 && typeof data6 == "object" && !Array.isArray(data6)){
if(data6.achieved === undefined){
const err16 = {instancePath:instancePath+"/summary",schemaPath:"#/properties/summary/required",keyword:"required",params:{missingProperty: "achieved"},message:"must have required property '"+"achieved"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data6.partial === undefined){
const err17 = {instancePath:instancePath+"/summary",schemaPath:"#/properties/summary/required",keyword:"required",params:{missingProperty: "partial"},message:"must have required property '"+"partial"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data6.missing === undefined){
const err18 = {instancePath:instancePath+"/summary",schemaPath:"#/properties/summary/required",keyword:"required",params:{missingProperty: "missing"},message:"must have required property '"+"missing"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data6.total === undefined){
const err19 = {instancePath:instancePath+"/summary",schemaPath:"#/properties/summary/required",keyword:"required",params:{missingProperty: "total"},message:"must have required property '"+"total"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
for(const key1 in data6){
if(!((((key1 === "achieved") || (key1 === "partial")) || (key1 === "missing")) || (key1 === "total"))){
const err20 = {instancePath:instancePath+"/summary",schemaPath:"#/properties/summary/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data6.achieved !== undefined){
let data7 = data6.achieved;
if(!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))){
const err21 = {instancePath:instancePath+"/summary/achieved",schemaPath:"#/properties/summary/properties/achieved/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 < 0 || isNaN(data7)){
const err22 = {instancePath:instancePath+"/summary/achieved",schemaPath:"#/properties/summary/properties/achieved/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
if(data6.partial !== undefined){
let data8 = data6.partial;
if(!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))){
const err23 = {instancePath:instancePath+"/summary/partial",schemaPath:"#/properties/summary/properties/partial/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 < 0 || isNaN(data8)){
const err24 = {instancePath:instancePath+"/summary/partial",schemaPath:"#/properties/summary/properties/partial/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
if(data6.missing !== undefined){
let data9 = data6.missing;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err25 = {instancePath:instancePath+"/summary/missing",schemaPath:"#/properties/summary/properties/missing/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 < 0 || isNaN(data9)){
const err26 = {instancePath:instancePath+"/summary/missing",schemaPath:"#/properties/summary/properties/missing/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
if(data6.total !== undefined){
let data10 = data6.total;
if(!(((typeof data10 == "number") && (!(data10 % 1) && !isNaN(data10))) && (isFinite(data10)))){
const err27 = {instancePath:instancePath+"/summary/total",schemaPath:"#/properties/summary/properties/total/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if((typeof data10 == "number") && (isFinite(data10))){
if(data10 < 1 || isNaN(data10)){
const err28 = {instancePath:instancePath+"/summary/total",schemaPath:"#/properties/summary/properties/total/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
}
}
else {
const err29 = {instancePath:instancePath+"/summary",schemaPath:"#/properties/summary/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.requirements !== undefined){
let data11 = data.requirements;
if(Array.isArray(data11)){
if(data11.length > 256){
const err30 = {instancePath:instancePath+"/requirements",schemaPath:"#/properties/requirements/maxItems",keyword:"maxItems",params:{limit: 256},message:"must NOT have more than 256 items"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data11.length < 1){
const err31 = {instancePath:instancePath+"/requirements",schemaPath:"#/properties/requirements/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
const len0 = data11.length;
for(let i0=0; i0<len0; i0++){
if(!(validate299(data11[i0], {instancePath:instancePath+"/requirements/" + i0,parentData:data11,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate299.errors : vErrors.concat(validate299.errors);
errors = vErrors.length;
}
}
}
else {
const err32 = {instancePath:instancePath+"/requirements",schemaPath:"#/properties/requirements/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
}
else {
const err33 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
validate298.errors = vErrors;
return errors === 0;
}
validate298.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};
